import { Coordinates } from './coordinates';
import { Currency } from './currency';
import { Language } from 'hic-components/src/multi-languages-input/multi-languages-types';
import { LocalizedString } from 'hic-components/src/multi-languages-input/multi-languages-types';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CapitalizedString: any;
  Coordinates: Coordinates;
  Currency: Currency;
  Date: Date;
  DateTime: Date;
  EmailAddress: string;
  EncryptedString: string;
  JSON: any;
  Language: Language;
  LocalizedString: LocalizedString;
  PhoneNumber: string;
  Time: Date;
  URL: string;
  UppercaseString: any;
  UtcOffset: string;
  Void: any;
};

/** Entità che serve per identificare le cod */
export type AccountantCategory = {
  auditable: Auditable;
  default: AccountantDefault;
  defaultVat: Vat;
  /** Il default Vat indica l'aliquota iva di default della voce contabile */
  defaultVatId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type AccountantCategoryQueryFilter = {
  advance?: InputMaybe<Scalars['Boolean']>;
  deposit?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Tipo che ci permette di sapere quale voce utilizzare in modo automatico per le varie operazioni */
export type AccountantDefault = {
  advance: Scalars['Boolean'];
  deposit: Scalars['Boolean'];
};

/**
 * Questo tipo ci permette di slavare all'interno della reservation e ReservedResource tutte le azioni che ci possono essere.
 * Ad esempio link WCI Inviata, WCI Effettuato, Carta Richiesta etc etc.
 */
export type ActionLog = {
  createdOn: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ActivatePointOfSaleItem = {
  /** Flag che indica se il Punto Vendita deve essere attivato o disattivato. */
  activate: Scalars['Boolean'];
  description: Scalars['String'];
  /** Codice identificativo usato dal sistema esterno (per CassaInCloud è il SalesPointId). */
  externalId: Scalars['String'];
  /** L'id del Punto Vendita, se esiste. */
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ActivatePointOfSalesInput = {
  /** L'ApiKey a cui associare i PuntiVendita che vengono creati. */
  apiKey: Scalars['String'];
  /** L'id del charge-category da usare quando deve essere creato il PuntoVendita di default. */
  defaultChargeCategoryId: Scalars['ID'];
  /** L'elenco dei PuntiVendita da attivare o disattivare. */
  pointOfSales: Array<ActivatePointOfSaleItem>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type AdditionaServiceImage = {
  additionalServiceId: Scalars['ID'];
  images?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * Il servizio è un entità che permette di generare addebiti all'interno di un conto
 * Ha delle regole che permettono al sistema di generare la corretta produzione
 */
export type AdditionalService = {
  auditable: Auditable;
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti gli adulti.
   * Default False. Visibile se *PERSON*.
   */
  automaticForAdults: Scalars['Boolean'];
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti i children che occupano un posto letto.
   * Default false. Visibile se *PERSON*.
   */
  automaticForChildren: Scalars['Boolean'];
  /**
   * La gestione della disponibilità di un servizio di default è infinita
   * Se si specifica availabilityConfig, lo si lega ad un resourceType e si gestisce la disponibilità in maniera finita
   */
  availabilityConfig?: Maybe<ServiceAvailability>;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  /** Prezzi per Fascia di età, attivabile solo se il tipo è *Person*. */
  childServicePrices?: Maybe<Array<ChildServicePrice>>;
  currency: Scalars['Currency'];
  description: Scalars['LocalizedString'];
  excludeCheckin: Scalars['Boolean'];
  excludeCheckout: Scalars['Boolean'];
  id: Scalars['ID'];
  imageIds?: Maybe<Array<Scalars['ID']>>;
  images?: Maybe<Array<File>>;
  /** Giorni massimi per poter attivare il servizio */
  maxStay?: Maybe<Scalars['Int']>;
  /** Giorni minimi per poter attivare il servizio */
  minStay?: Maybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  order?: Maybe<Scalars['Int']>;
  /** Visibile anche su IBE e Preventivi Self-made */
  pmsOnly?: Maybe<Scalars['Boolean']>;
  price: Scalars['Int'];
  pricingType: PricingType;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  /** Vendibile solo per alcune tipologie di risorsa */
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  /** La validità non è obbligatoria, ma può essere utile in situazioni tipo lo skipass */
  validity?: Maybe<Range>;
};

export type AdditionalServiceInput = {
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti gli adulti
   * Default False visibile se *PERSON*
   */
  automaticForAdults: Scalars['Boolean'];
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti i children che occupano un posto letto
   * Default false visibile se *PERSON*
   */
  automaticForChildren: Scalars['Boolean'];
  /**
   * La gestione della disponibilità di un servizio di default è infinita
   * Se si specifica availabilityConfig, lo si lega ad un resourceType e si gestisce la disponibilità in maniera finita
   */
  availabilityConfig?: InputMaybe<ServiceAvailabilityInput>;
  chargeCategoryId: Scalars['ID'];
  /** Prezzi per Fascia di età, attivabile solo se il tipo è *Person* */
  childServicePrices?: InputMaybe<Array<ChildServicePriceInput>>;
  currency: Scalars['Currency'];
  description: Scalars['LocalizedString'];
  excludeCheckin: Scalars['Boolean'];
  excludeCheckout: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  maxStay?: InputMaybe<Scalars['Int']>;
  minStay?: InputMaybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  order?: InputMaybe<Scalars['Int']>;
  /** Nascondi su IBE e Preventivi Self-made */
  pmsOnly?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Int'];
  pricingType: PricingType;
  propertyId?: InputMaybe<Scalars['ID']>;
  /** Vendibile solo per alcune tipologie di risorsa */
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  validity?: InputMaybe<RangeInput>;
};

export type AdditionalServiceLimitedAvailability = {
  day: Scalars['Date'];
  resourceId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  time: TimeRange;
};

export type AdditionalServiceLimitedAvailabilityInput = {
  day: Scalars['Date'];
  resourceId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  time: TimeRangeInput;
};

export type AdditionalServiceQueryFilter = {
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<IDFilter>;
  stay?: InputMaybe<ClosedRangeInput>;
  tenantId: IDFilter;
};

/** Address , embedded document */
export type Address = {
  address?: Maybe<Scalars['CapitalizedString']>;
  /** city è la località di nascita solo per gli esteri. Per gli italiani c'è municipalityId */
  city?: Maybe<Scalars['CapitalizedString']>;
  coordinates?: Maybe<Scalars['Coordinates']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['ID']>;
  municipality?: Maybe<Municipality>;
  municipalityId?: Maybe<Scalars['ID']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['Coordinates']>;
  countryId?: InputMaybe<Scalars['ID']>;
  municipalityId?: InputMaybe<Scalars['ID']>;
  postalCode?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
};

export const AgodaOccupancyModel = {
  FullRate: 'FullRate'
} as const;

export type AgodaOccupancyModel = typeof AgodaOccupancyModel[keyof typeof AgodaOccupancyModel];
/** Entità che contiene i dati di configurazione del portale Agoda. */
export type AgodaParameters = {
  occupancyModel: AgodaOccupancyModel;
};

export type AirbnbHostAuthentication = {
  /** I dati di autenticazione correntemente attivi. */
  authentication?: Maybe<AirbnbParametersAuthentication>;
  /** Codice ottenuto al termine della procedura con cui l'albergatore autorizza la nostra applicazione a gestire i dati presenti su Airbnb. */
  hostAuthorizationCode?: Maybe<Scalars['String']>;
  /** Data e ora in cui l'albergatore ha autorizzato la nostra applicazione. */
  hostAuthorizationTimestamp?: Maybe<Scalars['DateTime']>;
  /** Identificativo dell'albergatore nella piattaforma Airbnb. */
  hostUserId?: Maybe<Scalars['String']>;
};

export type AirbnbHostAuthorizationInput = {
  channelId: Scalars['ID'];
  /** Code retrieved from the Host authorization Redirect URL */
  hostAuthorizationCode: Scalars['String'];
};

/** Entità che contiene i dati di configurazione del portale Airbnb. */
export type AirbnbParameters = {
  /** I dati di autenticazione correntemente attivi. */
  authentication?: Maybe<AirbnbParametersAuthentication>;
  /** Codice ottenuto al termine della procedura con cui l'albergatore autorizza la nostra applicazione a gestire i dati presenti su Airbnb. */
  hostAuthorizationCode?: Maybe<Scalars['String']>;
  /** Data e ora in cui l'albergatore ha autorizzato la nostra applicazione. */
  hostAuthorizationTimestamp?: Maybe<Scalars['DateTime']>;
  /** Identificativo dell'albergatore nella piattaforma Airbnb. */
  hostUserId?: Maybe<Scalars['String']>;
};

export type AirbnbParametersAuthentication = {
  accessToken: Scalars['EncryptedString'];
  /** Unix time */
  expiresAt: Scalars['Int'];
  refreshToken: Scalars['EncryptedString'];
};

export const AlgebraicSign = {
  NEGATIVE: 'NEGATIVE',
  POSITIVE: 'POSITIVE'
} as const;

export type AlgebraicSign = typeof AlgebraicSign[keyof typeof AlgebraicSign];
/** Dotazioni e servizi che possono essere associate ad una tipologia di risorsa */
export type Amenity = {
  auditable: Auditable;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
};

export type AmenityInput = {
  image?: InputMaybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
};

export type AmenityQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<LocalizedStringFilter>;
};

export type AttachmentForDocumentInput = {
  body?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  messageTemplateId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

/** Entità di Audit, contiene le modifiche ad ogni record Auditable */
export type Audit = {
  changes?: Maybe<Scalars['JSON']>;
  correlationId: Scalars['String'];
  entityId: Scalars['ID'];
  entityName: Scalars['String'];
  expirationDate: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  operationName: Scalars['String'];
  tenantId?: Maybe<Scalars['ID']>;
  timestamp: Scalars['DateTime'];
};

export type AuditQueryFilter = {
  correlationId?: InputMaybe<StringFilter>;
  date?: InputMaybe<ClosedRangeInput>;
  entityId?: InputMaybe<IDFilter>;
  entityName?: InputMaybe<StringFilter>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<StringFilter>;
  operationName?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type AuditSortInput = {
  timestamp?: InputMaybe<Sort>;
};

/** Dati Auditable, embedded document da utilizzare in tutte le entità */
export type Auditable = {
  audits: Array<Audit>;
  createdBy?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  state: State;
  versions: Array<Maybe<Scalars['JSON']>>;
};

export type AvailabilityRequest = {
  auditable: Auditable;
  customer: CustomerAvailabilityRequest;
  end: Scalars['Date'];
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  resources: Array<ResourceAvailabilityRequest>;
  start: Scalars['Date'];
  state: AvailabilityRequestState;
  tenantId: Scalars['ID'];
};

export type AvailabilityRequestInput = {
  customer: CustomerAvailabilityRequestInput;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resources: Array<ResourceRQInput>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type AvailabilityRequestQueryFilter = {
  dateRange?: InputMaybe<ClosedRangeInput>;
  propertyId?: InputMaybe<IDFilter>;
  state?: InputMaybe<AvailabilityRequestStateFilter>;
  tenantId: IDFilter;
};

export const AvailabilityRequestState = {
  NEW: 'NEW',
  NOTIFIED: 'NOTIFIED',
  RESERVED: 'RESERVED',
  VISITED: 'VISITED'
} as const;

export type AvailabilityRequestState = typeof AvailabilityRequestState[keyof typeof AvailabilityRequestState];
export type AvailabilityRequestStateFilter = {
  in: Array<AvailabilityRequestState>;
};

export type AvailableResourcesInput = {
  endDate: Scalars['Date'];
  excludeReservedResourceId?: InputMaybe<Scalars['ID']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  rateId?: InputMaybe<Scalars['ID']>;
  resourceTypeId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export const BackgroundStyle = {
  IBE_IMAGE: 'IBE_IMAGE',
  PRIMARY_COLOR: 'PRIMARY_COLOR',
  PROPERTY_IMAGE: 'PROPERTY_IMAGE'
} as const;

export type BackgroundStyle = typeof BackgroundStyle[keyof typeof BackgroundStyle];
export const BeforeOrAfter = {
  AFTER: 'AFTER',
  BEFORE: 'BEFORE'
} as const;

export type BeforeOrAfter = typeof BeforeOrAfter[keyof typeof BeforeOrAfter];
/**
 * Il conto contiene è un raggruppamento di addebiti di produzione
 * Il conto può essere legato ad una o più prenotazioni e a una o più risorse
 * Il conto può essere legato soltanto ad un customer e rappresenta un conto passante
 * Il conto quando viene creato è di default di tipo MAIN
 */
export type Bill = {
  auditable: Auditable;
  category: BillCategoryType;
  description: Scalars['String'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  open: Scalars['Boolean'];
  owner: Customer;
  ownerId: Scalars['ID'];
  productions?: Maybe<Array<ProductionAssigned>>;
  propertyId: Scalars['ID'];
  reservation?: Maybe<Array<Reservation>>;
  reservationId?: Maybe<Array<Scalars['ID']>>;
  reservedResource?: Maybe<Array<ReservedResource>>;
  reservedResourceId?: Maybe<Array<Scalars['ID']>>;
  searchInfo: BillSearchInfo;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type BillAllocationInput = {
  billId: Scalars['ID'];
  quota: Scalars['Float'];
};

export const BillCategoryType = {
  EXTRA: 'EXTRA',
  MAIN: 'MAIN',
  REVERSE: 'REVERSE',
  WALKIN: 'WALKIN'
} as const;

export type BillCategoryType = typeof BillCategoryType[keyof typeof BillCategoryType];
export type BillCheckoutInput = {
  billId: Scalars['ID'];
  productions: Array<ProductionCheckoutInput>;
};

export type BillInput = {
  category: BillCategoryType;
  description: Scalars['String'];
  ownerId: Scalars['ID'];
  productions?: InputMaybe<Array<ProductionAssignedInput>>;
  propertyId: Scalars['ID'];
  reservationId?: InputMaybe<Array<Scalars['ID']>>;
  reservedResourceId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
};

export type BillQueryFilter = {
  category?: InputMaybe<BillCategoryType>;
  createdOn?: InputMaybe<RangeInput>;
  description?: InputMaybe<StringFilter>;
  end?: InputMaybe<DateFilter>;
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  reservationId?: InputMaybe<IDFilter>;
  reservedResourceId?: InputMaybe<IDFilter>;
  start?: InputMaybe<DateFilter>;
  tenantId: IDFilter;
};

export type BillSearchInfo = {
  end?: Maybe<Scalars['Date']>;
  guestNames?: Maybe<Array<Scalars['String']>>;
  ownerName: Scalars['String'];
  resources?: Maybe<Array<Scalars['String']>>;
  start?: Maybe<Scalars['Date']>;
};

export type BillsByReservationQueryFilter = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const BookingAction = {
  BOOK: 'BOOK',
  CANCEL: 'CANCEL',
  MODIFY: 'MODIFY'
} as const;

export type BookingAction = typeof BookingAction[keyof typeof BookingAction];
/** BookingEngineConfiguration */
export type BookingEngineConfiguration = {
  backgroundStyle?: Maybe<BackgroundStyle>;
  fiscalAdvances: Scalars['Boolean'];
  font?: Maybe<Scalars['String']>;
  /** Codice Google Analytics 4 */
  googleGA4?: Maybe<Scalars['String']>;
  /**  se nullo si intende 2 pax  */
  ibeDefaultPax?: Maybe<Scalars['Int']>;
  ibeImage?: Maybe<File>;
  ibeImageId?: Maybe<Scalars['ID']>;
  metaToken?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  resizeBackgroundImage?: Maybe<Scalars['Boolean']>;
  secondaryColor?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['LocalizedString']>;
  welcomeTextColor?: Maybe<Scalars['String']>;
};

export type BookingEngineConfigurationInput = {
  backgroundStyle?: InputMaybe<BackgroundStyle>;
  fiscalAdvances: Scalars['Boolean'];
  font?: InputMaybe<Scalars['String']>;
  /** Codice Google Analytics 4 */
  googleGA4?: InputMaybe<Scalars['String']>;
  /**  se nullo si intende 2 pax  */
  ibeDefaultPax?: InputMaybe<Scalars['Int']>;
  ibeImageId?: InputMaybe<Scalars['ID']>;
  metaToken?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  resizeBackgroundImage?: InputMaybe<Scalars['Boolean']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['LocalizedString']>;
  welcomeTextColor?: InputMaybe<Scalars['String']>;
};

export type BookingEngineUrl = {
  auditable: Auditable;
  id: Scalars['ID'];
  propertyId: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};

export type BookingEngineUrlInput = {
  propertyId: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};

/** La politica di booking contine le logiche per garantire la prenotazione, pagamenti, cancellazione e la gestione di eventuali penali. */
export type BookingPolicy = {
  additionalNote?: Maybe<Scalars['LocalizedString']>;
  auditable: Auditable;
  /** Gestione delle policy di cancellazione */
  cancellationPolicy: CancellationPolicy;
  id: Scalars['ID'];
  /** Nome solo ad uso interno */
  name: Scalars['String'];
  /** Regole per gestire il no show */
  noShowRule: NoShowRule;
  /** Regole per la conferma della prenotaizone */
  paymentRule: PaymentRule;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type BookingPolicyDigitalPaymentInfo = {
  amount: Scalars['Int'];
  bookingPolicy: ReservationBookingPolicy;
  confirmationPageNote: Scalars['String'];
  currency: Scalars['Currency'];
  noShow: Scalars['Int'];
};

export type BookingPolicyDigitalPaymentInput = {
  currency: Scalars['Currency'];
  firstNightAmount: Scalars['Int'];
  language: Scalars['Language'];
  policies: Array<ReservationBookingPolicyInput>;
  rateFrequency?: InputMaybe<RateFrequency>;
  start: Scalars['Date'];
  timeZone?: InputMaybe<Scalars['UtcOffset']>;
  totalAmount: Scalars['Int'];
};

export type BookingPolicyInput = {
  additionalNote?: InputMaybe<Scalars['LocalizedString']>;
  cancellationPolicy: CancellationPolicyInput;
  name: Scalars['String'];
  noShowRule: NoShowRuleInput;
  paymentRule: PaymentRuleInput;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type BookingPolicyQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** EXCEL */
export type BulkReservation = {
  correlationId: Scalars['String'];
  deleteError?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importedId?: Maybe<Scalars['ID']>;
  processed: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  row: BulkReservationRow;
  tenantId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type BulkReservationInput = {
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Int'];
  companyName?: InputMaybe<Scalars['String']>;
  createdOn?: InputMaybe<Scalars['DateTime']>;
  credit?: InputMaybe<CreditType>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerLanguage?: InputMaybe<Scalars['Language']>;
  customerName: Scalars['String'];
  customerPhone?: InputMaybe<Scalars['String']>;
  end: Scalars['Date'];
  groupName?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalId?: InputMaybe<Scalars['String']>;
  portalName?: InputMaybe<Scalars['String']>;
  reservationCode?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  totalAmount: Scalars['Int'];
  voucher?: InputMaybe<Scalars['String']>;
};

export type BulkReservationRow = {
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Int'];
  companyName?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  credit?: Maybe<CreditType>;
  customerEmail?: Maybe<Scalars['String']>;
  customerLanguage?: Maybe<Scalars['Language']>;
  customerName: Scalars['String'];
  customerPhone?: Maybe<Scalars['String']>;
  end: Scalars['Date'];
  groupName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  originalId?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  reservationCode?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  totalAmount: Scalars['Int'];
  voucher?: Maybe<Scalars['String']>;
};

export type CacheCollection = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  value: Scalars['JSON'];
};

/** Questo tipo contiene le informazioni che servono al sistema per calcolare l'importo , il vaore è semrpe intero anche per le percentuali */
export type CalculationPrice = {
  type: ValueType;
  value: Scalars['Int'];
};

export type CalculationPriceInput = {
  type: ValueType;
  value: Scalars['Int'];
};

export const CancelReservationResult = {
  DONE: 'DONE',
  NOSHOW: 'NOSHOW',
  NOTREF: 'NOTREF',
  PENALTY: 'PENALTY',
  REFUND_ERROR: 'REFUND_ERROR'
} as const;

export type CancelReservationResult = typeof CancelReservationResult[keyof typeof CancelReservationResult];
/** Tipo di penale per le cancellazioni tardive */
export const CancellationPenaltyType = {
  FIRSTNIGHT: 'FIRSTNIGHT',
  PERCENTAGE_TOTAL: 'PERCENTAGE_TOTAL',
  TOTAL: 'TOTAL'
} as const;

export type CancellationPenaltyType = typeof CancellationPenaltyType[keyof typeof CancellationPenaltyType];
/** Policy di cancellazione legata alla booking policy */
export type CancellationPolicy = {
  /**
   * Se il valore è zero indica che si può cancellare senza penali fino al giorno dell'arrivo, default 7.
   * Se non impostato vuol dire che non è rimborsabile.
   */
  daysWithoutPenalties?: Maybe<Scalars['Int']>;
  /**
   * Default è mezzanotte 00:00 che indica l'inzio del giorno, altrimenti è possibile gestire l'orario in aggiunta ai giorni.
   * Se non impostato vuol dire che non è rimborsabile.
   * Default 7 giorni e 00:00 indica che la prenotazione può essere cancellata fino alle 23.59 dell'ottavo giorno prima dell'arrivo.
   *
   * ATTENZIONE: Non convertire MAI in ora locale ma usare sempre il valore UTC, in quanto l'orario UTC salvato rappresenta già l'orario locale desiderato.
   */
  hourWithoutPenalties?: Maybe<Scalars['Time']>;
  /** Dati per calcolare le penali su tardiva cancellazione */
  penaltyType?: Maybe<CancellationPenaltyType>;
  percentage?: Maybe<Scalars['Float']>;
  type: CancellationPolicyType;
};

export type CancellationPolicyInput = {
  daysWithoutPenalties?: InputMaybe<Scalars['Int']>;
  hourWithoutPenalties?: InputMaybe<Scalars['Time']>;
  penaltyType?: InputMaybe<CancellationPenaltyType>;
  percentage?: InputMaybe<Scalars['Float']>;
  type: CancellationPolicyType;
};

/** Tipo di cancellazione */
export const CancellationPolicyType = {
  ALWAYSFREE: 'ALWAYSFREE',
  BYDATE: 'BYDATE',
  NOTREF: 'NOTREF'
} as const;

export type CancellationPolicyType = typeof CancellationPolicyType[keyof typeof CancellationPolicyType];
export type CancelledDocument = {
  auditable: Auditable;
  document: Document;
  documentDate: Scalars['Date'];
  documentId: Scalars['ID'];
  documentSetCode?: Maybe<Scalars['String']>;
  documentType: DocumentType;
  fiscalType: FiscalType;
  id: Scalars['ID'];
  number: Scalars['Int'];
  numberExtended: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type Card = {
  cardType: Scalars['String'];
  plans?: Maybe<Array<Plan>>;
  title: Scalars['String'];
};

/** Entità Cassa */
export type CashDesk = {
  auditable: Auditable;
  cashDeskType: CashDeskType;
  cashDeskTypeId: Scalars['ID'];
  hotelDate: Scalars['Date'];
  id: Scalars['ID'];
  open: Scalars['Boolean'];
  owner?: Maybe<User>;
  /**
   * La cassa potrebbe avere un owner in modo che solo chi è il proprietario la può usare.
   * Non è obligatorio perchè non è gestito in tutte le strutture, di default sarà sempre aperta e chiusa in fase di chiusura
   */
  ownerID?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CashDeskInput = {
  cashDeskTypeId: Scalars['ID'];
  hotelDate: Scalars['Date'];
  ownerID?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CashDeskQueryFilter = {
  cashDeskTypeId?: InputMaybe<IDFilter>;
  hotelDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<IDFilter>;
  open?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/**
 * Tipo cassa, il tipo cassa è associato alla property o alla sub property e permette di avere le configurazioni necessarie per gestire la cassa.
 * La creazione di una nuova property genera una cassa collegata che permette di emettere tutti i tipi di documenti.
 * Per ogni cassa è possibile avere solo un tipo documento
 * Su ogni tipo cassa è possibile associare uno o più workstation di fiscal gateway
 */
export type CashDeskType = {
  auditable: Auditable;
  code: CashDeskTypeCode;
  documentsActive: Array<DocumentActive>;
  documentsActiveId: Array<Scalars['ID']>;
  fiscalGatewayWorkstations: Array<FiscalGatewayWorkstation>;
  id: Scalars['ID'];
  /** Codice da utilizzare per le configurazioni di export */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  property: Property;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const CashDeskTypeCode = {
  FRONT: 'FRONT'
} as const;

export type CashDeskTypeCode = typeof CashDeskTypeCode[keyof typeof CashDeskTypeCode];
export type CashDeskTypeInput = {
  code: CashDeskTypeCode;
  documentsActiveId: Array<Scalars['ID']>;
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudApiKey = {
  apiKey: Scalars['String'];
  description: Scalars['String'];
};

export type CassaInCloudApiKeyInput = {
  apiKey: Scalars['String'];
  description: Scalars['String'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudConfiguration = {
  /** Elenco delle ApiKey gestite. */
  apiKeys?: Maybe<Array<CassaInCloudConfigurationApiKeyEntry>>;
  /** Il secret da comunicare a CassaInCloud. Tale secret deve essere passato in ogni chiamata ai nostri servizi. */
  tenantSecret: Scalars['String'];
};

export type CassaInCloudConfigurationApiKeyEntry = {
  apiKey: Scalars['EncryptedString'];
  description: Scalars['String'];
  /** Elenco dei Punti Vendita collegati a questa ApiKey. */
  pointOfSaleIds?: Maybe<Array<Scalars['ID']>>;
  pointOfSales?: Maybe<Array<PointOfSale>>;
};

export type CassaInCloudDepartment = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type CassaInCloudDepartmentsQueryFilter = {
  pointOfSaleId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudSalesMode = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type CassaInCloudSalesModesQueryFilter = {
  pointOfSaleId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudSalesPoint = {
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CervedActivityStatus = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedAdvancedAddress = {
  city?: Maybe<CervedCity>;
  country?: Maybe<CervedCountry>;
  postal_code?: Maybe<Scalars['String']>;
  province?: Maybe<CervedProvince>;
  street?: Maybe<CervedStreet>;
};

export type CervedAdvancedNoReaData = {
  form_code?: Maybe<Scalars['String']>;
  form_description?: Maybe<Scalars['String']>;
};

/** Input per la ricerca avanzata in Cerved */
export type CervedAdvancedSearchInput = {
  /** Nominativo o ragione sociale */
  name?: InputMaybe<Scalars['String']>;
  /** Ricerca generica */
  searchText?: InputMaybe<Scalars['String']>;
  /** Codice fiscale */
  taxCode?: InputMaybe<Scalars['String']>;
  /** Partita IVA */
  vatNumber?: InputMaybe<Scalars['String']>;
};

/** Risposta della ricerca avanzata in Cerved */
export type CervedAdvancedSearchResponse = {
  subjects?: Maybe<Array<Maybe<CervedSubject>>>;
  subjects_total_number?: Maybe<Scalars['Int']>;
};

export type CervedAteco = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedCity = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  istat_code?: Maybe<Scalars['String']>;
};

export type CervedCompanyInfo = {
  activity_status?: Maybe<CervedActivityStatus>;
  business_name?: Maybe<Scalars['String']>;
  economic_activity?: Maybe<CervedEconomicActivity>;
  head_office?: Maybe<Scalars['Boolean']>;
  legal_form?: Maybe<CervedLegalForm>;
  lei_code?: Maybe<Scalars['String']>;
  no_rea_data?: Maybe<CervedAdvancedNoReaData>;
  operational_flag?: Maybe<Scalars['Boolean']>;
  public_administration?: Maybe<CervedPublicAdministration>;
  rea_code?: Maybe<CervedRea>;
  vat_number?: Maybe<Scalars['String']>;
};

/** Input per recuperare la lista dei contatti di un Soggetto (persona giuridica) */
export type CervedContactsInput = {
  /** Identificativo univoco Cerved del Soggetto (persona giuridica) restituito dal servizio di ricerca. */
  subjectId: Scalars['String'];
};

/** Risposta della richiesta dei contatti di un Soggetto */
export type CervedContactsResponse = {
  /** Lista di indirizzi (non PEC) associati al soggetto */
  indirizzi_email?: Maybe<Array<Maybe<CervedEmail>>>;
  /** Lista di indirizzi PEC associati al soggetto */
  indirizzi_email_certificate?: Maybe<Array<Maybe<CervedEmail>>>;
  /** Lista delle url dei siti associati al soggetto */
  siti_web?: Maybe<Array<Maybe<CervedSitoWeb>>>;
  /** Lista di numeri di telefono associati al soggetto */
  telefoni?: Maybe<Array<Maybe<CervedTelefono>>>;
};

export type CervedCountry = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isoCode?: Maybe<Scalars['String']>;
};

export type CervedEconomicActivity = {
  ateco?: Maybe<CervedAteco>;
};

export type CervedEmail = {
  /** Categoria associata a ciascun indirizzo email */
  categoria?: Maybe<Scalars['String']>;
  /** Indirizzo email */
  email?: Maybe<Scalars['String']>;
};

export type CervedLegalForm = {
  class_code?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedPersonInfo = {
  birth_date?: Maybe<Scalars['String']>;
  birth_place?: Maybe<CervedAdvancedAddress>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CervedProvince = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedPublicAdministration = {
  pa_owned?: Maybe<Scalars['Boolean']>;
  pa_subject?: Maybe<Scalars['Boolean']>;
  pa_supplier?: Maybe<Scalars['Boolean']>;
};

export type CervedRea = {
  cciaa?: Maybe<Scalars['String']>;
  rea_number?: Maybe<Scalars['Int']>;
  registration_date?: Maybe<Scalars['String']>;
};

export type CervedSitoWeb = {
  /** Tipologia sito web (principale o secondario) */
  tipo?: Maybe<Scalars['String']>;
  /** Sito web */
  url?: Maybe<Scalars['String']>;
};

export type CervedStreet = {
  description?: Maybe<Scalars['String']>;
};

export type CervedSubject = {
  address?: Maybe<CervedAdvancedAddress>;
  company_info?: Maybe<CervedCompanyInfo>;
  person_info?: Maybe<CervedPersonInfo>;
  subject_id?: Maybe<Scalars['String']>;
  subject_type?: Maybe<Scalars['String']>;
  tax_code?: Maybe<Scalars['String']>;
};

export type CervedTelefono = {
  /** Fonte di ciascun numero di telefono */
  fonte?: Maybe<Scalars['String']>;
  /** Numero di telefono */
  numero?: Maybe<Scalars['String']>;
  /** Sede a cui è associato il numero */
  sede?: Maybe<Scalars['String']>;
  /** Uso di ciascun numero di telefono */
  uso?: Maybe<Scalars['String']>;
};

/**
 * Entità che mantiene le configurazioni dei portali collegati alla property, in questo caso potrebbero essere anche subproperty
 * Lo stato in qesto caso è importante perchè è possibile inibire l'invio dei dati lasciando il portale inattivo, fino a quando non sarà l'operatore a decidere di attivare.
 * In quel caso è necessario chiedere all'operatore se deve essere aggiornato i dati del portale con i dati presenti o meno.
 */
export type Channel = {
  /** I dati di configurazione della struttura nel portale Agoda. */
  agodaParameters?: Maybe<AgodaParameters>;
  /** I dati di configurazione della struttura nel portale Airbnb. */
  airbnbParameters?: Maybe<AirbnbParameters>;
  auditable: Auditable;
  channelChargeMappings?: Maybe<Array<ChannelChargeMapping>>;
  channelRateMappings?: Maybe<Array<ChannelRateMapping>>;
  channelResourceTypeMappings?: Maybe<Array<ChannelResourceTypeMapping>>;
  /** Eventuali credenziali assegnate alla struttura dal portale per accedere ai propri servizi web. */
  credentials?: Maybe<ChannelCredentials>;
  /** I dati di configurazione della struttura nel portale Expedia. */
  expediaParameters?: Maybe<ExpediaParameters>;
  id: Scalars['ID'];
  /** Dati informativi che possono essere visulizzati sul client */
  info?: Maybe<Scalars['String']>;
  /**
   * Se impostata indica quando è stato eseguito l'import iniziale delle prenotazioni.
   * Se la data è presente non deve essere possibile rieseguire l'import.
   */
  initialImportDate?: Maybe<Scalars['DateTime']>;
  /** Indica quando è stato fatto l'ultima operazione di download di una prenotazione */
  lastDownload?: Maybe<Scalars['DateTime']>;
  /** Indica quando è stato eseguito l'ultimo aggiornamento massivo del canale */
  lastUpdateChannel?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  /**
   * Per ogni account dei portali  è possibile specificare una variazione in percentuale della tariffa
   * Ad esempio 3% in più su Booking.com e 4% in più su Air Bnb.
   * Default 0
   */
  percentage: Scalars['Float'];
  portal: Portal;
  portalId: Scalars['ID'];
  property: Property;
  propertyId: Scalars['ID'];
  /** Codice che identifica la property sul portale se gestito. */
  propertyPortalCode?: Maybe<Scalars['String']>;
  subProperty?: Maybe<Property>;
  subPropertyId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  /** Se viene utilizzato tramite Figaro è necessario avere l'id del portale per le connessioni */
  throughFigaro?: Maybe<Scalars['Int']>;
};

export type ChannelAvailabilityEventPayload = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  stopSellEvent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type ChannelChargeMapping = {
  chargeCategory: ChargeCategory;
  chargeCategoryCodePortal: Scalars['String'];
  chargeCategoryId: Scalars['ID'];
};

export type ChannelChargeMappingInput = {
  chargeCategoryCodePortal: Scalars['String'];
  chargeCategoryId: Scalars['ID'];
};

export type ChannelCommunicationFilter = {
  channelId: IDFilter;
  error: Scalars['Boolean'];
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const ChannelCommunicationOperation = {
  AVAILABILITY: 'AVAILABILITY',
  PRICE: 'PRICE',
  PROPERTY_DATA: 'PROPERTY_DATA',
  RESERVATION: 'RESERVATION',
  RESTRICTION: 'RESTRICTION'
} as const;

export type ChannelCommunicationOperation = typeof ChannelCommunicationOperation[keyof typeof ChannelCommunicationOperation];
/**
 * Collection che ci permette di salvare per ogni canale le informazioni da mostrare all'utente, queste informazioni rimangono live solo per n giorni. N da specificare sul TTL
 * Le stesse informazioni sono presenti in helk con una retention maggiore.
 */
export type ChannelCommunicationResult = {
  channel?: Maybe<Channel>;
  channelId: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  dataSendJson: Scalars['JSON'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  operations?: Maybe<Array<ChannelCommunicationOperation>>;
  portalName: PortalName;
  property?: Maybe<Property>;
  propertyId: Scalars['ID'];
  state: ChannelCommunicationState;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
};

export const ChannelCommunicationState = {
  ERROR: 'ERROR',
  OK: 'OK',
  WARNING: 'WARNING'
} as const;

export type ChannelCommunicationState = typeof ChannelCommunicationState[keyof typeof ChannelCommunicationState];
export type ChannelCredentials = {
  /** Password dell'utenza. */
  password: Scalars['EncryptedString'];
  /** Identificativo dell'utenza. */
  userId: Scalars['EncryptedString'];
};

export type ChannelCredentialsInput = {
  /** Password dell'utenza. */
  password: Scalars['EncryptedString'];
  /** Identificativo dell'utenza. */
  userId: Scalars['EncryptedString'];
};

export type ChannelInput = {
  /** Codice ottenuto al termine della procedura con cui l'albergatore autorizza la nostra applicazione a gestire i dati presenti su Airbnb. */
  airbnbHostAuthorizationCode?: InputMaybe<Scalars['String']>;
  channelChargeMappings?: InputMaybe<Array<ChannelChargeMappingInput>>;
  channelId?: InputMaybe<Scalars['ID']>;
  channelRateMappings?: InputMaybe<Array<ChannelRateMappingInput>>;
  channelResourceTypeMappings?: InputMaybe<Array<ChannelResourceTypeMappingInput>>;
  /** Eventuali credenziali assegnate alla struttura per accedere ai servizi web del portale. */
  credentials?: InputMaybe<ChannelCredentialsInput>;
  name: Scalars['String'];
  percentage: Scalars['Float'];
  portalId: Scalars['ID'];
  propertyId: Scalars['ID'];
  propertyPortalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<State>;
  subPropertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type ChannelManagerEvent = {
  message?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  processed: Scalars['Boolean'];
  propertyId?: Maybe<Scalars['ID']>;
  reservationCode?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type ChannelManagerEventFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Entita che ci permette di aggiungere informazioni provenienti dai portali alla pagina di configurazione. */
export type ChannelOutput = {
  channel?: Maybe<Channel>;
  id: Scalars['ID'];
  /** Eventuali messaggi che vogliamo veicolare sul client */
  message?: Maybe<Scalars['String']>;
  /** onboardingUrl attivo solo se stato è draft, è utilizzabile solo AirBnb e Booking.com */
  onboardingUrl?: Maybe<Scalars['String']>;
  /** Indica lo stato dei dati di configurazione presenti nel portale.     Se true: tutti i dati sono stati letti con successo.     Se false: non è stato possibile leggere i dati del portale. */
  portalDataRetrieved: Scalars['Boolean'];
  portalOpportunities?: Maybe<Array<PortalOpportunity>>;
  /** Mapping Rate non più attivi */
  portalRatesNoLongerExist?: Maybe<Array<ChannelRateMapping>>;
  /** Tipologie */
  portalRatesNotMapped?: Maybe<Array<PortalRate>>;
  /** Id di rate mappate ma tariffe non più presenti sul portale */
  portalRatesWarn?: Maybe<Array<Scalars['ID']>>;
  /** Mapping Tipologie non più attivi */
  portalResourcesTypeNoLongerExist?: Maybe<Array<ChannelResourceTypeMapping>>;
  portalResourcesTypeNotMapped?: Maybe<Array<PortalResourceType>>;
  /** Id di tipologie mappate ma camere non più presenti sul portale */
  portalResourcesTypeWarn?: Maybe<Array<Scalars['ID']>>;
};

export type ChannelPropertyDataEventPayload = {
  propertyId: Scalars['ID'];
  rateIds: Array<Scalars['ID']>;
  resourceTypeIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type ChannelQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const ChannelQueueType = {
  HIGH: 'HIGH',
  NORMAL: 'NORMAL',
  RATE_LIMITED: 'RATE_LIMITED'
} as const;

export type ChannelQueueType = typeof ChannelQueueType[keyof typeof ChannelQueueType];
export type ChannelRateEventPayload = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  rateId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  stopSellRateEvent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

/** Tipo che ci permette di associare per ogni tariffa del pms la tariffa del portale, su ogni tariffa sono presenti le tipologie gestite. */
export type ChannelRateMapping = {
  /** Arrangiamento, possiamo decidere di non usare l'arrangiamento di default */
  chargeCategoryId?: Maybe<Scalars['ID']>;
  portalrate: PortalRate;
  rate?: Maybe<Rate>;
  rateId: Scalars['ID'];
};

export type ChannelRateMappingInput = {
  /** Arrangiamento, possiamo decidere di non usare l'arrangiamento di default */
  chargeCategoryId?: InputMaybe<Scalars['ID']>;
  portalrate: PortalRateInput;
  rateId: Scalars['ID'];
};

/** Tipo che contiene le prenotazioni scaricate dai channels */
export type ChannelReservation = {
  action: BookingAction;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['ID']>;
  expireAt: Scalars['DateTime'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  /**
   * Token per recuperare dal card-vault i dati della carta di pagamento, se presente:
   * se nella prenotazione sono presenti i dati di una carta, questa viene tokenizzata e i dati originali nella prenotazione vengono offuscati.
   */
  paymentCardToken?: Maybe<Scalars['String']>;
  portalName: PortalName;
  processed: Scalars['Boolean'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  receivedOn: Scalars['DateTime'];
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
  sourceJson: Scalars['JSON'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type ChannelReservationEventPayload = {
  action: BookingAction;
  channelReservationId: Scalars['String'];
};

/** Tipo che ci permette di associare le tipologie tra il portale e il gestionale */
export type ChannelResourceTypeMapping = {
  portalResourceType: PortalResourceType;
  resourceType?: Maybe<ResourceType>;
  resourceTypeId: Scalars['ID'];
};

export type ChannelResourceTypeMappingInput = {
  portalResourceType: PortalResourceTypeInput;
  resourceTypeId: Scalars['ID'];
};

export type ChannelSpecificAvailabilityEventPayload = {
  channelId: Scalars['ID'];
  end: Scalars['Date'];
  priority?: Maybe<ChannelQueueType>;
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  stopSellEvent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type ChannelSpecificPriceEventPayload = {
  channelId: Scalars['ID'];
  end: Scalars['Date'];
  priority?: Maybe<ChannelQueueType>;
  propertyId: Scalars['ID'];
  rateId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type ChannelSpecificPropertyDataEventPayload = {
  channelId: Scalars['ID'];
  priority?: Maybe<ChannelQueueType>;
  propertyId: Scalars['ID'];
  rateIds: Array<Scalars['ID']>;
  resourceTypeIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

/**
 * Entita base per gli addebiti, si porta dietro le informazioni base come l'iva di default se è un arrangiamento
 * Potrebbero essere tipi addebiti comuni al tenant
 */
export type ChargeCategory = {
  auditable: Auditable;
  breakfastIncluded: Scalars['Boolean'];
  cityTax: Scalars['Boolean'];
  /** Codice richiesto nel caso di addebiti di arrangiamento */
  code?: Maybe<ChargeCategoryBoard>;
  defaultVat: Vat;
  /** Il default Vat indica l'aliquota iva di default dell'addebito */
  defaultVatId: Scalars['ID'];
  dinnerIncluded: Scalars['Boolean'];
  id: Scalars['ID'];
  lunchIncluded: Scalars['Boolean'];
  /** Codice da utilizzare per le configurazioni di export */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId?: Maybe<Scalars['ID']>;
  /** Indica se la categoria è un arrangiamento */
  stayIncluded: Scalars['Boolean'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

/** Enumerativo dei codici di arrangiamento */
export const ChargeCategoryBoard = {
  BB: 'BB',
  FB: 'FB',
  HB: 'HB',
  RO: 'RO'
} as const;

export type ChargeCategoryBoard = typeof ChargeCategoryBoard[keyof typeof ChargeCategoryBoard];
export type ChargeCategoryInput = {
  breakfastIncluded: Scalars['Boolean'];
  cityTax: Scalars['Boolean'];
  code?: InputMaybe<ChargeCategoryBoard>;
  defaultVatId: Scalars['ID'];
  dinnerIncluded: Scalars['Boolean'];
  lunchIncluded: Scalars['Boolean'];
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId?: InputMaybe<Scalars['ID']>;
  stayIncluded: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type ChargeCategoryPrice = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  price: Scalars['Int'];
  range?: Maybe<Array<Range>>;
};

export type ChargeCategoryPriceInput = {
  chargeCategoryId: Scalars['ID'];
  price: Scalars['Int'];
  range?: InputMaybe<Array<RangeInput>>;
};

export type ChargeCategoryQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<IDFilter>;
  stayIncluded?: InputMaybe<Scalars['Boolean']>;
  tenantId: IDFilter;
};

export type ChargeCategoryTranscodeSource = {
  /** L'identificativo esterno del reparto. */
  externalDepartmentId: Scalars['String'];
  /** L'identificativo esterno della modalità di vendita. */
  externalSalesModeId?: Maybe<Scalars['String']>;
  /** L'identificativo del turno. Se non è presente, allora il turno è unico. */
  mealShiftId?: Maybe<Scalars['String']>;
};

export type ChargeConversion = {
  destinationChargeCategory: ChargeCategory;
  destinationChargeCategoryId: Scalars['ID'];
  resourceId?: Maybe<Scalars['ID']>;
  resourceTypeId?: Maybe<Scalars['ID']>;
  sourceChargeCategoryId: Scalars['ID'];
};

export type ChargeConversionInput = {
  destinationChargeCategoryId: Scalars['ID'];
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId?: InputMaybe<Scalars['ID']>;
  sourceChargeCategoryId: Scalars['ID'];
};

export type ChargeForReservationInput = {
  payment: PaymentInput;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ChargePartition = {
  chargeMappings: Array<ChargePartitionMapping>;
  rateId?: Maybe<Scalars['ID']>;
  residualChargeCategory: ChargeCategory;
  residualChargeCategoryId: Scalars['ID'];
  sourceChargeCategoryId: Scalars['ID'];
  validity?: Maybe<ClosedRange>;
};

export type ChargePartitionInput = {
  chargeMappings: Array<ChargePartitionMappingInput>;
  rateId?: InputMaybe<Scalars['ID']>;
  residualChargeCategoryId: Scalars['ID'];
  sourceChargeCategoryId: Scalars['ID'];
  validity?: InputMaybe<ClosedRangeInput>;
};

export type ChargePartitionMapping = {
  adults: Scalars['Boolean'];
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Boolean'];
  type: ValueType;
  value: Scalars['Int'];
};

export type ChargePartitionMappingInput = {
  adults: Scalars['Boolean'];
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Boolean'];
  type: ValueType;
  value: Scalars['Int'];
};

/**
 * Questa entità fornisce la varizioni di prezzo dall'arrangiamento base
 * L'importo si riferisce sempre a persona e a notte se specificato a persona, se il modello è derivato altrimenti
 * se statico non viene gestito il tipo di operazione ma viene usato il price come importo e gli importi per le altre occupazioni
 * Se derivato la variazione può essere positiva o negativa in base al servizio selezionato come base.
 * In caso in cui si imposta l'importo direttamente (Static Rate) si gestisce tutto in priceForDifferentOccupation, in questo caso
 * deve essere specificato anche la tipologia di camera
 */
export type ChargeRate = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  operation: MathOperation;
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i prezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: Maybe<Array<PriceOccupation>>;
  priceModel: PriceModel;
  resourceType?: Maybe<ResourceType>;
  resourceTypeId?: Maybe<Scalars['ID']>;
};

export type ChargeRateBaseInput = {
  chargeCategoryBoard: ChargeCategoryBoard;
  operation: MathOperation;
  price: Scalars['Int'];
};

export type ChargeRateInput = {
  chargeCategoryId: Scalars['ID'];
  operation: MathOperation;
  price: Scalars['Int'];
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  priceModel: PriceModel;
  resourceTypeId?: InputMaybe<Scalars['ID']>;
};

/** Entita per gestire gli scorpori e la riclassificazione degli addebiti */
export type ChargeTransformation = {
  auditable: Auditable;
  conversions: Array<ChargeConversion>;
  id: Scalars['ID'];
  partitions: Array<ChargePartition>;
  property: Property;
  propertyId: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type ChargeTransformationInput = {
  conversions: Array<ChargeConversionInput>;
  partitions: Array<ChargePartitionInput>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CheckinCheckoutReservedResourceInput = {
  guestOccupancyIds: Array<Scalars['ID']>;
  reservedResourceId: Scalars['ID'];
};

export type CheckinCheckoutReservedResourcesInput = {
  /** Nota: campo obbligatorio quando la chiamata avviene nel dominio di sicurezza 'GUEST_PORTAL'. */
  reservationId?: InputMaybe<Scalars['ID']>;
  reservedResources: Array<CheckinCheckoutReservedResourceInput>;
  tenantId: Scalars['ID'];
};

export const CheckoutDocumentGroupType = {
  ANALITIC: 'ANALITIC',
  DATE: 'DATE',
  DATE_BILL: 'DATE_BILL',
  TOTAL: 'TOTAL',
  TOTAL_BILL: 'TOTAL_BILL'
} as const;

export type CheckoutDocumentGroupType = typeof CheckoutDocumentGroupType[keyof typeof CheckoutDocumentGroupType];
/** CHECKOUT */
export type CheckoutDocumentInput = {
  billCheckout: Array<BillCheckoutInput>;
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  deposits: Array<DepositCheckoutInput>;
  draft: Scalars['Boolean'];
  fiscalType: FiscalType;
  groupBy?: InputMaybe<CheckoutDocumentGroupType>;
  note?: InputMaybe<Scalars['String']>;
  payments: Array<DocumentPaymentDetailInput>;
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

export type CheckoutReservedResourceOption = {
  keepResourceInHouse?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Per ogni property è possibile definire le tipologie dei ragazzi
 * Ad esempio Infant min = 0 e MAx 2, Child min 3 max 12 il resto si considera adulto.
 * In fase di onboarding vengono create di default 2 fasce di cui la infant non occupa posto
 */
export type Child = {
  auditable: Auditable;
  id: Scalars['ID'];
  maxAge: Scalars['Int'];
  minAge: Scalars['Int'];
  /** Proprietà che indica se il bambino è da considerarsi come occupante, se è true non occupa un posto letto. */
  noOccupancy: Scalars['Boolean'];
  /** Indica lo sconto base della fascia di età, varia da 0 a 1 */
  percentageDiscount: Scalars['Float'];
  propertyId?: Maybe<Scalars['ID']>;
  taxonomy: Taxonomy;
  taxonomyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Tipo che ci permette di sapere lo sconto applicare per ogni fascia */
export type ChildDiscountPercentage = {
  child: Child;
  childId: Scalars['ID'];
  percentage: Scalars['Float'];
};

/** Tipo che ci permette di sapere lo sconto applicare per ogni fascia (childID deve essere stringa vuota per creare un nuovo Child) */
export type ChildDiscountPercentageInput = {
  child?: InputMaybe<ChildRateInput>;
  childId: Scalars['ID'];
  percentage: Scalars['Float'];
};

export type ChildOccupancy = {
  child: Child;
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildOccupancyAvailabilityRequest = {
  child: Child;
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildOccupancyInput = {
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildOccupancyRQInput = {
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildQueryFilter = {
  id?: InputMaybe<IDFilter>;
  maxAge?: InputMaybe<IntFilter>;
  minAge?: InputMaybe<IntFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Tipo che permette di inserire/modificare un Child quando si gestisce una Rate BASE */
export type ChildRateInput = {
  maxAge: Scalars['Int'];
  minAge: Scalars['Int'];
  noOccupancy: Scalars['Boolean'];
  taxonomyId: Scalars['ID'];
};

export type ChildRule = {
  /** Eventuali sconti per fascia di età che vanno in ovveride agli sconti standard */
  childDiscount?: Maybe<Array<ChildDiscountPercentage>>;
  rule: ChildRuleType;
};

export type ChildRuleInput = {
  /** Eventuali sconti per fascia di età che vanno in ovveride agli sconti standard */
  childDiscount?: InputMaybe<Array<ChildDiscountPercentageInput>>;
  rule: ChildRuleType;
};

export const ChildRuleType = {
  INHERITANCE: 'INHERITANCE',
  NOTAPPLY: 'NOTAPPLY',
  OVERRIDE: 'OVERRIDE'
} as const;

export type ChildRuleType = typeof ChildRuleType[keyof typeof ChildRuleType];
/** Embedded Type per AdditionalService */
export type ChildServicePrice = {
  child: Child;
  childId: Scalars['ID'];
  price: Scalars['Int'];
};

export type ChildServicePriceInput = {
  childId: Scalars['ID'];
  price: Scalars['Int'];
};

export type CiaoAppOcrResponse = {
  /** City of birth */
  birth_city?: Maybe<Scalars['String']>;
  /** Birthplace, 3-letter country ISO code */
  birth_country_code?: Maybe<Scalars['String']>;
  /** Full country name */
  birth_country_name?: Maybe<Scalars['String']>;
  /** YYYY-MM-DD birth date */
  birth_date?: Maybe<Scalars['String']>;
  /** 1 - date has passed a syntactic check; 0 - date is probably incorrect */
  birth_date_check?: Maybe<Scalars['Int']>;
  /** Number given by the issuing authority */
  document_number?: Maybe<Scalars['String']>;
  /** 1 - info has passed a syntactic check; 0 - date is probably incorrect */
  document_number_check?: Maybe<Scalars['Int']>;
  /**
   * Document type code:
   * 0 - Not defined
   * 1 - Card-sized ID, back
   * 2 - Card-sized ID, front
   * 3 - Card-sized driver's license
   * 5 - Card-sized, unspecified
   * 6 - Passport
   * 7 - Italian paper ID, interior
   * 8 - Italian paper ID, exterior
   * 9 - Large document, unspecified
   */
  document_type?: Maybe<Scalars['Int']>;
  /** YYYY-MM-DD document expiration date */
  expiration_date?: Maybe<Scalars['String']>;
  /** 1 - date has passed a syntactic check; 0 - date is probably incorrect */
  expiration_date_check?: Maybe<Scalars['Int']>;
  /** 3-letter ISO country code */
  issuing_country_code?: Maybe<Scalars['String']>;
  /** Full country name */
  issuing_country_name?: Maybe<Scalars['String']>;
  /** Issuing municipality */
  issuing_municipality?: Maybe<Scalars['String']>;
  /** First (and middle) name(s) */
  name?: Maybe<Scalars['String']>;
  /** Citizenship, 3-letter country ISO code */
  nationality_code?: Maybe<Scalars['String']>;
  /** Full country name */
  nationality_name?: Maybe<Scalars['String']>;
  /** If success=0, human-readable description of the error */
  reason?: Maybe<Scalars['String']>;
  /** 1 - info has been read from the document; 0 - info is inferred */
  residence_country_check?: Maybe<Scalars['Int']>;
  /** Residence, 3-letter country ISO code */
  residence_country_code?: Maybe<Scalars['String']>;
  /** Full country name */
  residence_country_name?: Maybe<Scalars['String']>;
  /** Place of residence */
  residence_extended?: Maybe<Scalars['String']>;
  /** Residence municipality */
  residence_municipality?: Maybe<Scalars['String']>;
  /** 'F'/'M'/'U' (female, male, unknown) */
  sex?: Maybe<Scalars['String']>;
  /** 1 - Success; 0 - Error */
  success: Scalars['Int'];
  /** Last (family) name */
  surname?: Maybe<Scalars['String']>;
};

export type CityTaxAmountByPeriod = {
  amount: Scalars['Int'];
  period: Range;
};

export type CityTaxAmountByPeriodInput = {
  amount: Scalars['Int'];
  period: RangeInput;
};

/** CityTaxConfiguration embedded document */
export type CityTaxConfiguration = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  configurations: Array<CityTaxRuleConfiguration>;
};

export type CityTaxConfigurationInput = {
  amount: Scalars['Int'];
  amountByPeriod?: InputMaybe<Array<CityTaxAmountByPeriodInput>>;
  currency: Scalars['Currency'];
  fileGenerator?: InputMaybe<CityTaxFileGenerator>;
  genericConfiguration?: InputMaybe<CityTaxGenericConfigurationInput>;
  name: Scalars['String'];
  resourceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  rule: CityTaxRule;
};

export type CityTaxDocumentRange = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

/** Causali di esenzione CityTax */
export type CityTaxExoneration = {
  code: CityTaxExonerationCode;
  description: Scalars['LocalizedString'];
  discount?: Maybe<Scalars['Float']>;
  extCode?: Maybe<Scalars['String']>;
};

export const CityTaxExonerationCode = {
  ACINV74: 'ACINV74',
  ACPZRI: 'ACPZRI',
  AGECOMM: 'AGECOMM',
  AIRBNB: 'AIRBNB',
  AIRE: 'AIRE',
  ANZIANI: 'ANZIANI',
  ARTIACC: 'ARTIACC',
  ASSDEGENTI: 'ASSDEGENTI',
  ATLETI: 'ATLETI',
  AUTELE: 'AUTELE',
  AUTISTA: 'AUTISTA',
  AZPROD: 'AZPROD',
  CALAMITA: 'CALAMITA',
  CARDTURI: 'CARDTURI',
  CASERIPOSO: 'CASERIPOSO',
  COMROS: 'COMROS',
  CONTR_TO: 'CONTR_TO',
  CONVRFI: 'CONVRFI',
  CORDIPLEST: 'CORDIPLEST',
  COSSNA: 'COSSNA',
  COVID19: 'COVID19',
  DAYUSE: 'DAYUSE',
  DETNT: 'DETNT',
  DIPPUBMIS: 'DIPPUBMIS',
  DIPSTRUT: 'DIPSTRUT',
  DISABILI: 'DISABILI',
  DOCENTE: 'DOCENTE',
  EDUCATOUR: 'EDUCATOUR',
  ES12NOTTI: 'ES12NOTTI',
  ESENTEG7: 'ESENTEG7',
  ESGESTR: 'ESGESTR',
  ESMINSTRA: 'ESMINSTRA',
  ESPROINT: 'ESPROINT',
  ESVITRATTA: 'ESVITRATTA',
  ESVIVIODOM: 'ESVIVIODOM',
  ETAMAX: 'ETAMAX',
  ETAMIN: 'ETAMIN',
  FAPZR: 'FAPZR',
  FGLTRZ: 'FGLTRZ',
  FORZEORD: 'FORZEORD',
  GEMELTAO: 'GEMELTAO',
  GIORNALIST: 'GIORNALIST',
  GIORTAO: 'GIORTAO',
  GRATUITA: 'GRATUITA',
  GRPSCL: 'GRPSCL',
  GRPSPORT: 'GRPSPORT',
  GRUPPI: 'GRUPPI',
  GUIDA: 'GUIDA',
  INDACC: 'INDACC',
  INVAL74: 'INVAL74',
  LAV5NOTMAX: 'LAV5NOTMAX',
  LAVORATORE: 'LAVORATORE',
  LAVPUB: 'LAVPUB',
  MINA18: 'MINA18',
  MINGSP: 'MINGSP',
  MINORI: 'MINORI',
  MINOSP: 'MINOSP',
  MULTI: 'MULTI',
  NOCITYTAX: 'NOCITYTAX',
  NOTTIMAX: 'NOTTIMAX',
  NOTTIMAXCN: 'NOTTIMAXCN',
  NOTTIMAXCV: 'NOTTIMAXCV',
  NOTTIMAXUA: 'NOTTIMAXUA',
  OSPCASA: 'OSPCASA',
  OSPCOMUNE: 'OSPCOMUNE',
  OSPUAB: 'OSPUAB',
  P6090120: 'P6090120',
  PGKO: 'PGKO',
  PROIMM: 'PROIMM',
  PROIMU: 'PROIMU',
  R50GSCT: 'R50GSCT',
  RESIDENTE: 'RESIDENTE',
  RIABILITAZ: 'RIABILITAZ',
  RICERCA: 'RICERCA',
  RID30GR: 'RID30GR',
  RIFPOL: 'RIFPOL',
  RITARDI: 'RITARDI',
  SALUTE: 'SALUTE',
  SALUTE104: 'SALUTE104',
  SALUTEGEN: 'SALUTEGEN',
  SCOLARESC: 'SCOLARESC',
  SCONTOMIN: 'SCONTOMIN',
  SPOSI: 'SPOSI',
  STAGE: 'STAGE',
  STUDACC: 'STUDACC',
  STUDENTE: 'STUDENTE',
  TARFORFET: 'TARFORFET',
  TERAPIA: 'TERAPIA',
  TERMALI: 'TERMALI',
  TRADUTTORE: 'TRADUTTORE',
  VOLONTARI: 'VOLONTARI'
} as const;

export type CityTaxExonerationCode = typeof CityTaxExonerationCode[keyof typeof CityTaxExonerationCode];
export type CityTaxExonerationInput = {
  code: CityTaxExonerationCode;
  description: Scalars['LocalizedString'];
  discount?: InputMaybe<Scalars['Float']>;
  extCode?: InputMaybe<Scalars['String']>;
};

export type CityTaxExonerations = {
  code: CityTaxExonerationCode;
  guests: Array<Scalars['String']>;
  nights: Scalars['Int'];
};

export const CityTaxFileGenerator = {
  PROXIMA: 'PROXIMA',
  TBPRES01: 'TBPRES01'
} as const;

export type CityTaxFileGenerator = typeof CityTaxFileGenerator[keyof typeof CityTaxFileGenerator];
export type CityTaxGenericConfiguration = {
  amountType: ValueType;
  exonerations: Array<CityTaxExoneration>;
  maxNights: Scalars['Int'];
  minAge: Scalars['Int'];
  validity?: Maybe<CityTaxValidity>;
};

export type CityTaxGenericConfigurationInput = {
  amountType: ValueType;
  exonerations: Array<CityTaxExonerationInput>;
  maxNights: Scalars['Int'];
  minAge: Scalars['Int'];
  validity?: InputMaybe<CityTaxValidityInput>;
};

export type CityTaxMonthSummaryAstat = {
  /**
   * Is the month closed for local tax?
   * - true: the month is closed, no further changes to data of this month are allowed
   * - false: the month is open/prepared
   */
  isMonthClosed?: Maybe<Scalars['Boolean']>;
  /** Month */
  month: Scalars['Int'];
  /** A unique token that stands for the related month and associated local tax data */
  token: Scalars['String'];
  /** Total overnights of adults */
  totalTaxAdults: Scalars['Int'];
  /** Total overnights of children */
  totalTaxChilds: Scalars['Int'];
  /** Total overnights of people exempted for special reasons */
  totalTaxExempted: Scalars['Int'];
  /** Year */
  year: Scalars['Int'];
};

export type CityTaxRegulationRicestat = {
  municipalityCode: Scalars['String'];
  rules: Array<CityTaxRegulationRicestatRule>;
};

export type CityTaxRegulationRicestatRule = {
  cityTaxCode: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CityTaxReport = {
  creditNote?: Maybe<CityTaxReportDetail>;
  invoice?: Maybe<CityTaxReportDetail>;
  receipt?: Maybe<CityTaxReportDetail>;
};

export type CityTaxReportDetail = {
  amount: Scalars['Int'];
  currency: Scalars['Currency'];
  documents: CityTaxDocumentRange;
  exonerations: Array<CityTaxReportExoneration>;
  payingGuests: Scalars['Int'];
  payingNights: Scalars['Int'];
};

export type CityTaxReportExoneration = {
  guests: Scalars['Int'];
  nights: Scalars['Int'];
  type: CityTaxReportExonerationType;
};

export type CityTaxReportExonerationType = {
  code: CityTaxExonerationCode;
  description: Scalars['LocalizedString'];
};

export type CityTaxReportInput = {
  from: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  to: Scalars['Date'];
};

export const CityTaxRule = {
  BERGAMO: 'BERGAMO',
  CALENZANO: 'CALENZANO',
  FIUGGI: 'FIUGGI',
  GENERIC: 'GENERIC',
  ROMA: 'ROMA',
  ROMA_CAMPING: 'ROMA_CAMPING',
  SERRALUNGA_ALBA: 'SERRALUNGA_ALBA',
  SIRACUSA: 'SIRACUSA',
  VENEZIA: 'VENEZIA'
} as const;

export type CityTaxRule = typeof CityTaxRule[keyof typeof CityTaxRule];
export type CityTaxRuleConfiguration = {
  amount: Scalars['Int'];
  amountByPeriod?: Maybe<Array<CityTaxAmountByPeriod>>;
  currency: Scalars['Currency'];
  fileGenerator?: Maybe<CityTaxFileGenerator>;
  genericConfiguration?: Maybe<CityTaxGenericConfiguration>;
  name: Scalars['String'];
  resourceIds?: Maybe<Array<Scalars['ID']>>;
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  rule: CityTaxRule;
};

export type CityTaxRulesOutput = {
  match: Scalars['Boolean'];
  rules: Array<CityTaxRule>;
};

export type CityTaxStatistics = {
  amount: Scalars['Int'];
  exonerations: Array<CityTaxExonerations>;
  payingGuests: Array<Scalars['String']>;
  payingNights: Scalars['Int'];
};

export type CityTaxValidity = {
  /**  mmDD format  */
  end: Scalars['String'];
  /**  mmDD format  */
  start: Scalars['String'];
};

export type CityTaxValidityInput = {
  /**  mmDD format  */
  end: Scalars['String'];
  /**  mmDD format  */
  start: Scalars['String'];
};

export const CleaningState = {
  CLEAN: 'CLEAN',
  DIRTY: 'DIRTY'
} as const;

export type CleaningState = typeof CleaningState[keyof typeof CleaningState];
export type CloseCityTaxMonthAstatInput = {
  month: Scalars['Int'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  token: Scalars['String'];
  year: Scalars['Int'];
};

export type CloseCityTaxMonthAstatResult = {
  /** Url for downloading the pagoPA payment slip */
  paymentPdfUrl: Scalars['String'];
};

export type ClosedRange = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};

export type ClosedRangeInput = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};

/** Tipo company serve per gestire le specificità delle aziende */
export type Company = {
  defaultCredit?: Maybe<CreditType>;
  felOptions?: Maybe<CompanyFelOptions>;
  physicalPerson: Scalars['Boolean'];
  sdiCode?: Maybe<Scalars['String']>;
  splitPayment: Scalars['Boolean'];
};

export type CompanyFelOptions = {
  /** se true riporta il voucher della prenotazione sul campo 2.2.1.15 (RiferimentoAmministrazione) */
  riferimentoAmministrazione?: Maybe<Scalars['Boolean']>;
};

export type CompanyFelOptionsInput = {
  /** se true riporta il voucher della prenotazione sul campo 2.2.1.15 (RiferimentoAmministrazione) */
  riferimentoAmministrazione?: InputMaybe<Scalars['Boolean']>;
};

export type CompanyInfoForPrivacyOutput = {
  address?: Maybe<Scalars['String']>;
  fiscalCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type CompanyInput = {
  defaultCredit?: InputMaybe<CreditType>;
  felOptions?: InputMaybe<CompanyFelOptionsInput>;
  physicalPerson: Scalars['Boolean'];
  sdiCode?: InputMaybe<Scalars['String']>;
  splitPayment: Scalars['Boolean'];
};

export type ConfigMappingQueryFilter = {
  portalId: IDFilter;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export type ConfirmQuotationInput = {
  additionalNote?: InputMaybe<NoteInput>;
  company?: InputMaybe<CustomerInput>;
  customer?: InputMaybe<CustomerInput>;
  overbooking: OvbResolveType;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userAddedResourceLayouts?: InputMaybe<Array<UserAddedResourceLayoutInput>>;
  userAddedServices?: InputMaybe<Array<UserAddedService>>;
};

/**
 * Tipo che contiene le informazioni che non devono mutare all'interno del documento e che permettono una nuova stampa o gestione che non varia nel tempo
 * Il layout è da consolidare come tipo
 */
export type ConsolidatedData = {
  cityTaxStatistics?: Maybe<CityTaxStatistics>;
  customer: Customer;
  /** TBD da definire coem gestirlo */
  layout: Scalars['String'];
};

/** Entità per la gestione dei contatori (prenotazioni, documenti, ...) */
export type Counter = {
  auditable: Auditable;
  documentActiveId?: Maybe<Scalars['ID']>;
  /** Codifica del numeratore con placeholders: {{value}}, {{value:x}}, {{year}}, {{year_2}} */
  format: Scalars['String'];
  id: Scalars['ID'];
  propertyId?: Maybe<Scalars['ID']>;
  /** Impostare a true Se il numeratore deve essere resettato al cambio anno. */
  reset: Scalars['Boolean'];
  /**  subType e documentActiveId sono valorizzati solo se il type è DOCUMENT  */
  subType?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  type: CounterType;
  value: Scalars['Int'];
  year: Scalars['Int'];
};

export type CounterResult = {
  code: Scalars['String'];
  value: Scalars['Int'];
};

/** Tipologie di contatori per i progressivi */
export const CounterType = {
  CUSTOMER: 'CUSTOMER',
  DOCUMENT: 'DOCUMENT',
  ELECTRONIC_INVOICE: 'ELECTRONIC_INVOICE',
  GDPRLOG: 'GDPRLOG',
  QUOTATION: 'QUOTATION',
  RESERVATION: 'RESERVATION'
} as const;

export type CounterType = typeof CounterType[keyof typeof CounterType];
/** Nazioni con codici ISO necessari per le integrazioni */
export type Country = {
  auditable: Auditable;
  codeItalianPs: Scalars['String'];
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  isoCode3: Scalars['String'];
  istat: Scalars['String'];
  name: Scalars['LocalizedString'];
};

export type CountryInput = {
  codeItalianPs: Scalars['String'];
  isoCode: Scalars['String'];
  isoCode3: Scalars['String'];
  istat: Scalars['String'];
  name: Scalars['LocalizedString'];
};

export type CountryQueryFilter = {
  id?: InputMaybe<IDFilter>;
  isoCode?: InputMaybe<StringFilter>;
  isoCode3?: InputMaybe<StringFilter>;
  name?: InputMaybe<LocalizedStringFilter>;
};

export type CreateCounterInput = {
  documentActiveId?: InputMaybe<Scalars['String']>;
  format: Scalars['String'];
  propertyId?: InputMaybe<Scalars['ID']>;
  reset: Scalars['Boolean'];
  subType?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  type: CounterType;
  value: Scalars['Int'];
  year: Scalars['Int'];
};

export type CreateCountersForPropertyInput = {
  propertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  year: Scalars['Int'];
};

export type CreateResourceUnavailabilityInput = {
  resourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailability: ResourceUnavailabilityInput;
};

/** CREDIT NOTE */
export type CreditNoteDocumentInput = {
  /** id of the document to revert */
  documentId: Scalars['ID'];
  paymentActiveId?: InputMaybe<Scalars['ID']>;
  /** Used to partial revert document */
  productionsToRevert?: InputMaybe<Array<ProductionToRevertInput>>;
  reverseProduction: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type CreditNoteForAdvanceInput = {
  /** id of the document to revert */
  documentId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const CreditType = {
  FC: 'FC',
  FCT: 'FCT',
  HC: 'HC',
  HCT: 'HCT',
  NC: 'NC'
} as const;

export type CreditType = typeof CreditType[keyof typeof CreditType];
/**
 * Tipo di logica daapplicare al motore di tariffe, se l'offerta non copre tutto il periodo richiesto il sistema deve decidere in base a questo valore
 * Nocross indica al sistema che l'offerta non ha termini di applicabilità diversi da quelli impostati, estendi indica che l'importo viene esteso anche agli altri giorni,
 * ma non viene applicato lo sconto
 */
export const CrossSell = {
  EXTEND: 'EXTEND',
  NOCROSS: 'NOCROSS'
} as const;

export type CrossSell = typeof CrossSell[keyof typeof CrossSell];
/** Enum usato negli eventi */
export const CrudOperation = {
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE'
} as const;

export type CrudOperation = typeof CrudOperation[keyof typeof CrudOperation];
/**
 * Il Customer può essere una persona o un'azienda, l'azienda puà essere una società
 * In caso di persona il nome completo deve essere inserito in name mettendo prima il cognome e poi il nome.
 */
export type Customer = {
  address?: Maybe<Address>;
  auditable: Auditable;
  cityTax?: Maybe<CustomerCityTax>;
  /** In caso di tipo company ci sono i dati specifici. */
  company?: Maybe<Company>;
  /** Indica il Cliente fittizio, è presente un solo customer dummy per tenant */
  dummyCustomer?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['CapitalizedString']>;
  fiscalCode?: Maybe<Scalars['UppercaseString']>;
  id: Scalars['ID'];
  language: Scalars['Language'];
  lastName?: Maybe<Scalars['CapitalizedString']>;
  mailContacts?: Maybe<Array<MailContact>>;
  /** Codice da utilizzare per le configurazioni di export */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['CapitalizedString'];
  /** In caso di tipo Persona ci sono i dati specifici. */
  person?: Maybe<Person>;
  phoneContacts?: Maybe<Array<PhoneContact>>;
  privacy?: Maybe<Privacy>;
  relatedCompany?: Maybe<Customer>;
  /**  Azienda collegata ad un cliente  */
  relatedCompanyId?: Maybe<Scalars['ID']>;
  /**  vatId to use for stay production  */
  stayVatId?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Tag>>;
  tagsId?: Maybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  type: CustomerType;
  vatNumber?: Maybe<Scalars['UppercaseString']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type CustomerAvailabilityRequest = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Scalars['Language'];
  lastName: Scalars['String'];
  privacy: Privacy;
};

export type CustomerAvailabilityRequestInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Scalars['Language'];
  lastName: Scalars['String'];
  privacy: PrivacyInput;
};

export type CustomerCityTax = {
  contracts?: Maybe<Array<Range>>;
  exoneration?: Maybe<CityTaxExonerationCode>;
};

export type CustomerCityTaxInput = {
  contracts?: InputMaybe<Array<RangeInput>>;
  exoneration?: InputMaybe<CityTaxExonerationCode>;
};

/**
 * Entità che contiene una immagine collegata a un ospite (esempio: documento di identità, firma, ecc.).
 * Le immagini vengono cancellate da una procedura dopo 10gg da checkoutDate.
 * NB: a parità di customer, possono esistere altre immagini per eventuali altre facciate dello stesso documento.
 */
export type CustomerDocumentImage = {
  /** Data di checkout dell'ospite (serve per la successiva cancellazione dell'immagine, dopo 10 giorni). */
  checkoutDate: Scalars['Date'];
  /** Id del Customer a cui appartiene il documento. */
  customerId: Scalars['ID'];
  /** Descrizione dell'immagine (esempio: Carta d'identità - fronte, Carta d'identità - retro, firma, ecc.). */
  description: Scalars['String'];
  file: File;
  /** Id dell'entità File contenente i dettagli dell'immagine. */
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  reservedResource: ReservedResource;
  /** Id della ReservedResource a cui è associato il documento. */
  reservedResourceId: Scalars['ID'];
  /** La tipologia di immagine. */
  type: CustomerDocumentImageType;
};

export type CustomerDocumentImageQueryFilter = {
  customerId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** La tipologia di immagine collegata a un ospite. */
export const CustomerDocumentImageType = {
  IDENTIFICATION_DOCUMENT: 'IDENTIFICATION_DOCUMENT',
  SELFIE: 'SELFIE',
  SIGNATURE: 'SIGNATURE'
} as const;

export type CustomerDocumentImageType = typeof CustomerDocumentImageType[keyof typeof CustomerDocumentImageType];
/** IMAGES */
export type CustomerGuestInput = {
  /** Non valorizzare se ospite italiano */
  birthCity?: InputMaybe<Scalars['String']>;
  birthCountryId: Scalars['ID'];
  birthDate: Scalars['Date'];
  /** Non valorizzare se ospite straniero */
  birthMunicipalityId?: InputMaybe<Scalars['ID']>;
  /** Non valorizzare se ospite italiano */
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  gender: GenderType;
  identificationDocument?: InputMaybe<CustomerIdentificationDocumentInput>;
  language: Scalars['Language'];
  lastName?: InputMaybe<Scalars['String']>;
  /** Non valorizzare se ospite straniero */
  municipalityId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  /** Cittadinanza */
  nationalityId?: InputMaybe<Scalars['ID']>;
  privacy?: InputMaybe<CustomerPrivacyInfo>;
  selfieImage?: InputMaybe<CustomerImage>;
  type: GuestType;
};

export type CustomerIdentificationDocumentInput = {
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  documentTypeId: Scalars['ID'];
  expirationDate: Scalars['Date'];
  images?: InputMaybe<Array<CustomerImage>>;
  number: Scalars['String'];
  releasedBy?: InputMaybe<Scalars['String']>;
};

export type CustomerImage = {
  /** Descrizione dell'immagine. */
  description: Scalars['String'];
  /** Id dell'entità File contenente i dettagli dell'immagine. */
  fileId: Scalars['ID'];
};

export type CustomerInput = {
  address?: InputMaybe<AddressInput>;
  cityTax?: InputMaybe<CustomerCityTaxInput>;
  company?: InputMaybe<CompanyInput>;
  firstName?: InputMaybe<Scalars['String']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  language: Scalars['Language'];
  lastName?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  person?: InputMaybe<PersonInput>;
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  privacy?: InputMaybe<PrivacyInput>;
  relatedCompanyId?: InputMaybe<Scalars['ID']>;
  stayVatId?: InputMaybe<Scalars['ID']>;
  tagsId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  type: CustomerType;
  vatNumber?: InputMaybe<Scalars['String']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export type CustomerPrivacyInfo = {
  dataThirdPartyConsent?: InputMaybe<Scalars['Boolean']>;
  managementConsent: Scalars['Boolean'];
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  profiledMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  signature: CustomerImage;
};

export type CustomerPrivacyInput = {
  checkoutDate: Scalars['Date'];
  customerId: Scalars['ID'];
  privacy: CustomerPrivacyInfo;
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CustomerQueryFilter = {
  dummy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IDFilter>;
  search?: InputMaybe<StringFilter>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: IDFilter;
  type?: InputMaybe<CustomerType>;
};

/** Use just one key per array element */
export type CustomerSortInput = {
  fiscalCode?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  person?: InputMaybe<PersonSortInput>;
  type?: InputMaybe<Sort>;
  vatNumber?: InputMaybe<Sort>;
};

export const CustomerType = {
  COMPANY: 'COMPANY',
  PERSON: 'PERSON'
} as const;

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];
/** Definizione giornaliera della disponibilità, l'availability è la disponibilità reale della tipololgia, onlineLimit è quella on line. */
export type DailyAvailability = {
  auditable: Auditable;
  availability: Scalars['Int'];
  day: Scalars['Date'];
  id: Scalars['ID'];
  inventory: Scalars['Int'];
  onlineAvailability: Scalars['Int'];
  onlineInventory?: Maybe<Scalars['Int']>;
  onlineLimit?: Maybe<Scalars['Int']>;
  portalVariations?: Maybe<Array<PortalVariation>>;
  property: Property;
  propertyId: Scalars['ID'];
  reservedResources: Array<ReservedResource>;
  reservedResourcesId: Array<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  resources: Array<ResourceCommitment>;
  shadowCommitments?: Maybe<Array<ShadowCommitment>>;
  stopSellOTA: Scalars['Boolean'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type DailyAvailabilityQueryFilter = {
  dateRange?: InputMaybe<ClosedRangeInput>;
  propertyId?: InputMaybe<IDFilter>;
  resourceTypeId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Rate Query Embedded Type */
export type DailyAvailabilityRq = {
  availability: Scalars['Int'];
  day: Scalars['Date'];
};

/** Configurazione delle procedure di chiusura notturna per Property */
export type DailyClosure = {
  auditable: Auditable;
  id: Scalars['ID'];
  /** procedures with order less than 100 are executed under transaction */
  order: Scalars['Int'];
  procedureName: DailyClosureProcedure;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Log delle procedure di chiusura notturna */
export type DailyClosureAudit = {
  /** Nome della eventuale configurazione della procedura. */
  configurationName?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  executedBy: Scalars['String'];
  executionDate: Scalars['DateTime'];
  /** Gli identificativi di eventuali file scaricati e/o generati dalla procedura. */
  fileIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  manualExecution: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  procedureName: DailyClosureProcedure;
  propertyId: Scalars['ID'];
  referenceDate: Scalars['DateTime'];
  result: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type DailyClosureAuditQueryFilter = {
  executionDate?: InputMaybe<DateFilter>;
  procedureName?: InputMaybe<DailyClosureProcedure>;
  propertyId: IDFilter;
  referenceDate?: InputMaybe<DateFilter>;
  result?: InputMaybe<Scalars['Boolean']>;
  tenantId: IDFilter;
};

export type DailyClosureAuditSortInput = {
  executionDate?: InputMaybe<Sort>;
  result?: InputMaybe<Sort>;
};

export type DailyClosureCommandPayload = {
  messageGroupId: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: DailyClosureCommandType;
};

export const DailyClosureCommandType = {
  DAILY_CLOSURE: 'DAILY_CLOSURE',
  SEND_PS: 'SEND_PS'
} as const;

export type DailyClosureCommandType = typeof DailyClosureCommandType[keyof typeof DailyClosureCommandType];
export type DailyClosureConfiguration = {
  automatic: Scalars['Boolean'];
  time: Scalars['Time'];
};

export type DailyClosureConfigurationInput = {
  automatic: Scalars['Boolean'];
  time: Scalars['Time'];
};

export type DailyClosureEvent = {
  errors?: Maybe<Array<Scalars['String']>>;
  procedureNames?: Maybe<Array<DailyClosureProcedure>>;
  propertyId: Scalars['ID'];
  result: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type DailyClosureEventFilter = {
  procedureName?: InputMaybe<DailyClosureProcedure>;
  propertyId: Scalars['ID'];
  result?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

/** Procedure che possono essere lanciate durante la chiusura giornaliera */
export const DailyClosureProcedure = {
  AssignIncomingResource: 'AssignIncomingResource',
  ChangeDate: 'ChangeDate',
  CreateDailyAvailabilitySnapshot: 'CreateDailyAvailabilitySnapshot',
  ExpiredQuotations: 'ExpiredQuotations',
  ExtendDailyAvailability: 'ExtendDailyAvailability',
  GetReceiptPS: 'GetReceiptPS',
  PSLongStay: 'PSLongStay',
  ResourceCleaningState: 'ResourceCleaningState',
  SendIstat: 'SendIstat',
  SendPS: 'SendPS',
  VerifyAndReOpenCashDesks: 'VerifyAndReOpenCashDesks'
} as const;

export type DailyClosureProcedure = typeof DailyClosureProcedure[keyof typeof DailyClosureProcedure];
/** Istantanea della disponibilità per il pickup */
export type DailyForecastSnapshot = {
  currency: Scalars['Currency'];
  days: Array<DayForecastSnapshot>;
  hotelDate: Scalars['Date'];
  hotelDateHistory?: Maybe<DayForecastSnapshot>;
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  year: Scalars['Int'];
};

export type DailyForecastSnapshotQueryFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DailyForecastSnapshotSortInput = {
  hotelDate?: InputMaybe<Sort>;
};

export type DailyPrice = {
  chargeCategoryId: Scalars['ID'];
  day: Scalars['Date'];
  price: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

/** Rate Query Embedded Type */
export type DailyPriceRq = {
  day: Scalars['Date'];
  price: Scalars['Int'];
  restriction?: Maybe<RateRestriction>;
};

/**
 * Entità che mantiene giornalmente i dati delle tariffe:
 * per ogni giorno e tariffa contiene la lista dei prezzi modificati
 */
export type DailyRate = {
  auditable: Auditable;
  bookingPolicy?: Maybe<BookingPolicy>;
  /** E' possibile avere una gestione giornaliera della policy */
  bookingPolicyId?: Maybe<Scalars['ID']>;
  chargesRate?: Maybe<Array<ResourceChargeRate>>;
  closeChargesCategories?: Maybe<Array<ChargeCategory>>;
  /** Arrangiamenti chiusi rispetto alla tariffa, ad esempio in inverno non c'è il ristorante o è chiuso per problemi */
  closeChargesCategoryId?: Maybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  day: Scalars['Date'];
  id: Scalars['ID'];
  property: Property;
  propertyId: Scalars['ID'];
  rate: Rate;
  /** Tariffa a cui si applicano le modifiche */
  rateId: Scalars['ID'];
  stopSellResourcesType?: Maybe<Array<ResourceType>>;
  /** Risorse bloccate alla vendita sul giorno, vanno in ovveride alla tariffa */
  stopSellResourcesTypeId?: Maybe<Array<Scalars['ID']>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type DashBoardRefreshEvent = {
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DashboardEventRow = {
  /** The data related to the event. */
  data?: Maybe<Array<Scalars['String']>>;
  /** The date and time when the event occurred. */
  occurred: Scalars['DateTime'];
};

export type DashboardKpiRow = {
  /** The current number counted up to now. */
  current: Scalars['Int'];
  /** Additional data. */
  moreData?: Maybe<Array<Scalars['Int']>>;
  /** The expected total number for today. */
  total?: Maybe<Scalars['Int']>;
};

export type DashboardMealsQueryOutput = {
  /** The breakfasts. */
  breakfasts: DashboardKpiRow;
  /** The dinners. */
  dinners: DashboardKpiRow;
  /** The lunches. */
  lunches: DashboardKpiRow;
};

export type DashboardMealsReportChild = {
  maxAge: Scalars['Int'];
  minAge: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type DashboardMealsReportDataRow = {
  arrangement: Scalars['String'];
  breakfast: Scalars['Int'];
  checkoutDate: Scalars['String'];
  dinner: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  guest: Scalars['String'];
  guestOccupancy: Array<GuestOccupancyDetail>;
  lunch: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  pax: DashboardMealsReportPax;
  paxCount: Scalars['Int'];
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  room: Scalars['String'];
};

export type DashboardMealsReportPax = {
  adults: Scalars['Int'];
  children?: Maybe<Array<DashboardMealsReportChild>>;
};

export type DashboardQueryFilter = {
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DashboardReceptionQueryOutput = {
  /** The resources with guests who are arriving, where: moreData[0] is 'current persons arrived up to now'; moreData[1] is 'expected persons to arrive today'; moreData[2] is 'resources with not shown persons (when the requested day is HotelDate)'; moreData[3] is 'not shown persons (when the requested day is HotelDate)'. */
  arrivals: DashboardKpiRow;
  /** The resources availability. */
  availability: DashboardKpiRow;
  /** The resources with guests who are leaving, where: moreData[0] is 'current persons left up to now'; moreData[1] is 'expected persons to leave today'. */
  departures: DashboardKpiRow;
  /** The resources occupancy, where: moreData[0] is 'resources unavailability'. */
  occupancy: DashboardKpiRow;
};

export type DashboardRevenueQueryOutput = {
  /** The Average Daily Rate (ADR). */
  adr: DashboardKpiRow;
  /** The Revenue Per Available Room (RevPAR). */
  revpar: DashboardKpiRow;
  /** The room production. */
  roomProduction: DashboardKpiRow;
  /** The total production. */
  totalProduction: DashboardKpiRow;
};

export type DashboardSellsQueryOutput = {
  /** The number of cancellations, where: total is 'total production generated by the reservations'. */
  cancellations: DashboardKpiRow;
  /** The last cancellation, where: data[0] is 'reservation number'; data[1] is 'arrival date'; data[2] is 'reservation amount'; data[3] is 'name of the person who had booked'. */
  lastCancellation?: Maybe<DashboardEventRow>;
  /** The last reservation, where: data[0] is 'reservation number'; data[1] is 'arrival date'; data[2] is 'reservation amount'; data[3] is 'name of the person who has booked'. */
  lastReservation?: Maybe<DashboardEventRow>;
  /** The number of reservations, where: total is 'the total production generated by the reservations'. */
  reservations: DashboardKpiRow;
};

export type DatabaseAttachState = {
  info?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Int']>;
  state: Scalars['String'];
};

export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
};

export type DatiDocumentiCorrelati = {
  codiceCIG?: Maybe<Scalars['String']>;
  codiceCUP?: Maybe<Scalars['String']>;
  commessa?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Date']>;
  idDocumento?: Maybe<Scalars['String']>;
};

export type DatiDocumentiCorrelatiInput = {
  codiceCIG?: InputMaybe<Scalars['String']>;
  codiceCUP?: InputMaybe<Scalars['String']>;
  commessa?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Date']>;
  idDocumento?: InputMaybe<Scalars['String']>;
};

export type DayForecastSnapshot = {
  day: Scalars['Date'];
  distributions: Array<ForecastDistribution>;
  /** Sum of inventory of all resource types. */
  inventory: Scalars['Int'];
  /** Sum of availability of all resource types. */
  occupancy: Scalars['Int'];
  resourceTypeHistory: Array<ForecastResourceType>;
  roomProduction: ProductionAmount;
  shadowCommitments?: Maybe<Scalars['Int']>;
  totalProduction: ProductionAmount;
  /** Sum of all unavailability */
  unavailability: Scalars['Int'];
};

export type DeleteResourceUnavailabilityInput = {
  resourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailabilityId: Scalars['ID'];
};

/**
 * Entità che ci permette di associare i documenti di deposito con i conti
 * Il conto non è obbligatorio. Amount è sempre positivo.
 * Se non esiste documentId la quota di deposito è disponibile
 * Se esiste documentId la quota di deposito è stata utilizzata
 * La quota disponibile di un depositDocument è la somma di amount dei record con depositDocumentId richiesto e documentId a null
 * La quota utilizzata di un depositDocument è la somma di amount dei record con depositDocumentId richiesto e documentId valorizzato
 */
export type DepositAssigned = {
  amount: Scalars['Int'];
  auditable: Auditable;
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  depositDocument: Document;
  depositDocumentId: Scalars['ID'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
  reservedResource?: Maybe<ReservedResource>;
  reservedResourceId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type DepositAssignment = {
  amount: Scalars['Int'];
  billId?: Maybe<Scalars['ID']>;
  reservationId?: Maybe<Scalars['ID']>;
  reservedResourceId?: Maybe<Scalars['ID']>;
};

export type DepositAssignmentInput = {
  amount: Scalars['Int'];
  billId?: InputMaybe<Scalars['ID']>;
  reservationId?: InputMaybe<Scalars['ID']>;
  reservedResourceId?: InputMaybe<Scalars['ID']>;
};

export type DepositCheckoutInput = {
  amount: Scalars['Int'];
  depositAssignedId: Scalars['ID'];
};

/** DEPOSIT */
export type DepositDocumentInput = {
  amount: Scalars['Int'];
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  depositAssignments: Array<DepositAssignmentInput>;
  draft: Scalars['Boolean'];
  fiscalType: FiscalType;
  note?: InputMaybe<Scalars['String']>;
  payments: Array<DocumentPaymentDetailInput>;
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  vatId?: InputMaybe<Scalars['ID']>;
};

export type DepositDocumentQueryFilter = {
  billId?: InputMaybe<Scalars['ID']>;
  reservationId?: InputMaybe<Scalars['ID']>;
  tenantId: IDFilter;
};

/** Le regole di derivazione si applicano ad importo passato e vengono elaborate seguendo l'order */
export type DerivationPriceRules = {
  operation: MathOperation;
  order: Scalars['Int'];
  round: Scalars['Boolean'];
  type: ValueType;
  value: Scalars['Float'];
};

/** Tipo che definisce la variazione di prezzo in percentuale rispetto alla base, può sommare o diminuire. */
export type DerivationRules = {
  operation: MathOperation;
  value: Scalars['Float'];
};

/** Tipo che definisce la variazione di prezzo in percentuale rispetto alla base, può sommare o diminuire. */
export type DerivationRulesInput = {
  operation: MathOperation;
  value: Scalars['Float'];
};

/** Questo tipo serve all'interno delle rate per collegare gli addebiti che ereditano dal base i dati e hanno soltanto delle logiche di derivaioni prezzi */
export type DerivedCharge = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  priceRules?: Maybe<Array<DerivationPriceRules>>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type DescriptionRow = {
  description?: Maybe<Scalars['String']>;
  imageFirst?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Tipo che contiene le possibili entità che sono collegate al dettaglio */
export type DetailNature = {
  accountantCategory?: Maybe<AccountantCategory>;
  accountantCategoryId?: Maybe<Scalars['ID']>;
  chargeCategory?: Maybe<ChargeCategory>;
  chargeCategoryId?: Maybe<Scalars['ID']>;
};

export type DetailNatureInput = {
  accountantCategoryId?: InputMaybe<Scalars['ID']>;
  chargeCategoryId?: InputMaybe<Scalars['ID']>;
};

/** Il tipo dictionary è una */
export type Dictionary = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Il tipo dictionarySecrect è un dictionary che la particolarità di avere il valore criptato */
export type DictionarySecrect = {
  key: Scalars['String'];
  value: Scalars['EncryptedString'];
};

/** L'entità documento rappresenta tutti i possibili tipi di documenti che possono essere gestiti in HIC */
export type Document = {
  auditable: Auditable;
  bills?: Maybe<Array<Bill>>;
  cashDesk: CashDesk;
  cashDeskId: Scalars['ID'];
  cashDeskType: CashDeskType;
  cashDeskTypeId: Scalars['ID'];
  consolidatedData?: Maybe<ConsolidatedData>;
  creditNote?: Maybe<Document>;
  creditNoteId?: Maybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  customer: Customer;
  customerId: Scalars['ID'];
  depositAssigneds?: Maybe<Array<DepositAssigned>>;
  depositAssignments?: Maybe<Array<DepositAssignment>>;
  documentDate: Scalars['Date'];
  documentDetails: Array<DocumentDetail>;
  documentPaymentDetails: Array<DocumentPaymentDetail>;
  documentSetCode?: Maybe<Scalars['String']>;
  documentType: DocumentType;
  documentVatDetails: Array<DocumentVatDetail>;
  exportInfo?: Maybe<ExportInfo>;
  felAdditionalInfo?: Maybe<FelAdditionalInfo>;
  fiscalType: FiscalType;
  id: Scalars['ID'];
  /** Eventuali dati extra aggiunti dalla procedura di importazione quando il documento proviene da un altro PMS. */
  importInfo?: Maybe<DocumentImportInfo>;
  netAmount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  numberExtended: Scalars['String'];
  property: Property;
  propertyId: Scalars['ID'];
  referenceDocument?: Maybe<Document>;
  /** Campo calcolato in caso di documentType ADVANCE */
  residualAmount?: Maybe<Scalars['Int']>;
  scelAdditionalInfo?: Maybe<ScelAdditionalInfo>;
  splitPayment: Scalars['Boolean'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
  totalAmount: Scalars['Int'];
  unpaidAmount: Scalars['Int'];
  vatAmount: Scalars['Int'];
};

/**
 * Tipi documenti attivi per la property o per le subproperty.
 * Per ogni tipologia di documento è possibile definire una serie.
 * Non è possibile avere lo stesso tipo documento attivo senza una serie.
 */
export type DocumentActive = {
  auditable: Auditable;
  counters?: Maybe<Array<Counter>>;
  documentSetCode?: Maybe<Scalars['String']>;
  fiscalType: FiscalType;
  id: Scalars['ID'];
  managementCode?: Maybe<Scalars['String']>;
  property: Property;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DocumentActiveInput = {
  documentNumberFormat?: InputMaybe<Scalars['String']>;
  documentSetCode?: InputMaybe<Scalars['String']>;
  fiscalType: FiscalType;
  managementCode?: InputMaybe<Scalars['String']>;
  nextDocumentNumber?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DocumentCounterInput = {
  documentActiveId?: InputMaybe<Scalars['String']>;
  documentSetCode?: InputMaybe<Scalars['String']>;
  fiscalType?: InputMaybe<FiscalType>;
  format?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  tenantId: Scalars['String'];
  value?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};

/** EVENTS */
export type DocumentCreatedEvent = {
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  sendReceiptByMail?: Maybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

/** Tipo che identifica le righe */
export type DocumentDetail = {
  amount: Scalars['Int'];
  bill?: Maybe<Bill>;
  /** Valorizzato solo nel caso di addebiti raggruppati per conto */
  billId?: Maybe<Scalars['ID']>;
  date: Scalars['Date'];
  /** Valorizzato solo nel caso di addebiti raggruppati per periodo */
  dateTo?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  quantity: Scalars['Int'];
  reference: DetailNature;
  referenceDocument?: Maybe<Document>;
  /** Indica il documento di riferimento, può essere una caparra/anticipo/sospeso */
  referenceDocumentId?: Maybe<Scalars['ID']>;
  totalAmount: Scalars['Int'];
  vat?: Maybe<Vat>;
  vatId?: Maybe<Scalars['ID']>;
};

export type DocumentDetailInput = {
  amount: Scalars['Int'];
  billId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  description: Scalars['String'];
  quantity: Scalars['Int'];
  reference: DetailNatureInput;
  referenceDocumentId?: InputMaybe<Scalars['ID']>;
  vatId?: InputMaybe<Scalars['ID']>;
};

export type DocumentExportedEvent = {
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numberExtended: Scalars['String'];
  propertyId: Scalars['ID'];
  success: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type DocumentExportedEventFilter = {
  propertyId: Scalars['ID'];
  success?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

/** Dati aggiuntivi quando il documento proviene da una importazione. */
export type DocumentImportInfo = {
  /** Elenco dei pagamenti che compensano il sospeso, da usare quando le corrispondenti quietanze non sono disponibili. */
  paidInFullPayments?: Maybe<Array<DocumentImportInfoPaidInFullPayment>>;
};

export type DocumentImportInfoPaidInFullPayment = {
  /** Importo del pagamento. */
  amount: Scalars['Int'];
  /** Data del pagamento. */
  date: Scalars['Date'];
  /** Eventuale descrizione del pagamento o il nome del tipo pagamento. */
  description?: Maybe<Scalars['String']>;
  /** Eventuale riferimento del pagamento. */
  reference?: Maybe<Scalars['String']>;
};

export type DocumentInput = {
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  documentDetails?: InputMaybe<Array<DocumentDetailInput>>;
  documentPaymentDetails?: InputMaybe<Array<DocumentPaymentDetailInput>>;
  documentType: DocumentType;
  fiscalType: FiscalType;
  note?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

/** Tipo che ci permette di legare l'incasso al documento */
export type DocumentPaymentDetail = {
  amount: Scalars['Int'];
  expireDate?: Maybe<Scalars['Date']>;
  paymentActive: PaymentActive;
  paymentActiveId: Scalars['ID'];
  referenceDocument?: Maybe<Document>;
  /** Indica il documento di riferimento, può essere una caparra/anticipo o il documento di origine di una nota di credito */
  referenceDocumentId?: Maybe<Scalars['ID']>;
};

export type DocumentPaymentDetailInput = {
  amount: Scalars['Int'];
  expireDate?: InputMaybe<Scalars['Date']>;
  paymentActiveId: Scalars['ID'];
  referenceDocumentId?: InputMaybe<Scalars['ID']>;
};

export type DocumentQueryFilter = {
  cashDeskTypeId?: InputMaybe<IDFilter>;
  customerId?: InputMaybe<IDFilter>;
  documentDate?: InputMaybe<DateFilter>;
  documentType?: InputMaybe<DocumentType>;
  draft?: InputMaybe<Scalars['Boolean']>;
  fiscalType?: InputMaybe<FiscalTypeFilter>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  referenceDocumentId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  unpaid?: InputMaybe<Scalars['Boolean']>;
  userTsId?: InputMaybe<Scalars['String']>;
};

export type DocumentTotal = {
  currency: Scalars['Currency'];
  totals: DocumentTotalByCurrency;
};

export type DocumentTotalByCurrency = {
  advance: Scalars['Int'];
  citytax: Scalars['Int'];
  deposit: Scalars['Int'];
  other: Scalars['Int'];
  payments: Array<DocumentTotalPayment>;
  stay: Scalars['Int'];
  totalAmount: Scalars['Int'];
  vatAmount: Scalars['Int'];
};

export type DocumentTotalPayment = {
  paymentActiveId: Scalars['ID'];
  paymentActiveName: Scalars['LocalizedString'];
  total: Scalars['Int'];
};

export const DocumentType = {
  ADVANCE: 'ADVANCE',
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
  PAID_IN_FULL: 'PAID_IN_FULL',
  RETURN_ADVANCE: 'RETURN_ADVANCE'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];
/** Indica l'importo dell'iva raggruppato per tipo. Il calcolo deve avvenire sempre sommando prima tutti gli importi delle righe e poi scorporare */
export type DocumentVatDetail = {
  netAmount: Scalars['Int'];
  vat: Vat;
  vatAmount: Scalars['Int'];
  vatId: Scalars['ID'];
};

/** Entità Email, contiene le informazioni sulle email inviate dal sistema */
export type Email = {
  availabilityRequestId?: Maybe<Scalars['ID']>;
  bcc?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  customerId?: Maybe<Scalars['ID']>;
  documents?: Maybe<Array<Document>>;
  documentsId?: Maybe<Array<Scalars['ID']>>;
  emailState: EmailState;
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  messageAutomationId?: Maybe<Scalars['ID']>;
  messageId?: Maybe<Scalars['String']>;
  messageTemplateId: Scalars['ID'];
  quotationId?: Maybe<Scalars['ID']>;
  replyTo?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['ID']>;
  stateTransaction: Array<EmailStateTransaction>;
  subject: Scalars['String'];
  tenantId: Scalars['ID'];
  to: Scalars['String'];
};

/** Stati delle entità di HIC */
export const EmailState = {
  BOUNCE: 'BOUNCE',
  CLICK: 'CLICK',
  DELIVERY: 'DELIVERY',
  ERROR: 'ERROR',
  OPEN: 'OPEN',
  SEND: 'SEND'
} as const;

export type EmailState = typeof EmailState[keyof typeof EmailState];
export type EmailStateTransaction = {
  result?: Maybe<Scalars['String']>;
  state: EmailState;
  timestamp: Scalars['DateTime'];
};

/** Contiene la configurazione del servizio aggiuntivo e la quantità richiesta. */
export type EmbeddedAdditionalService = {
  /** Il servizio aggiuntivo. */
  additionalService: AdditionalService;
  /** Obbligatorio nel caso di servizio a disponibilità limitata */
  limitedAvailability?: Maybe<AdditionalServiceLimitedAvailability>;
  /** Indica se il servizio è obbligatorio per la tariffa (quindi aggiunto automaticamente). */
  mandatory: Scalars['Boolean'];
  /** Indica se il prezzo del servizio è incluso nella tariffa (quindi il prezzo è zero). */
  priceZero: Scalars['Boolean'];
  /**
   * Quantità del servizio. In caso di servizio configurato 'per ospite', la quantità NON deve essere specificata
   * (la produzione viene poi calcolata in funzione del numero di ospiti)."
   */
  quantity?: Maybe<Scalars['Int']>;
};

export type EmbeddedAdditionalServiceInput = {
  /** Id del servizio aggiuntivo */
  additionalServiceId: Scalars['ID'];
  /** Obbligatorio nel caso di servizio a disponibilità limitata */
  limitedAvailability?: InputMaybe<AdditionalServiceLimitedAvailabilityInput>;
  /** Quantità del servizio. In caso di servizio configurato 'per ospite', la quantità non deve essere specificata perchè sarà ricavata automaticamente dal numero di ospiti. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type EmbeddedProductionInput = {
  amount: Scalars['Float'];
  billId?: InputMaybe<Scalars['ID']>;
  chargeCategoryId: Scalars['ID'];
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  total: Scalars['Float'];
  vatId: Scalars['ID'];
};

export type EngagementCompany = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  vatCode?: Maybe<Scalars['String']>;
};

export type EngagementRequest = {
  company: EngagementCompany;
  lastViewCheck: Scalars['Boolean'];
  userEmail: Scalars['String'];
};

export type EngagementResponse = {
  uri?: Maybe<Scalars['String']>;
};

export type EntityImageInput = {
  additionalServiceImages?: InputMaybe<Array<AdditionaServiceImage>>;
  propertyId: Scalars['ID'];
  propertyImages?: InputMaybe<PropertyImageInput>;
  resourceTypeImages?: InputMaybe<Array<ResourceTypeImageInput>>;
  tenantId: Scalars['ID'];
};

/** L'ambito in cui sono utilizzate o richieste le esenzioni: determina l'eventuale filtro applicato al set di esenzioni disponibili. */
export const ExonerationUsage = {
  /** Le esenzioni applicabili in caso di configurazione della regola generica. */
  CONFIGURATION_GENERIC: 'CONFIGURATION_GENERIC',
  /** Le esenzioni applicabili in caso di modifica di una scheda cliente. */
  CUSTOMER: 'CUSTOMER',
  /** Le esenzioni applicabili in caso di modifica di un ospite (cioè in una prenotazione). */
  GUEST: 'GUEST',
  /** Le esenzioni applicabili in caso di modifica di un addebito di produzione. */
  PRODUCTION: 'PRODUCTION',
  /** Tutte le esenzioni della struttura. */
  PROPERTY: 'PROPERTY'
} as const;

export type ExonerationUsage = typeof ExonerationUsage[keyof typeof ExonerationUsage];
/** Entità che contiene i dati di configurazione del portale Expedia. */
export type ExpediaParameters = {
  allowedAgeCategories?: Maybe<Array<Scalars['String']>>;
  distributionModels?: Maybe<Array<Scalars['String']>>;
  pricingModel: ExpediaPricingModel;
  rateAcquisitionType?: Maybe<Scalars['String']>;
};

export const ExpediaPricingModel = {
  OccupancyBasedPricing: 'OccupancyBasedPricing',
  PerDayPricing: 'PerDayPricing'
} as const;

export type ExpediaPricingModel = typeof ExpediaPricingModel[keyof typeof ExpediaPricingModel];
/** Richieste di export */
export type ExportData = {
  auditable: Auditable;
  exportProcedure: ExportProcedure;
  exportProcedureId: Scalars['ID'];
  fileIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  requestInfo: ExportRequest;
  status: ExportRequestStatus;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type ExportDataQueryFilter = {
  exportProcedureId: Scalars['String'];
  tenantId: IDFilter;
};

export type ExportDatabaseInput = {
  database: Scalars['String'];
  extPropertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type ExportDatabaseOutput = {
  taskId: Scalars['ID'];
};

export type ExportInfo = {
  data: Scalars['DateTime'];
  forceExport: Scalars['Boolean'];
  user: Scalars['String'];
};

export type ExportInput = {
  end: Scalars['Date'];
  exportProcedureId: Scalars['ID'];
  forceExport?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
  user?: InputMaybe<Scalars['String']>;
};

/** Configurazione Base per Export COntabile */
export type ExportManagement = {
  batchPayments: Scalars['String'];
  batchSales: Scalars['String'];
  /** Conto debiti Enti comunali, obbligayporio se attiva city tax */
  cityTaxDebts?: Maybe<Scalars['String']>;
  /** Mastro clienti */
  customersAccount: Scalars['String'];
  /** Conto caparre */
  customersDeposit: Scalars['String'];
  /** Conti Acconti */
  customersFiscalDeposit: Scalars['String'];
  /** Conto corrispettivi */
  customersVATPayments: Scalars['String'];
  /** Debiti per iva */
  debtsforVAT: Scalars['String'];
  defaultCompanyCode: Scalars['String'];
  exportSuspendedPayments: Scalars['Boolean'];
  /** Raggruppa incassi corrispettivi */
  groupPayments: Scalars['Boolean'];
  /** Raggruppa ricavi corrispettivi */
  groupRevenues: Scalars['Boolean'];
  /** Conto ricavi */
  revenueAccount: Scalars['String'];
  /** Iva vendite */
  vatSales: Scalars['String'];
  /** IVA_RF_Sospeso */
  vatrfSuspended: Scalars['String'];
};

export type ExportManagementInput = {
  batchPayments: Scalars['String'];
  batchSales: Scalars['String'];
  cityTaxDebts?: InputMaybe<Scalars['String']>;
  customersAccount: Scalars['String'];
  customersDeposit: Scalars['String'];
  customersFiscalDeposit: Scalars['String'];
  customersVATPayments: Scalars['String'];
  debtsforVAT: Scalars['String'];
  defaultCompanyCode: Scalars['String'];
  exportSuspendedPayments: Scalars['Boolean'];
  groupPayments: Scalars['Boolean'];
  groupRevenues: Scalars['Boolean'];
  revenueAccount: Scalars['String'];
  vatSales: Scalars['String'];
  vatrfSuspended: Scalars['String'];
};

/** Tipologie di export */
export const ExportManagementProcedure = {
  TS: 'TS'
} as const;

export type ExportManagementProcedure = typeof ExportManagementProcedure[keyof typeof ExportManagementProcedure];
/** Collection che contiene le procedure configurate per il tenant o per la property. */
export type ExportProcedure = {
  auditable: Auditable;
  id: Scalars['ID'];
  managementConfiguration: ExportManagement;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  type: ExportManagementProcedure;
};

export type ExportProcedureInput = {
  managementConfiguration: ExportManagementInput;
  propertyId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<State>;
  tenantId: Scalars['ID'];
  type: ExportManagementProcedure;
};

export type ExportProcedureQueryFilter = {
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  type?: InputMaybe<ExportManagementProcedure>;
};

export type ExportRequest = {
  end: Scalars['Date'];
  forceExport?: Maybe<Scalars['Boolean']>;
  start: Scalars['Date'];
  user?: Maybe<Scalars['String']>;
};

export const ExportRequestStatus = {
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS'
} as const;

export type ExportRequestStatus = typeof ExportRequestStatus[keyof typeof ExportRequestStatus];
export type ExportableDatabase = {
  name: Scalars['String'];
  ready: Scalars['Boolean'];
};

export type FakeInput = {
  ia: Scalars['String'];
  ib: Scalars['Int'];
};

export type FakeOutput = {
  oa: Scalars['String'];
  ob: Scalars['Int'];
};

/** Funzionalità dell'applicativo */
export const Feature = {
  AUTOMATION: 'AUTOMATION',
  AUTOMATION_API: 'AUTOMATION_API',
  ENTERPRISE: 'ENTERPRISE',
  GUEST_PORTAL: 'GUEST_PORTAL',
  HOUSEKEEPER: 'HOUSEKEEPER',
  HUB: 'HUB',
  HUB_EXT: 'HUB_EXT',
  MULTI_PROPERTY: 'MULTI_PROPERTY'
} as const;

export type Feature = typeof Feature[keyof typeof Feature];
export type FelAdditionalInfo = {
  /** state is one of TS DIGITAL final states */
  closed: Scalars['Boolean'];
  customFields?: Maybe<FelCustomFields>;
  flowType?: Maybe<SdiFlowType>;
  /** TS Digital HubId */
  hubId?: Maybe<Scalars['String']>;
  /** last error received from TS DIGITAL */
  lastError?: Maybe<Scalars['String']>;
  /** Sent to TS Digital */
  sent: Scalars['Boolean'];
  /** TD Digital State */
  state?: Maybe<FelState>;
  /** Timestamp of last update */
  timeStamp: Scalars['DateTime'];
};

/** Electronic Invoice Configuration */
export type FelConfiguration = {
  authorizedCapital?: Maybe<Scalars['Int']>;
  /** Se non specificato è SDI */
  flowType?: Maybe<FlowType>;
  inLiquidation: Scalars['Boolean'];
  reaCode?: Maybe<Scalars['String']>;
  reaOffice?: Maybe<Scalars['String']>;
  soleShareholder: Scalars['Boolean'];
  taxSystem: RegimeFiscale;
};

export type FelConfigurationInput = {
  authorizedCapital?: InputMaybe<Scalars['Int']>;
  /** Se non specificato è SDI */
  flowType?: InputMaybe<FlowType>;
  inLiquidation: Scalars['Boolean'];
  reaCode?: InputMaybe<Scalars['String']>;
  reaOffice?: InputMaybe<Scalars['String']>;
  soleShareholder: Scalars['Boolean'];
  taxSystem: RegimeFiscale;
};

export type FelCustomFields = {
  bolloVirtuale?: Maybe<Scalars['Boolean']>;
  datiContratto?: Maybe<DatiDocumentiCorrelati>;
  datiConvenzione?: Maybe<DatiDocumentiCorrelati>;
  datiFattureCollegate?: Maybe<DatiDocumentiCorrelati>;
  datiOrdineAcquisto?: Maybe<DatiDocumentiCorrelati>;
  datiRicezione?: Maybe<DatiDocumentiCorrelati>;
  riferimentoAmministrazione?: Maybe<Scalars['String']>;
};

export type FelCustomFieldsInput = {
  bolloVirtuale?: InputMaybe<Scalars['Boolean']>;
  datiContratto?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiConvenzione?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiFattureCollegate?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiOrdineAcquisto?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiRicezione?: InputMaybe<DatiDocumentiCorrelatiInput>;
};

export const FelState = {
  ACCETTATO: 'ACCETTATO',
  CARICATO: 'CARICATO',
  CONTROLLATO: 'CONTROLLATO',
  DEPOSITATO: 'DEPOSITATO',
  FIRMATO: 'FIRMATO',
  INVIATO: 'INVIATO',
  IN_GESTIONE: 'IN_GESTIONE',
  NESSUNA_RISPOSTA: 'NESSUNA_RISPOSTA',
  NON_RECAPITATO: 'NON_RECAPITATO',
  REGISTRATO: 'REGISTRATO',
  RIFIUTATO: 'RIFIUTATO',
  SCARICATO: 'SCARICATO',
  SCARTATO: 'SCARTATO',
  VALIDATO: 'VALIDATO'
} as const;

export type FelState = typeof FelState[keyof typeof FelState];
/**
 * Entità che rappresenta un file caricato sulla piattaforma, collegabile ad una o più
 * altre entità.
 */
export type File = {
  URL: Scalars['String'];
  auditable: Auditable;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['ID']>;
  public: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type FileInput = {
  filename: Scalars['String'];
  mimeType?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  public: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type FileUploadResponse = {
  file: File;
  preSignedURL: Scalars['String'];
};

export type FilesQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type FiscalConfiguration = {
  address?: Maybe<Address>;
  cashDeskTypeIds: Array<Scalars['ID']>;
  default: Scalars['Boolean'];
  dutyStampAuthorizationCode?: Maybe<Scalars['String']>;
  felConfiguration?: Maybe<FelConfiguration>;
  fiscalCode?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nexi?: Maybe<NexiData>;
  propertyName?: Maybe<Scalars['String']>;
  registryItemId: Scalars['String'];
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  tspay?: Maybe<TsPayData>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type FiscalConfigurationInput = {
  address?: InputMaybe<AddressInput>;
  cashDeskTypeIds: Array<Scalars['ID']>;
  default: Scalars['Boolean'];
  dutyStampAuthorizationCode?: InputMaybe<Scalars['String']>;
  felConfiguration?: InputMaybe<FelConfigurationInput>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nexi?: InputMaybe<NexiDataInput>;
  propertyName?: InputMaybe<Scalars['String']>;
  registryItemId: Scalars['String'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

/** Dati relativi al fiscal gateway vengono creati in fase di */
export type FiscalGatewayData = {
  accountID: Scalars['String'];
  createdOn: Scalars['DateTime'];
  secret: Scalars['EncryptedString'];
  webhook: Scalars['Boolean'];
};

/**
 * Il fiscal Gateway rappresenta una stampante fiscale collegata al gestionale.
 * I dati comuni sono all'interno del tenant e servono per identificarsi sul gateway oltre che al workstationid
 * L'apikey che è criptata serve come dato da far visualizzare all'utente per associare la cassa
 */
export type FiscalGatewayWorkstation = {
  apikey: Scalars['EncryptedString'];
  auditable: Auditable;
  cashDeskType?: Maybe<CashDeskType>;
  cashDeskTypeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastCommandSend?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
  workstationID: Scalars['String'];
};

export type FiscalGatewayWorkstationQueryFilter = {
  name?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export const FiscalType = {
  CREDIT_NOTE: 'CREDIT_NOTE',
  INVOICE: 'INVOICE',
  NON_FISCAL: 'NON_FISCAL',
  PAID_IN_FULL: 'PAID_IN_FULL',
  RECEIPT: 'RECEIPT',
  RETURN_DOCUMENT: 'RETURN_DOCUMENT'
} as const;

export type FiscalType = typeof FiscalType[keyof typeof FiscalType];
export type FiscalTypeFilter = {
  eq?: InputMaybe<FiscalType>;
  in?: InputMaybe<Array<FiscalType>>;
  ne?: InputMaybe<FiscalType>;
  nin?: InputMaybe<Array<FiscalType>>;
};

export const FiscalTypeForAdvances = {
  INVOICE: 'INVOICE',
  NON_FISCAL: 'NON_FISCAL',
  RECEIPT: 'RECEIPT'
} as const;

export type FiscalTypeForAdvances = typeof FiscalTypeForAdvances[keyof typeof FiscalTypeForAdvances];
export const FlowType = {
  SDI: 'SDI',
  STORE: 'STORE'
} as const;

export type FlowType = typeof FlowType[keyof typeof FlowType];
export type FooterFeature = {
  text: Scalars['String'];
};

export type ForecastDistribution = {
  chargeCategoryLabel: Scalars['String'];
  occupancy: Scalars['Int'];
  originLabel: Scalars['String'];
  roomProduction: ProductionAmount;
  totalProduction: ProductionAmount;
};

export type ForecastResourceType = {
  distributions: Array<ForecastDistribution>;
  inventory: Scalars['Int'];
  occupancy: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
  roomProduction: ProductionAmount;
  shadowCommitments?: Maybe<Scalars['Int']>;
  totalProduction: ProductionAmount;
  unavailability: Scalars['Int'];
};

export type GdprLog = {
  action: GdprLogAction;
  checksum: Scalars['String'];
  function: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  mode: GdprLogMode;
  operation: GdprLogOperation;
  progress: Scalars['Int'];
  request?: Maybe<RequestData>;
  sent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  userId?: Maybe<Scalars['String']>;
};

export const GdprLogAction = {
  ChangeMode: 'ChangeMode',
  Exec: 'Exec',
  Login: 'Login',
  LoginFailed: 'LoginFailed',
  Logout: 'Logout',
  Message: 'Message'
} as const;

export type GdprLogAction = typeof GdprLogAction[keyof typeof GdprLogAction];
export const GdprLogMode = {
  Background: 'Background',
  Foreground: 'Foreground'
} as const;

export type GdprLogMode = typeof GdprLogMode[keyof typeof GdprLogMode];
export const GdprLogOperation = {
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  READ: 'READ',
  UPDATE: 'UPDATE'
} as const;

export type GdprLogOperation = typeof GdprLogOperation[keyof typeof GdprLogOperation];
export type GdprLogQueryFilter = {
  sent?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  timestamp?: InputMaybe<DateFilter>;
  userId?: InputMaybe<Scalars['String']>;
};

export const GenderType = {
  FEMALE: 'FEMALE',
  MALE: 'MALE'
} as const;

export type GenderType = typeof GenderType[keyof typeof GenderType];
export type GenerateCityTaxFileError = {
  /** Il giorno a cui si riferisce l'errore, se disponibile. */
  date?: Maybe<Scalars['Date']>;
  /** L'ospite a cui si riferisce l'errore, se disponibile. */
  guest?: Maybe<Scalars['String']>;
  /** Messaggio di errore. */
  message: Scalars['String'];
  /** Nome della configurazione della regola di CityTax. */
  ruleConfigurationName: Scalars['String'];
};

export type GenerateCityTaxFileInput = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  ruleConfigurationName?: InputMaybe<Scalars['String']>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type GenerateCityTaxFileResult = {
  errors?: Maybe<Array<GenerateCityTaxFileError>>;
  fileUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GenerateIstatFileError = {
  /** Nome della configurazione Istat. */
  configurationName: Scalars['String'];
  /** Il giorno a cui si riferisce l'errore, se disponibile. */
  date?: Maybe<Scalars['Date']>;
  /** L'ospite a cui si riferisce l'errore, se disponibile. */
  guest?: Maybe<IstatGuest>;
  /** Messaggio di errore. */
  message: Scalars['String'];
};

export type GenerateIstatFileInput = {
  configurationName: Scalars['String'];
  end: Scalars['Date'];
  /**
   * Indica se è la prima generazione del file di dati: nel primo invio, alcuni sistemi Istat (es. SPOT-Puglia)
   * richiedono dati aggiuntivi per inizializzare il loro archivio, ad es. i presenti del giorno precedente il primo invio.
   */
  isFirstFile?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type GenerateIstatFileResult = {
  errors?: Maybe<Array<GenerateIstatFileError>>;
  fileUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GetCityTaxMonthSummaryAstatInput = {
  month: Scalars['Int'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  year: Scalars['Int'];
};

export type GetCityTaxRegulationRicestatInput = {
  municipalityCodeItalianPS: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type GetCityTaxRulesInput = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type GetCounterInput = {
  propertyId?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type: CounterType;
  year: Scalars['Int'];
};

export type GetIstatDataInput = {
  /** Nome della configurazione Istat. */
  configurationName?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type GetIstatPropertiesTrentinoInput = {
  password: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  username: Scalars['String'];
};

export type GetRegistryItemsInput = {
  countryIsoCode: Scalars['String'];
  fiscalCode?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

/**
 * Entità che contiene lo stato globale dell'applicazione, i cui valori vengono persistiti e possono essere riletti in momenti successivi.
 * Può contenere, ad esempio: data e ora di eventi globali, valori di run-time che devono essere mantenuti per un certo tempo, ecc.
 */
export type GlobalState = {
  /** I dati dello stato dell'applicazione. */
  data: GlobalStateData;
  id: Scalars['ID'];
  /** Chiave identificativa dello stato. */
  key: GlobalStateKey;
  /** Timestamp dell'ultima modifica dello stato. */
  modifiedOn: Scalars['DateTime'];
};

/** Entità che rappresenta lo stato globale dell'applicazione. */
export type GlobalStateData = {
  /** Stato del Channel-Manager. */
  channelManager?: Maybe<GlobalStateDataChannelManager>;
  /** Stato di esempio (temporaneamente usato nei test in mancanza di altre sezioni) */
  sampleSection?: Maybe<GlobalStateDataSampleSection>;
};

/** Entità che rappresenta lo stato del Channel-Manager. */
export type GlobalStateDataChannelManager = {
  /** Timestamp dell'ultimo controllo di nuovi errori di comunicazione con i canali. */
  lastCommunicationErrorCheck?: Maybe<Scalars['DateTime']>;
};

/** Entità che rappresenta lo stato di una sezione di esempio. */
export type GlobalStateDataSampleSection = {
  /** Valore di esempio (temporaneamente usato nei test in mancanza di altri valori) */
  sampleValue?: Maybe<Scalars['String']>;
};

export const GlobalStateKey = {
  GLOBAL: 'GLOBAL'
} as const;

export type GlobalStateKey = typeof GlobalStateKey[keyof typeof GlobalStateKey];
export type GoogleCoordinates = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type GoogleLocation = {
  location: GoogleCoordinates;
};

/** Oggetto che ritorna dal serviizo di di Google */
export type GooglePlace = {
  formatted_address: Scalars['String'];
  geometry: GoogleLocation;
  name: Scalars['String'];
  place_id: Scalars['String'];
  rating: Scalars['Float'];
};

/** Dati di dettaglio per aumentare i tipi è necessario vedere il servizio */
export type GooglePlaceDetail = {
  formatted_address: Scalars['String'];
  formatted_phone_number?: Maybe<Scalars['String']>;
  international_phone_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price_level?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  reviews?: Maybe<Array<GooglePlaceReview>>;
  url?: Maybe<Scalars['String']>;
  user_ratings_total?: Maybe<Scalars['Int']>;
  vicinity?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** Dati di dettaglio ricavati da Google tramite il Place ID */
export type GooglePlaceDetailResponse = {
  error_message?: Maybe<Scalars['String']>;
  info_messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  result?: Maybe<GooglePlaceDetail>;
  status?: Maybe<Scalars['String']>;
};

/**
 * Input per recuperare le info che ha salvato google per il place id passato.
 * I risultati sono inerenti alla lingua passata.
 */
export type GooglePlaceInput = {
  language: Scalars['String'];
  place_id: Scalars['String'];
};

/**
 * Elenco di candidati che sono stati recuperati dal servizio api di Google Place
 * Se status non è OK è presente il messaggio di errore
 */
export type GooglePlaceResponse = {
  candidates?: Maybe<Array<GooglePlace>>;
  error_message?: Maybe<Scalars['String']>;
  info_messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['String']>;
};

/** Oggetto che ritorna dal servizio di di Google e rappresenta una review */
export type GooglePlaceReview = {
  author_name: Scalars['String'];
  rating: Scalars['Float'];
  relative_time_description: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  time: Scalars['Float'];
};

/** Input per ricercare i dati tramite l'api di google */
export type GooglePlacesFindInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  name: Scalars['String'];
};

/**
 * Tipo di Garanzia richiesta
 * Le tipologie pilotano anche l'intefaccia, vedi specifiche
 */
export const GuaranteeType = {
  FIRSTNIGHT: 'FIRSTNIGHT',
  NOTREQUIRED: 'NOTREQUIRED',
  PERCENTAGE_TOTAL: 'PERCENTAGE_TOTAL',
  TOTAL: 'TOTAL'
} as const;

export type GuaranteeType = typeof GuaranteeType[keyof typeof GuaranteeType];
/**
 * Tipo che ci permette di salvare all'interno della prenotazione gli ospiti.
 * Come per la ReservedResource ci sono le fasi anche per gli ospiti.
 */
export type GuestOccupancy = {
  checkin?: Maybe<Scalars['DateTime']>;
  checkout?: Maybe<Scalars['DateTime']>;
  cityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guest: Customer;
  guestId: Scalars['ID'];
  id: Scalars['ID'];
  phase: ReservedResourcePhase;
  /** Informazioni sull'invio ad alloggiati web */
  psSent?: Maybe<PsSent>;
  start: Scalars['Date'];
  type: GuestType;
  /** Lo stato del Web Check-in. */
  wciState?: Maybe<WciState>;
};

export type GuestOccupancyDetail = {
  name: Scalars['String'];
  type: GuestType;
};

export type GuestOccupancyInput = {
  cityTaxExoneration?: InputMaybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guestId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  start: Scalars['Date'];
  type: GuestType;
};

export type GuestPortalAddServicesInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalAddServicesReservedResource>;
};

export type GuestPortalAddServicesReservedResource = {
  additionalServices: Array<GuestPortalAddServicesReservedResourceService>;
  reservedResourceId: Scalars['ID'];
};

export type GuestPortalAddServicesReservedResourceService = {
  additionalServiceId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type GuestPortalCheckinReservedResource = {
  guests: Array<GuestPortalCheckinReservedResourceGuest>;
  reservedResourceId: Scalars['ID'];
};

export type GuestPortalCheckinReservedResourceGuest = {
  guestId: Scalars['ID'];
  selfieImage?: InputMaybe<CustomerImage>;
};

export type GuestPortalCheckinReservedResourcesInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalCheckinReservedResource>;
};

export type GuestPortalCheckoutDocumentInput = {
  billIds: Array<Scalars['String']>;
  callbackUrl: Scalars['String'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  fiscalType: FiscalType;
  reservationId: Scalars['ID'];
};

export type GuestPortalCheckoutDocumentResult = {
  documentId: Scalars['String'];
  tsPayUrl?: Maybe<Scalars['String']>;
};

export type GuestPortalCheckoutReservedResource = {
  guestIds: Array<Scalars['ID']>;
  reservedResourceId: Scalars['ID'];
};

export type GuestPortalCheckoutReservedResourcesInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalCheckoutReservedResource>;
};

export type GuestPortalReservationBillsOutput = {
  bills: Array<Bill>;
  billsId: Array<Scalars['ID']>;
  currency: Scalars['Currency'];
  depositsAmount: Scalars['Int'];
  id: Scalars['ID'];
};

export type GuestPortalWebCheckinInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalWebCheckinReservedResource>;
};

export type GuestPortalWebCheckinReservedResource = {
  guests: Array<CustomerGuestInput>;
  reservedResourceId: Scalars['ID'];
};

export type GuestStatistic = {
  arrived: Scalars['Int'];
  /**  average age of guests  */
  averageAge: Scalars['Float'];
  nationalityIsoCodes: Array<NationalityStatistic>;
  total: Scalars['Int'];
};

/** Tipologia Ospite PS Italiana */
export const GuestType = {
  FAMILY: 'FAMILY',
  GROUP_HEAD: 'GROUP_HEAD',
  GROUP_MEMBER: 'GROUP_MEMBER',
  HEAD_OF_FAMILY: 'HEAD_OF_FAMILY',
  SINGLE_GUEST: 'SINGLE_GUEST'
} as const;

export type GuestType = typeof GuestType[keyof typeof GuestType];
export type HoauConfiguration = {
  baseUrl: Scalars['String'];
  token?: Maybe<Scalars['EncryptedString']>;
  userId: Scalars['String'];
};

export type HoauConfigurationInput = {
  baseUrl: Scalars['String'];
  token?: InputMaybe<Scalars['EncryptedString']>;
  userId: Scalars['String'];
};

export type HorecaHubFlows = {
  id: Scalars['ID'];
  integration1Id: Scalars['ID'];
  integration2Id: Scalars['ID'];
  state: Scalars['String'];
};

/** Horeca Hub: entità di integrazione */
export type HorecaHubIntegration = {
  auditable: Auditable;
  handledEntities?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  secret: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
  token?: Maybe<Scalars['String']>;
};

export type HotelDateInput = {
  hotelDate: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type HousekeepingConfiguration = {
  /** Numero di giorni dopo il quale la risorsa in checkin viene impostata a DIRTY. */
  daysForResourceDirty?: Maybe<Scalars['Int']>;
  /** Eventuali colonne aggiuntive da visualizzare nel report governante. */
  reportAdditionalColumns?: Maybe<Array<Scalars['String']>>;
  /** Abilita la suddivisione degli alloggi tra il personale delle pulizie */
  resourceAssignment?: Maybe<Scalars['Boolean']>;
};

export type HousekeepingConfigurationInput = {
  /** Numero di giorni dopo il quale la risorsa in checkin viene impostata a DIRTY. */
  daysForResourceDirty?: InputMaybe<Scalars['Int']>;
  /** Eventuali colonne aggiuntive da visualizzare nel report governante. */
  reportAdditionalColumns?: InputMaybe<Array<Scalars['String']>>;
  /** Abilita la suddivisione degli alloggi tra il personale delle pulizie */
  resourceAssignment?: InputMaybe<Scalars['Boolean']>;
};

export type HubSpotDataInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type IDFilter = {
  eq?: InputMaybe<Scalars['ID']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  ne?: InputMaybe<Scalars['ID']>;
  nin?: InputMaybe<Array<Scalars['ID']>>;
};

export type IbeCodeFilter = {
  ibeCode: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Entità dei tipi documento, le tipologie sono standard */
export type IdentificationDocument = {
  auditable: Auditable;
  codeItalianPs: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type IdentificationDocumentInput = {
  codeItalianPs: Scalars['String'];
  duration: Scalars['Int'];
  name: Scalars['LocalizedString'];
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type IdentificationDocumentQueryFilter = {
  codeIstat?: InputMaybe<StringFilter>;
  codeItalianPs?: InputMaybe<StringFilter>;
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<LocalizedStringFilter>;
  tenantId?: InputMaybe<IDFilter>;
};

export type ImportPropertyConfigurationInput = {
  msLimit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['ID'];
  step?: InputMaybe<ImportPropertyConfigurationStep>;
  taskId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const ImportPropertyConfigurationStep = {
  BILLS: 'BILLS',
  CONFIGURATION: 'CONFIGURATION',
  CUSTOMERS: 'CUSTOMERS',
  DATA: 'DATA',
  DOCUMENTS: 'DOCUMENTS',
  REBUILD_AVAILABILITY: 'REBUILD_AVAILABILITY',
  REBUILD_HISTORY: 'REBUILD_HISTORY',
  RESERVATIONS: 'RESERVATIONS'
} as const;

export type ImportPropertyConfigurationStep = typeof ImportPropertyConfigurationStep[keyof typeof ImportPropertyConfigurationStep];
export type ImportPropertyInput = {
  bookingPolicy: ReservationBookingPolicyInput;
  categoryId?: InputMaybe<Scalars['ID']>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  externalPropertyId: Scalars['String'];
  felConfiguration?: InputMaybe<FelConfigurationInput>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  plantId?: InputMaybe<Scalars['String']>;
  registryItemId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type ImportPropertyOutput = {
  propertyId: Scalars['ID'];
  taskId: Scalars['ID'];
};

export const ImportTaskType = {
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT'
} as const;

export type ImportTaskType = typeof ImportTaskType[keyof typeof ImportTaskType];
export type ImportedAdditionalService = {
  data: ImportedAdditionalServiceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedAdditionalServiceData = {
  automaticForAdults: Scalars['Boolean'];
  automaticForChildren: Scalars['Boolean'];
  description: ImportedLocalizedString;
  excludeCheckin: Scalars['Boolean'];
  excludeCheckout: Scalars['Boolean'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  minStay?: Maybe<Scalars['Int']>;
  name: ImportedLocalizedString;
  price: Scalars['Int'];
  /** PER_STAY, PER_PERSON, PER_NIGHT, PER_PERSON_PER_NIGHT */
  pricingType: PricingType;
  validity?: Maybe<Range>;
};

export type ImportedAddress = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Scalars['String']>;
  municipalityIstatCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
};

export type ImportedBill = {
  data: ImportedBillData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedBillData = {
  /** MAIN, EXTRA, WALKIN, REVERSE */
  category: BillCategoryType;
  createdOn?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  extDocumentId?: Maybe<Scalars['String']>;
  extOwnerId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservationId?: Maybe<Scalars['String']>;
  extReservedResourceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  open: Scalars['Boolean'];
};

export type ImportedBookingPolicy = {
  data: ImportedBookingPolicyData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedBookingPolicyData = {
  cancellationPolicy?: Maybe<ImportedCancellationPolicy>;
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  noShowRule?: Maybe<ImportedNoShowRule>;
  paymentRule?: Maybe<ImportedPaymentRule>;
};

export type ImportedCancellationPolicy = {
  daysWithoutPenalties?: Maybe<Scalars['Int']>;
  hourWithoutPenalties?: Maybe<Scalars['String']>;
  penaltyType?: Maybe<CancellationPenaltyType>;
  percentage?: Maybe<Scalars['Int']>;
  type: CancellationPolicyType;
};

export type ImportedChargeCategory = {
  data: ImportedChargeCategoryData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedChargeCategoryData = {
  breakfastIncluded: Scalars['Boolean'];
  cityTax: Scalars['Boolean'];
  /** RO BB HB FB */
  code?: Maybe<ChargeCategoryBoard>;
  dinnerIncluded: Scalars['Boolean'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  lunchIncluded: Scalars['Boolean'];
  name: Scalars['String'];
  stayIncluded: Scalars['Boolean'];
  vat: ImportedVat;
};

export type ImportedCompany = {
  /** NC, HC, HCT, FC, FCT */
  defaultCredit?: Maybe<CreditType>;
  physicalPerson: Scalars['Boolean'];
  sdiCode?: Maybe<Scalars['String']>;
  splitPayment: Scalars['Boolean'];
};

export type ImportedCounter = {
  data: ImportedCounterData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedCounterData = {
  documentInfo?: Maybe<ImportedCounterDocumentData>;
  extPropertyId: Scalars['String'];
  format: Scalars['String'];
  id: Scalars['String'];
  reset: Scalars['Boolean'];
  /** RESERVATION, DOCUMENT, ELECTRONIC_INVOICE, QUOTATION */
  type: CounterType;
  value: Scalars['Int'];
  year: Scalars['Int'];
};

export type ImportedCounterDocumentData = {
  fiscalType: Scalars['String'];
  set?: Maybe<Scalars['String']>;
};

export type ImportedCustomer = {
  data: ImportedCustomerData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedCustomerData = {
  address?: Maybe<ImportedAddress>;
  company?: Maybe<ImportedCompany>;
  firstName?: Maybe<Scalars['String']>;
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCompany: Scalars['Boolean'];
  languageIsoCode: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  mailContact?: Maybe<ImportedMailContact>;
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  person?: Maybe<ImportedPerson>;
  phoneContact?: Maybe<ImportedPhoneContact>;
  privacy?: Maybe<ImportedPrivacy>;
  vatNumber?: Maybe<Scalars['String']>;
  webContact?: Maybe<ImportedWebContact>;
};

export type ImportedDocument = {
  creditNoteMapped?: Maybe<Scalars['Boolean']>;
  data: ImportedDocumentData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentAdditionalInfo = {
  fel_flow_type?: Maybe<ImportedFelFlowType>;
  fel_hubId?: Maybe<Scalars['String']>;
  fel_state?: Maybe<FelState>;
  sent: Scalars['Boolean'];
  timeStamp: Scalars['DateTime'];
};

export type ImportedDocumentData = {
  additionalInfo?: Maybe<ImportedDocumentAdditionalInfo>;
  consolidatedCustomer: ImportedCustomerData;
  documentDate: Scalars['Date'];
  documentSetCode?: Maybe<Scalars['String']>;
  documentType: ImportedDocumentType;
  extCustomerId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  isAdvance: Scalars['Boolean'];
  netAmount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  numberExtended: Scalars['String'];
  splitPayment: Scalars['Boolean'];
  totalAmount: Scalars['Int'];
  unpaidAmount: Scalars['Int'];
  vatAmount: Scalars['Int'];
};

export type ImportedDocumentDepositAssignment = {
  data: ImportedDocumentDepositAssignmentData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentDepositAssignmentData = {
  amount: Scalars['Int'];
  depositExtDocumentId: Scalars['String'];
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservationId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedDocumentDetail = {
  data: ImportedDocumentDetailData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentDetailData = {
  amount: Scalars['Int'];
  date: Scalars['Date'];
  description: Scalars['String'];
  extChargeCategoryId?: Maybe<Scalars['String']>;
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  quantity: Scalars['Int'];
  referenceExtDocumentId?: Maybe<Scalars['String']>;
  totalAmount: Scalars['Int'];
  vat?: Maybe<ImportedVat>;
};

export type ImportedDocumentPaymentDetail = {
  data: ImportedDocumentPaymentDetailData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentPaymentDetailData = {
  amount: Scalars['Int'];
  expireDate?: Maybe<Scalars['Date']>;
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  /** CASH, CHANGE, BANKTRANSFER, BANKCHECK, CREDITCARD, UNPAID, BALANCE_UNPAID, DEPOSIT, RETURN_DEPOSIT, SPLITPAYMENT, RETURN_SPLITPAYMENT */
  paymentTypeCode: PaymentTypeCode;
  referenceExtDocumentId?: Maybe<Scalars['String']>;
};

export const ImportedDocumentType = {
  CREDIT_NOTE: 'CREDIT_NOTE',
  INVOICE: 'INVOICE',
  NON_FISCAL_ADVANCE: 'NON_FISCAL_ADVANCE',
  NON_FISCAL_RETURN_ADVANCE: 'NON_FISCAL_RETURN_ADVANCE',
  PAID_IN_FULL: 'PAID_IN_FULL',
  RECEIPT: 'RECEIPT'
} as const;

export type ImportedDocumentType = typeof ImportedDocumentType[keyof typeof ImportedDocumentType];
export type ImportedDocumentVatDetail = {
  data: ImportedDocumentVatDetailData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentVatDetailData = {
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  netAmount: Scalars['Int'];
  vat: ImportedVat;
  vatAmount: Scalars['Int'];
};

export type ImportedError = {
  entity: Scalars['String'];
  error: Scalars['String'];
  extEntityId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  timeStamp: Scalars['DateTime'];
};

export type ImportedErrorQueryFilter = {
  extPropertyId?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId?: InputMaybe<IDFilter>;
};

export const ImportedFelFlowType = {
  SDIPA: 'SDIPA',
  SDIPR: 'SDIPR'
} as const;

export type ImportedFelFlowType = typeof ImportedFelFlowType[keyof typeof ImportedFelFlowType];
export type ImportedGuestOccupancy = {
  data: ImportedGuestOccupancyData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedGuestOccupancyData = {
  checkin?: Maybe<Scalars['DateTime']>;
  checkout?: Maybe<Scalars['DateTime']>;
  end: Scalars['Date'];
  extCustomerId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
  /** RESERVATION, CHECKIN, CHECKOUT */
  phase: ReservedResourcePhase;
  start: Scalars['Date'];
  /** SINGLE_GUEST, HEAD_OF_FAMILY, GROUP_HEAD, FAMILY, GROUP_MEMBER */
  type: GuestType;
};

export type ImportedLocalizedString = {
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
  it?: Maybe<Scalars['String']>;
};

export type ImportedMailContact = {
  mail?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
};

export type ImportedNoShowRule = {
  percentage?: Maybe<Scalars['Int']>;
  type: NoShowType;
};

export type ImportedPaymentRule = {
  guaranteedCreditCard: Scalars['Boolean'];
  percentage?: Maybe<Scalars['Int']>;
  type: GuaranteeType;
};

export type ImportedPerson = {
  birthAddress?: Maybe<ImportedAddress>;
  birthDate?: Maybe<Scalars['Date']>;
  identificationDocument?: Maybe<ImportedPersonIdentificationDocument>;
  isMale?: Maybe<Scalars['Boolean']>;
  nationalityIsoCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ImportedPersonIdentificationDocument = {
  city?: Maybe<Scalars['String']>;
  codeItalianPs: Scalars['String'];
  countryIsoCode: Scalars['String'];
  expirationDate: Scalars['Date'];
  number: Scalars['UppercaseString'];
  releaseBy?: Maybe<Scalars['String']>;
};

export type ImportedPhoneContact = {
  fax?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
};

export type ImportedPortalInfo = {
  externalId: Scalars['String'];
  /** BOOKING, EXPEDIA, AIRBNB */
  portalName: PortalName;
};

export type ImportedPrivacy = {
  dataThirdPartyConsent?: Maybe<Scalars['Boolean']>;
  dataThirdPartyConsentDate?: Maybe<Scalars['Date']>;
  managementConsent?: Maybe<Scalars['Boolean']>;
  managementConsentDate?: Maybe<Scalars['Date']>;
  marketingConsent?: Maybe<Scalars['Boolean']>;
  marketingConsentDate?: Maybe<Scalars['Date']>;
};

export type ImportedProduct = {
  data: ImportedProductData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedProductData = {
  amount: Scalars['Int'];
  description: Scalars['String'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedProduction = {
  data: ImportedProductionData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedProductionAssigned = {
  data: ImportedProductionAssignedData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedProductionAssignedData = {
  extBillId: Scalars['String'];
  extProductionId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  quota: Scalars['Float'];
};

export type ImportedProductionData = {
  amount: Scalars['Int'];
  cityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  extAdditionalServiceId?: Maybe<Scalars['String']>;
  extChargeCategoryId: Scalars['String'];
  extGuestId?: Maybe<Scalars['String']>;
  extPropertyId: Scalars['String'];
  extReservedResourceId?: Maybe<Scalars['String']>;
  hotelDate: Scalars['Date'];
  id: Scalars['String'];
  manual: Scalars['Boolean'];
  quantity: Scalars['Int'];
  total: Scalars['Int'];
  vat: ImportedVat;
};

/** Collections */
export type ImportedProperty = {
  data: ImportedPropertyData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

/** Entità di configurazione */
export type ImportedPropertyData = {
  address?: Maybe<ImportedAddress>;
  description: ImportedLocalizedString;
  fiscalCode?: Maybe<Scalars['String']>;
  hotelDate?: Maybe<Scalars['Date']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mailContact?: Maybe<ImportedMailContact>;
  name: Scalars['String'];
  phoneContact?: Maybe<ImportedPhoneContact>;
  vatNumber?: Maybe<Scalars['String']>;
  webContact?: Maybe<ImportedWebContact>;
};

export type ImportedRate = {
  data: ImportedRateData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedRateData = {
  description: ImportedLocalizedString;
  extBookingPolicyId: Scalars['String'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  name: ImportedLocalizedString;
  order: Scalars['Int'];
};

/** Tipi comuni */
export type ImportedReference = {
  /**
   * Rappresenta l'id interno di TSH
   * Viene valorizzato nel momento in cui il documento viene processato.
   * Per le tabelle molti a molti rimane vuoto perché vengono processate come embedded document
   */
  importedId?: Maybe<Scalars['ID']>;
  timeStamp: Scalars['DateTime'];
};

export type ImportedReservation = {
  data: ImportedReservationData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservationData = {
  canceledOn?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  /** NC, HC, HCT, FC, FCT */
  credit: CreditType;
  extPropertyId: Scalars['String'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCanceled: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  isGroup: Scalars['Boolean'];
  isNoShow: Scalars['Boolean'];
  isOptioned: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  optionExpiration?: Maybe<Scalars['Date']>;
  /** OTA, PMS, IBE */
  origin: OriginName;
  portalInfo?: Maybe<ImportedPortalInfo>;
  reference: ImportedReservationReference;
  reservationCode: Scalars['String'];
  voucher?: Maybe<Scalars['String']>;
};

export type ImportedReservationReference = {
  /** Agenzia */
  agencyId?: Maybe<Scalars['String']>;
  /** Prenotante Azienda */
  customerCompanyId?: Maybe<Scalars['String']>;
  customerPersonId?: Maybe<Scalars['String']>;
  /** Ospite Principale, sempre obbligatorio potrebbe essere lo stesso di custmerPerson */
  mainGuestId: Scalars['String'];
};

export type ImportedReservedResource = {
  data: ImportedReservedResourceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceAdditionalService = {
  data: ImportedReservedResourceAdditionalServiceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceAdditionalServiceData = {
  extAdditionalServiceId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
  mandatory: Scalars['Boolean'];
  priceZero: Scalars['Boolean'];
  quantity?: Maybe<Scalars['Int']>;
};

export type ImportedReservedResourceChargeCategory = {
  data: ImportedReservedResourceChargeCatogoryData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceChargeCatogoryData = {
  day: Scalars['Date'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedReservedResourceDailyPrice = {
  data: ImportedReservedResourceDailyPriceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceDailyPriceData = {
  day: Scalars['Date'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Int'];
};

export type ImportedReservedResourceData = {
  adults: Scalars['Int'];
  assignedExtResourceTypeId: Scalars['String'];
  children: Scalars['Int'];
  end: Scalars['Date'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extRateId: Scalars['String'];
  extReservationId: Scalars['String'];
  extResourceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: Maybe<Scalars['Int']>;
  /** RESERVATION, CHECKIN, CHECKOUT */
  phase: ReservedResourcePhase;
  portalExternalId?: Maybe<Scalars['String']>;
  reservedAdults: Scalars['Int'];
  reservedChildren: Scalars['Int'];
  reservedEnd: Scalars['Date'];
  reservedExtResourceTypeId: Scalars['String'];
  reservedStart: Scalars['Date'];
  start: Scalars['Date'];
};

export type ImportedResource = {
  data: ImportedResourceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceData = {
  code: Scalars['String'];
  description: Scalars['String'];
  extPropertyId: Scalars['String'];
  extResourceTypeId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedResourceType = {
  data: ImportedResourceTypeData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceTypeData = {
  additionalPersons: Scalars['Int'];
  autoEquivalent: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  description: ImportedLocalizedString;
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  inventory: Scalars['Int'];
  logicalType: Scalars['Boolean'];
  maxAdults: Scalars['Int'];
  minRate: Scalars['Int'];
  name: ImportedLocalizedString;
  order: Scalars['Int'];
  persons: Scalars['Int'];
  rackRate: Scalars['Int'];
};

export type ImportedResourceTypeEquivalence = {
  data: ImportedResourceTypeEquivalenceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceTypeEquivalenceData = {
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  masterId: Scalars['String'];
  order: Scalars['Int'];
  slaveId: Scalars['String'];
};

export type ImportedResourceUnavailability = {
  data: ImportedResourceUnavailabilityData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceUnavailabilityData = {
  end: Scalars['Date'];
  extPropertyId: Scalars['String'];
  extResourceId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  start: Scalars['Date'];
};

export type ImportedTask = {
  database?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  extPropertyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastError?: Maybe<Scalars['String']>;
  lastMessage?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  tenantId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
  type: ImportTaskType;
};

export type ImportedTaskQueryFilter = {
  extPropertyId?: InputMaybe<StringFilter>;
  taskId?: InputMaybe<IDFilter>;
  tenantId?: InputMaybe<IDFilter>;
};

export const ImportedVat = {
  E10: 'E10',
  E15: 'E15',
  E72: 'E72',
  E74: 'E74',
  E124: 'E124',
  FCI: 'FCI',
  V4: 'V4',
  V5: 'V5',
  V10: 'V10',
  V22: 'V22'
} as const;

export type ImportedVat = typeof ImportedVat[keyof typeof ImportedVat];
export type ImportedWebContact = {
  instagram?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  webprivacy?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
};

/** Codici degli insight, nella BL ci sono le informazioni che devono essere gestite per ogni codice ->commoninsightinsight.bl.ts */
export const Insight = {
  CHANNEL: 'CHANNEL',
  CHILD: 'CHILD',
  CITYTAX: 'CITYTAX',
  CITYTAX_NODEF: 'CITYTAX_NODEF',
  FISCAL_GATEWAY: 'FISCAL_GATEWAY',
  IBE: 'IBE',
  ISTAT: 'ISTAT',
  ISTAT_NODEF: 'ISTAT_NODEF',
  PS: 'PS',
  RELEASE: 'RELEASE',
  SINAPSI: 'SINAPSI',
  TSPAY: 'TSPAY'
} as const;

export type Insight = typeof Insight[keyof typeof Insight];
export type InsightInput = {
  endPause: Scalars['Date'];
  insightId: Scalars['ID'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type InsightItem = {
  actionUrl?: Maybe<Scalars['String']>;
  code: Insight;
  description: Scalars['LocalizedString'];
  priority: InsightPriority;
  title: Scalars['LocalizedString'];
  type: InsightType;
};

export const InsightPriority = {
  HIGH: 'HIGH',
  HIGHEST: 'HIGHEST',
  LOW: 'LOW',
  NORMAL: 'NORMAL'
} as const;

export type InsightPriority = typeof InsightPriority[keyof typeof InsightPriority];
export type InsightQueryFilter = {
  id?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/**
 * Entità che gestisce per ogni property lo stato dei messaggi insight
 * La prima volta che viene richiamata la gestione insight si occupa di verificare se ci sono nuovi insight e li aggiunge alla entità
 * Se sono gestite sulla property mette active, altrimenti mette draft.
 * Quando sono completi viene messo inactive
 * Se sono in pausa rimangono active ma hanno un tempo di fine pausa
 */
export type InsightStatus = {
  auditable: Auditable;
  /** Quando l'entità viene messa in pausa, l'interfaccia deve proporre un tempo Un giorno, una settimana, un mese e mai ?? */
  endPause?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  insightCode: Insight;
  insightInfo?: Maybe<InsightItem>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const InsightType = {
  ALERT: 'ALERT',
  INFO: 'INFO',
  NEW: 'NEW',
  POPUP: 'POPUP',
  URGENT: 'URGENT',
  WARNING: 'WARNING'
} as const;

export type InsightType = typeof InsightType[keyof typeof InsightType];
/**
 * Definizione di rata, la prima rata può richiedere un pagamento immediato, solo nella prima rata non è obbligatorio il campo DayfromCheckin,
 * perchè viene richiesto subito un pagamento.
 */
export type Installment = {
  dayFromCheckin?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  value: Scalars['Int'];
};

/**
 * Definizione di rata, la prima rata può richiedere un pagamento immediato, solo nella prima rata non è obbligatorio il campo DayfromCheckin,
 * perchè viene richiesto subito un pagamento.
 */
export type InstallmentInput = {
  dayFromCheckin?: InputMaybe<Scalars['Int']>;
  order: Scalars['Int'];
  value: Scalars['Int'];
};

export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
};

/** Represents the capabilities of an Istat system. */
export type IstatCapabilities = {
  /** Indicates whether the implementation handles the cancellation. */
  handlesCancellation?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the system supports automatic sending of Istat data. */
  supportsAutomaticSend?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the system supports the generation of Istat data files (to be uploaded separately). */
  supportsFileGeneration?: Maybe<Scalars['Boolean']>;
};

/** Istat Configuration */
export type IstatConfiguration = {
  auto: Scalars['Boolean'];
  name: Scalars['String'];
  overrideBedsNumber?: Maybe<Scalars['Int']>;
  overrideResourcesNumber?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['EncryptedString']>;
  procedureCode: IstatProcedureCode;
  propertyCode?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['ID']>>;
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  sendCityTax?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['EncryptedString']>;
};

export type IstatConfigurationInput = {
  /**  auto is true by default  */
  auto: Scalars['Boolean'];
  name: Scalars['String'];
  overrideBedsNumber?: InputMaybe<Scalars['Int']>;
  overrideResourcesNumber?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['EncryptedString']>;
  procedureCode: IstatProcedureCode;
  propertyCode?: InputMaybe<Scalars['String']>;
  /** DEPRECATO - Questo campo in futuro verrà rimosso. Utilizzare 'resources' invece. */
  resourceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  resources?: InputMaybe<Array<IstatResourceConfiguration>>;
  username?: InputMaybe<Scalars['EncryptedString']>;
};

export type IstatDailyData = {
  date: Scalars['Date'];
  guests: Array<IstatGuest>;
  property: IstatPropertyInfo;
};

export type IstatError = {
  /** Nome della configurazione Istat. */
  configurationName: Scalars['String'];
  /** Il giorno a cui si riferisce l'errore, se disponibile.  */
  date?: Maybe<Scalars['Date']>;
  /** L'ospite a cui si riferisce l'errore, se disponibile. */
  guest?: Maybe<IstatGuest>;
  /** Messaggio di errore. */
  message: Scalars['String'];
  /** Messaggio restituito dal sistema Istat. */
  messageFromSystem?: Maybe<Scalars['String']>;
};

export type IstatGuest = {
  birthCountry: IstatOrigin;
  birthDate: Scalars['Date'];
  birthPlace: IstatOrigin;
  /** Identificativo univoco del checkin. È un valore formato da reservationId + guestId + data di inizio soggiorno dell'ospite. */
  checkinId: Scalars['String'];
  country: IstatOrigin;
  end: Scalars['Date'];
  firstName: Scalars['String'];
  gender: GenderType;
  guarantorId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  mealPlan: ChargeCategoryBoard;
  municipality?: Maybe<IstatOrigin>;
  municipalityProvince?: Maybe<IstatOrigin>;
  /** Le fasi in cui si trova l'ospite (checkin, checkout, checkin + checkout, stay). */
  phases: IstatGuestPhase;
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  reservedResourceStart: Scalars['Date'];
  /** Codice Istat della risorsa. Presente quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  resourceCodeIstat?: Maybe<Scalars['String']>;
  resourceId: Scalars['ID'];
  resources: Array<IstatResource>;
  start: Scalars['Date'];
  type: GuestType;
};

export type IstatGuestPhase = {
  /** Nota: l'ospite può essere contemporaneamente anche in fase CheckOut. */
  checkin: Scalars['Boolean'];
  /** Nota: l'ospite può essere contemporaneamente anche in fase CheckIn. */
  checkout: Scalars['Boolean'];
  stay: Scalars['Boolean'];
};

export type IstatOrigin = {
  /** Codice Istat. */
  code: Scalars['String'];
  /** Codice Polizia di Stato. */
  codeItalianPs: Scalars['String'];
  /** Codice di 2 caratteri che contiene: il codice ISO, se questo oggetto è una nazione; oppure la sigla della provincia, se questo oggetto è un comune. */
  isoCode: Scalars['String'];
  /** Nome della nazione o del comune. */
  name: Scalars['String'];
  /** Codice postale, se questo oggetto è un comune. */
  postalCode?: Maybe<Scalars['String']>;
};

export const IstatProcedure = {
  /** Bolzano */
  ASTAT: 'ASTAT',
  /** Campania */
  ISTAT_CAMPANIA: 'ISTAT_CAMPANIA',
  /** Trentino */
  ISTAT_TRENTINO: 'ISTAT_TRENTINO',
  /** Lazio */
  RADAR: 'RADAR',
  /** Toscana (città di Arezzo, Grosseto, Livorno, Lucca, Massa Carrara, Pisa, Siena) */
  RICESTAT: 'RICESTAT',
  /** Liguria */
  RIMOVCLI: 'RIMOVCLI',
  /** Abruzzo, Basilicata, Calabria, Emilia Romagna, Lombardia, Marche, Piemonte, Veneto, Toscana (città di Firenze, Pistoia e Prato), Sardegna */
  ROSS1000: 'ROSS1000',
  /** Sicilia */
  SIOT: 'SIOT',
  /** Puglia */
  SPOT: 'SPOT',
  /** Umbria */
  TURISMATICA: 'TURISMATICA',
  /** Friuli (appartamenti) */
  WEBTUR_FLATS: 'WEBTUR_FLATS',
  /** Friuli (camere) */
  WEBTUR_ROOMS: 'WEBTUR_ROOMS'
} as const;

export type IstatProcedure = typeof IstatProcedure[keyof typeof IstatProcedure];
export const IstatProcedureCode = {
  ASTAT_BOLZANO: 'ASTAT_BOLZANO',
  ISTAT_CAMPANIA: 'ISTAT_CAMPANIA',
  ISTAT_TRENTINO: 'ISTAT_TRENTINO',
  RADAR_LAZIO: 'RADAR_LAZIO',
  RICESTAT_AREZZO: 'RICESTAT_AREZZO',
  RICESTAT_GROSSETO: 'RICESTAT_GROSSETO',
  RICESTAT_LIVORNO: 'RICESTAT_LIVORNO',
  RICESTAT_LUCCA: 'RICESTAT_LUCCA',
  RICESTAT_MASSACARRARA: 'RICESTAT_MASSACARRARA',
  RICESTAT_PISA: 'RICESTAT_PISA',
  RICESTAT_SIENA: 'RICESTAT_SIENA',
  RIMOVCLI_LIGURIA: 'RIMOVCLI_LIGURIA',
  ROSS1000_ABRUZZO: 'ROSS1000_ABRUZZO',
  ROSS1000_BASILICATA: 'ROSS1000_BASILICATA',
  ROSS1000_CALABRIA: 'ROSS1000_CALABRIA',
  ROSS1000_EMILIAROMAGNA: 'ROSS1000_EMILIAROMAGNA',
  ROSS1000_FIRENZE: 'ROSS1000_FIRENZE',
  ROSS1000_LIGURIA: 'ROSS1000_LIGURIA',
  ROSS1000_LOMBARDIA: 'ROSS1000_LOMBARDIA',
  ROSS1000_MARCHE: 'ROSS1000_MARCHE',
  ROSS1000_PIEMONTE: 'ROSS1000_PIEMONTE',
  ROSS1000_PISTOIA: 'ROSS1000_PISTOIA',
  ROSS1000_PRATO: 'ROSS1000_PRATO',
  ROSS1000_SARDEGNA: 'ROSS1000_SARDEGNA',
  ROSS1000_VENETO: 'ROSS1000_VENETO',
  SIOT_SICILIA: 'SIOT_SICILIA',
  SPOT_PUGLIA: 'SPOT_PUGLIA',
  TURISMATICA_UMBRIA: 'TURISMATICA_UMBRIA',
  WEBTUR_FLATS_FRIULI: 'WEBTUR_FLATS_FRIULI',
  WEBTUR_ROOMS_FRIULI: 'WEBTUR_ROOMS_FRIULI'
} as const;

export type IstatProcedureCode = typeof IstatProcedureCode[keyof typeof IstatProcedureCode];
export type IstatPropertyInfo = {
  availableBeds: Scalars['Int'];
  availableRooms: Scalars['Int'];
  inventoryBeds: Scalars['Int'];
  inventoryRooms: Scalars['Int'];
  /** Indica se la struttura è chiusa. */
  isClosed?: Maybe<Scalars['Boolean']>;
  occupiedRooms: Scalars['Int'];
};

export type IstatPropertyTrentino = {
  /** Identificativo della struttura. */
  code: Scalars['String'];
  /** Nome della struttura associata all'utenza. */
  name: Scalars['String'];
};

export type IstatResource = {
  end: Scalars['Date'];
  /** Il codice assegnato alla risorsa (cioè il nome o numero). */
  resourceCode: Scalars['String'];
  /** Codice Istat della risorsa. Presente quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  resourceCodeIstat?: Maybe<Scalars['String']>;
  resourceId: Scalars['ID'];
  start: Scalars['Date'];
};

export type IstatResourceConfiguration = {
  /** Codice Istat della risorsa. Necessario quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  codeIstat?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type KeyValue = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type LastThreadMessage = {
  createdOn: Scalars['DateTime'];
  externalUserId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type Link2PayCheckoutDocumentInput = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  customerId: Scalars['ID'];
  documentId: Scalars['ID'];
  payment: PaymentInput;
  propertyId: Scalars['ID'];
  reservationId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type Link2PayInput = {
  amount: Scalars['Int'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  description: Scalars['String'];
  merchantRef: Scalars['String'];
  paymentRef: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  title: Scalars['String'];
};

export type Link2PayOutput = {
  orderKey: Scalars['String'];
  type: PaymentLinkType;
  url: Scalars['String'];
};

export type Link2PayQuotationInput = {
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type Link2PayReservationInput = {
  payment?: InputMaybe<PaymentInput>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type Link2PayUnpaidDocumentInput = {
  /** paid in full document identifier */
  customerId: Scalars['ID'];
  documentId: Scalars['ID'];
  payment: PaymentInput;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type LocalizedMailMessageTemplate = {
  language: Scalars['Language'];
  value: MailMessageTemplate;
};

export type LocalizedMailMessageTemplateInput = {
  language: Scalars['Language'];
  value: MailMessageTemplateInput;
};

export type LocalizedStringFilter = {
  language?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type MailContact = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: MailContactType;
  value: Scalars['EmailAddress'];
};

export type MailContactInput = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: MailContactType;
  value: Scalars['EmailAddress'];
};

/** Tipologie di contatti Mail */
export const MailContactType = {
  GUEST: 'GUEST',
  MAIN: 'MAIN',
  OTHER: 'OTHER',
  PEC: 'PEC',
  PRIVATE: 'PRIVATE',
  SUPPORT: 'SUPPORT'
} as const;

export type MailContactType = typeof MailContactType[keyof typeof MailContactType];
export type MailInput = {
  availabilityRequestId?: InputMaybe<Scalars['ID']>;
  bcc?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  customerId?: InputMaybe<Scalars['ID']>;
  documentsId?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['String'];
  messageAutomationId?: InputMaybe<Scalars['ID']>;
  messageTemplateId: Scalars['ID'];
  quotationId?: InputMaybe<Scalars['ID']>;
  replyTo?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['ID']>;
  subject: Scalars['String'];
  tenantId: Scalars['ID'];
  to: Scalars['String'];
};

export type MailMessageTemplate = {
  /** Contiene il json che utilizza il componente per visualizzare le mail */
  design?: Maybe<Scalars['String']>;
  /** Body html da utilizzare per inviare le mail */
  html?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type MailMessageTemplateInput = {
  /** Contiene il json che utilizza il componente per visualizzare le mail */
  design?: InputMaybe<Scalars['String']>;
  /** Body html da utilizzare per inviare le mail */
  html?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type ManualDailyPrice = {
  day: Scalars['Date'];
  price: Scalars['Int'];
};

export type ManualDailyPriceInput = {
  day: Scalars['Date'];
  price: Scalars['Int'];
};

export type ManualDocumentDetailInput = {
  amount: Scalars['Int'];
  date: Scalars['Date'];
  description: Scalars['String'];
  quantity: Scalars['Int'];
  reference: DetailNatureInput;
  vatId?: InputMaybe<Scalars['ID']>;
};

/** DOCUMENT */
export type ManualDocumentInput = {
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  documentDetails?: InputMaybe<Array<ManualDocumentDetailInput>>;
  documentPaymentDetails?: InputMaybe<Array<ManualDocumentPaymentDetailInput>>;
  /** default: true */
  draft?: InputMaybe<Scalars['Boolean']>;
  fiscalType: FiscalType;
  note?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

export type ManualDocumentPaymentDetailInput = {
  amount: Scalars['Int'];
  expireDate?: InputMaybe<Scalars['Date']>;
  paymentActiveId: Scalars['ID'];
};

export const MathOperation = {
  DECREASE: 'DECREASE',
  SUM: 'SUM'
} as const;

export type MathOperation = typeof MathOperation[keyof typeof MathOperation];
export type MessageAutomation = {
  auditable: Auditable;
  cancellationMessageTemplate?: Maybe<MessageTemplate>;
  /**  Required if scheduledType is CREATION  */
  cancellationMessageTemplateId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastExecution?: Maybe<Scalars['DateTime']>;
  linkToPayMessageTemplate?: Maybe<MessageTemplate>;
  /**  Required if scheduledType is CREATION  */
  linkToPayMessageTemplateId?: Maybe<Scalars['ID']>;
  messageTemplate: MessageTemplate;
  messageTemplateCode: MessageTemplateCode;
  messageTemplateId: Scalars['ID'];
  name: Scalars['String'];
  originIds: Array<Scalars['ID']>;
  phase: Array<ReservedResourcePhase>;
  property: Property;
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  scheduledConfiguration?: Maybe<MessageAutomationSchedule>;
  scheduledType: MessageAutomationScheduleType;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  wciState: MessageAutomationPresence;
};

export type MessageAutomationInput = {
  cancellationMessageTemplateId?: InputMaybe<Scalars['ID']>;
  isActive: Scalars['Boolean'];
  linkToPayMessageTemplateId?: InputMaybe<Scalars['ID']>;
  messageTemplateId: Scalars['ID'];
  name: Scalars['String'];
  originIds: Array<Scalars['ID']>;
  phase: Array<ReservedResourcePhase>;
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  scheduledConfiguration?: InputMaybe<MessageAutomationScheduleInput>;
  scheduledType: MessageAutomationScheduleType;
  tenantId: Scalars['ID'];
  wciState: MessageAutomationPresence;
};

export const MessageAutomationOutOfBouce = {
  IGNORE: 'IGNORE',
  SEND: 'SEND'
} as const;

export type MessageAutomationOutOfBouce = typeof MessageAutomationOutOfBouce[keyof typeof MessageAutomationOutOfBouce];
export const MessageAutomationPresence = {
  ALWAYS: 'ALWAYS',
  WCI_DONE: 'WCI_DONE',
  WCI_TODO: 'WCI_TODO'
} as const;

export type MessageAutomationPresence = typeof MessageAutomationPresence[keyof typeof MessageAutomationPresence];
export type MessageAutomationQueryFilter = {
  id?: InputMaybe<IDFilter>;
  messageTemplateId?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type MessageAutomationSchedule = {
  beforeOrAfter: BeforeOrAfter;
  days: Scalars['Int'];
  outOfBounds: MessageAutomationOutOfBouce;
  scheduleAt: Scalars['DateTime'];
};

export type MessageAutomationScheduleInput = {
  beforeOrAfter: BeforeOrAfter;
  days: Scalars['Int'];
  outOfBounds: MessageAutomationOutOfBouce;
  scheduleAt: Scalars['DateTime'];
};

export const MessageAutomationScheduleType = {
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  CREATION: 'CREATION'
} as const;

export type MessageAutomationScheduleType = typeof MessageAutomationScheduleType[keyof typeof MessageAutomationScheduleType];
export type MessageForAutomationInput = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/**
 * Template mail per le comunicazioni verso gli ospiti
 * I template sono gestiti da TS, quelli di sistema non hanno il tenant inserito.
 * In caso in cui il cliente le vuole personalizzare vengono duplicati e inseriti nel tenant.
 * In caso di multiproperty è possibile associare i template alle property
 * La gestione di campi unione viene gestita con handlebars che utilizza mustache come linguaggio
 * Lo stato Inactive è gestito quindi è necessario prenedere sia gli active che gli inactive se non diversamente specificato
 */
export type MessageTemplate = {
  auditable: Auditable;
  chat?: Maybe<Scalars['LocalizedString']>;
  /** Codice che identifica il template */
  code: MessageTemplateCode;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mail?: Maybe<Array<LocalizedMailMessageTemplate>>;
  name: Scalars['String'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
  type: MessageTemplateType;
};

/** Enum per i codici di MessageTemplate */
export const MessageTemplateCode = {
  AVAILABILITY_REQUEST: 'AVAILABILITY_REQUEST',
  COMMUNICATION: 'COMMUNICATION',
  LINK2PAY: 'LINK2PAY',
  POS_LINK2PAY: 'POS_LINK2PAY',
  QUOTATION: 'QUOTATION',
  RESERVATION: 'RESERVATION',
  RESERVATION_CANCEL: 'RESERVATION_CANCEL',
  UNPAID_DOCUMENTS: 'UNPAID_DOCUMENTS',
  WCI: 'WCI'
} as const;

export type MessageTemplateCode = typeof MessageTemplateCode[keyof typeof MessageTemplateCode];
export type MessageTemplateCodeFilter = {
  eq?: InputMaybe<MessageTemplateCode>;
  in?: InputMaybe<Array<MessageTemplateCode>>;
  ne?: InputMaybe<MessageTemplateCode>;
  nin?: InputMaybe<Array<MessageTemplateCode>>;
};

export type MessageTemplateInput = {
  chat?: InputMaybe<Scalars['LocalizedString']>;
  code: MessageTemplateCode;
  description?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  mail?: InputMaybe<Array<LocalizedMailMessageTemplateInput>>;
  name: Scalars['String'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  type: MessageTemplateType;
};

export type MessageTemplateQueryFilter = {
  code?: InputMaybe<MessageTemplateCodeFilter>;
  customOnly: Scalars['Boolean'];
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['Language']>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  type?: InputMaybe<MessageTemplateType>;
};

export const MessageTemplateType = {
  CHAT: 'CHAT',
  MAIL: 'MAIL'
} as const;

export type MessageTemplateType = typeof MessageTemplateType[keyof typeof MessageTemplateType];
/**
 * Moduli del metering
 *   BE BOOKING ENGINE
 *   CM CHANNEL MANAGER
 *   PMS PMS CORE
 *   RM RATE MANAGER
 */
export const MeteringModule = {
  BE: 'BE',
  CM: 'CM',
  PMS: 'PMS',
  RM: 'RM'
} as const;

export type MeteringModule = typeof MeteringModule[keyof typeof MeteringModule];
/**
 * Il modulo è legato al pacchetto che arriva dal metering
 * I moduli base sono PMS, CM, RMS e BM
 * Il modulo viene creato dal metering
 * Se viene disattivato viene gestito lo stato Inactive, cosi rimane traccia dei moduli.
 * La quantità serve per le camere
 */
export type Module = {
  auditable: Auditable;
  bbsPackageId?: Maybe<Scalars['String']>;
  consumptions?: Maybe<Array<ModuleConsumption>>;
  expireDate?: Maybe<Scalars['Date']>;
  family?: Maybe<Scalars['String']>;
  featureCode: MeteringModule;
  features?: Maybe<Array<Feature>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  packageId: Scalars['String'];
  plantId: Scalars['String'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  workspaceId: Scalars['String'];
};

export type ModuleConsumption = {
  quantity: Scalars['Int'];
  slotId: Scalars['String'];
};

export type MoveProductionAssignedInput = {
  destinationBill: Scalars['ID'];
  productionAssigneds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

/** Comuni italiani con dati neessari per gestire comunicazioni ps e istat. La collections viene aggiornata esternamente. */
export type Municipality = {
  auditable: Auditable;
  cadastralCode: Scalars['String'];
  codeItalianPs: Scalars['String'];
  history?: Maybe<Array<MunicipalityHistory>>;
  id: Scalars['ID'];
  istat: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
  provincialCapital: Scalars['Boolean'];
  region: Scalars['String'];
  regionCode: Scalars['String'];
};

export type MunicipalityHistory = {
  codeItalianPs: Scalars['String'];
  from: Scalars['Date'];
  istat: Scalars['String'];
  province: Scalars['String'];
  to: Scalars['Date'];
};

export type MunicipalityInput = {
  cadastralCode: Scalars['String'];
  codeItalianPs: Scalars['String'];
  istat: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
  provincialCapital: Scalars['Boolean'];
  region: Scalars['String'];
  regionCode: Scalars['String'];
};

export type MunicipalityQueryFilter = {
  id?: InputMaybe<IDFilter>;
  istat?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  province?: InputMaybe<StringFilter>;
};

export type Mutation = {
  activatePointOfSales?: Maybe<Scalars['Void']>;
  addCassaInCloudApiKey?: Maybe<CassaInCloudConfigurationApiKeyEntry>;
  airbnbResetRefreshToken?: Maybe<Scalars['Void']>;
  associateFiscalGatewayWorkstation: FiscalGatewayWorkstation;
  attachDatabaseForExport: Scalars['String'];
  checkinReservedResources?: Maybe<Scalars['Void']>;
  checkoutReservedResources?: Maybe<Scalars['Void']>;
  cleanImport?: Maybe<Scalars['Void']>;
  closeCashDesk?: Maybe<Scalars['Void']>;
  closeCityTaxMonthAstat: CloseCityTaxMonthAstatResult;
  confirmQuotation: PayAndConfirmQuotation;
  createAdditionalService: AdditionalService;
  createAmenity: Amenity;
  createAvailabilityRequest: AvailabilityRequest;
  createBill: Bill;
  createBookingEngineUrl: BookingEngineUrl;
  createBookingPolicy: BookingPolicy;
  createCashDesk: CashDesk;
  createCashDeskType: CashDeskType;
  createChannel: Channel;
  createChargeCategory: ChargeCategory;
  /**  Crea un pagamento per una prenotazione  */
  createChargeForReservation: TsPayCharge;
  createCheckoutDocument: Document;
  createCreditNoteDocument: Scalars['String'];
  createCreditNoteForAdvance: Scalars['String'];
  createCustomer: Customer;
  createDepositDocument: Document;
  createDocumentActive: DocumentActive;
  createExportProcedure: ExportProcedure;
  createExportScripts?: Maybe<Scalars['Void']>;
  createFiscalGatewayWorkstation: FiscalGatewayWorkstation;
  createIdentificationDocument: IdentificationDocument;
  /**  Crea un link 2 Pay per attivare il pos in presenza  */
  createLink2PayPosOnLine: Link2PayOutput;
  /**  Crea un link per attivare il pos in base alle booking policy della quotation (restituisce null se non c'è nulla da pagare in anticipo)  */
  createLinkForQuotation?: Maybe<Link2PayOutput>;
  /**  Crea un link per attivare il pos in base alle booking policy della reservation (restituisce null se non c'è nulla da pagare in anticipo)  */
  createLinkForReservation?: Maybe<Link2PayOutput>;
  /**  Crea un link 2 Pay per un documento di quietanza sospesi  */
  createLinkForUnpaidDocument: Link2PayOutput;
  createManualDocument: Document;
  createMessageAutomation: MessageAutomation;
  createMessageTemplate: MessageTemplate;
  createMunicipality: Municipality;
  createOrigin: Origin;
  createPaidInFullDocument: Scalars['String'];
  createPaymentActive: PaymentActive;
  createPaymentMethod: PaymentMethod;
  createPointOfSaleMealShift: PointOfSaleMealShift;
  createPosition: Position;
  createProduct: Product;
  createProduction: Production;
  createProperty: Property;
  createQuotation: Quotation;
  createQuotationForIbe: QuotationForIbeOutput;
  createQuotationRequest?: Maybe<Scalars['Void']>;
  createRate: Rate;
  createReservation: Reservation;
  createReservationState: ReservationState;
  createReservedResource: ReservedResource;
  createResource: Resource;
  createResourceType: ResourceType;
  createResourceUnavailability: Resource;
  createTSPayGatewayForProperties?: Maybe<Scalars['Void']>;
  createTag: Tag;
  createTotem: Totem;
  /**  Crea un'apikey per il merchant, da chiamare dopo il completamento dell'onboarding  */
  createTsPayApiKey: TsPayApiKey;
  createUserAndRole?: Maybe<Scalars['Void']>;
  createVat: Vat;
  deleteAdditionalService?: Maybe<Scalars['Void']>;
  deleteAmenity?: Maybe<Scalars['Void']>;
  deleteBill?: Maybe<Scalars['Void']>;
  deleteBookingEngineUrl?: Maybe<Scalars['Void']>;
  deleteBookingPolicy?: Maybe<Scalars['Void']>;
  deleteBulkReservations?: Maybe<Scalars['Void']>;
  deleteCashDeskType?: Maybe<Scalars['Void']>;
  deleteChannel?: Maybe<Scalars['Void']>;
  deleteChargeCategory?: Maybe<Scalars['Void']>;
  deleteCustomer?: Maybe<Scalars['Void']>;
  deleteCustomerDocumentImage?: Maybe<Scalars['Void']>;
  deleteDocument?: Maybe<Scalars['Void']>;
  deleteDocumentActive?: Maybe<Scalars['Void']>;
  deleteExportProcedure?: Maybe<Scalars['Void']>;
  deleteFiscalGatewayWorkstation?: Maybe<Scalars['Void']>;
  deleteIdentificationDocument?: Maybe<Scalars['Void']>;
  deleteInternalThreadMessage?: Maybe<Scalars['Void']>;
  deleteMessageAutomation?: Maybe<Scalars['Void']>;
  deleteMessageTemplate?: Maybe<Scalars['Void']>;
  deleteMunicipality?: Maybe<Scalars['Void']>;
  deleteOrigin?: Maybe<Scalars['Void']>;
  deletePaymentActive?: Maybe<Scalars['Void']>;
  deletePaymentMethod?: Maybe<Scalars['Void']>;
  deletePointOfSaleMealShift?: Maybe<Scalars['Void']>;
  deletePosition?: Maybe<Scalars['Void']>;
  deleteProduct?: Maybe<Scalars['Void']>;
  deleteProduction?: Maybe<Scalars['Void']>;
  deleteProperty?: Maybe<Scalars['Void']>;
  deleteQuotation?: Maybe<Scalars['Void']>;
  deleteRate?: Maybe<Scalars['Void']>;
  deleteReservation?: Maybe<Scalars['Void']>;
  deleteReservationState?: Maybe<Scalars['Void']>;
  deleteReservedResource?: Maybe<Scalars['Void']>;
  deleteResource?: Maybe<Scalars['Void']>;
  deleteResourceType?: Maybe<Scalars['Void']>;
  deleteResourceUnavailability: Resource;
  deleteTag?: Maybe<Scalars['Void']>;
  deleteTotem?: Maybe<Scalars['Void']>;
  deleteVat?: Maybe<Scalars['Void']>;
  downloadPSReceipt: Array<File>;
  executeDailyClosure?: Maybe<Scalars['Void']>;
  executeMessageAutomation?: Maybe<Scalars['Void']>;
  exportDatabase: ExportDatabaseOutput;
  fileUploadPresignedURL: FileUploadResponse;
  finalizeDocument?: Maybe<Scalars['Void']>;
  generateCityTaxFile: GenerateCityTaxFileResult;
  generateIstatFile: GenerateIstatFileResult;
  generateTenantSecret: Scalars['String'];
  guestPortalAddServices?: Maybe<Scalars['Void']>;
  guestPortalCancelReservation: CancelReservationResult;
  guestPortalCheckinReservedResources?: Maybe<Scalars['Void']>;
  guestPortalCheckoutReservedResources?: Maybe<Scalars['Void']>;
  guestPortalCreateCheckoutDocument: GuestPortalCheckoutDocumentResult;
  guestPortalWebCheckin?: Maybe<Scalars['Void']>;
  horecahubRegisterIntegration: HorecaHubIntegration;
  importProperty: ImportPropertyOutput;
  importPropertyRetry: ImportPropertyOutput;
  insertBulkReservations?: Maybe<Scalars['String']>;
  /** Create a new Sinapsi competitor scraping task */
  insertSinapsiCompetitorRetrievalTask: Scalars['ID'];
  makeFakeEvent?: Maybe<Scalars['Void']>;
  moveProductionAssigned?: Maybe<Scalars['Void']>;
  notifyAvailabilityRequest?: Maybe<Scalars['Void']>;
  onboardingProperty?: Maybe<Property>;
  onboardingResourceType: ResourceType;
  openCashDesk?: Maybe<Scalars['Void']>;
  planReservedResourceCommitments?: Maybe<Scalars['Void']>;
  processReservation?: Maybe<Scalars['Void']>;
  rebuildPropertyAvailability?: Maybe<Scalars['Void']>;
  removeCassaInCloudApiKey?: Maybe<Scalars['Void']>;
  removePointOfSale?: Maybe<Scalars['Void']>;
  retrieveFutureReservations: Scalars['Date'];
  retrieveReservation?: Maybe<Scalars['Void']>;
  sendAttachmentEmailForDocument?: Maybe<Email>;
  sendAvailabilitiesAndPrices?: Maybe<Scalars['Void']>;
  sendDataHubSpot?: Maybe<Scalars['String']>;
  /**  BAD FORMAT errors are returned as string  */
  sendInvoiceToTSDigital?: Maybe<FelAdditionalInfo>;
  sendIstat?: Maybe<Array<IstatError>>;
  sendIstatCancellation?: Maybe<Array<IstatError>>;
  sendIstatPeriod?: Maybe<Scalars['Void']>;
  sendMail: Email;
  sendMessageForAutomation?: Maybe<Scalars['Void']>;
  sendPaymentLinkEmailForUnpaidDocuments?: Maybe<Email>;
  sendPosLink2PayEmail?: Maybe<Email>;
  sendPropertyData?: Maybe<Scalars['Void']>;
  sendPs?: Maybe<Array<Scalars['String']>>;
  sendQuotationEmail?: Maybe<Email>;
  sendReceiptToFiscalGateway?: Maybe<Scalars['Void']>;
  sendReminderEmailForUnpaidDocuments?: Maybe<Email>;
  sendReservationMessage?: Maybe<Scalars['Void']>;
  sendThreadMessage?: Maybe<Scalars['Void']>;
  setChargeTransformation?: Maybe<Scalars['Void']>;
  setEntityImages?: Maybe<Scalars['Void']>;
  setHotelDate?: Maybe<Scalars['Void']>;
  setInsightPause?: Maybe<Scalars['Void']>;
  setNcsNotificationRead?: Maybe<Scalars['Void']>;
  setNcsNotificationsRead?: Maybe<Scalars['Void']>;
  setNcsUserPreference?: Maybe<Scalars['Void']>;
  setPropertyCityTaxConfiguration?: Maybe<Scalars['Void']>;
  setPropertyConfigurations?: Maybe<Scalars['Void']>;
  setPropertyFiscalConfiguration?: Maybe<Scalars['Void']>;
  setPropertyIstatConfiguration?: Maybe<Scalars['Void']>;
  setPropertyPsConfiguration?: Maybe<Scalars['Void']>;
  setPropertySinapsiConfiguration?: Maybe<Scalars['Void']>;
  setPropertySubAddresses?: Maybe<Scalars['Void']>;
  setQuotationState?: Maybe<Scalars['Void']>;
  setResourceCleaningState?: Maybe<Scalars['Void']>;
  setResourceHousekeepers?: Maybe<Scalars['Void']>;
  setScelTemplate?: Maybe<Scalars['Void']>;
  /** Run a round of Autopilot updates and/or cache refreshes; usually invoked as a Lambda, this API entry is provided for debug */
  sinapsiUpdate: SinapsiUpdateOutcome;
  splitProductionAssigned?: Maybe<Scalars['Void']>;
  /**
   * Mutation che si occupa di eseguire l'export, sono gestiti errori relativi a mancanza di configurazione e errore in casi di export già estratti
   * CONFIGURATION_KEY , INVALID_OPERATION
   */
  startExportManagement: ExportData;
  startTotemWorkflow?: Maybe<Scalars['Void']>;
  /**  Ritorna l'url da seguire per completare l'onboarding  */
  startTsPayOnboarding: Scalars['String'];
  stopTotemWorkflow?: Maybe<Scalars['Void']>;
  undoCheckinReservedResources?: Maybe<Scalars['Void']>;
  undoCheckoutReservedResources?: Maybe<Scalars['Void']>;
  undoDocument?: Maybe<Scalars['Void']>;
  undoImport?: Maybe<Scalars['Void']>;
  updateAdditionalService: AdditionalService;
  updateAmenity: Amenity;
  /** Apply Sinapsi recommendtions to a given property */
  updateBasePricesBySinapsiAutopilot: SinapsiUpdateOutcome;
  updateBill: Bill;
  updateBookingEngineUrl: BookingEngineUrl;
  updateBookingPolicy: BookingPolicy;
  updateCashDeskType: CashDeskType;
  updateCassaInCloudApiKey?: Maybe<Scalars['Void']>;
  updateChannel: Channel;
  updateChargeCategory: ChargeCategory;
  updateCityTaxProduction?: Maybe<Scalars['Void']>;
  updateCustomer: Customer;
  updateCustomerPrivacySign?: Maybe<Scalars['Void']>;
  updateDepositAssigneds?: Maybe<Scalars['Void']>;
  updateDocument: Document;
  updateDocumentActive: DocumentActive;
  updateDocumentNumber?: Maybe<Scalars['Void']>;
  updateDocumentPaymentDetails?: Maybe<Scalars['Void']>;
  updateExportProcedure: ExportProcedure;
  updateFinalizedDocument: Document;
  updateIdentificationDocument: IdentificationDocument;
  updateInvoiceCustomFields?: Maybe<Scalars['Void']>;
  updateInvoiceState?: Maybe<FelAdditionalInfo>;
  updateMessageAutomation: MessageAutomation;
  updateMessageTemplate: MessageTemplate;
  updateMunicipality: Municipality;
  updateOrigin: Origin;
  updatePaymentActive: PaymentActive;
  updatePaymentMethod: PaymentMethod;
  updatePointOfSale?: Maybe<Scalars['Void']>;
  updatePointOfSaleMealShift?: Maybe<Scalars['Void']>;
  updatePosition: Position;
  updatePriceCalendar?: Maybe<Scalars['Void']>;
  updatePriceCalendarRange?: Maybe<Scalars['Void']>;
  updatePrivacySettings?: Maybe<Scalars['Void']>;
  updateProduct: Product;
  updateProduction: Production;
  updateProperty: Property;
  updateQuotation: Quotation;
  updateRate: Rate;
  updateReservation: Reservation;
  updateReservationState: ReservationState;
  updateReservedResource: ReservedResource;
  updateReservedResources: Array<ReservedResource>;
  updateResource: Resource;
  updateResourceType: ResourceType;
  updateResourceUnavailability: Resource;
  updateResourcesRoomTetrisOrder?: Maybe<Scalars['Void']>;
  updateSellerName?: Maybe<Scalars['Void']>;
  /** Update an existing competitor scraping task */
  updateSinapsiCompetitorRetrievalTask: Scalars['ID'];
  /** Store the results of a Sinapsi competitor scraping task and unlock it for the next execution */
  updateSinapsiCompetitorRetrievalTaskResults: Scalars['String'];
  updateSupportUserRole: Scalars['Boolean'];
  updateTSPaySourcesForProperties?: Maybe<Scalars['Void']>;
  updateTag: Tag;
  updateThread?: Maybe<Scalars['Void']>;
  updateTotem: Totem;
  updateUserRole?: Maybe<Scalars['Void']>;
  updateVat: Vat;
  upsertNcsGroups?: Maybe<Scalars['Void']>;
  upsertReservedResourceGuest?: Maybe<Scalars['Void']>;
};


export type MutationactivatePointOfSalesArgs = {
  input: ActivatePointOfSalesInput;
};


export type MutationaddCassaInCloudApiKeyArgs = {
  value: CassaInCloudApiKeyInput;
};


export type MutationairbnbResetRefreshTokenArgs = {
  channelId: Scalars['ID'];
};


export type MutationassociateFiscalGatewayWorkstationArgs = {
  cashDeskTypeId: Scalars['ID'];
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationattachDatabaseForExportArgs = {
  backupName: Scalars['String'];
  dbName: Scalars['String'];
};


export type MutationcheckinReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
  skipProduction?: InputMaybe<Scalars['Boolean']>;
};


export type MutationcheckoutReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
  options?: InputMaybe<CheckoutReservedResourceOption>;
};


export type MutationcleanImportArgs = {
  tenantId: Scalars['ID'];
};


export type MutationcloseCashDeskArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationcloseCityTaxMonthAstatArgs = {
  input: CloseCityTaxMonthAstatInput;
};


export type MutationconfirmQuotationArgs = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  input: ConfirmQuotationInput;
};


export type MutationcreateAdditionalServiceArgs = {
  value: AdditionalServiceInput;
};


export type MutationcreateAmenityArgs = {
  value: AmenityInput;
};


export type MutationcreateAvailabilityRequestArgs = {
  input: AvailabilityRequestInput;
};


export type MutationcreateBillArgs = {
  value: BillInput;
};


export type MutationcreateBookingEngineUrlArgs = {
  value: BookingEngineUrlInput;
};


export type MutationcreateBookingPolicyArgs = {
  value: BookingPolicyInput;
};


export type MutationcreateCashDeskArgs = {
  value: CashDeskInput;
};


export type MutationcreateCashDeskTypeArgs = {
  value: CashDeskTypeInput;
};


export type MutationcreateChannelArgs = {
  value: ChannelInput;
};


export type MutationcreateChargeCategoryArgs = {
  value: ChargeCategoryInput;
};


export type MutationcreateChargeForReservationArgs = {
  input: ChargeForReservationInput;
};


export type MutationcreateCheckoutDocumentArgs = {
  value: CheckoutDocumentInput;
};


export type MutationcreateCreditNoteDocumentArgs = {
  input: CreditNoteDocumentInput;
};


export type MutationcreateCreditNoteForAdvanceArgs = {
  input: CreditNoteForAdvanceInput;
};


export type MutationcreateCustomerArgs = {
  returnExisting?: InputMaybe<Scalars['Boolean']>;
  value: CustomerInput;
};


export type MutationcreateDepositDocumentArgs = {
  value: DepositDocumentInput;
};


export type MutationcreateDocumentActiveArgs = {
  value: DocumentActiveInput;
};


export type MutationcreateExportProcedureArgs = {
  value: ExportProcedureInput;
};


export type MutationcreateExportScriptsArgs = {
  backupName: Scalars['String'];
  type: PmsType;
};


export type MutationcreateFiscalGatewayWorkstationArgs = {
  cashDeskTypeId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationcreateIdentificationDocumentArgs = {
  value: IdentificationDocumentInput;
};


export type MutationcreateLink2PayPosOnLineArgs = {
  input: Link2PayInput;
};


export type MutationcreateLinkForQuotationArgs = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  input: Link2PayQuotationInput;
};


export type MutationcreateLinkForReservationArgs = {
  input: Link2PayReservationInput;
};


export type MutationcreateLinkForUnpaidDocumentArgs = {
  input: Link2PayUnpaidDocumentInput;
};


export type MutationcreateManualDocumentArgs = {
  value: ManualDocumentInput;
};


export type MutationcreateMessageAutomationArgs = {
  value: MessageAutomationInput;
};


export type MutationcreateMessageTemplateArgs = {
  value: MessageTemplateInput;
};


export type MutationcreateMunicipalityArgs = {
  value: MunicipalityInput;
};


export type MutationcreateOriginArgs = {
  value: OriginInput;
};


export type MutationcreatePaidInFullDocumentArgs = {
  input: PaidInFullDocumentInput;
};


export type MutationcreatePaymentActiveArgs = {
  value: PaymentActiveInput;
};


export type MutationcreatePaymentMethodArgs = {
  value: PaymentMethodInput;
};


export type MutationcreatePointOfSaleMealShiftArgs = {
  value: PointOfSaleMealShiftInput;
};


export type MutationcreatePositionArgs = {
  value: PositionInput;
};


export type MutationcreateProductArgs = {
  value: ProductInput;
};


export type MutationcreateProductionArgs = {
  billAllocation: Array<BillAllocationInput>;
  value: ProductionInput;
};


export type MutationcreatePropertyArgs = {
  plantId?: InputMaybe<Scalars['String']>;
  value: PropertyInput;
};


export type MutationcreateQuotationArgs = {
  value: QuotationInput;
};


export type MutationcreateQuotationForIbeArgs = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  value: QuotationInput;
};


export type MutationcreateQuotationRequestArgs = {
  request: QuotationRequestInput;
  value: QuotationInput;
};


export type MutationcreateRateArgs = {
  value: RateInput;
};


export type MutationcreateReservationArgs = {
  options?: InputMaybe<ReservationOptions>;
  value: ReservationInput;
};


export type MutationcreateReservationStateArgs = {
  value: ReservationStateInput;
};


export type MutationcreateReservedResourceArgs = {
  options: ReservationOptions;
  value: ReservedResourceInput;
};


export type MutationcreateResourceArgs = {
  value: ResourceInput;
};


export type MutationcreateResourceTypeArgs = {
  value: ResourceTypeInput;
};


export type MutationcreateResourceUnavailabilityArgs = {
  allowOverbooking: Scalars['Boolean'];
  value: CreateResourceUnavailabilityInput;
};


export type MutationcreateTSPayGatewayForPropertiesArgs = {
  tenantId: Scalars['ID'];
};


export type MutationcreateTagArgs = {
  value: TagInput;
};


export type MutationcreateTotemArgs = {
  value: TotemInput;
};


export type MutationcreateTsPayApiKeyArgs = {
  merchantRef: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationcreateUserAndRoleArgs = {
  input: UserInput;
};


export type MutationcreateVatArgs = {
  value: VatInput;
};


export type MutationdeleteAdditionalServiceArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteAmenityArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBillArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBookingEngineUrlArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBookingPolicyArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBulkReservationsArgs = {
  correlationId: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteCashDeskTypeArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteChannelArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteChargeCategoryArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteCustomerArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteCustomerDocumentImageArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteDocumentArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteDocumentActiveArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteExportProcedureArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteFiscalGatewayWorkstationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteIdentificationDocumentArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteInternalThreadMessageArgs = {
  tenantId: Scalars['ID'];
  threadMessageId: Scalars['ID'];
};


export type MutationdeleteMessageAutomationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteMessageTemplateArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteMunicipalityArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteOriginArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePaymentActiveArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePaymentMethodArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePointOfSaleMealShiftArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePositionArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteProductArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteProductionArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePropertyArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteQuotationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteRateArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteReservationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteReservationStateArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteReservedResourceArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteResourceArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteResourceTypeArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteResourceUnavailabilityArgs = {
  value: DeleteResourceUnavailabilityInput;
};


export type MutationdeleteTagArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteTotemArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteVatArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdownloadPSReceiptArgs = {
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationexecuteDailyClosureArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationexecuteMessageAutomationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationexportDatabaseArgs = {
  input: ExportDatabaseInput;
};


export type MutationfileUploadPresignedURLArgs = {
  file: FileInput;
};


export type MutationfinalizeDocumentArgs = {
  id: Scalars['String'];
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};


export type MutationgenerateCityTaxFileArgs = {
  input: GenerateCityTaxFileInput;
};


export type MutationgenerateIstatFileArgs = {
  input: GenerateIstatFileInput;
};


export type MutationgenerateTenantSecretArgs = {
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};


export type MutationguestPortalAddServicesArgs = {
  value: GuestPortalAddServicesInput;
};


export type MutationguestPortalCancelReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationguestPortalCheckinReservedResourcesArgs = {
  input: GuestPortalCheckinReservedResourcesInput;
};


export type MutationguestPortalCheckoutReservedResourcesArgs = {
  input: GuestPortalCheckoutReservedResourcesInput;
};


export type MutationguestPortalCreateCheckoutDocumentArgs = {
  value: GuestPortalCheckoutDocumentInput;
};


export type MutationguestPortalWebCheckinArgs = {
  value: GuestPortalWebCheckinInput;
};


export type MutationhorecahubRegisterIntegrationArgs = {
  tenantId: Scalars['ID'];
};


export type MutationimportPropertyArgs = {
  value: ImportPropertyInput;
};


export type MutationimportPropertyRetryArgs = {
  input: RetryImportPropertyInput;
};


export type MutationinsertBulkReservationsArgs = {
  propertyId: Scalars['ID'];
  rows: Array<BulkReservationInput>;
  tenantId: Scalars['ID'];
};


export type MutationinsertSinapsiCompetitorRetrievalTaskArgs = {
  task_info: SinapsiCompetitorRetrievalTaskInput;
};


export type MutationmoveProductionAssignedArgs = {
  input: MoveProductionAssignedInput;
};


export type MutationnotifyAvailabilityRequestArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationonboardingPropertyArgs = {
  value: OnBoardingInput;
};


export type MutationonboardingResourceTypeArgs = {
  value: OnBoardingResourceTypeInput;
};


export type MutationopenCashDeskArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationplanReservedResourceCommitmentsArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationprocessReservationArgs = {
  channelReservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationrebuildPropertyAvailabilityArgs = {
  fireAndForget: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationremoveCassaInCloudApiKeyArgs = {
  apiKey: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationremovePointOfSaleArgs = {
  input: RemovePointOfSaleInput;
};


export type MutationretrieveFutureReservationsArgs = {
  channelId: Scalars['ID'];
  portalName: PortalName;
  tenantId: Scalars['ID'];
};


export type MutationretrieveReservationArgs = {
  channelId: Scalars['ID'];
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  portalName: PortalName;
  tenantId: Scalars['ID'];
  voucher?: InputMaybe<Scalars['String']>;
};


export type MutationsendAttachmentEmailForDocumentArgs = {
  input: AttachmentForDocumentInput;
};


export type MutationsendAvailabilitiesAndPricesArgs = {
  input: SendAvailabilitiesAndPricesInput;
};


export type MutationsendDataHubSpotArgs = {
  data: Array<HubSpotDataInput>;
};


export type MutationsendInvoiceToTSDigitalArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsendIstatArgs = {
  input: SendIstatInput;
};


export type MutationsendIstatCancellationArgs = {
  input: SendIstatCancellationInput;
};


export type MutationsendIstatPeriodArgs = {
  input: SendIstatPeriodInput;
};


export type MutationsendMailArgs = {
  input: MailInput;
};


export type MutationsendMessageForAutomationArgs = {
  input: MessageForAutomationInput;
};


export type MutationsendPaymentLinkEmailForUnpaidDocumentsArgs = {
  input: PaymentLinkForUnpaidDocumentsInput;
};


export type MutationsendPosLink2PayEmailArgs = {
  input: SendPosLink2PayEmailInput;
};


export type MutationsendPropertyDataArgs = {
  input: SendPropertyDataInput;
};


export type MutationsendPsArgs = {
  input: SendPSInput;
};


export type MutationsendQuotationEmailArgs = {
  input: SendQuotationEmailInput;
};


export type MutationsendReceiptToFiscalGatewayArgs = {
  id: Scalars['ID'];
  resend?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};


export type MutationsendReminderEmailForUnpaidDocumentsArgs = {
  input: ReminderForUnpaidDocumentsInput;
};


export type MutationsendReservationMessageArgs = {
  input: SendReservationMessageInput;
};


export type MutationsendThreadMessageArgs = {
  input: SendMessageInput;
};


export type MutationsetChargeTransformationArgs = {
  value: ChargeTransformationInput;
};


export type MutationsetEntityImagesArgs = {
  input: EntityImageInput;
};


export type MutationsetHotelDateArgs = {
  input: HotelDateInput;
};


export type MutationsetInsightPauseArgs = {
  input: InsightInput;
};


export type MutationsetNcsNotificationReadArgs = {
  id: Scalars['String'];
  read: Scalars['Boolean'];
};


export type MutationsetNcsNotificationsReadArgs = {
  propertyId: Scalars['ID'];
  read: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationsetNcsUserPreferenceArgs = {
  preferences: Array<NcsTemplatePreferenceInput>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationsetPropertyCityTaxConfigurationArgs = {
  config: Array<CityTaxConfigurationInput>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertyConfigurationsArgs = {
  value: SetPropertyConfigurationsInput;
};


export type MutationsetPropertyFiscalConfigurationArgs = {
  config: Array<FiscalConfigurationInput>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertyIstatConfigurationArgs = {
  config?: InputMaybe<Array<IstatConfigurationInput>>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertyPsConfigurationArgs = {
  config?: InputMaybe<Array<PsConfigurationInput>>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertySinapsiConfigurationArgs = {
  config: SinapsiConfigurationInput;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertySubAddressesArgs = {
  config?: InputMaybe<Array<PropertySubAddressInput>>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetQuotationStateArgs = {
  id: Scalars['ID'];
  state: SetQuotationState;
  tenantId: Scalars['ID'];
};


export type MutationsetResourceCleaningStateArgs = {
  input: ResourceCleaningStateInput;
};


export type MutationsetResourceHousekeepersArgs = {
  input: SetResourceHousekeepersInput;
};


export type MutationsetScelTemplateArgs = {
  scelTemplate: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationsinapsiUpdateArgs = {
  options: SinapsiUpdateOptions;
};


export type MutationsplitProductionAssignedArgs = {
  input: SplitProductionAssignedInput;
};


export type MutationstartExportManagementArgs = {
  input: ExportInput;
};


export type MutationstartTotemWorkflowArgs = {
  input: StartTotemWorkflowInput;
};


export type MutationstartTsPayOnboardingArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  vatNumber: Scalars['String'];
};


export type MutationstopTotemWorkflowArgs = {
  input: StopTotemWorkflowInput;
};


export type MutationundoCheckinReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
};


export type MutationundoCheckoutReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
};


export type MutationundoDocumentArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationundoImportArgs = {
  deleteImported: Scalars['Boolean'];
  deleteProperty: Scalars['Boolean'];
  extPropertyId: Scalars['String'];
  stepFrom: UndoImportStep;
  tenantId: Scalars['ID'];
};


export type MutationupdateAdditionalServiceArgs = {
  id: Scalars['String'];
  value: AdditionalServiceInput;
};


export type MutationupdateAmenityArgs = {
  id: Scalars['String'];
  value: AmenityInput;
};


export type MutationupdateBasePricesBySinapsiAutopilotArgs = {
  filter: SinapsiFilter;
  options: SinapsiAutopilotOptions;
};


export type MutationupdateBillArgs = {
  id: Scalars['ID'];
  value: BillInput;
};


export type MutationupdateBookingEngineUrlArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};


export type MutationupdateBookingPolicyArgs = {
  id: Scalars['String'];
  value: BookingPolicyInput;
};


export type MutationupdateCashDeskTypeArgs = {
  id: Scalars['String'];
  input: CashDeskTypeInput;
};


export type MutationupdateCassaInCloudApiKeyArgs = {
  value: CassaInCloudApiKeyInput;
};


export type MutationupdateChannelArgs = {
  id: Scalars['String'];
  value: ChannelInput;
};


export type MutationupdateChargeCategoryArgs = {
  id: Scalars['String'];
  value: ChargeCategoryInput;
};


export type MutationupdateCityTaxProductionArgs = {
  fullStay?: InputMaybe<Scalars['Boolean']>;
  guestId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateCustomerArgs = {
  guestOfReservedResourceId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  value: CustomerInput;
};


export type MutationupdateCustomerPrivacySignArgs = {
  input: CustomerPrivacyInput;
};


export type MutationupdateDepositAssignedsArgs = {
  depositAssigneds: Array<UpdateDepositAssigneds>;
  depositDocumentId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateDocumentArgs = {
  id: Scalars['String'];
  value: DocumentInput;
};


export type MutationupdateDocumentActiveArgs = {
  id: Scalars['String'];
  input: DocumentActiveInput;
};


export type MutationupdateDocumentNumberArgs = {
  input: UpdateDocumentNumberInput;
};


export type MutationupdateDocumentPaymentDetailsArgs = {
  id: Scalars['ID'];
  paymentActiveIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};


export type MutationupdateExportProcedureArgs = {
  id: Scalars['String'];
  value: ExportProcedureInput;
};


export type MutationupdateFinalizedDocumentArgs = {
  id: Scalars['String'];
  value: DocumentInput;
};


export type MutationupdateIdentificationDocumentArgs = {
  id: Scalars['String'];
  value: IdentificationDocumentInput;
};


export type MutationupdateInvoiceCustomFieldsArgs = {
  customFields: FelCustomFieldsInput;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateInvoiceStateArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateMessageAutomationArgs = {
  id: Scalars['ID'];
  value: MessageAutomationInput;
};


export type MutationupdateMessageTemplateArgs = {
  id: Scalars['String'];
  value: MessageTemplateInput;
};


export type MutationupdateMunicipalityArgs = {
  id: Scalars['String'];
  value: MunicipalityInput;
};


export type MutationupdateOriginArgs = {
  id: Scalars['ID'];
  value: OriginInput;
};


export type MutationupdatePaymentActiveArgs = {
  id: Scalars['String'];
  input: PaymentActiveInput;
};


export type MutationupdatePaymentMethodArgs = {
  id: Scalars['String'];
  value: PaymentMethodInput;
};


export type MutationupdatePointOfSaleArgs = {
  id: Scalars['String'];
  value: PointOfSaleInput;
};


export type MutationupdatePointOfSaleMealShiftArgs = {
  id: Scalars['String'];
  value: PointOfSaleMealShiftInput;
};


export type MutationupdatePositionArgs = {
  id: Scalars['String'];
  value: PositionInput;
};


export type MutationupdatePriceCalendarArgs = {
  value: PriceCalendarInput;
};


export type MutationupdatePriceCalendarRangeArgs = {
  value: PriceCalendarRangeInput;
};


export type MutationupdatePrivacySettingsArgs = {
  tenantId: Scalars['ID'];
  value: PrivacySettingsInput;
};


export type MutationupdateProductArgs = {
  id: Scalars['ID'];
  value: ProductInput;
};


export type MutationupdateProductionArgs = {
  id: Scalars['ID'];
  value: ProductionInput;
};


export type MutationupdatePropertyArgs = {
  id: Scalars['ID'];
  value: PropertyInput;
};


export type MutationupdateQuotationArgs = {
  id: Scalars['ID'];
  setDraftState?: InputMaybe<Scalars['Boolean']>;
  value: QuotationInput;
};


export type MutationupdateRateArgs = {
  id: Scalars['String'];
  value: RateInput;
};


export type MutationupdateReservationArgs = {
  id: Scalars['ID'];
  options?: InputMaybe<ReservationOptions>;
  value: ReservationUpdateInput;
};


export type MutationupdateReservationStateArgs = {
  id: Scalars['ID'];
  value: ReservationStateInput;
};


export type MutationupdateReservedResourceArgs = {
  id: Scalars['ID'];
  options: ReservedResourceOptions;
  value: ReservedResourceInput;
};


export type MutationupdateReservedResourcesArgs = {
  options: ReservationOptions;
  value: Array<ReservedResourceMultiInput>;
};


export type MutationupdateResourceArgs = {
  id: Scalars['String'];
  value: ResourceInput;
};


export type MutationupdateResourceTypeArgs = {
  id: Scalars['String'];
  value: ResourceTypeInput;
};


export type MutationupdateResourceUnavailabilityArgs = {
  allowOverbooking: Scalars['Boolean'];
  value: UpdateResourceUnavailabilityInput;
};


export type MutationupdateResourcesRoomTetrisOrderArgs = {
  input: Array<UpdateResourceRoomTetrisOrderInput>;
  tenantId: Scalars['ID'];
};


export type MutationupdateSellerNameArgs = {
  tenantId: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
};


export type MutationupdateSinapsiCompetitorRetrievalTaskArgs = {
  updated_task_info: SinapsiCompetitorRetrievalTaskUpdateInput;
};


export type MutationupdateSinapsiCompetitorRetrievalTaskResultsArgs = {
  data: SinapsiCompetitorRetrievalTaskResultsInput;
};


export type MutationupdateSupportUserRoleArgs = {
  itemId: Scalars['String'];
};


export type MutationupdateTSPaySourcesForPropertiesArgs = {
  tenantId: Scalars['ID'];
};


export type MutationupdateTagArgs = {
  id: Scalars['String'];
  value: TagInput;
};


export type MutationupdateThreadArgs = {
  input: UpdateThreadInput;
};


export type MutationupdateTotemArgs = {
  id: Scalars['ID'];
  value: TotemInput;
};


export type MutationupdateUserRoleArgs = {
  id: Scalars['ID'];
  value: Array<UserRoleInput>;
};


export type MutationupdateVatArgs = {
  id: Scalars['String'];
  value: VatInput;
};


export type MutationupsertNcsGroupsArgs = {
  propertyId?: InputMaybe<Scalars['ID']>;
  skipUserPreferences?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationupsertReservedResourceGuestArgs = {
  value: ReservedResourceGuestInput;
};

export type NationalityStatistic = {
  isoCode: Scalars['String'];
  quantity: Scalars['Int'];
};

export const NcsChannel = {
  EMAIL: 'EMAIL',
  PEC: 'PEC',
  PUSH: 'PUSH',
  SMS: 'SMS',
  WEB: 'WEB',
  WEBHOOK: 'WEBHOOK'
} as const;

export type NcsChannel = typeof NcsChannel[keyof typeof NcsChannel];
export type NcsNotification = {
  appCode?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  delivered?: Maybe<Scalars['Boolean']>;
  deliveredDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ncsId?: Maybe<Scalars['String']>;
  notification?: Maybe<NcsNotificationDetail>;
  priority?: Maybe<NcsPriorityEnum>;
  read?: Maybe<Scalars['Boolean']>;
  readDate?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type NcsNotificationDetail = {
  message?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NcsNotificationSummary = {
  appCode?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  unread?: Maybe<Scalars['Int']>;
};

export const NcsPriorityEnum = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM'
} as const;

export type NcsPriorityEnum = typeof NcsPriorityEnum[keyof typeof NcsPriorityEnum];
/**
 * Tipo che identifica il template utilizzato per inviare un tipo messaggio tramite il servizio NCS.
 * Il template contiene le specifiche per i diversi canali (EMAIL, WEB, SMS...)
 */
export type NcsTemplate = {
  id: Scalars['ID'];
  ncsTemplatesRequest: Scalars['JSON'];
  processed: Scalars['Boolean'];
};

export type NcsTemplatePreference = {
  channels?: Maybe<Array<NcsChannel>>;
  template?: Maybe<Scalars['String']>;
};

export type NcsTemplatePreferenceInput = {
  channels: Array<NcsChannel>;
  template: Scalars['String'];
};

export type NcsUserPreference = {
  ncsId: Scalars['String'];
  templates: Array<NcsTemplatePreference>;
};

export type NcsUserPreferenceInput = {
  ncsIdGroup: Scalars['String'];
  ncsIdUser: Scalars['String'];
  preferences: Array<NcsTemplatePreferenceInput>;
};

export type NewThreadMessageEvent = {
  incoming: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type NewThreadMessageEventFilter = {
  incoming?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId?: InputMaybe<Scalars['ID']>;
};

export type NexiData = {
  /**  corrisponde ad apiKey di Nexi ed è salvato come apiKey sulla collectionu apiKey  */
  alias: Scalars['String'];
  /**  è il secretCode di Nexi per il calcolo del MAC ed è salvato come authKey sulla collection apiKey  */
  secretKey: Scalars['String'];
  /**  corrisponde al propertyCode di Nexi ed è salvato come merchantRef sulla collection apiKey  */
  terminal: Scalars['String'];
};

export type NexiDataInput = {
  alias: Scalars['String'];
  secretKey: Scalars['String'];
  terminal: Scalars['String'];
};

/** Regola di gestione del no show */
export type NoShowRule = {
  percentage?: Maybe<Scalars['Float']>;
  type: NoShowType;
};

export type NoShowRuleInput = {
  percentage?: InputMaybe<Scalars['Float']>;
  type: NoShowType;
};

export const NoShowType = {
  FIRSTNIGHT: 'FIRSTNIGHT',
  NOTAPPLY: 'NOTAPPLY',
  PERCENTAGE_TOTAL: 'PERCENTAGE_TOTAL',
  TOTAL: 'TOTAL'
} as const;

export type NoShowType = typeof NoShowType[keyof typeof NoShowType];
/** Le note divise per reparto sono un embedded documents della prenotazione */
export type Note = {
  description: Scalars['String'];
  type: NoteType;
};

export type NoteInput = {
  description: Scalars['String'];
  type: NoteType;
};

export const NoteType = {
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  HOUSEKEEPING: 'HOUSEKEEPING',
  PORTAL: 'PORTAL',
  RESERVATION: 'RESERVATION',
  RESTAURANT: 'RESTAURANT'
} as const;

export type NoteType = typeof NoteType[keyof typeof NoteType];
export type OnBoardingInput = {
  baseRate: RateBaseInput;
  bookingPolicy: ReservationBookingPolicyInput;
  mainChargeCategory: ChargeCategoryBoard;
  plantId?: InputMaybe<Scalars['String']>;
  property: PropertyBaseInput;
};

export type OnBoardingResourceTypeInput = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  propertyId: Scalars['ID'];
  resourceType: ResourceTypeBaseInput;
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: InputMaybe<Array<RuleOccupationInput>>;
  tenantId: Scalars['ID'];
};

/** Ruoli nel dominio di One Platform. */
export const OnePlatformRole = {
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
  SUPPORT: 'SUPPORT',
  USER: 'USER'
} as const;

export type OnePlatformRole = typeof OnePlatformRole[keyof typeof OnePlatformRole];
export const OnlinePaymentsProvider = {
  NEXI: 'NEXI',
  TSPAY: 'TSPAY'
} as const;

export type OnlinePaymentsProvider = typeof OnlinePaymentsProvider[keyof typeof OnlinePaymentsProvider];
export const OpenBillsFilterType = {
  CHECKOUT: 'CHECKOUT',
  CREATED_ON: 'CREATED_ON',
  PRODUTION_DATE: 'PRODUTION_DATE'
} as const;

export type OpenBillsFilterType = typeof OpenBillsFilterType[keyof typeof OpenBillsFilterType];
export type OpenBillsQueryFilter = {
  date: ClosedRangeInput;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: OpenBillsFilterType;
};

export const OptionType = {
  COMPOSITION: 'COMPOSITION',
  EQUIVALENCE: 'EQUIVALENCE'
} as const;

export type OptionType = typeof OptionType[keyof typeof OptionType];
export type Origin = {
  auditable: Auditable;
  custom: Scalars['Boolean'];
  id: Scalars['ID'];
  name: OriginName;
  ota: Scalars['Boolean'];
  pms: Scalars['Boolean'];
  tenantId?: Maybe<Scalars['ID']>;
};

export type OriginInput = {
  name: OriginName;
  ota: Scalars['Boolean'];
  pms: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

/** L'origine della prenotazione contiene dei dati di default e potrà poi essere customizzata per tenant e property */
export const OriginName = {
  IBE: 'IBE',
  OTA: 'OTA',
  PMS: 'PMS',
  QUOTATION: 'QUOTATION'
} as const;

export type OriginName = typeof OriginName[keyof typeof OriginName];
export type OriginQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<OriginName>;
  ota?: InputMaybe<Scalars['Boolean']>;
  pms?: InputMaybe<Scalars['Boolean']>;
  tenantId: IDFilter;
};

export type OutboxEvent = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  metadata?: Maybe<OutboxEventMetadata>;
  payload: Scalars['JSON'];
  queue: Scalars['String'];
};

export type OutboxEventMetadata = {
  correlationId?: Maybe<Scalars['String']>;
  operationName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export const OvbResolveType = {
  ALLOW: 'ALLOW',
  EQUIVALENCE: 'EQUIVALENCE',
  ERROR: 'ERROR'
} as const;

export type OvbResolveType = typeof OvbResolveType[keyof typeof OvbResolveType];
export type OverbookingResult = {
  date?: Maybe<Scalars['Date']>;
  resourceTypeId?: Maybe<Scalars['String']>;
};

/** PAID IN FULL */
export type PaidInFullDocumentInput = {
  cashDeskId?: InputMaybe<Scalars['ID']>;
  customerId: Scalars['ID'];
  draft: Scalars['Boolean'];
  paymentActiveId: Scalars['ID'];
  payments: Array<PaidInFullDocumentPaymentDetailInput>;
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type PaidInFullDocumentPaymentDetailInput = {
  amount: Scalars['Int'];
  referenceDocumentId: Scalars['ID'];
};

export type PassersByBill = {
  _id: Scalars['ID'];
  creationDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<PassersByBillDocument>;
  open?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<PassersByBillOwner>;
  productionLength?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type PassersByBillDocument = {
  _id?: Maybe<Scalars['ID']>;
  documentType?: Maybe<DocumentType>;
  fiscalType?: Maybe<FiscalType>;
  numberExtended?: Maybe<Scalars['String']>;
};

export type PassersByBillOwner = {
  _id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PayAndConfirmQuotation = {
  id: Scalars['ID'];
  link2Pay?: Maybe<Link2PayOutput>;
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

/** PaymentActive sono gli incassi e sono persoanlizzati per Tenant ed eventualmente per property */
export type PaymentActive = {
  auditable: Auditable;
  id: Scalars['ID'];
  /** Codice per exportazione Contabile */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentType: PaymentType;
  paymentTypeId: Scalars['ID'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type PaymentActiveInput = {
  isActive: Scalars['Boolean'];
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
  paymentTypeId: Scalars['ID'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type PaymentActiveQueryFilter = {
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/**
 * Entità che mantiene i gateway gestiti dalla struttura
 * Per ogni gateway è possibile specificare quali metodi supporta
 * All'interno di configuration sono presenti i dati
 * necessari per attivare il sistema, apikey, secret etc.
 */
export type PaymentGateway = {
  auditable: Auditable;
  configuration?: Maybe<Scalars['EncryptedString']>;
  id: Scalars['ID'];
  managedMethodTypes?: Maybe<Array<PaymentMethodType>>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentGatewayType;
};

export type PaymentGatewayInput = {
  configuration?: InputMaybe<Scalars['EncryptedString']>;
  managedMethodTypes?: InputMaybe<Array<PaymentMethodType>>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentGatewayType;
};

export type PaymentGatewayQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const PaymentGatewayType = {
  NEXI: 'NEXI',
  TSPAY: 'TSPAY'
} as const;

export type PaymentGatewayType = typeof PaymentGatewayType[keyof typeof PaymentGatewayType];
export type PaymentInput = {
  amount: Scalars['Int'];
  currency: Scalars['Currency'];
  description: Scalars['String'];
};

export type PaymentLinkForUnpaidDocumentsInput = {
  paidInFullDocumentId: Scalars['ID'];
  propertyId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export const PaymentLinkType = {
  LINK2PAY: 'LINK2PAY',
  LINK2SAVE: 'LINK2SAVE'
} as const;

export type PaymentLinkType = typeof PaymentLinkType[keyof typeof PaymentLinkType];
/**
 * I metodi di pagamento sono definiti per struttura e possono essere collegati ad un Gateway
 * Nel caso in cui il tipo sia diverso da OFFLINE il Gateway è obbligatorio
 */
export type PaymentMethod = {
  /** Potrebbe essere necessario aggiungere i dati dell'iban o altro */
  additionalNote?: Maybe<Scalars['LocalizedString']>;
  auditable: Auditable;
  gateway?: Maybe<PaymentGateway>;
  /** Gateway di pagamento obbligatorio se methodType in options non OFFLINE */
  gatewayId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  paymentActive?: Maybe<PaymentActive>;
  /**
   * Per i processi automatici generati dalle transazionei delle carte di credito è necessario specificare la modalità di pagamento
   * associata; questo ci peremtte di generare i documenti con la modalità corretta.
   */
  paymentActiveId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentMethodType;
};

export type PaymentMethodInput = {
  additionalNote?: InputMaybe<Scalars['LocalizedString']>;
  gatewayId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentMethodType;
};

export type PaymentMethodQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const PaymentMethodType = {
  BANKTRANSFER: 'BANKTRANSFER',
  CREDITCARD: 'CREDITCARD',
  OFFLINE: 'OFFLINE'
} as const;

export type PaymentMethodType = typeof PaymentMethodType[keyof typeof PaymentMethodType];
export type PaymentRule = {
  guaranteedCreditCard: Scalars['Boolean'];
  /**
   * E' possibile richiedere anche il pagmento in forma dilazionata, per ogni rata si può specificare i giorni dall'arrivo e la percentuale richiesta
   * Il totale sui calcolare le percentuali deriva dalla scelta fatta in guaranteedPrice, se totale prenotazione il pagamento avviene
   */
  installments?: Maybe<Array<Installment>>;
  paymentsAcceptedId?: Maybe<Array<Scalars['ID']>>;
  percentage?: Maybe<Scalars['Float']>;
  type: GuaranteeType;
};

export type PaymentRuleBaseInput = {
  guaranteedCreditCard: Scalars['Boolean'];
  percentage?: InputMaybe<Scalars['Float']>;
  type: GuaranteeType;
};

export type PaymentRuleInput = {
  guaranteedCreditCard: Scalars['Boolean'];
  installments?: InputMaybe<Array<InstallmentInput>>;
  paymentsAcceptedId?: InputMaybe<Array<Scalars['ID']>>;
  percentage?: InputMaybe<Scalars['Float']>;
  type: GuaranteeType;
};

/**
 * PaymentType sono i tipi di incasso che identificano i PaymentActive
 * Questa entità predefinita ed inserita tramite Migration, ci permette di avere le impostazioni già pronte per gestire FEL e SCEL
 * I tipi negativi ci permettono di gestire movimenti di uscita di cassa
 */
export type PaymentType = {
  auditable: Auditable;
  code: PaymentTypeCode;
  codePa?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  paymentTypeElectronicReceipt: PaymentTypeElectronicReceipt;
  sign: AlgebraicSign;
};

export const PaymentTypeCode = {
  BALANCE_UNPAID: 'BALANCE_UNPAID',
  BANKCHECK: 'BANKCHECK',
  BANKTRANSFER: 'BANKTRANSFER',
  CASH: 'CASH',
  CHANGE: 'CHANGE',
  CREDITCARD: 'CREDITCARD',
  DEPOSIT: 'DEPOSIT',
  RETURN_DEPOSIT: 'RETURN_DEPOSIT',
  RETURN_SPLITPAYMENT: 'RETURN_SPLITPAYMENT',
  SPLITPAYMENT: 'SPLITPAYMENT',
  UNPAID: 'UNPAID'
} as const;

export type PaymentTypeCode = typeof PaymentTypeCode[keyof typeof PaymentTypeCode];
export type PaymentTypeCodeFilter = {
  eq?: InputMaybe<PaymentTypeCode>;
  in?: InputMaybe<Array<PaymentTypeCode>>;
  ne?: InputMaybe<PaymentTypeCode>;
  nin?: InputMaybe<Array<PaymentTypeCode>>;
};

export const PaymentTypeElectronicReceipt = {
  BANKCHECK: 'BANKCHECK',
  BANK_TRANSFER: 'BANK_TRANSFER',
  CASH: 'CASH',
  CREDITCARD: 'CREDITCARD',
  UNPAID: 'UNPAID'
} as const;

export type PaymentTypeElectronicReceipt = typeof PaymentTypeElectronicReceipt[keyof typeof PaymentTypeElectronicReceipt];
export type PaymentTypeQueryFilter = {
  code?: InputMaybe<PaymentTypeCodeFilter>;
  sign?: InputMaybe<AlgebraicSign>;
};

/** Permessi applicazione */
export const Permissions = {
  BASE: 'BASE',
  BOOKING: 'BOOKING',
  CONFIG: 'CONFIG',
  HOUSEKEEPER: 'HOUSEKEEPER',
  POS: 'POS',
  STATISTICS: 'STATISTICS'
} as const;

export type Permissions = typeof Permissions[keyof typeof Permissions];
/** Tipo che indentifica i dati delle persone (la cittadinanza è birthAddress.country) */
export type Person = {
  birthAddress?: Maybe<Address>;
  birthDate?: Maybe<Scalars['Date']>;
  gender?: Maybe<GenderType>;
  identificationDocument?: Maybe<PersonIdentificationDocument>;
  nationality?: Maybe<Country>;
  nationalityId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

/** Tipo che raccoglie le proprietà dei documenti di identità registarti sul customer */
export type PersonIdentificationDocument = {
  city?: Maybe<Scalars['CapitalizedString']>;
  country: Country;
  countryId: Scalars['ID'];
  document: IdentificationDocument;
  documentId: Scalars['ID'];
  expirationDate: Scalars['Date'];
  number: Scalars['UppercaseString'];
  releaseBy?: Maybe<Scalars['String']>;
};

export type PersonIdentificationDocumentInput = {
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  documentId: Scalars['ID'];
  expirationDate: Scalars['Date'];
  number: Scalars['String'];
  releaseBy?: InputMaybe<Scalars['String']>;
};

export type PersonInput = {
  birthAddress?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<GenderType>;
  identificationDocument?: InputMaybe<PersonIdentificationDocumentInput>;
  nationalityId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PersonSortInput = {
  birthDate?: InputMaybe<Sort>;
};

/** Contatti telefonici */
export type PhoneContact = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: PhoneContactType;
  value: Scalars['String'];
};

export type PhoneContactInput = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: PhoneContactType;
  value: Scalars['String'];
};

/** Tipi di Telefono */
export const PhoneContactType = {
  FAX: 'FAX',
  MAIN: 'MAIN',
  MOBILE: 'MOBILE',
  OFFICE: 'OFFICE',
  OTHER: 'OTHER',
  PRIVATE: 'PRIVATE'
} as const;

export type PhoneContactType = typeof PhoneContactType[keyof typeof PhoneContactType];
/**  PICKUP  */
export type PickupFilter = {
  daysBefore: Scalars['Int'];
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type PickupOutputByResourceType = {
  daysBefore: Array<Scalars['Int']>;
  id: Scalars['ID'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type Plan = {
  billingFrequency?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  discountPercentage?: Maybe<Scalars['Float']>;
  footerFeatures?: Maybe<Array<FooterFeature>>;
  footerFooterFeatures?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  infoLabel?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type Plant = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export const PmsType = {
  NUCONGA: 'NUCONGA',
  WEBHOTEL: 'WEBHOTEL'
} as const;

export type PmsType = typeof PmsType[keyof typeof PmsType];
/** Rappresenta un Punto Vendita. */
export type PointOfSale = {
  auditable: Auditable;
  /** La configurazione del Punto Vendita */
  configuration: PointOfSaleConfiguration;
  description: Scalars['String'];
  /** Codice identificativo usato dal sistema esterno (per CassaInCloud è il SalesPointId). */
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Indica se è il Punto Vendita di default della struttura.     Il PV di default non è collegato a nessun PV esterno e viene utilizzato esclusivamente
   * per contenere le configurazioni di default che valgono per tutti i PV della struttura.
   */
  isDefault: Scalars['Boolean'];
  /** La mappatura dei codici esterni del Punto Vendita. */
  mappings: PointOfSaleMappings;
  name: Scalars['String'];
  property: Property;
  propertyId: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

/** Rappresenta una Comanda ricevuta da un Punto Vendita esterno. */
export type PointOfSaleBill = {
  auditable: Auditable;
  /** Identificativo unico della comanda. */
  billId: Scalars['String'];
  /**
   * Chiave univoca opzionale basata sull'identificativo dell'ordine, se l'ordine è presente.     La chiave è costruita secondo il seguente pattern:
   * - "R<roomId>-<orderId>", qualdo la comanda è addebitata in camera
   * - "P<passerbyId>-<orderId>", when la comanda è addebitata in un conto passanti
   */
  billOrderKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Flag che indica se la Comanda è stata annullata. */
  isCanceled: Scalars['Boolean'];
  /** Il payload completo della Comanda. */
  payload: Scalars['String'];
  /** Insieme delle righe di produzione generate da questa Comanda. */
  productions: Array<PointOfSaleBillProduction>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Associa una riga di produzione con i dati di origine della Comanda che l'hanno generata. */
export type PointOfSaleBillProduction = {
  production: Production;
  /** Id della riga di produzione. */
  productionId: Scalars['ID'];
  /** I dati di origine della riga di produzione. */
  source: PointOfSaleBillProductionSource;
};

/** Contiene i dati di origine della riga di produzione. */
export type PointOfSaleBillProductionSource = {
  /** L'origine della transcodifica del ChargeCategory. */
  chargeCategoryTranscodeSource?: Maybe<ChargeCategoryTranscodeSource>;
  /** L'elenco degli articoli. */
  products: Array<PointOfSaleBillProductionSourceProduct>;
};

export type PointOfSaleBillProductionSourceProduct = {
  amount: Scalars['Int'];
  description: Scalars['String'];
  /** L'identificativo esterno dell'articolo. */
  externalProductId: Scalars['String'];
  quantity: Scalars['Int'];
};

/** La configurazione del Punto Vendita */
export type PointOfSaleConfiguration = {
  /** Indica se è possibile aggiungere addebiti a camere già in checkout. */
  roomsOutChargeable?: Maybe<Scalars['Boolean']>;
};

export type PointOfSaleConfigurationInput = {
  /** Indica se è possibile aggiungere addebiti a camere già in checkout. */
  roomsOutChargeable?: InputMaybe<Scalars['Boolean']>;
};

export type PointOfSaleInput = {
  /** La configurazione del Punto Vendita */
  configuration: PointOfSaleConfigurationInput;
  description: Scalars['String'];
  /** La mappatura dei codici esterni del Punto Vendita. */
  mappings: PointOfSaleMappingsInput;
  name: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Contiene le mappature dei codici esterni del Punto Vendita, distinte per tipo entità.   Se la mappatura per un dato codice non esiste (cioè il codice non viene trovato), la transcodifica viene eseguita nuovamente utilizzando la mappatura del Punto Vendita di default della struttura. */
export type PointOfSaleMappings = {
  /** L'insieme delle voci di mappatura degli addebiti. */
  chargeCategories: Array<PointOfSaleMappingsChargeCategoryEntry>;
};

/** Rappresenta la voce di mappatura di un addebito. */
export type PointOfSaleMappingsChargeCategoryEntry = {
  /** Codice dell'addebito. */
  chargeCategoryId: Scalars['String'];
  /**
   * Codice esterno dell'addebito. Rappresenta la chiave di ricerca.     Per un Punto Vendita CiC è formato dalla concatenazione di:
   * - Id Reparto CiC
   * - Turno pasto
   * - Id Modalità di Vendita CiC
   */
  externalCode: Scalars['String'];
};

export type PointOfSaleMappingsChargeCategoryEntryInput = {
  /** Codice dell'addebito. */
  chargeCategoryId: Scalars['String'];
  /**
   * Codice esterno dell'addebito. Rappresenta la chiave di ricerca.     Per un Punto Vendita CiC è formato dalla concatenazione di:
   * - Id Reparto CiC
   * - Id Turno pasto
   * - Id Modalità di Vendita CiC
   */
  externalCode: Scalars['String'];
};

export type PointOfSaleMappingsInput = {
  /** L'insieme delle voci di mappatura degli addebiti. */
  chargeCategories: Array<PointOfSaleMappingsChargeCategoryEntryInput>;
};

/** Rappresenta un turno per i pasti. */
export type PointOfSaleMealShift = {
  auditable: Auditable;
  /** Descrizione del turno (pranzo, cena, ...) */
  description: Scalars['String'];
  /** Ora di inizio turno, nel formato HH:MM */
  fromTime: Scalars['String'];
  id: Scalars['ID'];
  /** Eventuale struttura a cui si riferisce il turno. Se mancante, il turno è valido per tutti le strutture del tenant. */
  propertyId?: Maybe<Scalars['ID']>;
  /** Eventuale tenant a cui si riferisce il turno. Se mancante, il turno è valido per tutti i tenant. */
  tenantId?: Maybe<Scalars['ID']>;
  /** Ora di fine turno, nel formato HH:MM */
  toTime: Scalars['String'];
};

export type PointOfSaleMealShiftInput = {
  /** Descrizione del turno (pranzo, cena, ...) */
  description: Scalars['String'];
  /** Ora di inizio turno, nel formato HH:MM */
  fromTime: Scalars['String'];
  /** Eventuale struttura a cui si riferisce il turno. Se mancante, il turno è valido per tutti le strutture del tenant. */
  propertyId?: InputMaybe<Scalars['ID']>;
  /** Il tenant a cui si riferisce il turno. */
  tenantId: Scalars['ID'];
  /** Ora di fine turno, nel formato HH:MM */
  toTime: Scalars['String'];
};

export type PointOfSaleMealShiftQueryFilter = {
  /** Esclude i turni di default (cioè non legati ad alcun tenant). */
  excludeDefaults?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantID: IDFilter;
};

export type PointOfSaleQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantID: IDFilter;
};

/** Entità che rappresenta il portale, al'interno sono contenute le informazioni necessarie per poterlo utilizzare */
export type Portal = {
  auditable: Auditable;
  commercialName: Scalars['String'];
  id: Scalars['ID'];
  /** Indica l'istante in cui è stata eseguita l'ultima operazione di download delle prenotazioni. */
  lastDownload?: Maybe<Scalars['DateTime']>;
  mailContacts?: Maybe<Array<MailContact>>;
  name: PortalName;
  phoneContacts?: Maybe<Array<PhoneContact>>;
  /** Se attivo indica che il portale è collegato tramite Figaro */
  throughFigaro?: Maybe<Array<Scalars['Int']>>;
  urlBackEnd?: Maybe<Scalars['String']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type PortalInfo = {
  /** La commissione destinata al portale. Valore percentuale tra 0.0 e 1.0. */
  commission?: Maybe<Scalars['Float']>;
  /** L'importo della commissione destinata al portale. */
  commissionAmount?: Maybe<Scalars['Int']>;
  createdOn: Scalars['DateTime'];
  externalId: Scalars['String'];
  modifiedOn?: Maybe<Scalars['DateTime']>;
  payment?: Maybe<PortalPayment>;
  portal: Portal;
  /** Codice di esonero da utilizzare se il portale ha fatto versato l'imposta al comune per conto della struttura */
  portalCityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  portalId: Scalars['ID'];
  /** L'origine della prenotazione nel network del portale. Ad esempio, per Expedia può essere: Expedia, Hotels.com, Travelocity, etc. */
  source?: Maybe<Scalars['String']>;
};

export const PortalName = {
  AGODA: 'AGODA',
  AIRBNB: 'AIRBNB',
  BEDBRKIT: 'BEDBRKIT',
  BOOKING: 'BOOKING',
  BOOKINGCLICK: 'BOOKINGCLICK',
  CISALPINA: 'CISALPINA',
  CITYBREAK: 'CITYBREAK',
  CRS: 'CRS',
  CTRIP: 'CTRIP',
  DEDGE: 'DEDGE',
  EBOOKERS: 'EBOOKERS',
  ERMES: 'ERMES',
  EXPEDIA: 'EXPEDIA',
  FASTBOOKING: 'FASTBOOKING',
  FERATEL: 'FERATEL',
  FIGARO: 'FIGARO',
  GDS: 'GDS',
  GOOGLEHOTELS: 'GOOGLEHOTELS',
  HOTELBEDS: 'HOTELBEDS',
  HOTELEASY: 'HOTELEASY',
  HOTUSA: 'HOTUSA',
  HRS: 'HRS',
  ITALCAMEL: 'ITALCAMEL',
  JUMBO: 'JUMBO',
  KEYTEL: 'KEYTEL',
  LASTMINUTE: 'LASTMINUTE',
  MRPRENO: 'MRPRENO',
  ODIGEO: 'ODIGEO',
  OPENTOUR: 'OPENTOUR',
  SIMPLEBOOKING: 'SIMPLEBOOKING',
  SIREON: 'SIREON',
  SUNHOTELS: 'SUNHOTELS',
  TABLET: 'TABLET',
  TRAVCO: 'TRAVCO',
  VERTICAL: 'VERTICAL',
  VISIONI: 'VISIONI',
  WEBHOTELIER: 'WEBHOTELIER'
} as const;

export type PortalName = typeof PortalName[keyof typeof PortalName];
/** Definizione delle opportunity */
export type PortalOpportunity = {
  code?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Contiene informazioni relative al pagamento (importo, metodo, eventuale carta, ...). */
export type PortalPayment = {
  /** Importo da addebitare sulla carta di pagamento o da richiedere al portale. */
  amount?: Maybe<Scalars['Int']>;
  /** Il modello di gestione delle commissioni, cioè se sono incluse o meno nell'importo del pagamento. */
  commissionModel?: Maybe<PortalPaymentCommissionModel>;
  /** la valuta del pagamento. */
  currency?: Maybe<Scalars['Currency']>;
  /** I dettagli della eventuale carta di pagamento. */
  paymentCard?: Maybe<PortalPaymentCard>;
  /** Il metodo di pagamento. */
  paymentMethod?: Maybe<PortalPaymentMethod>;
};

/** Contiene i dettagli della carta di pagamento. */
export type PortalPaymentCard = {
  /** When the PaymentMethod is VirtualCard, it is the date and time after which the virtual card can be charged. */
  cardActivationDate?: Maybe<Scalars['DateTime']>;
  /** The token associated to the card data stored in the card vault. */
  cardToken: Scalars['String'];
  /** Indicates the card type. For example: 'Credit Card' */
  cardType?: Maybe<Scalars['String']>;
};

/** Indica il modello di gestione delle commissioni, cioè se sono incluse o meno nell'importo del pagamento. */
export const PortalPaymentCommissionModel = {
  /** Le commissioni sono incluse. */
  GROSS: 'GROSS',
  /** Le commissioni non sono incluse. */
  NET: 'NET'
} as const;

export type PortalPaymentCommissionModel = typeof PortalPaymentCommissionModel[keyof typeof PortalPaymentCommissionModel];
/** Indica il metodo di pagamento. */
export const PortalPaymentMethod = {
  BANK_TRANSFER: 'BANK_TRANSFER',
  CASH: 'CASH',
  CUSTOMER_CREDIT_CARD: 'CUSTOMER_CREDIT_CARD',
  NONE: 'NONE',
  VIRTUAL_CARD: 'VIRTUAL_CARD'
} as const;

export type PortalPaymentMethod = typeof PortalPaymentMethod[keyof typeof PortalPaymentMethod];
export type PortalQueryFilter = {
  id?: InputMaybe<IDFilter>;
};

/** Rate del channel */
export type PortalRate = {
  /** Commissione da scalare alla tariffa */
  commission?: Maybe<Scalars['Float']>;
  derived: Scalars['Boolean'];
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: Maybe<Scalars['String']>;
  /** Numero persone da prendere di riferimento, anche questo attivo solo canali particolari */
  person?: Maybe<Scalars['Int']>;
  /** Codice che viene restituito dal canale (nel caso booking.com può essere Standard, OBP, RLO, LOS) */
  portalPricingType?: Maybe<Scalars['String']>;
  rateCodePortal: Scalars['String'];
  rateNamePortal?: Maybe<Scalars['String']>;
  /** Codici delle tipologie di room legate alla tariffa */
  resourceTypeCodes?: Maybe<Array<Scalars['String']>>;
};

export type PortalRateInput = {
  /** Commissione da scalare alla tariffa */
  commission?: InputMaybe<Scalars['Float']>;
  derived: Scalars['Boolean'];
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: InputMaybe<Scalars['String']>;
  /** Numero persone da prendere di riferimento, anche questo attivo solo canali particolari */
  person?: InputMaybe<Scalars['Int']>;
  /** Codice che viene restituito dal canale (nel caso booking.com può essere Standard, OBP, RLO, LOS) */
  portalPricingType?: InputMaybe<Scalars['String']>;
  rateCodePortal: Scalars['String'];
  rateNamePortal?: InputMaybe<Scalars['String']>;
  /** Codici delle tipologie di room legate alla tariffa */
  resourceTypeCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalResourceType = {
  /** Il numero di adulti permette di sapere su quale occupazione il sistema scrive e quale tariffa del PMS viene presa */
  adults: Scalars['Int'];
  child?: Maybe<Scalars['Int']>;
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: Maybe<Scalars['String']>;
  resourceTypeCodePortal: Scalars['String'];
  resourceTypeNamePortal?: Maybe<Scalars['String']>;
};

export type PortalResourceTypeInput = {
  /** Il numero di adulti permette di sapere su quale occupazione il sistema scrive e quale tariffa del PMS viene presa */
  adults: Scalars['Int'];
  child?: InputMaybe<Scalars['Int']>;
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: InputMaybe<Scalars['String']>;
  resourceTypeCodePortal: Scalars['String'];
  resourceTypeNamePortal?: InputMaybe<Scalars['String']>;
};

/**  CHANNEL / PORTAL  */
export type PortalStatisticFilter = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type PortalStatisticOutputByResourceType = {
  date: Scalars['Date'];
  id: Scalars['ID'];
  portal?: Maybe<Portal>;
  portalId?: Maybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

/**
 * Tipo che ci permette di definire variazioni sui singoli portali
 * E' possibile chiudere la vendita per singolo portale e variare la disponibilità per singola risorsa, sempre come variazione positiva o negativa
 * se availabilityChanges = -2 indica al sistema che dovrà mandare al portale due risorse in meno rispetto all'availability generale.
 */
export type PortalVariation = {
  availabilityChanges: Scalars['Int'];
  portal: Portal;
  portalId: Scalars['ID'];
  stopSell?: Maybe<Scalars['Boolean']>;
};

/** La posizione serve per dividere le risorse, in particolare sulle stampe o in visualizzazioni tipo Tableau. */
export type Position = {
  auditable: Auditable;
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type PositionInput = {
  name: Scalars['String'];
  order: Scalars['Int'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type PositionQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Entità embedded che contiene le modifiche a un arrangiamento. */
export type PriceCalendarChargeCategoryChange = {
  /** Id dell'arrangiamento */
  chargeCategoryId: Scalars['ID'];
  /** Arrangiamento aperto o chiuso */
  closed?: InputMaybe<Scalars['Boolean']>;
  /** Modifiche ai prezzi per numero di persone */
  pricePerOccupationChanges?: InputMaybe<Array<PriceCalendarPricePerOccupationChange>>;
};

/**
 * Contiene i prezzi di un singolo giorno del calendario prezzi per i vari tipi risorsa.
 * I dati provengono da DailyAvailability insieme all'eventuale DailyRate definito per il giorno.
 */
export type PriceCalendarDay = {
  availabilities: Array<PriceCalendarDayAvailability>;
  day: Scalars['Date'];
  id: Scalars['ID'];
  rates: Array<PriceCalendarDayRate>;
};

/** Embedded entity che contiene i dati provenienti da DailyAvailability */
export type PriceCalendarDayAvailability = {
  availability: Scalars['Int'];
  dailyAvailabilityId: Scalars['ID'];
  inventory: Scalars['Int'];
  onlineAvailability: Scalars['Int'];
  onlineInventory?: Maybe<Scalars['Int']>;
  onlineLimit?: Maybe<Scalars['Int']>;
  portalVariations?: Maybe<Array<PortalVariation>>;
  reservedResources: Array<ReservedResource>;
  reservedResourcesId: Array<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  resourcesId: Array<Scalars['ID']>;
  stopSellOTA: Scalars['Boolean'];
};

/** Entità embedded che contiene le modifiche al calendario prezzi per un singolo giorno. */
export type PriceCalendarDayChange = {
  /** Il giorno a cui si riferiscono le modifiche. */
  day: Scalars['Date'];
  /** Le modifiche relative ai tipi risorsa */
  resourceTypeChanges: Array<PriceCalendarResourceTypeChange>;
};

/** Embedded entity che contiene i dati provenienti da DailyRate */
export type PriceCalendarDayRate = {
  bookingPolicy?: Maybe<BookingPolicy>;
  bookingPolicyId?: Maybe<Scalars['ID']>;
  chargesRate?: Maybe<Array<ResourceChargeRate>>;
  closeChargesCategories?: Maybe<Array<ChargeCategory>>;
  /** Arrangiamenti chiusi rispetto alla tariffa, ad esempio in inverno non c'è il ristorante o è chiuso per problemi */
  closeChargesCategoryId?: Maybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  dailyRateId: Scalars['ID'];
  rate: Rate;
  rateId: Scalars['ID'];
  stopSellResourcesType?: Maybe<Array<ResourceType>>;
  /** Risorse bloccate alla vendita sul giorno, vanno in ovveride alla tariffa */
  stopSellResourcesTypeId?: Maybe<Array<Scalars['ID']>>;
};

/** Filtro per recuperare i dati del calendario prezzi. */
export type PriceCalendarFilter = {
  endDate: Scalars['Date'];
  propertyId: IDFilter;
  startDate: Scalars['Date'];
  tenantId: IDFilter;
};

/** Input per aggiornare il calendario prezzi. Le proprietà non valorizzate non saranno modificate. */
export type PriceCalendarInput = {
  /** L'elenco delle modifiche per giorno */
  changes: Array<PriceCalendarDayChange>;
  /** La valuta dei prezzi */
  currency: Scalars['Currency'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Entità embedded che contiene il prezzo di un arrangiamento per occupazione. */
export type PriceCalendarPricePerOccupationChange = {
  /** Il numero di persone */
  occupation: Scalars['Int'];
  /** Prezzo relativo al numero di persone */
  price: Scalars['Int'];
};

/** Input per aggiornare un range di giorni del calendario prezzi. Le proprietà non valorizzate non saranno modificate. */
export type PriceCalendarRangeInput = {
  /** La valuta dei prezzi */
  currency: Scalars['Currency'];
  /** L'ultimo giorno del range da modificare. */
  endDate: Scalars['Date'];
  propertyId: Scalars['ID'];
  /** Le modifiche relative ai tipi risorsa */
  resourceTypeChanges: Array<PriceCalendarResourceTypeChange>;
  /** Il primo giorno del range da modificare. */
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
  /**
   * Valore contenente i giorni della settimana da modificare.
   * Stringa di 7 bit dove il primo bit rappresenta la domenica. Se un bit vale 1, il giorno corrispondente è selezionato.
   * Esempio: '1111111' -> tutti i giorni;  '0001000' -> solo Mercoledì;  '1000001' -> solo weekend;
   */
  weekdayFlags: Scalars['String'];
};

/** Entità embedded che contiene le modifiche alla tariffa. */
export type PriceCalendarRateChange = {
  /** Id della politica di booking */
  bookingPolicyId?: InputMaybe<Scalars['ID']>;
  /** Modifiche agli arrangiamenti */
  chargeCategoryChanges?: InputMaybe<Array<PriceCalendarChargeCategoryChange>>;
  /** Giorno Chiuso in arrivo */
  closedToArrival?: InputMaybe<Scalars['Boolean']>;
  /** Giorno Chiuso in partenza */
  closedToDeparture?: InputMaybe<Scalars['Boolean']>;
  /** Giorni minimi di soggiorno */
  minStay?: InputMaybe<Scalars['Int']>;
  /** Il tipo di prezzo. Obbligatorio se standardPrice o minStay o chargeCategoryChanges[].pricePerOccupation[] è specificato. */
  priceType?: InputMaybe<PriceType>;
  /** Id della tariffa */
  rateId: Scalars['ID'];
  /** Id dell'addebito standard. Obbligatorio se standardPrice o minStay è specificato. */
  standardChargeCategoryId?: InputMaybe<Scalars['ID']>;
  /** Prezzo standard */
  standardPrice?: InputMaybe<Scalars['Int']>;
  /** Indica se la tipologia risorsa deve essere messa in stop-sell */
  stopSell?: InputMaybe<Scalars['Boolean']>;
};

/** Entità embedded che contiene le modifiche al calendario prezzi relative a un tipo risorsa. */
export type PriceCalendarResourceTypeChange = {
  /** Indica l'inventario da mandare alle OTA */
  onlineInventory?: InputMaybe<Scalars['Int']>;
  /** Indica il limite di alloggi da mettere in vendita sulle OTA, se -1 lo elimina */
  onlineLimit?: InputMaybe<Scalars['Int']>;
  /** Le modifiche alla tariffa */
  rate?: InputMaybe<PriceCalendarRateChange>;
  /** Id della tipologia risorsa a cui si applicano le modifiche */
  resourceTypeId: Scalars['ID'];
  /** Indica se la tipologia risorsa deve essere messa in stop-sell per i portali online */
  stopSellOTA?: InputMaybe<Scalars['Boolean']>;
};

export const PriceModel = {
  DERIVED: 'DERIVED',
  STATIC: 'STATIC'
} as const;

export type PriceModel = typeof PriceModel[keyof typeof PriceModel];
/** Tipo che permette di associare un prezzo ad un occupazione */
export type PriceOccupation = {
  occupation: Scalars['Int'];
  price: Scalars['Int'];
};

/** Tipo che permette di associare un prezzo ad un occupazione */
export type PriceOccupationInput = {
  occupation: Scalars['Int'];
  price: Scalars['Int'];
};

export type PriceRange = {
  name: Scalars['String'];
  resourceType: Array<ResourceTypePriceRange>;
};

export type PriceRangeInput = {
  name: Scalars['String'];
  resourceType: Array<ResourceTypePriceRangeInput>;
};

/** Rate Query Embedded Type */
export type PriceRq = {
  bookable: Scalars['Boolean'];
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  dailyPrice: Array<DailyPriceRq>;
  rateRestriction?: Maybe<RateRestriction>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  restrictionsNotMet?: Maybe<Array<RateRestriction>>;
};

export const PriceType = {
  PERSON: 'PERSON',
  ROOM: 'ROOM'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];
export type PricesPage = {
  cards?: Maybe<Array<Card>>;
  description: Scalars['String'];
  descriptionRows?: Maybe<Array<DescriptionRow>>;
  url: Scalars['String'];
};

export const PricingType = {
  PER_NIGHT: 'PER_NIGHT',
  PER_PERSON: 'PER_PERSON',
  PER_PERSON_PER_NIGHT: 'PER_PERSON_PER_NIGHT',
  PER_STAY: 'PER_STAY'
} as const;

export type PricingType = typeof PricingType[keyof typeof PricingType];
export type Privacy = {
  dataThirdPartyConsent?: Maybe<Scalars['Boolean']>;
  dataThirdPartyConsentDate?: Maybe<Scalars['Date']>;
  healthDataConsent?: Maybe<Scalars['Boolean']>;
  healthDataConsentDate?: Maybe<Scalars['Date']>;
  log?: Maybe<RequestData>;
  managementConsent?: Maybe<Scalars['Boolean']>;
  managementConsentDate?: Maybe<Scalars['Date']>;
  marketingConsent?: Maybe<Scalars['Boolean']>;
  marketingConsentDate?: Maybe<Scalars['Date']>;
  profiledMarketingConsent?: Maybe<Scalars['Boolean']>;
  profiledMarketingConsentDate?: Maybe<Scalars['Date']>;
};

export type PrivacyInput = {
  dataThirdPartyConsent?: InputMaybe<Scalars['Boolean']>;
  dataThirdPartyConsentDate?: InputMaybe<Scalars['Date']>;
  healthDataConsent?: InputMaybe<Scalars['Boolean']>;
  healthDataConsentDate?: InputMaybe<Scalars['Date']>;
  managementConsent?: InputMaybe<Scalars['Boolean']>;
  managementConsentDate?: InputMaybe<Scalars['Date']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  marketingConsentDate?: InputMaybe<Scalars['Date']>;
  profiledMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  profiledMarketingConsentDate?: InputMaybe<Scalars['Date']>;
};

/** Configurazione del testo della Informativa sul trattamento dei dati personali. */
export type PrivacySettings = {
  companyAddress?: Maybe<Scalars['String']>;
  /** Email di contatto per le richieste privacy */
  companyEmail?: Maybe<Scalars['String']>;
  companyFiscalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyVat?: Maybe<Scalars['String']>;
  /** Durata del periodo di conservazione dei dati, in mesi. */
  dataRetentionMonths: Scalars['Int'];
  /** Se vale true, il testo è gestito manualmente dall'operatore; altrimenti viene generato dalla composizione delle sezioni abilitate. */
  isCustomText: Scalars['Boolean'];
  /** Il testo dell'Informativa. */
  text: Scalars['LocalizedString'];
  useDirectMarketing: Scalars['Boolean'];
  useHealthData: Scalars['Boolean'];
  useProfiledMarketing: Scalars['Boolean'];
  useThirdPartyMarketing: Scalars['Boolean'];
};

export type PrivacySettingsInput = {
  companyAddress?: InputMaybe<Scalars['String']>;
  /** Email di contatto per le richieste privacy */
  companyEmail?: InputMaybe<Scalars['String']>;
  companyFiscalCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyVat?: InputMaybe<Scalars['String']>;
  /** Durata del periodo di conservazione dei dati, in mesi. */
  dataRetentionMonths: Scalars['Int'];
  /** Se vale true, il testo è gestito manualmente dall'operatore; altrimenti viene generato dalla composizione delle sezioni abilitate. */
  isCustomText: Scalars['Boolean'];
  /** Il testo dell'Informativa. */
  text: Scalars['LocalizedString'];
  useDirectMarketing: Scalars['Boolean'];
  useHealthData: Scalars['Boolean'];
  useProfiledMarketing: Scalars['Boolean'];
  useThirdPartyMarketing: Scalars['Boolean'];
};

export type Product = {
  amount: Scalars['Int'];
  auditable: Auditable;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  description: Scalars['String'];
  id: Scalars['ID'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type ProductInput = {
  amount: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  description: Scalars['String'];
  isActive: Scalars['Boolean'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type ProductQueryFilter = {
  chargeCategoryId?: InputMaybe<IDFilter>;
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** L'entità produzione contiene tutti gli addebiti generati */
export type Production = {
  additionalService?: Maybe<AdditionalService>;
  additionalServiceId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  auditable: Auditable;
  bills?: Maybe<Array<ProductionAssigned>>;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  cityTax?: Maybe<ProductionCityTax>;
  currency: Scalars['Currency'];
  /** Data di riferimento per la produzione */
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  /** Data hotel di inserimento (è valorizzata automaticamente) */
  hotelDate: Scalars['Date'];
  id: Scalars['ID'];
  manual: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  quantity: Scalars['Int'];
  reservationInfo?: Maybe<ProductionReservationInfo>;
  reservedResource?: Maybe<ReservedResource>;
  reservedResourceId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  total: Scalars['Int'];
  vat: Vat;
  vatId: Scalars['ID'];
};

export type ProductionAmount = {
  amountAfterTax: Scalars['Int'];
  amountBeforeTax: Scalars['Int'];
};

/** L'entità ProductionAssigned ci permette di avere sul conto l'associazione con la produzione e la quota parte. */
export type ProductionAssigned = {
  bill: Bill;
  billId: Scalars['ID'];
  id: Scalars['ID'];
  production: Production;
  productionId: Scalars['ID'];
  quota: Scalars['Float'];
};

export type ProductionAssignedInput = {
  production: ProductionBillInput;
  productionId: Scalars['ID'];
};

export type ProductionBillInput = {
  amount: Scalars['Float'];
  chargeCategoryId: Scalars['ID'];
  cityTax?: InputMaybe<ProductionCityTaxInput>;
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  manual: Scalars['Boolean'];
  quantity: Scalars['Int'];
  reservedResourceId?: InputMaybe<Scalars['ID']>;
  total: Scalars['Float'];
  vatId: Scalars['ID'];
};

export type ProductionByReservedResource = {
  reservationId: Scalars['ID'];
  reservedResourceId?: Maybe<Scalars['ID']>;
  total: Scalars['Int'];
};

export type ProductionCheckoutInput = {
  amount: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  productionAssignedId: Scalars['ID'];
};

export type ProductionCityTax = {
  exoneration?: Maybe<CityTaxExonerationCode>;
  guestId?: Maybe<Scalars['ID']>;
};

export type ProductionCityTaxInput = {
  exoneration?: InputMaybe<CityTaxExonerationCode>;
  guestId?: InputMaybe<Scalars['ID']>;
};

export type ProductionInput = {
  additionalServiceId?: InputMaybe<Scalars['ID']>;
  amount: Scalars['Float'];
  chargeCategoryId: Scalars['ID'];
  cityTax?: InputMaybe<ProductionCityTaxInput>;
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  quantity: Scalars['Int'];
  reservedResourceId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  total: Scalars['Float'];
  vatId: Scalars['ID'];
};

export type ProductionQueryFilter = {
  propertyId: IDFilter;
  reservedResourceId: IDFilter;
  tenantId: IDFilter;
};

export type ProductionReservationInfo = {
  hasAgency: Scalars['Boolean'];
  hasCompany: Scalars['Boolean'];
  isGroup: Scalars['Boolean'];
  mainGuestCountryIsoCode?: Maybe<Scalars['String']>;
  originLabel: Scalars['String'];
  rateId: Scalars['ID'];
  reservationState: ProductionReservationState;
  reservationStateId: Scalars['ID'];
  tagsId?: Maybe<Array<Scalars['ID']>>;
};

export const ProductionReservationState = {
  CONFIRMED: 'CONFIRMED',
  NOSHOW: 'NOSHOW',
  OPTIONED: 'OPTIONED',
  OTHER: 'OTHER'
} as const;

export type ProductionReservationState = typeof ProductionReservationState[keyof typeof ProductionReservationState];
/**  PRODUCTION STATISTICS  */
export type ProductionStatisticOutput = {
  chargeCategory?: Maybe<ChargeCategory>;
  chargeCategoryId?: Maybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  originLabel?: Maybe<Scalars['String']>;
  rate?: Maybe<Rate>;
  rateId?: Maybe<Scalars['ID']>;
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType?: Maybe<ResourceType>;
  resourceTypeId?: Maybe<Scalars['ID']>;
  roomProduction: Scalars['Float'];
  totalProduction: Scalars['Float'];
};

export type ProductionStatisticsOption = {
  doNotApplyChargeTransformations?: InputMaybe<Scalars['Boolean']>;
  doNotGroupByAccomodation?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionToRevertInput = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

/**
 * Property rappresenta la struttura, deve essere presente almeno una struttura sul tenant.
 * Il Tipo Sub Property serve al nostro cliente per poter dividere le proprie risorse in modo da poter gestire in modo semplice la possibilità
 * di avere delle gestioni separate per PS, Istat, City Tax ed eventualemnte per la parte fiscale
 * Non è un multiproperty, la Property deve essere semrpe creata ed eredità dalla struttura base le impostazioni base.
 */
export type Property = {
  address?: Maybe<Address>;
  auditable: Auditable;
  bookingEngineConfiguration?: Maybe<BookingEngineConfiguration>;
  category?: Maybe<Taxonomy>;
  /** La categoria è relativa al tipo, 3 stelle, 4 stelle, etc etc. PROPERTY_CATEGORY */
  categoryId?: Maybe<Scalars['ID']>;
  checkin?: Maybe<TimeRange>;
  checkout?: Maybe<TimeRange>;
  cityTaxConfiguration?: Maybe<CityTaxConfiguration>;
  classType?: Maybe<Taxonomy>;
  /** La classe di tipologia indica Hotel, Appartamenti, B&B etc PROPERTY_CLASSTYPE */
  classTypeId?: Maybe<Scalars['ID']>;
  dailyClosureConfiguration: DailyClosureConfiguration;
  description?: Maybe<Scalars['LocalizedString']>;
  fiscalCode?: Maybe<Scalars['String']>;
  fiscalConfigurations?: Maybe<Array<FiscalConfiguration>>;
  groups?: Maybe<Array<PropertyGroup>>;
  groupsId?: Maybe<Array<Scalars['ID']>>;
  hoauConfiguration?: Maybe<HoauConfiguration>;
  hotelDate: Scalars['Date'];
  housekeepingConfiguration?: Maybe<HousekeepingConfiguration>;
  ibeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: Maybe<Array<PropertyImage>>;
  istatConfigurations?: Maybe<Array<IstatConfiguration>>;
  mailContacts?: Maybe<Array<MailContact>>;
  /** Moduli collegati al property e al modulo acquistato */
  modules?: Maybe<Array<Module>>;
  name: Scalars['String'];
  ncsId?: Maybe<Scalars['String']>;
  parentProperty?: Maybe<Property>;
  parentPropertyId?: Maybe<Scalars['ID']>;
  phoneContacts?: Maybe<Array<PhoneContact>>;
  placeId?: Maybe<Scalars['String']>;
  psConfigurations?: Maybe<Array<PsConfiguration>>;
  reportConfigurations?: Maybe<Array<ReportConfiguration>>;
  /** Se true indica alla procedura di autoassegnazione che viene attivata in chiusura di assegnare le camere in arrivo */
  resourceAutoAssign?: Maybe<Scalars['Boolean']>;
  /** TSDIGITAL office identifier */
  resourceId?: Maybe<Scalars['String']>;
  sinapsiConfiguration?: Maybe<SinapsiConfiguration>;
  /**  Indirizzi alternativi per resourceType (piccola struttura diffusa)  */
  subAddresses?: Maybe<Array<PropertySubAddress>>;
  subProperties?: Maybe<Array<Property>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  /** Timezone serve per avere l'orario corretto della struttura rispetto a UCT */
  timeZone?: Maybe<Scalars['UtcOffset']>;
  /** Il tipo indica se siamo in presenza di una subproperty o di una property */
  type: PropertyType;
  vatNumber?: Maybe<Scalars['String']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type PropertyBaseInput = {
  address?: InputMaybe<AddressInput>;
  categoryId?: InputMaybe<Scalars['ID']>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['LocalizedString']>;
  felConfiguration?: InputMaybe<FelConfigurationInput>;
  fiscalAdvances?: InputMaybe<Scalars['Boolean']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  hotelDate?: InputMaybe<Scalars['Date']>;
  housekeepingConfiguration?: InputMaybe<HousekeepingConfigurationInput>;
  iban?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  name: Scalars['String'];
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  placeId?: InputMaybe<Scalars['String']>;
  registryItemId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['UtcOffset']>;
  vatNumber?: InputMaybe<Scalars['String']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export type PropertyFilterClient = {
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * Il property Group è un insieme di strutture, ha vari scopi in ambito Multistruttura.
 * Sarà attivabile sicuramente con una licenza specifica e permette una visione complessiva delle strutture.
 */
export type PropertyGroup = {
  auditable: Auditable;
  id: Scalars['ID'];
  name: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type PropertyGroupInput = {
  name: Scalars['String'];
  tenantId: Scalars['ID'];
};

export type PropertyImage = {
  imageIds?: Maybe<Array<Scalars['ID']>>;
  images?: Maybe<Array<File>>;
  type: PropertyImageType;
};

export type PropertyImageInput = {
  images?: InputMaybe<Array<Scalars['ID']>>;
  logo?: InputMaybe<Scalars['ID']>;
  squareLogo?: InputMaybe<Scalars['ID']>;
};

export const PropertyImageType = {
  IMAGE: 'IMAGE',
  LOGO: 'LOGO',
  SQUARE_LOGO: 'SQUARE_LOGO'
} as const;

export type PropertyImageType = typeof PropertyImageType[keyof typeof PropertyImageType];
export type PropertyInput = {
  address?: InputMaybe<AddressInput>;
  bookingEngineConfiguration?: InputMaybe<BookingEngineConfigurationInput>;
  categoryId?: InputMaybe<Scalars['ID']>;
  checkin?: InputMaybe<TimeRangeInput>;
  checkout?: InputMaybe<TimeRangeInput>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  dailyClosureConfiguration?: InputMaybe<DailyClosureConfigurationInput>;
  description?: InputMaybe<Scalars['LocalizedString']>;
  featuresId?: InputMaybe<Array<Scalars['ID']>>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  groupsId?: InputMaybe<Array<Scalars['ID']>>;
  hoauConfiguration?: InputMaybe<HoauConfigurationInput>;
  hotelDate?: InputMaybe<Scalars['Date']>;
  housekeepingConfiguration?: InputMaybe<HousekeepingConfigurationInput>;
  ibeCode?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  name: Scalars['String'];
  parentPropertyId?: InputMaybe<Scalars['ID']>;
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  placeId?: InputMaybe<Scalars['String']>;
  resourceAutoAssign?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['UtcOffset']>;
  type: PropertyType;
  vatNumber?: InputMaybe<Scalars['String']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export type PropertyPsConfigurationInput = {
  name: Scalars['String'];
  resourceTypeIds: Array<Scalars['ID']>;
  resources: Array<PsResourceConfiguration>;
};

export type PropertyPsConfigurationQueryInput = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type PropertyQueryFilter = {
  id?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type PropertyResourceMultiConfigurationInput = {
  name: Scalars['String'];
  resourceIds: Array<Scalars['ID']>;
  resourceTypeIds: Array<Scalars['ID']>;
};

export type PropertyResourceTypeMultiConfigurationInput = {
  name: Scalars['String'];
  resourceTypeIds: Array<Scalars['ID']>;
};

export type PropertySubAddress = {
  address?: Maybe<Address>;
  category?: Maybe<Taxonomy>;
  /**  La categoria è relativa al tipo, 3 stelle, 4 stelle, etc etc. PROPERTY_CATEGORY  */
  categoryId?: Maybe<Scalars['ID']>;
  checkin?: Maybe<TimeRange>;
  checkout?: Maybe<TimeRange>;
  classType?: Maybe<Taxonomy>;
  /**  La classe di tipologia indica Hotel, Appartamenti, B&B etc PROPERTY_CLASSTYPE  */
  classTypeId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['LocalizedString']>;
  ibeCode?: Maybe<Scalars['String']>;
  mailContacts?: Maybe<Array<MailContact>>;
  name: Scalars['String'];
  phoneContacts?: Maybe<Array<PhoneContact>>;
  placeId?: Maybe<Scalars['String']>;
  resourceTypeIds: Array<Scalars['ID']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type PropertySubAddressInput = {
  address?: InputMaybe<AddressInput>;
  categoryId?: InputMaybe<Scalars['ID']>;
  checkin?: InputMaybe<TimeRangeInput>;
  checkout?: InputMaybe<TimeRangeInput>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['LocalizedString']>;
  ibeCode?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  name: Scalars['String'];
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  placeId?: InputMaybe<Scalars['String']>;
  resourceTypeIds: Array<Scalars['ID']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export const PropertyType = {
  PROPERTY: 'PROPERTY',
  SUBPROPERTY: 'SUBPROPERTY'
} as const;

export type PropertyType = typeof PropertyType[keyof typeof PropertyType];
/** Alloggiati Web Configuration */
export type PsConfiguration = {
  auto: Scalars['Boolean'];
  name: Scalars['String'];
  password: Scalars['EncryptedString'];
  resourceIds?: Maybe<Array<Scalars['ID']>>;
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  username: Scalars['EncryptedString'];
  wskey: Scalars['EncryptedString'];
};

export type PsConfigurationInput = {
  auto: Scalars['Boolean'];
  name: Scalars['String'];
  password: Scalars['EncryptedString'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  resources?: InputMaybe<Array<PsResourceConfiguration>>;
  username: Scalars['EncryptedString'];
  wskey: Scalars['EncryptedString'];
};

export type PsError = {
  code: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type PsResourceConfiguration = {
  codeItalianPs?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type PsSent = {
  /** La data prevista di fine soggiorno dell'ospite che è stata comunicata alla PS. */
  end: Scalars['Date'];
  lastError?: Maybe<PsError>;
  success: Scalars['Boolean'];
  timestamp: Scalars['DateTime'];
};

export type Query = {
  accountantCategories?: Maybe<Array<AccountantCategory>>;
  additionalServices?: Maybe<Array<AdditionalService>>;
  amenities?: Maybe<Array<Amenity>>;
  apiVersion: Scalars['String'];
  audits?: Maybe<Array<Audit>>;
  availabilityRequests?: Maybe<Array<AvailabilityRequest>>;
  bills?: Maybe<Array<Bill>>;
  bookingEngineUrls: Array<BookingEngineUrl>;
  bookingPolicies?: Maybe<Array<BookingPolicy>>;
  bulkReservations: Array<BulkReservation>;
  cashDeskTypes?: Maybe<Array<CashDeskType>>;
  cashDesks?: Maybe<Array<CashDesk>>;
  cervedAdvancedSearch: CervedAdvancedSearchResponse;
  cervedContacts: CervedContactsResponse;
  /** Query che recupera i dati dei risultati */
  channelCommunicationResults?: Maybe<Array<ChannelCommunicationResult>>;
  /** Query che recupera i dati presenti nel database e recuper la informazioni dal portale se possibile */
  channelDetails: ChannelOutput;
  channels?: Maybe<Array<Channel>>;
  chargeCategories?: Maybe<Array<ChargeCategory>>;
  chargeCategoryCodes?: Maybe<Array<ChargeCategoryBoard>>;
  /** Verifica se l'ApiKey specificato è valido. */
  checkCassaInCloudApiKey: Scalars['Boolean'];
  checkNcsNotifications?: Maybe<Scalars['Void']>;
  checkQuotationAvailability?: Maybe<ReservationAvailability>;
  checkReservationAvailability?: Maybe<ReservationAvailability>;
  children?: Maybe<Array<Child>>;
  cityTaxExonerations?: Maybe<Array<CityTaxExoneration>>;
  countries?: Maybe<Array<Country>>;
  customerDocumentImages?: Maybe<Array<CustomerDocumentImage>>;
  customers?: Maybe<Array<Customer>>;
  dailyAvailabilities?: Maybe<Array<DailyAvailability>>;
  dailyClosureAudits?: Maybe<Array<DailyClosureAudit>>;
  dailyForecastSnapshots?: Maybe<Array<DailyForecastSnapshot>>;
  dashboardMeals?: Maybe<DashboardMealsQueryOutput>;
  dashboardReception?: Maybe<DashboardReceptionQueryOutput>;
  dashboardRevenue?: Maybe<DashboardRevenueQueryOutput>;
  dashboardSells?: Maybe<DashboardSellsQueryOutput>;
  defaultMessageTemplates?: Maybe<Array<MessageTemplate>>;
  depositDocuments?: Maybe<Array<Document>>;
  documentActives?: Maybe<Array<DocumentActive>>;
  documentOcr: CiaoAppOcrResponse;
  documentTotals: Array<DocumentTotal>;
  documents?: Maybe<Array<Document>>;
  exportData?: Maybe<Array<ExportData>>;
  exportProcedures?: Maybe<Array<ExportProcedure>>;
  exportableDatabases?: Maybe<Array<ExportableDatabase>>;
  files?: Maybe<Array<File>>;
  fiscalGatewayWorkstations: Array<FiscalGatewayWorkstation>;
  gdprLogs?: Maybe<Array<GdprLog>>;
  getAllAvailableResources?: Maybe<Array<Resource>>;
  getBookingPolicyDigitalPaymentInfo: BookingPolicyDigitalPaymentInfo;
  getCassaInCloudDepartments: Array<CassaInCloudDepartment>;
  getCassaInCloudSalesModes: Array<CassaInCloudSalesMode>;
  getCassaInCloudSalesPoints: Array<CassaInCloudSalesPoint>;
  getCatalogFromStore: StoreResponse;
  getChargeTransformation?: Maybe<ChargeTransformation>;
  getCityTaxMonthSummaryAstat: CityTaxMonthSummaryAstat;
  getCityTaxRegulationRicestat: CityTaxRegulationRicestat;
  getCityTaxReport: CityTaxReport;
  getCityTaxRules: CityTaxRulesOutput;
  getCompanyInfoForPrivacy: CompanyInfoForPrivacyOutput;
  getDashboardMealsReportData?: Maybe<Array<DashboardMealsReportDataRow>>;
  getDatabaseAttachState: DatabaseAttachState;
  getDocumentEmails?: Maybe<Array<Email>>;
  getIstatData?: Maybe<Array<IstatDailyData>>;
  getIstatProcedureByProperty: IstatProcedureCode;
  getIstatPropertiesTrentino: Array<IstatPropertyTrentino>;
  getIstatSystemCapabilities: IstatCapabilities;
  getNcsNotifications?: Maybe<Array<NcsNotification>>;
  getNcsNotificationsSummary?: Maybe<Array<NcsNotificationSummary>>;
  getPickupByResourceType: Array<PickupOutputByResourceType>;
  getPriceCalendar: Array<PriceCalendarDay>;
  getProductionStatistics?: Maybe<Array<ProductionStatisticOutput>>;
  getQuotationDigitalPaymentInfo: QuotationPaymentInfo;
  getQuotationLink: Scalars['String'];
  getRegistryItems: Array<RegistryItem>;
  getReservationDigitalPaymentInfo: ReservationPaymentInfo;
  getReservationEmails?: Maybe<Array<Email>>;
  getReservationLink: Scalars['String'];
  /** Ritorna i dati della carta di pagamento associata alla prenotazione specificata. Oppure null se non esiste alcuna carta. */
  getReservationPortalPaymentCard?: Maybe<ReservationPortalPaymentCard>;
  getResourceAvailability: Scalars['Boolean'];
  getResourceTypeAvailability: Scalars['Int'];
  /** Get the list of existing competitor locations */
  getSinapsiCompetitorLocations: Array<SinapsiCompetitorLocationItem>;
  /** Retrieve (and lock) the next Sinapsi competitor scraping task based on filter and last execution */
  getSinapsiCompetitorNextRetrievalTask?: Maybe<SinapsiCompetitorRetrievalTaskItem>;
  /** Get the list of updated competitor prices for the specified hotels (use the IDs returned by getSinapsiCompetitorProperties) */
  getSinapsiCompetitorPrices: Array<SinapsiCompetitorPropertyPricingInfo>;
  /** Get the list of previously scraped properties for the given location */
  getSinapsiCompetitorProperties: Array<SinapsiCompetitorPropertyBasicInfo>;
  /** Retrieve the list of Sinapsi competitor scraping tasks */
  getSinapsiCompetitorRetrievalTasks: Array<SinapsiCompetitorRetrievalTaskItem>;
  /** Get the list of base rate changes */
  getSinapsiDailyPriceAudit: Array<SinapsiDailyPriceAuditOutput>;
  /** Compute new proposed prices and budget forecasts */
  getSinapsiPrices: SinapsiOutput;
  getStatistics?: Maybe<Array<StatisticOutput>>;
  getSubscriptionInfo: Array<SubscriptionDigital>;
  getSubscriptionStore: Scalars['String'];
  getTotalBillsByReservation?: Maybe<Array<ProductionByReservedResource>>;
  getTotalBillsByReservedResource?: Maybe<Array<ProductionByReservedResource>>;
  getTotalProductionByReservedResource?: Maybe<Array<ProductionByReservedResource>>;
  getUrlForEngagement?: Maybe<Scalars['String']>;
  getUrlFromStore: StoreUpgradeResponse;
  getUserPermissions: UserPermissionOutput;
  getWorstBookingPolicy: ReservationBookingPolicy;
  googlePlaceDetail: GooglePlaceDetailResponse;
  googlePlacesFind: GooglePlaceResponse;
  guestPortalReservation?: Maybe<Reservation>;
  guestPortalReservationBills: GuestPortalReservationBillsOutput;
  guestPortalVerifyCheckoutDocument: Scalars['Boolean'];
  heartbeat?: Maybe<Scalars['Void']>;
  horecahubFlows: Array<HorecaHubFlows>;
  horecahubIntegrations: Array<HorecaHubIntegration>;
  identificationDocuments?: Maybe<Array<IdentificationDocument>>;
  importableProperties?: Maybe<Array<ImportedProperty>>;
  importedErrors?: Maybe<Array<ImportedError>>;
  importedTasks?: Maybe<Array<ImportedTask>>;
  insights?: Maybe<Array<InsightStatus>>;
  messageAutomations?: Maybe<Array<MessageAutomation>>;
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  municipalities?: Maybe<Array<Municipality>>;
  ncsUserPreferences: NcsUserPreference;
  openBills?: Maybe<Array<Bill>>;
  origins?: Maybe<Array<Origin>>;
  passersByBills?: Maybe<Array<PassersByBill>>;
  paymentActives: Array<PaymentActive>;
  paymentGateways?: Maybe<Array<PaymentGateway>>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentTypes: Array<PaymentType>;
  pointOfSaleMealShifts: Array<PointOfSaleMealShift>;
  pointOfSales: Array<PointOfSale>;
  portals?: Maybe<Array<Portal>>;
  positions?: Maybe<Array<Position>>;
  productions?: Maybe<Array<Production>>;
  products?: Maybe<Array<Product>>;
  properties?: Maybe<Array<Property>>;
  provinces: Array<Scalars['String']>;
  quotation: Quotation;
  quotations: Array<Quotation>;
  rateQuery: RqOutput;
  rateQueryForResource: RqForResourceOutput;
  rates?: Maybe<Array<Rate>>;
  reservationSearch?: Maybe<Array<ReservationQueryOutput>>;
  reservationStates?: Maybe<Array<ReservationState>>;
  reservations?: Maybe<Array<Reservation>>;
  reservedResources?: Maybe<Array<ReservedResource>>;
  resolveBookingEngineUrl?: Maybe<BookingEngineUrl>;
  resourceLayouts?: Maybe<Array<ResourceLayout>>;
  resourceTypes?: Maybe<Array<ResourceType>>;
  resources?: Maybe<Array<Resource>>;
  resourcesHousekeeping?: Maybe<Array<ResourceHousekeeping>>;
  roles?: Maybe<Array<Role>>;
  tags?: Maybe<Array<Tag>>;
  taxonomies?: Maybe<Array<Taxonomy>>;
  tenants?: Maybe<Array<Tenant>>;
  testPropertyPsConfiguration?: Maybe<Scalars['Boolean']>;
  threadMessages?: Maybe<Array<ThreadMessage>>;
  threads?: Maybe<Array<Thread>>;
  totems?: Maybe<Array<Totem>>;
  tsPayApiKeys?: Maybe<Array<TsPayApiKey>>;
  tsPayLinks?: Maybe<TsPayLink>;
  unusedPlants: Array<Plant>;
  users?: Maybe<Array<User>>;
  validateIbeCode: Scalars['Boolean'];
  validateItalianFiscalCode: Scalars['Boolean'];
  validateItalianVatCode: Scalars['Boolean'];
  vats?: Maybe<Array<Vat>>;
};


export type QueryaccountantCategoriesArgs = {
  filter: AccountantCategoryQueryFilter;
};


export type QueryadditionalServicesArgs = {
  filter: AdditionalServiceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryamenitiesArgs = {
  filter: AmenityQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryauditsArgs = {
  filter: AuditQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<AuditSortInput>>;
};


export type QueryavailabilityRequestsArgs = {
  filter: AvailabilityRequestQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerybillsArgs = {
  filter: BillQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerybookingEngineUrlsArgs = {
  propertyId: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};


export type QuerybookingPoliciesArgs = {
  filter: BookingPolicyQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerybulkReservationsArgs = {
  correlationId: Scalars['String'];
  error?: InputMaybe<Scalars['Boolean']>;
  processed?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerycashDeskTypesArgs = {
  filter: TenantPropertyIdFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycashDesksArgs = {
  filter: CashDeskQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycervedAdvancedSearchArgs = {
  input: CervedAdvancedSearchInput;
};


export type QuerycervedContactsArgs = {
  input: CervedContactsInput;
};


export type QuerychannelCommunicationResultsArgs = {
  filter: ChannelCommunicationFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerychannelDetailsArgs = {
  id: IDFilter;
  tenantId: Scalars['ID'];
};


export type QuerychannelsArgs = {
  filter: ChannelQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerychargeCategoriesArgs = {
  filter: ChargeCategoryQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerychargeCategoryCodesArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerycheckCassaInCloudApiKeyArgs = {
  apiKey: Scalars['String'];
};


export type QuerycheckNcsNotificationsArgs = {
  delivered?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  read?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerycheckQuotationAvailabilityArgs = {
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerycheckReservationAvailabilityArgs = {
  reservedResourceIdToIgnore?: InputMaybe<Array<Scalars['ID']>>;
  resources: Array<ResourceOccupancyInput>;
  tenantId: Scalars['ID'];
};


export type QuerychildrenArgs = {
  filter: ChildQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycityTaxExonerationsArgs = {
  propertyId: Scalars['ID'];
  reservedResourceId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  usage: ExonerationUsage;
};


export type QuerycountriesArgs = {
  filter?: InputMaybe<CountryQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycustomerDocumentImagesArgs = {
  filter: CustomerDocumentImageQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycustomersArgs = {
  filter: CustomerQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<CustomerSortInput>>;
};


export type QuerydailyAvailabilitiesArgs = {
  filter: DailyAvailabilityQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerydailyClosureAuditsArgs = {
  filter: DailyClosureAuditQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<DailyClosureAuditSortInput>>;
};


export type QuerydailyForecastSnapshotsArgs = {
  filter: DailyForecastSnapshotQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<DailyForecastSnapshotSortInput>>;
};


export type QuerydashboardMealsArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydashboardReceptionArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydashboardRevenueArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydashboardSellsArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydefaultMessageTemplatesArgs = {
  type?: InputMaybe<MessageTemplateType>;
};


export type QuerydepositDocumentsArgs = {
  filter: DepositDocumentQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerydocumentActivesArgs = {
  filter: TenantPropertyIdFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerydocumentOcrArgs = {
  fileId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerydocumentTotalsArgs = {
  filter: DocumentQueryFilter;
};


export type QuerydocumentsArgs = {
  filter: DocumentQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryexportDataArgs = {
  filter: ExportDataQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryexportProceduresArgs = {
  filter: ExportProcedureQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryfilesArgs = {
  filter: FilesQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryfiscalGatewayWorkstationsArgs = {
  filter: FiscalGatewayWorkstationQueryFilter;
};


export type QuerygdprLogsArgs = {
  filter: GdprLogQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerygetAllAvailableResourcesArgs = {
  filter: AvailableResourcesInput;
};


export type QuerygetBookingPolicyDigitalPaymentInfoArgs = {
  input: BookingPolicyDigitalPaymentInput;
};


export type QuerygetCassaInCloudDepartmentsArgs = {
  filter: CassaInCloudDepartmentsQueryFilter;
};


export type QuerygetCassaInCloudSalesModesArgs = {
  filter: CassaInCloudSalesModesQueryFilter;
};


export type QuerygetCassaInCloudSalesPointsArgs = {
  apiKey: Scalars['String'];
};


export type QuerygetCatalogFromStoreArgs = {
  tenantId: Scalars['ID'];
};


export type QuerygetChargeTransformationArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetCityTaxMonthSummaryAstatArgs = {
  input: GetCityTaxMonthSummaryAstatInput;
};


export type QuerygetCityTaxRegulationRicestatArgs = {
  input: GetCityTaxRegulationRicestatInput;
};


export type QuerygetCityTaxReportArgs = {
  filter: CityTaxReportInput;
};


export type QuerygetCityTaxRulesArgs = {
  input: GetCityTaxRulesInput;
};


export type QuerygetCompanyInfoForPrivacyArgs = {
  tenantId: Scalars['ID'];
};


export type QuerygetDashboardMealsReportDataArgs = {
  filter: DashboardQueryFilter;
};


export type QuerygetDatabaseAttachStateArgs = {
  dbName: Scalars['String'];
  taskId: Scalars['Int'];
};


export type QuerygetDocumentEmailsArgs = {
  customerId: Scalars['ID'];
  documentId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};


export type QuerygetIstatDataArgs = {
  input: GetIstatDataInput;
};


export type QuerygetIstatProcedureByPropertyArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetIstatPropertiesTrentinoArgs = {
  input: GetIstatPropertiesTrentinoInput;
};


export type QuerygetIstatSystemCapabilitiesArgs = {
  procedureCode: IstatProcedureCode;
};


export type QuerygetNcsNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<NcsPriorityEnum>;
  propertyId: Scalars['ID'];
  startingAfter?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerygetNcsNotificationsSummaryArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerygetPickupByResourceTypeArgs = {
  filter: PickupFilter;
};


export type QuerygetPriceCalendarArgs = {
  filter: PriceCalendarFilter;
};


export type QuerygetProductionStatisticsArgs = {
  details?: InputMaybe<Array<StatisticDetail>>;
  filter: StatisticFilter;
  options?: InputMaybe<ProductionStatisticsOption>;
};


export type QuerygetQuotationDigitalPaymentInfoArgs = {
  propertyId: Scalars['ID'];
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetQuotationLinkArgs = {
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetRegistryItemsArgs = {
  input: GetRegistryItemsInput;
};


export type QuerygetReservationDigitalPaymentInfoArgs = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetReservationEmailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  reservationId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};


export type QuerygetReservationLinkArgs = {
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetReservationPortalPaymentCardArgs = {
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetResourceAvailabilityArgs = {
  filter: ResourceAvailabilityInput;
};


export type QuerygetResourceTypeAvailabilityArgs = {
  filter: ResourceTypeAvailabilityInput;
};


export type QuerygetSinapsiCompetitorLocationsArgs = {
  filter?: InputMaybe<SinapsiCompetitorRetrievalTaskFilterInput>;
};


export type QuerygetSinapsiCompetitorNextRetrievalTaskArgs = {
  filter?: InputMaybe<SinapsiCompetitorRetrievalTaskFilterInput>;
};


export type QuerygetSinapsiCompetitorPricesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerygetSinapsiCompetitorPropertiesArgs = {
  filter: SinapsiCompetitorRetrievalTaskFilterInput;
};


export type QuerygetSinapsiCompetitorRetrievalTasksArgs = {
  filter?: InputMaybe<SinapsiCompetitorRetrievalTaskFilterInput>;
};


export type QuerygetSinapsiDailyPriceAuditArgs = {
  filter: SinapsiDailyPriceAuditFilterInput;
};


export type QuerygetSinapsiPricesArgs = {
  filter: SinapsiFilter;
  options: SinapsiQueryOptions;
};


export type QuerygetStatisticsArgs = {
  details?: InputMaybe<Array<StatisticDetail>>;
  filter: StatisticFilter;
  productionOptions?: InputMaybe<ProductionStatisticsOption>;
};


export type QuerygetSubscriptionInfoArgs = {
  registryCompanyId: Scalars['String'];
};


export type QuerygetSubscriptionStoreArgs = {
  input: SubscriptionInfoInput;
};


export type QuerygetTotalBillsByReservationArgs = {
  filter: BillsByReservationQueryFilter;
};


export type QuerygetTotalBillsByReservedResourceArgs = {
  filter: DashboardQueryFilter;
};


export type QuerygetTotalProductionByReservedResourceArgs = {
  filter: DashboardQueryFilter;
};


export type QuerygetUrlForEngagementArgs = {
  tenantId: Scalars['ID'];
};


export type QuerygetUrlFromStoreArgs = {
  request: StoreUpgradeInput;
};


export type QuerygetUserPermissionsArgs = {
  input: UserPermissionQueryInput;
};


export type QuerygetWorstBookingPolicyArgs = {
  input: WorstBookingPolicyInput;
};


export type QuerygooglePlaceDetailArgs = {
  input: GooglePlaceInput;
};


export type QuerygooglePlacesFindArgs = {
  input: GooglePlacesFindInput;
};


export type QueryguestPortalReservationArgs = {
  reservationId: Scalars['ID'];
};


export type QueryguestPortalReservationBillsArgs = {
  reservationId: Scalars['ID'];
};


export type QueryguestPortalVerifyCheckoutDocumentArgs = {
  documentId: Scalars['String'];
  reservationId: Scalars['ID'];
};


export type QueryhorecahubFlowsArgs = {
  productCode: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type QueryhorecahubIntegrationsArgs = {
  tenantId?: InputMaybe<Scalars['ID']>;
};


export type QueryidentificationDocumentsArgs = {
  filter?: InputMaybe<IdentificationDocumentQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryimportablePropertiesArgs = {
  tenantId: Scalars['ID'];
};


export type QueryimportedErrorsArgs = {
  filters: ImportedErrorQueryFilter;
};


export type QueryimportedTasksArgs = {
  filters: ImportedTaskQueryFilter;
};


export type QueryinsightsArgs = {
  filter: InsightQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerymessageAutomationsArgs = {
  filter: MessageAutomationQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerymessageTemplatesArgs = {
  filter: MessageTemplateQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerymunicipalitiesArgs = {
  filter?: InputMaybe<MunicipalityQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryncsUserPreferencesArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryopenBillsArgs = {
  filter: OpenBillsQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryoriginsArgs = {
  filter: OriginQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypassersByBillsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  open?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};


export type QuerypaymentActivesArgs = {
  filter: PaymentActiveQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypaymentGatewaysArgs = {
  filter: PaymentGatewayQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypaymentMethodsArgs = {
  filter: PaymentMethodQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypaymentTypesArgs = {
  filter: PaymentTypeQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypointOfSaleMealShiftsArgs = {
  filter: PointOfSaleMealShiftQueryFilter;
};


export type QuerypointOfSalesArgs = {
  filter: PointOfSaleQueryFilter;
};


export type QueryportalsArgs = {
  filter?: InputMaybe<PortalQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypositionsArgs = {
  filter: PositionQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryproductionsArgs = {
  filter: ProductionQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryproductsArgs = {
  filter: ProductQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypropertiesArgs = {
  filter: PropertyQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryquotationArgs = {
  id: Scalars['ID'];
  setReadState?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};


export type QueryquotationsArgs = {
  filter: QuotationQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryrateQueryArgs = {
  filter: RqQueryFilter;
};


export type QueryrateQueryForResourceArgs = {
  filter: RqQueryForResourceFilter;
};


export type QueryratesArgs = {
  filter: RateQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryreservationSearchArgs = {
  filter: ReservationFullTextQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ReservationFullTextQuerySortInput>;
};


export type QueryreservationStatesArgs = {
  filter: ReservationStateQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryreservationsArgs = {
  filter: ReservationQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryreservedResourcesArgs = {
  filter: ReservedResourceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresolveBookingEngineUrlArgs = {
  url: Scalars['String'];
};


export type QueryresourceLayoutsArgs = {
  filter: ResourceLayoutQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresourceTypesArgs = {
  filter: ResourceTypeQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresourcesArgs = {
  filter: ResourceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresourcesHousekeepingArgs = {
  filter: ResourceHousekeepingQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryrolesArgs = {
  filter?: InputMaybe<RoleQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytagsArgs = {
  filter: TagQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytaxonomiesArgs = {
  filter: TaxonomyQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytenantsArgs = {
  filter?: InputMaybe<TenantQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytestPropertyPsConfigurationArgs = {
  name?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerythreadMessagesArgs = {
  filter: ThreadMessageQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerythreadsArgs = {
  filter: ThreadQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytotemsArgs = {
  filter: TotemQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytsPayApiKeysArgs = {
  merchantRef: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type QuerytsPayLinksArgs = {
  orderKey: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type QueryunusedPlantsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryusersArgs = {
  filter: UserQueryInput;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryvalidateIbeCodeArgs = {
  filter?: InputMaybe<IbeCodeFilter>;
};


export type QueryvalidateItalianFiscalCodeArgs = {
  fiscalCode: Scalars['String'];
};


export type QueryvalidateItalianVatCodeArgs = {
  vatCode: Scalars['String'];
};


export type QueryvatsArgs = {
  filter: VatQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type Quotation = {
  auditable: Auditable;
  expiration?: Maybe<Scalars['Date']>;
  fiscalTypeForAdvances?: Maybe<FiscalTypeForAdvances>;
  fromIbe: Scalars['Boolean'];
  id: Scalars['ID'];
  noteForCustomer?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Note>>;
  property: Property;
  propertyId: Scalars['ID'];
  /** Il codice è la chiave di ricerca del preventivo (gestito come contatore) */
  quotationCode: Scalars['String'];
  quotationDetails: Array<QuotationDetail>;
  quotationState: QuotationState;
  quotationStateHistory: Array<QuotationStateHistory>;
  /** Riferimenti a customer */
  reference: ReservationReference;
  /** Contiene i dati della richiesta di preventivo */
  request?: Maybe<QuotationRequest>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type QuotationDetail = {
  quotedResources: Array<QuotedResource>;
  /** refFrom quotationId for security domain */
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
};

export type QuotationDetailInput = {
  quotedResources: Array<QuotedResourceInput>;
  reservationId?: InputMaybe<Scalars['ID']>;
};

export type QuotationForIbe = {
  propertyId: Scalars['ID'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
  token: Scalars['String'];
};

export type QuotationForIbeOutput = {
  /**  if link2Pay is empty, the quotation can be confirmed immediately  */
  link2Pay?: Maybe<Link2PayOutput>;
  quotation?: Maybe<QuotationForIbe>;
};

export type QuotationGuestOccupancy = {
  cityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guest: Customer;
  guestId: Scalars['ID'];
  start: Scalars['Date'];
  type: GuestType;
};

export type QuotationGuestOccupancyInput = {
  cityTaxExoneration?: InputMaybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guestId: Scalars['ID'];
  start: Scalars['Date'];
  type: GuestType;
};

export type QuotationInput = {
  expiration?: InputMaybe<Scalars['Date']>;
  fiscalTypeForAdvances?: InputMaybe<FiscalTypeForAdvances>;
  noteForCustomer?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Array<NoteInput>>;
  propertyId: Scalars['ID'];
  quotationDetails: Array<QuotationDetailInput>;
  /** Riferimenti a customer */
  reference: ReservationReferenceInput;
  tenantId: Scalars['ID'];
};

export type QuotationPaymentInfo = {
  amount: Scalars['Int'];
  bookingPolicy: ReservationBookingPolicy;
  confirmationPageNote: Scalars['String'];
  currency: Scalars['Currency'];
  end: Scalars['Date'];
  guests: Scalars['Int'];
  mainGuest: QuotationPaymentInfoMainGuest;
  merchantRef?: Maybe<Scalars['String']>;
  noShow: Scalars['Int'];
  paymentProvider?: Maybe<OnlinePaymentsProvider>;
  propertyName: Scalars['String'];
  quotationCode: Scalars['String'];
  start: Scalars['Date'];
  totalAmount: Scalars['Int'];
};

export type QuotationPaymentInfoMainGuest = {
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['Language']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type QuotationQueryFilter = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<Scalars['ID']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  quotationState?: InputMaybe<QuotationStateFilter>;
  search?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<DateFilter>;
  tenantId: Scalars['ID'];
};

export type QuotationRequest = {
  adults: Scalars['Int'];
  chargeCategoryCode?: Maybe<ChargeCategoryBoard>;
  childOccupancies?: Maybe<Array<ChildOccupancy>>;
  children: Scalars['Int'];
  end: Scalars['Date'];
  flexibleStay: Scalars['Boolean'];
  noteFromCustomer?: Maybe<Scalars['String']>;
  rooms: Scalars['Int'];
  start: Scalars['Date'];
};

export type QuotationRequestInput = {
  adults: Scalars['Int'];
  chargeCategoryCode?: InputMaybe<ChargeCategoryBoard>;
  childOccupancies?: InputMaybe<Array<ChildOccupancyInput>>;
  children: Scalars['Int'];
  end: Scalars['Date'];
  flexibleStay: Scalars['Boolean'];
  noteFromCustomer?: InputMaybe<Scalars['String']>;
  rooms: Scalars['Int'];
  start: Scalars['Date'];
};

export type QuotationResourceOccupancy = {
  end: Scalars['Date'];
  reservedResourceLayout?: Maybe<ResourceLayout>;
  reservedResourceLayoutId?: Maybe<Scalars['ID']>;
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType: ResourceType;
  /** La resourcetype è quella venduta */
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
};

export type QuotationResourceOccupancyInput = {
  end: Scalars['Date'];
  reservedResourceLayoutId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  /** La resourcetype è quella venduta */
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
};

export const QuotationState = {
  CANCELED: 'CANCELED',
  CONFIRMED: 'CONFIRMED',
  DRAFT: 'DRAFT',
  EXPIRED: 'EXPIRED',
  READ: 'READ',
  REQUEST: 'REQUEST',
  SENT: 'SENT'
} as const;

export type QuotationState = typeof QuotationState[keyof typeof QuotationState];
export type QuotationStateFilter = {
  in: Array<QuotationState>;
};

export type QuotationStateHistory = {
  state: QuotationState;
  timestamp: Scalars['DateTime'];
};

export type QuotationStateHistoryInput = {
  state: QuotationState;
  timestap: Scalars['DateTime'];
};

export type QuotedResource = {
  /** Lista degli eventuali servizi aggiuntivi (sia quelli richiesti dall'utente che già previsti dalla tariffa). */
  additionalServices?: Maybe<Array<EmbeddedAdditionalService>>;
  adults: Scalars['Int'];
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: Maybe<Array<ChildOccupancy>>;
  children: Scalars['Int'];
  end: Scalars['Date'];
  guestOccupancies?: Maybe<Array<QuotationGuestOccupancy>>;
  /** Identificativo per distinguere le varie entità QuotedResource.     Viene automaticamente generato dal backend quando si crea una nuova entità. */
  identifier: Scalars['ID'];
  /** Prezzi giornalieri */
  manualDailyPrices?: Maybe<Array<ManualDailyPrice>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: Maybe<Scalars['Int']>;
  nationalityIsoCode?: Maybe<Scalars['String']>;
  policy?: Maybe<ReservationBookingPolicy>;
  rate: Rate;
  rateId: Scalars['ID'];
  /** Lista delle risorse occupate durante il soggiorno */
  resourceOccupancies: Array<QuotationResourceOccupancy>;
  start: Scalars['Date'];
};

export type QuotedResourceInput = {
  /** Lista degli eventuali servizi aggiuntivi (che si aggiungono a quelli già previsti dalla tariffa) */
  additionalServices?: InputMaybe<Array<EmbeddedAdditionalServiceInput>>;
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: InputMaybe<Array<ChildOccupancyInput>>;
  children: Scalars['Int'];
  end: Scalars['Date'];
  guestOccupancies?: InputMaybe<Array<QuotationGuestOccupancyInput>>;
  /**
   * Identificativo per distinguere le varie entità QuotedResource.     La prima volta che si salva la risorsa non deve essere valorizzato: verrà automaticamente generato dal backend e
   * dovrà essere passato indietro al backend senza alterazioni.
   */
  identifier?: InputMaybe<Scalars['ID']>;
  /** Prezzi giornalieri */
  manualDailyPrices?: InputMaybe<Array<ManualDailyPriceInput>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<ReservationBookingPolicyInput>;
  rateId: Scalars['ID'];
  /** Lista delle risorse occupate durante il soggiorno */
  resourceOccupancies: Array<QuotationResourceOccupancyInput>;
  start: Scalars['Date'];
};

/** Il tipo range indica un periodo */
export type Range = {
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export type RangeInput = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

/** La tariffa rappresenta il listino prezzi, la tariffa ha una arrangiamneto di default, in modo da semplificare le gestione online. */
export type Rate = {
  affiliatedCompanies?: Maybe<Array<Customer>>;
  /** Aziende convenzionate */
  affiliatedCompaniesId?: Maybe<Array<Scalars['ID']>>;
  /** Indica se la tariffa è una tariffa convenzionata */
  agreementRate: Scalars['Boolean'];
  auditable: Auditable;
  /** La prenotabilità indica il periodo in cui l'ospite può utilizzare la tariffa, in caso di booking engine è il peirodo in cui è visibile. */
  bookability?: Maybe<Array<Range>>;
  bookingPolicy: BookingPolicy;
  /** Le politica di booking contiene le regole di per i pagamenti e per le cancellazioni è il default che viene utilizzato, ma può essere sovrascritta nel dettaglio giornaliero. */
  bookingPolicyId: Scalars['ID'];
  chargeCategory: ChargeCategory;
  /** Arrangiamneto di default della tariffa, deve essere un charge che ha stayInclude a True. */
  chargeCategoryId: Scalars['ID'];
  /** Variazioni di prezzo dall'arrangiamento base . */
  chargesRate?: Maybe<Array<ChargeRate>>;
  /** Regole di gestione dei bambini */
  childRule: ChildRule;
  /** Indica i giorni in cui non è previsto l'arrivo, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToArrival?: Maybe<Scalars['String']>;
  /** Indica i giorni in cui non è prevista la partenza, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToDeparture?: Maybe<Scalars['String']>;
  /**
   * In caso in cui l'offerta non sia valida in tutto il periodo richiesto l'operatore può decidere come il sistema deve ragionare.
   * Default NOCROSS
   */
  crossSell: CrossSell;
  currency: Scalars['Currency'];
  /** Le regole di derivazione si applicano sugli arrangiamenti, se non sono presenti non sono gestiti sulla tariffa. */
  derivedRules?: Maybe<Array<DerivationRules>>;
  description: Scalars['LocalizedString'];
  /** Frequenza dell'addebito, se null si intende giornaliero. Valido solo per le tariffe statiche */
  frequency?: Maybe<RateFrequency>;
  /** Se presente indica al sistema che non è una tariifa pubblica */
  ibeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Se attivo i prezzi vengono arrotondati all'unità più vicina (da valorizzare solo sulla rate base) */
  intPrices?: Maybe<Scalars['Boolean']>;
  /** Servizi aggiuntivi Obbligatori */
  mandatoryAdditionalServices?: Maybe<Array<RateMandatoryAdditionalService>>;
  /** Giorni massimi che possono intercorrere tra la data di arrivo e la data di prenotazione (Last Minute) */
  maxAdvance?: Maybe<Scalars['Int']>;
  /** Giorni massimi del soggiorno valido se >=1 */
  maxStay?: Maybe<Scalars['Int']>;
  /** Giorni minimi che devono intercorrere tra la data di arrivo e la data di prenotazione (Prenota Prima) */
  minAdvance?: Maybe<Scalars['Int']>;
  /** Giorni minimi di soggiorno valido se >1 */
  minStay?: Maybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  order: Scalars['Int'];
  parentRate?: Maybe<Rate>;
  /** Se siamo in presenza di una tariffa derivata sono presenti le regole di derivazione */
  parentRateId?: Maybe<Scalars['ID']>;
  /** Fasce di Prezzo */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** I prezzi per gli addebiti non di arrangiamento */
  prices?: Maybe<Array<ChargeCategoryPrice>>;
  property: Property;
  propertyId: Scalars['ID'];
  /** Tariffa base */
  resourcesRate?: Maybe<Array<ResourceRate>>;
  resourcesTypeEnabled?: Maybe<Array<ResourceType>>;
  /** Nel caso di tariffe derivate è possibile specificare se la tariffa è attiva solo su alcune tipologie. */
  resourcesTypeEnabledId?: Maybe<Array<Scalars['ID']>>;
  /** Indica se le restrizioni sono ereditate dalla tariffa base */
  restrictionFromParent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  type: RateType;
  /**
   * La validità non è un dato obbligatorio, sulle tariffe base possiamo indicare al sistema che saranno sempre attive
   * in base al calendario predefinito della struttura
   */
  validity?: Maybe<Array<Range>>;
  /** Indica se la tariffa è visibile sul booking engine */
  visibilityOnIbe: Scalars['Boolean'];
};

export type RateBaseInput = {
  /** Arrangiamneto di default della tariffa, deve essere un charge che ha stayInclude a True. */
  chargeCategoryBoard: ChargeCategoryBoard;
  /** Variazioni di prezzo dall'arrangiamento base . */
  chargesRate?: InputMaybe<Array<ChargeRateBaseInput>>;
  currency: Scalars['Currency'];
  /** Le regole di derivazione si applicano sugli arrangiamenti, se non sono presenti non sono gestiti sulla tariffa. */
  derivedRules?: InputMaybe<Array<DerivationRulesInput>>;
  description: Scalars['LocalizedString'];
  /** Se attivo i prezzi vengono arrotondati all'unità più vicina (da valorizzare solo sulla rate base) */
  intPrices?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['LocalizedString'];
  /** Tariffa base */
  resourcesRate: Array<ResourceRateBaseInput>;
};

export const RateFrequency = {
  PER_MONTH: 'PER_MONTH',
  PER_NIGHT: 'PER_NIGHT',
  PER_STAY: 'PER_STAY',
  PER_TWO_WEEK: 'PER_TWO_WEEK',
  PER_WEEK: 'PER_WEEK',
  PER_YEAR: 'PER_YEAR'
} as const;

export type RateFrequency = typeof RateFrequency[keyof typeof RateFrequency];
export type RateInput = {
  /** Aziende convenzionate */
  affiliatedCompaniesId?: InputMaybe<Array<Scalars['ID']>>;
  /** Indica se la tariffa è una tariffa convenzionata */
  agreementRate: Scalars['Boolean'];
  /** La prenotabilità indica il periodo in cui l'ospite può utilizzare la tariffa, in caso di booking engine è il peirodo in cui è visibile. */
  bookability?: InputMaybe<Array<RangeInput>>;
  /** Le politica di booking contiene le regole di per i pagamenti e per le cancellazioni è il default che viene utilizzato, ma può essere sovrascritta nel dettaglio giornaliero. */
  bookingPolicyId: Scalars['ID'];
  /** Arrangiamneto di default della tariffa, deve essere un charge che ha stayInclude a True. */
  chargeCategoryId: Scalars['ID'];
  /** Variazioni di prezzo dall'arrangiamento base . */
  chargesRate?: InputMaybe<Array<ChargeRateInput>>;
  /** Regole di gestione dei bambini */
  childRule: ChildRuleInput;
  /** Indica i giorni in cui non è previsto l'arrivo, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToArrival?: InputMaybe<Scalars['String']>;
  /** Indica i giorni in cui non è prevista la partenza, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToDeparture?: InputMaybe<Scalars['String']>;
  /**
   * In caso in cui l'offerta non sia valida in tutto il periodo richiesto l'operatore può decidere come il sistema deve ragionare.
   * Default NOCROSS
   */
  crossSell: CrossSell;
  currency: Scalars['Currency'];
  /** Le regole di derivazione si applicano sugli arrangiamenti, se non sono presenti non sono gestiti sulla tariffa. */
  derivedRules?: InputMaybe<Array<DerivationRulesInput>>;
  description: Scalars['LocalizedString'];
  /** Frequenza dell'addebito, se null si intende giornaliero. Valido solo per le tariffe statiche */
  frequency?: InputMaybe<RateFrequency>;
  /** Se presente indica al sistema che non è una tariifa pubblica */
  ibeCode?: InputMaybe<Scalars['String']>;
  /** Se attivo i prezzi vengono arrotondati all'unità più vicina (da valorizzare solo sulla rate base) */
  intPrices?: InputMaybe<Scalars['Boolean']>;
  /** Servizi aggiuntivi */
  mandatoryAdditionalServices?: InputMaybe<Array<RateMandatoryAdditionalServiceInput>>;
  /** Giorni massimi che possono intercorrere tra la data di arrivo e la data di prenotazione */
  maxAdvance?: InputMaybe<Scalars['Int']>;
  /** Giorni massimi del soggiorno valido se >=1 */
  maxStay?: InputMaybe<Scalars['Int']>;
  /** Giorni minimi che devono intercorrere tra la data di arrivo e la data di prenotazione */
  minAdvance?: InputMaybe<Scalars['Int']>;
  /** Giorni minimi di soggiorno valido se >1 */
  minStay?: InputMaybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  order: Scalars['Int'];
  /** Se siamo in presenza di una tariffa derivata sono presenti le regole di derivazione */
  parentRateId?: InputMaybe<Scalars['ID']>;
  /** Fasce di Prezzo */
  priceRanges?: InputMaybe<Array<PriceRangeInput>>;
  /** I prezzi per gli addebiti non di arrangiamento */
  prices?: InputMaybe<Array<ChargeCategoryPriceInput>>;
  propertyId: Scalars['ID'];
  /** Tariffa base */
  resourcesRate?: InputMaybe<Array<ResourceRateInput>>;
  /** Nel caso di tariffe derivate è possibile specificare se la tariffa è attiva solo su alcune tipologie. */
  resourcesTypeEnabledId?: InputMaybe<Array<Scalars['ID']>>;
  /** Indica se le restrizioni sono ereditate dalla tariffa base */
  restrictionFromParent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  type: RateType;
  /**
   * La validità non è un dato obbligatorio, sulle tariffe base possiamo indicare al sistema che saranno sempre attive
   * in base al calendario predefinito della struttura
   */
  validity?: InputMaybe<Array<RangeInput>>;
  /** Indica se la tariffa è visibile sul booking engine */
  visibilityOnIbe: Scalars['Boolean'];
};

export type RateMandatoryAdditionalService = {
  additionalService: AdditionalService;
  additionalServiceId: Scalars['ID'];
  priceZero: Scalars['Boolean'];
};

export type RateMandatoryAdditionalServiceInput = {
  additionalServiceId: Scalars['ID'];
  priceZero: Scalars['Boolean'];
};

export type RateQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  type?: InputMaybe<RateType>;
};

export const RateRestriction = {
  ADVANCE: 'ADVANCE',
  CTA: 'CTA',
  CTD: 'CTD',
  LASTMINUTE: 'LASTMINUTE',
  MAXSTAY: 'MAXSTAY',
  MINSTAY: 'MINSTAY',
  STOPSELL: 'STOPSELL',
  STOPSELL_CHARGE: 'STOPSELL_CHARGE'
} as const;

export type RateRestriction = typeof RateRestriction[keyof typeof RateRestriction];
/** Rate Query Embedded Type */
export type RateRq = {
  bookingPolicyOverride?: Maybe<BookingPolicy>;
  bookingPolicyOverrideId?: Maybe<Scalars['ID']>;
  rate: Rate;
  rateId: Scalars['ID'];
  resourceRates?: Maybe<Array<PriceRq>>;
  restrictionsNotMet?: Maybe<Array<RateRestriction>>;
};

export const RateType = {
  BASE: 'BASE',
  DERIVED: 'DERIVED',
  STATIC: 'STATIC'
} as const;

export type RateType = typeof RateType[keyof typeof RateType];
export type RebuildPropertyAvailabilityEvent = {
  errors?: Maybe<Array<ResourceTypeAvailabilityError>>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type RebuildPropertyAvailabilityEventFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type RefPointer = {
  refFrom?: InputMaybe<Scalars['String']>;
  refTo?: InputMaybe<Scalars['String']>;
};

export const RegimeFiscale = {
  RF01: 'RF01',
  RF02: 'RF02',
  RF04: 'RF04',
  RF05: 'RF05',
  RF06: 'RF06',
  RF07: 'RF07',
  RF08: 'RF08',
  RF09: 'RF09',
  RF10: 'RF10',
  RF11: 'RF11',
  RF12: 'RF12',
  RF13: 'RF13',
  RF14: 'RF14',
  RF15: 'RF15',
  RF16: 'RF16',
  RF17: 'RF17',
  RF18: 'RF18',
  RF19: 'RF19'
} as const;

export type RegimeFiscale = typeof RegimeFiscale[keyof typeof RegimeFiscale];
export type RegistryItem = {
  base: RegistryItemBase;
};

export type RegistryItemAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RegistryItemBase = {
  details: RegistryItemDetails;
  hierarchyId?: Maybe<Scalars['String']>;
  holdingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifier: RegistryItemIdentifier;
  ncsId: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  status: RegistryItemStatus;
};

export type RegistryItemContact = {
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RegistryItemDetails = {
  addresses: Array<RegistryItemAddress>;
  birthDate?: Maybe<Scalars['String']>;
  classifier: Scalars['String'];
  contacts?: Maybe<Array<Maybe<RegistryItemContact>>>;
  description?: Maybe<Scalars['String']>;
  economics?: Maybe<RegistryItemEconomics>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalClass?: Maybe<Scalars['String']>;
  legalForm: RegistryItemLegalForm;
  logoUrl?: Maybe<Scalars['String']>;
  professionalRegister: RegistryItemProfessionalRegister;
};

export type RegistryItemEconomicActivities = {
  mainActivity?: Maybe<RegistryItemEconomicActivitiesMainActivity>;
};

export type RegistryItemEconomicActivitiesMainActivity = {
  code?: Maybe<Scalars['String']>;
  rootCode?: Maybe<Scalars['String']>;
};

export type RegistryItemEconomics = {
  balanceSheetDate?: Maybe<Scalars['String']>;
  capitalStock?: Maybe<Scalars['String']>;
  cciaa?: Maybe<Scalars['String']>;
  economicActivities?: Maybe<RegistryItemEconomicActivities>;
  liquidationState?: Maybe<Scalars['String']>;
  rea?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
  soleShareholder?: Maybe<Scalars['String']>;
  taxRegime?: Maybe<Scalars['String']>;
};

export type RegistryItemIdentifier = {
  govCode?: Maybe<Scalars['String']>;
  taxId: Scalars['String'];
  taxRegion: Scalars['String'];
  vatNumber?: Maybe<Scalars['String']>;
};

export type RegistryItemLegalForm = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type RegistryItemProfessionalRegister = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
};

export type RegistryItemStatus = {
  activatedAt?: Maybe<Scalars['String']>;
  activatedBy?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  certificationStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  externallyValidated: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  ownership?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ReminderForUnpaidDocumentsInput = {
  customerId: Scalars['ID'];
  propertyId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  unpaidDocumentIds: Array<Scalars['ID']>;
};

export type RemovePointOfSaleInput = {
  pointOfSaleId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ReportConfiguration = {
  /** Name of the configuration. */
  name: Scalars['String'];
  parameters?: Maybe<Array<ReportConfigurationParameters>>;
};

export type ReportConfigurationParameters = {
  /** Indicates whether the header must be hidden. */
  hideHeader?: Maybe<Scalars['Boolean']>;
  /** Offset from page bottom in centimeters. */
  marginBottom?: Maybe<Scalars['Float']>;
  /** Offset from page top in centimeters. */
  marginTop?: Maybe<Scalars['Float']>;
  /** Name of the report the parameters apply to. */
  reportName: ReportName;
};

/** The only reports that support parameters. */
export const ReportName = {
  /** Documenti/Documento: Documento di cortesia */
  DOCUMENTI_DOCUMENTO: 'DOCUMENTI_DOCUMENTO'
} as const;

export type ReportName = typeof ReportName[keyof typeof ReportName];
export type RequestData = {
  ip: Scalars['String'];
  ips?: Maybe<Array<Scalars['String']>>;
  mobile?: Maybe<Scalars['Boolean']>;
  platform: Scalars['String'];
  timestamp: Scalars['DateTime'];
  userAgent: Scalars['String'];
};

/** L'entità reservation contiene i dati comuni di una prenotazione */
export type Reservation = {
  auditable: Auditable;
  canceledOn?: Maybe<Scalars['DateTime']>;
  credit: CreditType;
  depositAssigneds?: Maybe<Array<DepositAssigned>>;
  disableAutomation?: Maybe<Scalars['Boolean']>;
  fileIds?: Maybe<Array<Scalars['ID']>>;
  files?: Maybe<Array<File>>;
  fiscalTypeForAdvances?: Maybe<FiscalTypeForAdvances>;
  /** Nome del Gruppo */
  group?: Maybe<Scalars['String']>;
  guestPortalLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGroup: Scalars['Boolean'];
  notes?: Maybe<Array<Note>>;
  /** La data di scadenza opzione per adesso sulla testata */
  optionExpiration?: Maybe<Scalars['Date']>;
  origin: Origin;
  /** Origine della prenotazione è un dato obbligatorio */
  originId: Scalars['ID'];
  paCIG?: Maybe<Scalars['String']>;
  /**  DatiOrdineAcquisto  */
  paOrder?: Maybe<Scalars['String']>;
  /** Viene salvata la peggiore tra le policy presenti nelle reservedResource */
  policy?: Maybe<ReservationBookingPolicy>;
  /** Riferimenti del portale da cui è stata scaricata la prenotazione */
  portalInfo?: Maybe<PortalInfo>;
  property: Array<Property>;
  /** La struttura non è obbligatoria, potremmo avere dettagli su più strutture */
  propertyId: Array<Scalars['ID']>;
  /**  Id del preventivo se esistente  */
  quotationId?: Maybe<Scalars['ID']>;
  /** Riferimenti a customer */
  reference: ReservationReference;
  /** Il codice è la chiave di ricerca della prenotazione (gestito come contatore) */
  reservationCode: Scalars['String'];
  reservationState: ReservationState;
  /** Lo stato della prenotazione gestisce le ReservedResource collegate */
  reservationStateId: Scalars['ID'];
  /** Lista delle attività legate alla prenotazione */
  reservedResources?: Maybe<Array<ReservedResource>>;
  searchInfo?: Maybe<ReservationSearchInfo>;
  tags?: Maybe<Array<Tag>>;
  tagsId?: Maybe<Array<Scalars['ID']>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  tsPayCharges?: Maybe<Array<TsPayCharge>>;
  /** Ts Pay */
  tsPayLinks?: Maybe<Array<TsPayLink>>;
  /** Il voucher proviene da canali esterni */
  voucher?: Maybe<Scalars['String']>;
};

export type ReservationAvailability = {
  error?: Maybe<ReservationAvailabilityError>;
  success: Scalars['Boolean'];
};

export type ReservationAvailabilityError = {
  date: Scalars['Date'];
  resourceId?: Maybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
};

export type ReservationBillInput = {
  category: BillCategoryType;
  description: Scalars['String'];
  id: Scalars['ID'];
  ownerId: Scalars['ID'];
  propertyId: Scalars['ID'];
};

/**
 * Entità congelata nella ReservedResource; è un sottoinsieme delle property di BookingPolicy.
 * Viene presa da Rate durante la creazione/modifica di una ReservedResource
 */
export type ReservationBookingPolicy = {
  additionalNote?: Maybe<Scalars['LocalizedString']>;
  /** Gestione delle policy di cancellazione */
  cancellationPolicy: CancellationPolicy;
  name: Scalars['String'];
  /** Regole per gestire il no show */
  noShowRule: NoShowRule;
  /** Regole per la conferma della prenotaizone */
  paymentRule: PaymentRule;
};

export type ReservationBookingPolicyInput = {
  additionalNote?: InputMaybe<Scalars['LocalizedString']>;
  /** Gestione delle policy di cancellazione */
  cancellationPolicy: CancellationPolicyInput;
  name: Scalars['String'];
  /** Regole per gestire il no show */
  noShowRule: NoShowRuleInput;
  /** Regole per la conferma della prenotaizone */
  paymentRule: PaymentRuleInput;
};

export type ReservationCounterInput = {
  propertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  year: Scalars['Int'];
};

export type ReservationEventPayload = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: ReservationEventType;
};

export const ReservationEventType = {
  CANCEL: 'CANCEL',
  CONFIRM: 'CONFIRM',
  CREATE: 'CREATE'
} as const;

export type ReservationEventType = typeof ReservationEventType[keyof typeof ReservationEventType];
export type ReservationFilterInput = {
  id: Scalars['String'];
  propertyId: Scalars['String'];
  tenantId: Scalars['String'];
};

export const ReservationFullTextQueryDateRangeType = {
  ARRIVAL: 'ARRIVAL',
  CANCELATION: 'CANCELATION',
  CREATION: 'CREATION',
  DEPARTURE: 'DEPARTURE',
  EXPIRATION: 'EXPIRATION',
  IN_HOUSE: 'IN_HOUSE'
} as const;

export type ReservationFullTextQueryDateRangeType = typeof ReservationFullTextQueryDateRangeType[keyof typeof ReservationFullTextQueryDateRangeType];
export type ReservationFullTextQueryFilter = {
  filterFrom?: InputMaybe<Scalars['Date']>;
  filterTo?: InputMaybe<Scalars['Date']>;
  filterType?: InputMaybe<ReservationFullTextQueryDateRangeType>;
  id?: InputMaybe<Scalars['ID']>;
  originId?: InputMaybe<Array<Scalars['ID']>>;
  portalId?: InputMaybe<Array<Scalars['ID']>>;
  propertyId?: InputMaybe<Scalars['ID']>;
  reservationCode?: InputMaybe<Scalars['String']>;
  reservationStateId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
};

export type ReservationFullTextQuerySortInput = {
  company?: InputMaybe<Sort>;
  createdOn?: InputMaybe<Sort>;
  end?: InputMaybe<Sort>;
  mainGuest?: InputMaybe<Sort>;
  reservationCode?: InputMaybe<Sort>;
  reservationState?: InputMaybe<Sort>;
  resources?: InputMaybe<Sort>;
  start?: InputMaybe<Sort>;
};

export type ReservationInput = {
  bills?: InputMaybe<Array<ReservationBillInput>>;
  credit?: InputMaybe<CreditType>;
  disableAutomation?: InputMaybe<Scalars['Boolean']>;
  fileIds?: InputMaybe<Array<Scalars['ID']>>;
  fiscalTypeForAdvances?: InputMaybe<FiscalTypeForAdvances>;
  group?: InputMaybe<Scalars['String']>;
  isGroup: Scalars['Boolean'];
  notes?: InputMaybe<Array<NoteInput>>;
  optionExpiration?: InputMaybe<Scalars['Date']>;
  originId: Scalars['ID'];
  paCIG?: InputMaybe<Scalars['String']>;
  /**  DatiOrdineAcquisto  */
  paOrder?: InputMaybe<Scalars['String']>;
  propertyId: Array<Scalars['ID']>;
  /** Riferimenti a customer */
  reference: ReservationReferenceInput;
  /** Lo stato della prenotazione gestisce le ReservedResource collegate */
  reservationStateId: Scalars['ID'];
  /** Lista delle ReservedResource alla prenotazione */
  reservedResources?: InputMaybe<Array<ReservationResourceInput>>;
  searchInfo?: InputMaybe<ReservationSearchInfoInput>;
  tagsId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  voucher?: InputMaybe<Scalars['String']>;
};

export const ReservationMessageTemplateCode = {
  COMMUNICATION: 'COMMUNICATION',
  LINK2PAY: 'LINK2PAY',
  RESERVATION: 'RESERVATION',
  RESERVATION_CANCEL: 'RESERVATION_CANCEL',
  WCI: 'WCI'
} as const;

export type ReservationMessageTemplateCode = typeof ReservationMessageTemplateCode[keyof typeof ReservationMessageTemplateCode];
export type ReservationOptions = {
  guestsOverbooking?: InputMaybe<Scalars['Boolean']>;
  overbooking?: InputMaybe<OvbResolveType>;
  production?: InputMaybe<ReservationProductionType>;
};

export type ReservationPaymentInfo = {
  amount: Scalars['Int'];
  bookingPolicy: ReservationBookingPolicy;
  confirmationPageNote: Scalars['String'];
  currency: Scalars['Currency'];
  end: Scalars['Date'];
  guests: Scalars['Int'];
  mainGuest: ReservationPaymentInfoMainGuest;
  merchantRef?: Maybe<Scalars['String']>;
  noShow: Scalars['Int'];
  paymentProvider?: Maybe<OnlinePaymentsProvider>;
  propertyName: Scalars['String'];
  reservationCode: Scalars['String'];
  start: Scalars['Date'];
  totalAmount: Scalars['Int'];
};

export type ReservationPaymentInfoMainGuest = {
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['Language']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ReservationPortalPaymentCard = {
  /** Codice di sicurezza, se presente. */
  cvv?: Maybe<Scalars['String']>;
  /** Mese e anno di scadenza. */
  expiration: Scalars['String'];
  /** Nominativo dell'intestatario riportato sulla carta. */
  fullName: Scalars['String'];
  /** Network della carta. */
  network: Scalars['String'];
  /** Numero della carta. */
  number: Scalars['String'];
};

export const ReservationProductionType = {
  ASYNC: 'ASYNC',
  SYNC: 'SYNC'
} as const;

export type ReservationProductionType = typeof ReservationProductionType[keyof typeof ReservationProductionType];
export type ReservationQueryFilter = {
  customerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<Scalars['ID']>;
  reservationCode?: InputMaybe<StringFilter>;
  tenantId: IDFilter;
};

export type ReservationQueryOutput = {
  canceledOn?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Scalars['String']>;
  createdOn: Scalars['DateTime'];
  credit: CreditType;
  customer?: Maybe<Scalars['String']>;
  end: Scalars['Date'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGroup?: Maybe<Scalars['Boolean']>;
  mainGuest?: Maybe<Scalars['String']>;
  optionExpiration?: Maybe<Scalars['Date']>;
  originId: Scalars['ID'];
  portalId?: Maybe<Scalars['ID']>;
  portalInfo?: Maybe<PortalInfo>;
  reference: ReservationReference;
  reservationCode: Scalars['String'];
  reservationState: Scalars['String'];
  reservedResources?: Maybe<Array<ReservedResource>>;
  resources: Scalars['Int'];
  start: Scalars['Date'];
  voucher?: Maybe<Scalars['String']>;
};

/** Tipo che raccoglie i riferimenti legati al customer */
export type ReservationReference = {
  agency?: Maybe<Customer>;
  /** Agenzia */
  agencyId?: Maybe<Scalars['ID']>;
  customerCompany?: Maybe<Customer>;
  /** Prenotante Azienda */
  customerCompanyId?: Maybe<Scalars['ID']>;
  customerPerson?: Maybe<Customer>;
  /** Prenotante indviduale */
  customerPersonId?: Maybe<Scalars['ID']>;
  mainGuest: Customer;
  /** Ospite Principale, sempre obbligatorio potrebbe essere lo stesso di custmerPerson */
  mainGuestId: Scalars['ID'];
};

export type ReservationReferenceInput = {
  /** Agenzia */
  agencyId?: InputMaybe<Scalars['ID']>;
  /** Prenotante Azienda */
  customerCompanyId?: InputMaybe<Scalars['ID']>;
  /** Prenotante indviduale */
  customerPersonId?: InputMaybe<Scalars['ID']>;
  /** Ospite Principale, sempre obbligatorio potrebbe essere lo stesso di custmerPerson */
  mainGuestId: Scalars['ID'];
};

export type ReservationResourceInput = {
  /** Elenco di eventuali servizi aggiuntivi da aggiungere a quelli già previsti dalla tariffa */
  additionalServices?: InputMaybe<Array<EmbeddedAdditionalServiceInput>>;
  adults: Scalars['Int'];
  chargeCategories?: InputMaybe<Array<ResourceChargeCategoryInput>>;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: InputMaybe<Array<ChildOccupancyInput>>;
  children: Scalars['Int'];
  guestOccupancies?: InputMaybe<Array<GuestOccupancyInput>>;
  id?: InputMaybe<Scalars['ID']>;
  /** Prezzi giornalieri */
  manualDailyPrices?: InputMaybe<Array<ManualDailyPriceInput>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: InputMaybe<Scalars['Int']>;
  nationalityIsoCode?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<ReservationBookingPolicyInput>;
  productions?: InputMaybe<Array<EmbeddedProductionInput>>;
  rateId: Scalars['ID'];
  resourceOccupancies: Array<ResourceOccupancyInput>;
  time?: InputMaybe<TimeRangeInput>;
};

export type ReservationSearchInfo = {
  customerCompanyName?: Maybe<Scalars['String']>;
  customerPersonName?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Date']>;
  mainGuestName: Scalars['String'];
  nationalityIsoCodes?: Maybe<Array<Scalars['String']>>;
  originLabel: Scalars['String'];
  resources: Scalars['Int'];
  start?: Maybe<Scalars['Date']>;
};

export type ReservationSearchInfoInput = {
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerPersonName?: InputMaybe<Scalars['String']>;
  mainGuestName: Scalars['String'];
};

/** Gli stati della prenotazione, dovranno essere precaricati in automatico definire un set */
export type ReservationState = {
  auditable: Auditable;
  canceled: Scalars['Boolean'];
  color: Scalars['String'];
  confirmed: Scalars['Boolean'];
  custom: Scalars['Boolean'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  noshow: Scalars['Boolean'];
  optioned: Scalars['Boolean'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type ReservationStateInput = {
  canceled: Scalars['Boolean'];
  color: Scalars['String'];
  confirmed: Scalars['Boolean'];
  icon: Scalars['String'];
  name: Scalars['String'];
  noshow: Scalars['Boolean'];
  optioned: Scalars['Boolean'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type ReservationStateQueryFilter = {
  id?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type ReservationUpdateInput = {
  bills?: InputMaybe<Array<ReservationBillInput>>;
  credit?: InputMaybe<CreditType>;
  disableAutomation?: InputMaybe<Scalars['Boolean']>;
  fileIds?: InputMaybe<Array<Scalars['ID']>>;
  group?: InputMaybe<Scalars['String']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Array<NoteInput>>;
  optionExpiration?: InputMaybe<Scalars['Date']>;
  originId?: InputMaybe<Scalars['ID']>;
  paCIG?: InputMaybe<Scalars['String']>;
  /**  DatiOrdineAcquisto  */
  paOrder?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Array<Scalars['ID']>>;
  reference?: InputMaybe<ReservationReferenceInput>;
  reservationStateId?: InputMaybe<Scalars['ID']>;
  reservedResources?: InputMaybe<Array<ReservationResourceInput>>;
  tagsId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  voucher?: InputMaybe<Scalars['String']>;
};

/**
 * La ReservedResource è l'impegno di una tipologia di risorsa, in caso di PMS la ReservedResource cambia fase.
 * Lo stato nelle ReservedResource è molto importante, lo stato Active indica che l'impegno scarica la disponibilità;
 * gli altri casi sono gestiti a livello logico dall'applicazione.
 * Per le persone abbiamo diviso per adulti e bambini, con la possibilità di avere il dettaglio dei bambini.
 * Le proprietà che iniziano per 'reserved' indicano il dato inserito con la prenotazione e si potranno discostare rispetto ai dati effettivi che saranno gestiti in fase di checkin.
 */
export type ReservedResource = {
  /** Lista degli eventuali servizi aggiuntivi (sia quelli richiesti dall'utente che già previsti dalla tariffa). */
  additionalServices?: Maybe<Array<EmbeddedAdditionalService>>;
  adults: Scalars['Int'];
  auditable: Auditable;
  /** Riferimento per sistemi di automation esterni */
  automationId?: Maybe<Scalars['String']>;
  /**  Età media degli ospiti  */
  averageAge?: Maybe<Scalars['Float']>;
  /** Lista delle eventuali chargeCategory alternative per data */
  chargeCategories?: Maybe<Array<ResourceChargeCategory>>;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: Maybe<Array<ChildOccupancy>>;
  children: Scalars['Int'];
  /** Prezzi provenienti dal RateQuery memorizzati per futuri ricalcoli */
  dailyPricesStored?: Maybe<ReservedResourceDailyPricesStored>;
  end: Scalars['Date'];
  guestOccupancies?: Maybe<Array<GuestOccupancy>>;
  /**  Viene attivato se l'operatore forza il cambio di tipologia verso una che non ha posti sufficienti  */
  guestsOverbooking?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Prezzi giornalieri */
  manualDailyPrices?: Maybe<Array<ManualDailyPrice>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: Maybe<Scalars['Int']>;
  /**  Iso Code a due lettere della nazionalità  */
  nationalityIsoCode?: Maybe<Scalars['String']>;
  phase: ReservedResourcePhase;
  /** La policy viene salvata in modo da non avere problemi in caso in cui venga modificata successivamente. */
  policy: ReservationBookingPolicy;
  /** Riferimento esterno per prenotazioni scaricate dai portali */
  portalExternalId?: Maybe<Scalars['String']>;
  /** Addebiti giornalieri già calcolati e legati ai conti */
  productions?: Maybe<Array<Production>>;
  propertyId: Scalars['ID'];
  rate: Rate;
  /** La rate è sulla singola attività, se ci sono molteplici rate sono sugli addebiti */
  rateId: Scalars['ID'];
  reservation: Reservation;
  reservationId: Scalars['ID'];
  reservedAdults: Scalars['Int'];
  reservedChildOccupancies?: Maybe<Array<ChildOccupancy>>;
  reservedChildren: Scalars['Int'];
  reservedEnd: Scalars['Date'];
  /**
   * Fino a quando la la fase è reservation le date start e end sono sincronizzate,
   * poi quando siamo in checkin, in particolare la data di end può variare.
   */
  reservedStart: Scalars['Date'];
  /** Viene attivato nel cambio configurazione se non riesce a creare gli impegni shadow per questa risorsa */
  resourceCompositionError?: Maybe<Scalars['Boolean']>;
  /** Lista delle risorse occupate durante il soggiorno */
  resourceOccupancies: Array<ResourceOccupancy>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
  time?: Maybe<TimeRange>;
};

export type ReservedResourceDailyPricesStored = {
  adults: Scalars['Int'];
  childOccupancy?: Maybe<Array<ChildOccupancy>>;
  children: Scalars['Int'];
  dailyPrices: Array<DailyPrice>;
  persons: Scalars['Int'];
  rateId: Scalars['ID'];
};

export type ReservedResourceEvent = {
  cityTaxRequired?: Maybe<Scalars['Boolean']>;
  dashBoardKpiRefreshRequired?: Maybe<Scalars['Boolean']>;
  end: Scalars['Date'];
  forecastFull?: Maybe<Scalars['Boolean']>;
  forecastRequired?: Maybe<Scalars['Boolean']>;
  forecastUpdated?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  operation: CrudOperation;
  overbooking?: Maybe<Array<OverbookingResult>>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type ReservedResourceEventFilter = {
  propertyId: Scalars['ID'];
  range?: InputMaybe<ClosedRangeInput>;
  tenantId: Scalars['ID'];
};

export type ReservedResourceGuestInput = {
  customerId?: InputMaybe<Scalars['ID']>;
  guest: CustomerGuestInput;
  guestType: GuestType;
  images: StoreCustomerImagesInput;
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ReservedResourceInput = {
  /** Elenco di eventuali servizi aggiuntivi da aggiungere a quelli già previsti dalla tariffa */
  additionalServices?: InputMaybe<Array<EmbeddedAdditionalServiceInput>>;
  adults: Scalars['Int'];
  chargeCategories?: InputMaybe<Array<ResourceChargeCategoryInput>>;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: InputMaybe<Array<ChildOccupancyInput>>;
  children: Scalars['Int'];
  guestOccupancies?: InputMaybe<Array<GuestOccupancyInput>>;
  /** Default true */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Prezzi giornalieri */
  manualDailyPrices?: InputMaybe<Array<ManualDailyPriceInput>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: InputMaybe<Scalars['Int']>;
  nationalityIsoCode?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<ReservationBookingPolicyInput>;
  productions?: InputMaybe<Array<EmbeddedProductionInput>>;
  rateId: Scalars['ID'];
  reservationId: Scalars['ID'];
  resourceOccupancies: Array<ResourceOccupancyInput>;
  tenantId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export type ReservedResourceMultiInput = {
  id: Scalars['ID'];
  reservedResource: ReservedResourceInput;
};

export type ReservedResourceOptions = {
  guestsOverbooking?: InputMaybe<Scalars['Boolean']>;
  overbooking?: InputMaybe<OvbResolveType>;
  production?: InputMaybe<ReservedResourceProductionType>;
};

export const ReservedResourcePhase = {
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  RESERVATION: 'RESERVATION'
} as const;

export type ReservedResourcePhase = typeof ReservedResourcePhase[keyof typeof ReservedResourcePhase];
export type ReservedResourceProductionEvent = {
  end?: Maybe<Scalars['Date']>;
  error?: Maybe<Scalars['String']>;
  forecastFull: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  reservationId?: Maybe<Scalars['ID']>;
  reservedResourceId: Scalars['ID'];
  start?: Maybe<Scalars['Date']>;
  tenantId: Scalars['ID'];
};

export type ReservedResourceProductionEventFilter = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const ReservedResourceProductionType = {
  ASYNC: 'ASYNC',
  ASYNC_FULL: 'ASYNC_FULL',
  SKIP: 'SKIP',
  SYNC: 'SYNC',
  SYNC_FULL: 'SYNC_FULL'
} as const;

export type ReservedResourceProductionType = typeof ReservedResourceProductionType[keyof typeof ReservedResourceProductionType];
export type ReservedResourceQueryFilter = {
  dateRange?: InputMaybe<ClosedRangeInput>;
  excludeCanceled?: InputMaybe<Scalars['Boolean']>;
  guestId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  phase?: InputMaybe<ReservedResourcePhase>;
  propertyId?: InputMaybe<IDFilter>;
  reservationId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** La risorsa è l'entità fisica del sistema, viene creata solo nella gestione del PMS */
export type Resource = {
  auditable: Auditable;
  cleaningState: CleaningState;
  /** Il codice può essere il numerodi camera 100,101 oppure APP SOle */
  code: Scalars['String'];
  /** Codice Istat della risorsa. Valorizzato quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  codeIstat?: Maybe<Scalars['String']>;
  codeItalianPs?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  housekeeperNote?: Maybe<Scalars['String']>;
  housekeepers?: Maybe<Array<ResourceHousekeeper>>;
  id: Scalars['ID'];
  lastCleaningDate?: Maybe<Scalars['DateTime']>;
  layout?: Maybe<ResourceLayout>;
  layoutId?: Maybe<Scalars['ID']>;
  position?: Maybe<Position>;
  positionId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  resourceType: ResourceType;
  /** Il resourcetype associato alla risora serve per alimentare l'inventory */
  resourceTypeId: Scalars['ID'];
  /** Ordinamento utilizzato solo dal room tetris per assegnare le camere */
  roomTetrisOrder: Scalars['Int'];
  tenantId: Scalars['ID'];
  unavailabilities?: Maybe<Array<ResourceUnavailability>>;
};

export type ResourceAvailabilityInput = {
  endDate: Scalars['Date'];
  resourceId: Scalars['ID'];
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export type ResourceAvailabilityRequest = {
  adults: Scalars['Int'];
  childOccupancy?: Maybe<Array<ChildOccupancyAvailabilityRequest>>;
  quantity: Scalars['Int'];
};

/** Rate Query Embedded Type */
export type ResourceAvailabilityRq = {
  availability: Scalars['Int'];
  /**
   * City Tax amount for single requested Room (you must multiply each value by the corrisponding RqQueryFilter.resources.$.quantity)
   * In case of empty array or array with zero values, contact the structure for more information
   */
  cityTaxAmount?: Maybe<Scalars['Int']>;
  dailyAvailability?: Maybe<Array<DailyAvailabilityRq>>;
  inventory: Scalars['Int'];
  requestedResourceIdx: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

/** Tipo che ci permette di definire una chargeCategory alternativa su alcune date */
export type ResourceChargeCategory = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  day: Scalars['Date'];
};

export type ResourceChargeCategoryInput = {
  chargeCategoryId: Scalars['ID'];
  day: Scalars['Date'];
};

/** All'interno della tariffa è comunque possibile specificare in modo puntuale il prezzo delle risorse per arrangiamento */
export type ResourceChargeRate = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  /** Giorno Chiuso in arrivo */
  closedToArrival?: Maybe<Scalars['Boolean']>;
  /** Giorno Chiuso in partenza */
  closedToDeparture?: Maybe<Scalars['Boolean']>;
  /** Eredita la min stay della rate principale */
  minStay?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  /**
   * In caso in cui non è possibile derivare i prezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: Maybe<Array<PriceOccupation>>;
  priceType: PriceType;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: Maybe<Array<RuleOccupation>>;
};

export type ResourceCleaningStateInput = {
  cleaningState: CleaningState;
  housekeeperNote?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  layoutId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/**
 *  Per le risorse orarie va specificato "time":
 * - se più prenotazioni impegnano una specifica risorsa in orari diversi questa viene conteggiata una sola volta
 * - le prenotazioni che impegnano la tipologia senza specificare una risorsa scalano una camera ciascuna (senza tener conto degli orari)
 */
export type ResourceCommitment = {
  relatedResourceId?: Maybe<Scalars['ID']>;
  resourceId: Scalars['ID'];
  time?: Maybe<TimeRange>;
  type: ResourceCommitmentType;
};

export const ResourceCommitmentType = {
  RESERVATION: 'RESERVATION',
  UNAVAILABILITY: 'UNAVAILABILITY'
} as const;

export type ResourceCommitmentType = typeof ResourceCommitmentType[keyof typeof ResourceCommitmentType];
export type ResourceEvent = {
  cleaningStateUpdated?: Maybe<Scalars['Boolean']>;
  codeUpdated?: Maybe<Scalars['Boolean']>;
  descriptionUpdated?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  layoutUpdated?: Maybe<Scalars['Boolean']>;
  operation: CrudOperation;
  propertyId: Scalars['ID'];
  resourceTypeUpdated?: Maybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  unavailabilityUpdated?: Maybe<Scalars['Boolean']>;
};

export type ResourceEventFilter = {
  cleaningStateUpdated?: InputMaybe<Scalars['Boolean']>;
  codeUpdated?: InputMaybe<Scalars['Boolean']>;
  descriptionUpdated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  layoutUpdated?: InputMaybe<Scalars['Boolean']>;
  operation?: InputMaybe<CrudOperation>;
  propertyId: Scalars['ID'];
  resourceTypeUpdated?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  unavailabilityUpdated?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceHousekeeper = {
  date: Scalars['Date'];
  user: User;
  userId: Scalars['ID'];
};

export type ResourceHousekeeperInput = {
  date: Scalars['Date'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type ResourceHousekeeping = {
  cleaningState: CleaningState;
  code: Scalars['String'];
  description: Scalars['String'];
  housekeeperNote?: Maybe<Scalars['String']>;
  housekeepers?: Maybe<Array<ResourceHousekeeper>>;
  id: Scalars['ID'];
  layout?: Maybe<ResourceLayout>;
  layoutId?: Maybe<Scalars['ID']>;
  position?: Maybe<Position>;
  positionId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  reservedResource?: Maybe<ReservedResource>;
  reservedResourceId?: Maybe<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailabilities?: Maybe<Array<ResourceUnavailability>>;
};

export type ResourceHousekeepingQueryFilter = {
  cleaningState?: InputMaybe<CleaningState>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  resourceTypeId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type ResourceInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  layoutId?: InputMaybe<Scalars['ID']>;
  positionId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  roomTetrisOrder?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};

export const ResourceKind = {
  APARTMENT: 'APARTMENT',
  BED: 'BED',
  ROOM: 'ROOM'
} as const;

export type ResourceKind = typeof ResourceKind[keyof typeof ResourceKind];
/**
 * I possibili layout per comporre la camera, in base all'occupazione sono elencati, occupazione 2 un matrimoniale o 2 singoli, un divano letto un posto etc ect.
 * All'interno delle singole tipologie si può aggiungere i possibili scenari
 */
export type ResourceLayout = {
  auditable: Auditable;
  description: Scalars['LocalizedString'];
  id: Scalars['ID'];
  occupation: Scalars['Int'];
};

export type ResourceLayoutInput = {
  description: Scalars['String'];
  occupation: Scalars['Int'];
};

export type ResourceLayoutQueryFilter = {
  id?: InputMaybe<IDFilter>;
};

/**
 * "
 * Questo tipo serve per definire all'interno dell'ReservedResource quale risorse viene impegnata. Potrebbe non esserci la risorsa vera e propria
 * L'obbiettivo è quello di poter pianficare eventuali cambi camera e cmq tenere traccia degli spostatmenti durante il soggiorno
 */
export type ResourceOccupancy = {
  assignedResourceType: ResourceType;
  /** La assignedResourceType è quella effettivamente assegnata (ad esempio in equivalenza. Se c'è resourceId deve essere la resourceType legata alla resource) */
  assignedResourceTypeId: Scalars['ID'];
  commitments?: Maybe<Array<ResourceOccupancyCommitment>>;
  end: Scalars['Date'];
  phase: ReservedResourcePhase;
  reservedResourceLayout?: Maybe<ResourceLayout>;
  reservedResourceLayoutId?: Maybe<Scalars['ID']>;
  reservedResourceType: ResourceType;
  /** La reservedResourcetype è quella venduta */
  reservedResourceTypeId: Scalars['ID'];
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  start: Scalars['Date'];
};

export type ResourceOccupancyCommitment = {
  quantity: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  resources?: Maybe<Array<Resource>>;
  resourcesId?: Maybe<Array<Scalars['ID']>>;
};

export type ResourceOccupancyCommitmentInput = {
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
};

export type ResourceOccupancyInput = {
  assignedResourceTypeId?: InputMaybe<Scalars['ID']>;
  commitments?: InputMaybe<Array<ResourceOccupancyCommitmentInput>>;
  end: Scalars['Date'];
  reservedResourceLayoutId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  /** La resourcetype è quella venduta */
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
};

export type ResourceQueryFilter = {
  cleaningState?: InputMaybe<CleaningState>;
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  resourceTypeId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Tipo da utilizzare sulle richieste di rate query */
export type ResourceRQInput = {
  adults: Scalars['Int'];
  childOccupancy?: InputMaybe<Array<ChildOccupancyRQInput>>;
  quantity: Scalars['Int'];
};

/** Prezzi delle tipologie per l'arrangiamento base. */
export type ResourceRate = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: Maybe<Array<PriceOccupation>>;
  /** Per adesso gestiamo solo prezzo a Camera */
  priceType: PriceType;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: Maybe<Array<RuleOccupation>>;
};

export type ResourceRateBaseInput = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  resourceType: ResourceTypeBaseInput;
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: InputMaybe<Array<RuleOccupationInput>>;
};

/** Prezzi delle tipologie per l'arrangiamento base. */
export type ResourceRateInput = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  /** Per adesso gestiamo solo prezzo a Camera */
  priceType: PriceType;
  resourceTypeId: Scalars['ID'];
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: InputMaybe<Array<RuleOccupationInput>>;
};

/** Il resourcetype è l'entità base del sistema, tutta la logica della disponibilità e prezzi gira su questa entità. */
export type ResourceType = {
  /**
   * Indica il numero aggiuntivo di persone oltre Persons che possono prenotare questa tipologia.
   * Se non viene gestito il numero è uguale a zero.
   */
  additionalPersons: Scalars['Int'];
  amenities?: Maybe<Array<Amenity>>;
  amenitiesId?: Maybe<Array<Scalars['ID']>>;
  auditable: Auditable;
  autoEquivalent: Scalars['Boolean'];
  /** Codice esplicativo XX, X */
  code?: Maybe<Scalars['String']>;
  configurationsLayout?: Maybe<Array<ResourceLayout>>;
  configurationsLayoutId?: Maybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  /** Nome personalizzato */
  customName?: Maybe<Scalars['LocalizedString']>;
  defaultLayout?: Maybe<ResourceLayout>;
  defaultLayoutId?: Maybe<Scalars['ID']>;
  description: Scalars['LocalizedString'];
  equivalences: Array<ResourceTypeOption>;
  id: Scalars['ID'];
  imageIds?: Maybe<Array<Scalars['ID']>>;
  images?: Maybe<Array<File>>;
  /** L'inventory se è attiva la licenza del PMS è alimentata dall'inserimento delle risorse, nel IBE e Channel deve essere imputato. */
  inventory: Scalars['Int'];
  logicalType: Scalars['Boolean'];
  /**
   * Se viene gestito indica il numero massimo di adulti che possono essere aggiunti, in quel caso la differenza tra maxperson e maxadults
   * indica quanti bambini possono essere aggiunti.
   */
  maxAdults?: Maybe<Scalars['Int']>;
  /**
   * Tariffa minima, sotto questa tariffa il sistema non invia o non pubblica le tariffe di questa risorsa
   * Serve per sicurezza.
   */
  minRate: Scalars['Int'];
  name: Taxonomy;
  /** Il name è doppia, tripla, monolocale etc.ect. */
  nameId: Scalars['ID'];
  /** E' l'inventario da mandare online, se non valorizzato viene considerato uguale all'inventario */
  onlineInventory?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  /** Numero base di persone che occupano la tipologia. */
  persons: Scalars['Int'];
  propertyId: Scalars['ID'];
  /** Tariffa massima , viene usata su sistema non ancora inizializzati */
  rackRate: Scalars['Int'];
  resourceCategory: Taxonomy;
  /** La categoria è Camera, Appartamento, Posto Letto.. */
  resourceCategoryId: Scalars['ID'];
  resources?: Maybe<Array<Resource>>;
  tenantId: Scalars['ID'];
  /** Configurazione dell'orario di attività. Se valorizzata, indica che questa è una tipologia a pianificazione oraria. */
  timeConfiguration?: Maybe<TimeConfiguration>;
  visibilityOnIbe: Scalars['Boolean'];
};

export type ResourceTypeAvailabilityError = {
  error: Scalars['String'];
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeAvailabilityInput = {
  endDate: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type ResourceTypeBaseInput = {
  additionalPersons: Scalars['Int'];
  amenitiesId?: InputMaybe<Array<Scalars['ID']>>;
  autoEquivalent?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  configurationsLayoutId?: InputMaybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  customName?: InputMaybe<Scalars['LocalizedString']>;
  description: Scalars['LocalizedString'];
  equivalences?: InputMaybe<Array<ResourceTypeOptionInput>>;
  inventory: Scalars['Int'];
  logicalType?: InputMaybe<Scalars['Boolean']>;
  maxAdults?: InputMaybe<Scalars['Int']>;
  minRate: Scalars['Int'];
  nameId: Scalars['ID'];
  order: Scalars['Int'];
  persons: Scalars['Int'];
  resourceCategoryId: Scalars['ID'];
  timeConfiguration?: InputMaybe<TimeConfigurationInput>;
};

export type ResourceTypeEquivalence = {
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeEquivalenceInput = {
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeImageInput = {
  images?: InputMaybe<Array<Scalars['ID']>>;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeInput = {
  additionalPersons: Scalars['Int'];
  amenitiesId?: InputMaybe<Array<Scalars['ID']>>;
  autoEquivalent?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  configurationsLayoutId?: InputMaybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  customName?: InputMaybe<Scalars['LocalizedString']>;
  defaultLayoutId?: InputMaybe<Scalars['ID']>;
  description: Scalars['LocalizedString'];
  equivalences?: InputMaybe<Array<ResourceTypeOptionInput>>;
  inventory: Scalars['Int'];
  logicalType?: InputMaybe<Scalars['Boolean']>;
  maxAdults?: InputMaybe<Scalars['Int']>;
  minRate: Scalars['Int'];
  nameId: Scalars['ID'];
  onlineInventory?: InputMaybe<Scalars['Int']>;
  order: Scalars['Int'];
  persons: Scalars['Int'];
  propertyId: Scalars['ID'];
  rackRate: Scalars['Int'];
  resourceCategoryId: Scalars['ID'];
  tenantId: Scalars['ID'];
  timeConfiguration?: InputMaybe<TimeConfigurationInput>;
  /**  visibilityOnIbe default: true  */
  visibilityOnIbe?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Tipo che permette di gestire le equivalenze per le tipologie fisiche e logiche (solo le tipologie logiche possono avere composizioni)
 * E' permessa anche la composizione con un solo elemento che però si comporta diversamente dall'equivalenza.
 * L'equivalenza, infatti, non impegna "al contrario" come fa la composizione; inoltre, in prenotazione, la camera assegnata è sempre quella equivalente.
 * Es: A -> B (equivalenza)
 *         se prenoto A, e A non è disponibile, avrò come assegnata B e ci sarà un impegno ombra su A solo se questa è logica
 *         se prenoto B non ci sarà nessun impegno ombra
 * Es: A = B + C (composizione)
 *         se prenoto A, avrò A come risorsa assegnata e ci saranno impegni ombra su B e C
 *         se prenoto B o C, verrà creato un impegno ombra su A
 *     A = D (composizione verso una sola risorsa)
 *         se prenoto A, avrò A come risorsa assegnata e ci sarà un impegno ombra su D
 *         se prenoto D, verrà creato un impegno ombra su A (comportamento differente rispetto all'equivalenza)
 */
export type ResourceTypeOption = {
  /**  Elenco che costituisce la composizione (nel caso di equivalenza può contenere un solo elemento)  */
  group: Array<ResourceTypeEquivalence>;
  logicResourceId?: Maybe<Scalars['ID']>;
  order: Scalars['Int'];
  type: OptionType;
};

export type ResourceTypeOptionInput = {
  /**  Elenco che costituisce la composizione (nel caso di equivalenza contiene un solo elemento)  */
  group: Array<ResourceTypeEquivalenceInput>;
  logicResourceId?: InputMaybe<Scalars['ID']>;
  order: Scalars['Int'];
  type: OptionType;
};

export type ResourceTypePriceRange = {
  price: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypePriceRangeInput = {
  price: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  timeResources?: InputMaybe<Scalars['Boolean']>;
};

export const ResourceTypeTimeUnitOfMeasurement = {
  DAY: 'DAY',
  HALF_DAY: 'HALF_DAY',
  HALF_HOUR: 'HALF_HOUR',
  HOUR: 'HOUR',
  QUARTER: 'QUARTER'
} as const;

export type ResourceTypeTimeUnitOfMeasurement = typeof ResourceTypeTimeUnitOfMeasurement[keyof typeof ResourceTypeTimeUnitOfMeasurement];
export type ResourceUnavailability = {
  /**  end date has the same behavior as the reservation end date (the end day is not considered)  */
  end: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  start: Scalars['Date'];
};

export type ResourceUnavailabilityInput = {
  /**  end date has the same behavior as the reservation end date (the end day is not considered)  */
  end: Scalars['Date'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  start: Scalars['Date'];
};

export type ResourcesHousekeeperInput = {
  housekeepers?: InputMaybe<Array<ResourceHousekeeperInput>>;
  resourceId: Scalars['ID'];
};

export type RetryImportPropertyInput = {
  extPropertyId: Scalars['String'];
  tenantId: Scalars['ID'];
};

/**
 * Ruoli autorizzativi Admin, Delivery, Proprietrio, Direttore, FOM (Front Office Manager), Receptions...
 * E' possibile avere dei ruoli per tenant
 */
export type Role = {
  auditable: Auditable;
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  permissions?: Maybe<Array<Permissions>>;
  /** Se true, non può essere impostato da fe */
  systemRole?: Maybe<Scalars['Boolean']>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type RoleQueryFilter = {
  id?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type RollBackImportInput = {
  deleteImported: Scalars['Boolean'];
  deleteProperty: Scalars['Boolean'];
  extPropertyId: Scalars['String'];
  stepFrom: UndoImportStep;
  tenantId: Scalars['ID'];
};

/** Risultati del rate query per risorsa */
export type RqForResourceOutput = {
  id: Scalars['ID'];
  rate: RateRq;
};

/** Risultati del rate query */
export type RqOutput = {
  id: Scalars['ID'];
  rates?: Maybe<Array<RateRq>>;
  resources?: Maybe<Array<ResourceAvailabilityRq>>;
};

/**
 * Ratequery Filter
 * UserId ci permette di capire se la query viene fatta dal pms o da un sistema esterno.
 */
export type RqQueryFilter = {
  chargeCategoryId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  end: Scalars['Date'];
  ibeCode?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  rateId?: InputMaybe<Scalars['ID']>;
  resources: Array<ResourceRQInput>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type RqQueryForResourceFilter = {
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  childOccupancy?: InputMaybe<Array<ChildOccupancyRQInput>>;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  rateId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

/**
 * Tipo che identifica la regola del prezzo aggiuntivo a valore o in percentuale, occupancy è il numero di occupante aggiuntivo.
 * Può esserci collegata una validità, in modo da cambiare in base al periodo le variazioni
 */
export type RuleOccupation = {
  occupancy: Scalars['Int'];
  type: ValueType;
  validity?: Maybe<Range>;
  value: Scalars['Float'];
  variation: MathOperation;
};

/**
 * Tipo che identifica la regola del prezzo aggiuntivo a valore o in percentuale, occupancy è il numero di occupante aggiuntivo.
 * Può esserci collegata una validità, in modo da cambiare in base al periodo le variazioni
 */
export type RuleOccupationInput = {
  occupancy: Scalars['Int'];
  type: ValueType;
  validity?: InputMaybe<RangeInput>;
  value: Scalars['Float'];
  variation: MathOperation;
};

export type ScelAdditionalInfo = {
  /**  Live from FiscalGateway Hook  */
  canceled?: Maybe<Scalars['Boolean']>;
  /** last error received */
  lastError?: Maybe<Scalars['String']>;
  /** Note for FiscalGateway */
  note?: Maybe<Scalars['String']>;
  /** order_id sent to FiscalGateway */
  orderId: Scalars['String'];
  /** Sent to FiscalGateway (attempts) */
  sent: Scalars['Int'];
  /**  State from FiscalGateway Hook  */
  state?: Maybe<ScelState>;
  /** Timestamp of last update */
  timeStamp?: Maybe<Scalars['DateTime']>;
};

export const ScelState = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  WAITING: 'WAITING'
} as const;

export type ScelState = typeof ScelState[keyof typeof ScelState];
export const SdiFlowType = {
  SDIPA: 'SDIPA',
  SDIPR: 'SDIPR'
} as const;

export type SdiFlowType = typeof SdiFlowType[keyof typeof SdiFlowType];
export type SendAvailabilitiesAndPricesInput = {
  channelId: Scalars['ID'];
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type SendIstatCancellationInput = {
  /** Nome della configurazione Istat. */
  configurationName?: InputMaybe<Scalars['String']>;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type SendIstatInput = {
  /** Nome della configurazione Istat. Se non specificato, l'invio verrà eseguito per tutte le configurazioni della struttura. */
  configurationName?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SendIstatPeriodInput = {
  /** Nome della configurazione Istat. Se non specificato, l'invio verrà eseguito per tutte le configurazioni della struttura. */
  configurationName?: InputMaybe<Scalars['String']>;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type SendMessageInput = {
  internalNote: Scalars['Boolean'];
  message: Scalars['String'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type SendPSInput = {
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  testOnly: Scalars['Boolean'];
};

export type SendPosLink2PayEmailInput = {
  orderKey: Scalars['String'];
  propertyId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type SendPropertyDataInput = {
  channelId: Scalars['ID'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SendQuotationEmailInput = {
  propertyId: Scalars['ID'];
  quotationId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type SendReservationMessageInput = {
  body?: InputMaybe<Scalars['String']>;
  messageTemplateId: Scalars['ID'];
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type ServiceAvailability = {
  entireStay: Scalars['Boolean'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  time?: Maybe<TimeRange>;
};

export type ServiceAvailabilityInput = {
  entireStay: Scalars['Boolean'];
  resourceTypeId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export type SetNcsUserPreferenceInput = {
  preferences: Array<NcsTemplatePreferenceInput>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type SetPropertyConfigurationsInput = {
  cityTaxConfigurations?: InputMaybe<Array<PropertyResourceMultiConfigurationInput>>;
  fiscalConfigurations?: InputMaybe<Array<PropertyResourceTypeMultiConfigurationInput>>;
  istatConfigurations?: InputMaybe<Array<PropertyResourceMultiConfigurationInput>>;
  propertyId: Scalars['ID'];
  psConfigurations?: InputMaybe<Array<PropertyPsConfigurationInput>>;
  subAddresses?: InputMaybe<Array<PropertyResourceTypeMultiConfigurationInput>>;
  tenantId: Scalars['ID'];
};

export const SetQuotationState = {
  CANCELED: 'CANCELED',
  READ: 'READ',
  SENT: 'SENT'
} as const;

export type SetQuotationState = typeof SetQuotationState[keyof typeof SetQuotationState];
export type SetResourceHousekeepersInput = {
  propertyId: Scalars['ID'];
  resources?: InputMaybe<Array<ResourcesHousekeeperInput>>;
  tenantId: Scalars['ID'];
};

/**
 * Un impegno ombra è generato dalle prenotazioni su tipologie composte e serve per impegnare gli elementi della composizione o il contenitore.
 * Ad esempio, per gli ostelli, dove abbiamo Camerate e Posti Letto:
 * - quando prenoto una camerata impegno, con impegni ombra, tutti i posti letto che la compongono
 * - quando prenoto un posto letto impegno, con un impegno ombra, anche la camerata in cui si trova
 * Gli impegni ombra in cui è fissato resourceId vengono raggruppati e si conteggiano una sola volta per risorsa,
 * quelli in cui non è presente resourceId scalano la disponibilità in egual numero.
 */
export type ShadowCommitment = {
  reservedResource: ReservedResource;
  reservedResourceId: Scalars['ID'];
  resourceId?: Maybe<Scalars['ID']>;
  time?: Maybe<TimeRange>;
};

export type SinapsiAutopilot = {
  active: Scalars['Boolean'];
  /** Number of days in the future that will be handled by the autopilot (default: 180?) */
  max_n_days?: Maybe<Scalars['Int']>;
  /**
   * Autopilot policy wrt lowering prices. Admissible values:
   * - missing or 'no': prices can both increase and decrease;
   * - 'strict', prices cannot be decreased;
   * - 'smart', prices can only be decreased down to the maximum rate paid by previous reservations for the same room and day,
   * >>>> WORK IN PROGRESS, not yet enabled <<<<
   */
  prices_increase_only?: Maybe<Scalars['String']>;
};

export type SinapsiAutopilotInput = {
  active: Scalars['Boolean'];
  /** Number of days in the future that will be handled by the autopilot (default: 180?) */
  max_n_days?: InputMaybe<Scalars['Int']>;
  /**
   * Autopilot policy wrt lowering prices. Admissible values:
   * - missing or 'no': prices can both increase and decrease;
   * - 'strict', prices cannot be decreased;
   * - 'smart', prices can only be decreased down to the maximum rate paid by previous reservations for the same room and day,
   * >>>> WORK IN PROGRESS, not yet enabled <<<<
   */
  prices_increase_only?: InputMaybe<Scalars['String']>;
};

export type SinapsiAutopilotOptions = {
  /** If false, recompute the cache from scratch; otherwise (default) incrementally update it with the latest events */
  incremental_cache_update?: InputMaybe<Scalars['Boolean']>;
  /** If present, override the SERIAL_QUERIES constant in parameters.ts */
  serial_queries_override?: InputMaybe<Scalars['Boolean']>;
};

export type SinapsiBudgetForecast = {
  closed?: Maybe<Scalars['Float']>;
  long_term?: Maybe<Scalars['Float']>;
  month: Scalars['String'];
  no_ave?: Maybe<Scalars['Float']>;
  otb: Scalars['Int'];
  otb_one_year_ago?: Maybe<Scalars['Int']>;
  to_come: Scalars['Int'];
  total: Scalars['Int'];
};

/** Competitor property pricing info as provided to clients */
export type SinapsiCompetitorAccommodationItem = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  occupancy?: Maybe<Scalars['Int']>;
};

export type SinapsiCompetitorLocationItem = {
  location: Scalars['String'];
};

/** Portal-dependent info for a competitor */
export type SinapsiCompetitorPortalInfo = {
  /** Customer review stars of the property translated to a 0-10 scale */
  customer_stars?: Maybe<Scalars['Float']>;
  /** ID of the property within the portal (may not be unique across portals) */
  id: Scalars['String'];
  /** We might consider an ID to the 'portals' collection, but some portals might be outside the CM scope */
  portal_name: Scalars['String'];
  /** List of rooms inferred by the portal's results pages, if any */
  rooms?: Maybe<Array<SinapsiCompetitorRoomInfo>>;
};

export type SinapsiCompetitorPriceItem = {
  amount: Scalars['Float'];
  checkin: Scalars['Date'];
  guests: Scalars['Int'];
  nights: Scalars['Int'];
  room_id?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

export type SinapsiCompetitorPricingInfoByPortal = {
  customer_stars?: Maybe<Scalars['Float']>;
  portal_name?: Maybe<Scalars['String']>;
  prices: Array<SinapsiCompetitorPriceItem>;
  rooms?: Maybe<Array<SinapsiCompetitorAccommodationItem>>;
};

/**
 * Represents a property as it appears on a typical portal's results listing.
 * Maintains an array of all retrieved prices.
 */
export type SinapsiCompetitorProperty = {
  auditable: Auditable;
  /** Official star ranking */
  hotel_stars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Location of the hotel, as inferred by the scraper */
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /**
   * Every property must be referenced by at least one portal, possibly many.
   * Properties that may vary across portals are stored here.
   */
  portal_info: Array<SinapsiCompetitorPortalInfo>;
  /** Retrieved pricing info */
  pricing_info: Array<SinapsiCompetitorRetrievalResult>;
  /** If available, type inferred from some portal's results page (e.g., 'Hotel', 'B&B...) */
  type?: Maybe<Scalars['String']>;
};

/**
 * Info about a property's accommodation type as returned by the portal's results page.
 * The ID must be unique within a (portal, property) combination.
 */
export type SinapsiCompetitorPropertyAccommodationItem = {
  id: Scalars['String'];
  name: Scalars['String'];
  occupancy?: InputMaybe<Scalars['Int']>;
};

/** Subset of competitor property info, returned by API searching for properties in a specific geographic area */
export type SinapsiCompetitorPropertyBasicInfo = {
  hotel_stars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/**
 * Info about a property as returned by the portal's results page.
 * The scraper must provide a unique ID for each property within a portal; if the portal
 * does not provide such information, the scraper should create the ID by hashing some stable information about the property.
 */
export type SinapsiCompetitorPropertyItem = {
  /** List of accommodations, if the portal distinguishes them, referenced by the price items list. May be empty. */
  accommodations?: InputMaybe<Array<SinapsiCompetitorPropertyAccommodationItem>>;
  /** Customer review  stars as reported by the portal, translated to a 0-10 scale */
  customer_stars?: InputMaybe<Scalars['Float']>;
  /** Number of official stars, if applicable */
  hotel_stars?: InputMaybe<Scalars['Int']>;
  /** Portal's property ID */
  id: Scalars['String'];
  /** Location of the hotel, as inferred by the scraper */
  location?: InputMaybe<Scalars['String']>;
  /** Name of the property according to the portal's results page */
  name: Scalars['String'];
  /** List of retrieved pricing entries */
  pricing: Array<SinapsiCompetitorPropertyPriceItem>;
  /** Type of the property according to the portal's results page */
  type?: InputMaybe<Scalars['String']>;
};

/**
 * A single quotation returned by the scraped portal. Only variable quantities not contained in the query.
 * (e.g., number of nights is defined by the task)
 */
export type SinapsiCompetitorPropertyPriceItem = {
  /** Portal-defined ID of the corresponding accommodation. May be undefined. */
  accommodation_id?: InputMaybe<Scalars['String']>;
  /** Quotation (in cents) */
  amount: Scalars['Int'];
  /** Check-in date of the quotation */
  checkin: Scalars['Date'];
};

export type SinapsiCompetitorPropertyPricingInfo = {
  hotel_stars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pricing_info: Array<SinapsiCompetitorPricingInfoByPortal>;
  type?: Maybe<Scalars['String']>;
};

/**
 * Represents a row in the portal's results page contains a price quote for a room given the
 * requested check-in date.
 */
export type SinapsiCompetitorRetrievalResult = {
  /** Checkin date */
  checkin: Scalars['Date'];
  /** Property/room quote, in cents */
  price: Scalars['Int'];
  /** If the room is specified, it is referenced by the portal's ID */
  roomID?: Maybe<Scalars['String']>;
  sinapsiCompetitorRetrievalTask: SinapsiCompetitorRetrievalTask;
  /** The task that generated this result, containing all query details (except check-in date, see below) */
  sinapsiCompetitorRetrievalTaskId: Scalars['ID'];
  /** when was the result retrieved */
  timestamp: Scalars['DateTime'];
};

/**
 * Represents a retrieval task performing a sequence of queries.
 * The portal's responses to these queries populate the competitorRetrievalResults collection (or update existing documents)
 * They also populate the competitorProperties collection (or, if the property already exists, update the 'hotel_stars', 'customer_stars' and 'rooms' fields)
 */
export type SinapsiCompetitorRetrievalTask = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active: Scalars['Boolean'];
  auditable: Auditable;
  /** Day span, starting from today, for the query's check-in date */
  day_span: Scalars['Int'];
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: Maybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location: Scalars['String'];
  /** Number of guests for which the search must be issued */
  guests: Scalars['Int'];
  id: Scalars['ID'];
  /**
   * Task deadline used to set the priority.
   * If present, next time the task is expected to run.
   * Updated upon task completion by adding 'period' days to the current datetime.
   * Initially missing, meaning maximum priority
   */
  next_execution?: Maybe<Scalars['DateTime']>;
  /** Number of nights for which the search must be issued */
  nights: Scalars['Int'];
  /** Ideal number of days between retrievals */
  period: Scalars['Int'];
  /** Name of the target portal */
  portal_name: Scalars['String'];
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: Maybe<Scalars['Int']>;
  /**
   * If missing, null or older than 2 days, no client is running the task.
   * If present, the task has been provided to a client which hasn't returned a completion message (yet).
   * Set to null when the client sends a completion message.
   */
  running_since?: Maybe<Scalars['DateTime']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: Maybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: Maybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: Maybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: Maybe<Array<Scalars['Int']>>;
};

export type SinapsiCompetitorRetrievalTaskFilterInput = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location?: InputMaybe<Scalars['String']>;
  /** Name of the target portal */
  portal_name?: InputMaybe<Scalars['String']>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: InputMaybe<Scalars['String']>;
};

export type SinapsiCompetitorRetrievalTaskInput = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active: Scalars['Boolean'];
  /** Day span, starting from today, for the query's check-in date */
  day_span: Scalars['Int'];
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: InputMaybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location: Scalars['String'];
  /** Number of guests for which the search must be issued */
  guests: Scalars['Int'];
  /** Number of nights for which the search must be issued */
  nights: Scalars['Int'];
  /** Ideal number of days between retrievals */
  period: Scalars['Int'];
  /** Name of the target portal */
  portal_name: Scalars['String'];
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: InputMaybe<Scalars['Int']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: InputMaybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: InputMaybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: InputMaybe<Array<Scalars['Int']>>;
};

export type SinapsiCompetitorRetrievalTaskItem = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active: Scalars['Boolean'];
  /** Day span, starting from today, for the query's check-in date */
  day_span: Scalars['Int'];
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: Maybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location: Scalars['String'];
  /** Number of guests for which the search must be issued */
  guests: Scalars['Int'];
  id: Scalars['ID'];
  /**
   * Task deadline used to set the priority.
   * If present, next time the task is expected to run.
   * Updated upon task completion by adding 'period' days to the current datetime.
   * Initially missing, meaning maximum priority
   */
  next_execution?: Maybe<Scalars['DateTime']>;
  /** Number of nights for which the search must be issued */
  nights: Scalars['Int'];
  /** Ideal number of days between retrievals */
  period: Scalars['Int'];
  /** Name of the target portal */
  portal_name: Scalars['String'];
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: Maybe<Scalars['Int']>;
  /**
   * If missing, null or older than 2 days, no client is running the task.
   * If present, the task has been provided to a client which hasn't returned a completion message (yet).
   * Set to null when the client sends a completion message.
   */
  running_since?: Maybe<Scalars['DateTime']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: Maybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: Maybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: Maybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: Maybe<Array<Scalars['Int']>>;
};

/** Final results of a retrieval task. */
export type SinapsiCompetitorRetrievalTaskResultsInput = {
  /** List of results. May be missing if the API is called with the sole purpose of unblocking the task for */
  results?: InputMaybe<Array<SinapsiCompetitorPropertyItem>>;
  /** ID of the completed retrieval task */
  taskId: Scalars['ID'];
  /**
   * If true, this is the last update message for the task, which can be made available again.
   * If falsey, the task remains locked and more results will follow.
   * If the task is never unlocked, it will become available by default after two days of being assigned.
   */
  unlock?: InputMaybe<Scalars['Boolean']>;
};

export type SinapsiCompetitorRetrievalTaskUpdateInput = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Day span, starting from today, for the query's check-in date */
  day_span?: InputMaybe<Scalars['Int']>;
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: InputMaybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location?: InputMaybe<Scalars['String']>;
  /** Number of guests for which the search must be issued */
  guests?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Number of nights for which the search must be issued */
  nights?: InputMaybe<Scalars['Int']>;
  /** Ideal number of days between retrievals */
  period?: InputMaybe<Scalars['Int']>;
  /** Name of the target portal */
  portal_name?: InputMaybe<Scalars['String']>;
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: InputMaybe<Scalars['Int']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: InputMaybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: InputMaybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: InputMaybe<Array<Scalars['Int']>>;
};

/** Portal-dependent info for a competitor's room (resource / accommodation type) */
export type SinapsiCompetitorRoomInfo = {
  /** ID of the room within the portal (may not be unique across properties) */
  id: Scalars['String'];
  /** name of the room (if provided) */
  name?: Maybe<Scalars['String']>;
  /** occupancy of the room (if provided) */
  occupancy?: Maybe<Scalars['Int']>;
};

export type SinapsiConfiguration = {
  /** Settings for automated pricing changes */
  autopilot?: Maybe<SinapsiAutopilot>;
  /** Array of holidays for possible pricing exceptions and historic date alignment */
  holidays?: Maybe<Array<SinapsiHoliday>>;
  /** Array of resources that do not take part to the Sinapsi algorithm */
  ignore_resources?: Maybe<Array<Scalars['ID']>>;
  /** Parameters that influence decisions about pricing */
  pricing?: Maybe<SinapsiPricing>;
  /** Resources that must be aggregated to improve the result quality */
  resource_mapping?: Maybe<Array<SinapsiResourceMapping>>;
  /** Propensity to risk: determines the maximum price variation and periodicity */
  risk_profile?: Maybe<SinapsiRiskProfileParameters>;
};

export type SinapsiConfigurationInput = {
  /** Settings for automated pricing changes */
  autopilot?: InputMaybe<SinapsiAutopilotInput>;
  /** Array of holidays for possible pricing exceptions and historic date alignment */
  holidays?: InputMaybe<Array<SinapsiHolidayInput>>;
  /** Array of resources that do not take part to the Sinapsi algorithm */
  ignore_resources?: InputMaybe<Array<Scalars['ID']>>;
  /** Parameters that influence decisions about pricing */
  pricing?: InputMaybe<SinapsiPricingInput>;
  /** Resources that must be aggregated to improve the result quality */
  resource_mapping?: InputMaybe<Array<SinapsiResourceMappingInput>>;
  /** Propensity to risk: determines the maximum price variation and periodicity */
  risk_profile?: InputMaybe<SinapsiRiskProfileParametersInput>;
};

export type SinapsiDailyPriceAuditFilterInput = {
  day: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SinapsiDailyPriceAuditOutput = {
  price: Scalars['Int'];
  timestamp: Scalars['DateTime'];
};

export type SinapsiFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SinapsiHoliday = {
  /** Initial date */
  date: Scalars['Date'];
  /** Duration of the holiday */
  days: Scalars['Int'];
  /** Order of appearance */
  index?: Maybe<Scalars['Int']>;
  /** Initial date on the previous year (for realignment purposes) */
  last_year?: Maybe<Scalars['Date']>;
  /** Name of the holiday */
  name: Scalars['String'];
};

export type SinapsiHolidayInput = {
  /** Initial date */
  date: Scalars['Date'];
  /** Duration of the holiday */
  days: Scalars['Int'];
  /** Order of appearance */
  index?: InputMaybe<Scalars['Int']>;
  /** Initial date on the previous year (for realignment purposes) */
  last_year?: InputMaybe<Scalars['Date']>;
  /** Name of the holiday */
  name: Scalars['String'];
};

export type SinapsiLastPeriodStats = {
  /** Timestamp of the last price change operation */
  last_price_change: Scalars['DateTime'];
  /**
   * Number of unique accommodation/checkin date pairs updated at least once since period_start.
   * Note that multiple updates to the same accommodation/chackin date are only counted once
   */
  n_changed_prices: Scalars['Int'];
  /** Same as above, but every change to the same accommodation/checkin date is counted separately */
  n_changes: Scalars['Int'];
  /** Date from which the following statistics are counted */
  period_start: Scalars['DateTime'];
};

export type SinapsiOutput = {
  /** List of monthly budget forecasts */
  budget_forecast?: Maybe<Array<SinapsiBudgetForecast>>;
  /** Basic stats: number of changes in the last period, see SinapsiQueryOptions.n_days_for_stats */
  last_period_stats?: Maybe<SinapsiLastPeriodStats>;
  /** List of recommended prices */
  prices?: Maybe<Array<SinapsiResourceRecommendedPrices>>;
};

/**
 * Define how the price of a (real) resource is used to composed the price of a mapped (e.g., virtual) resource.
 * The real resource's contribution is multiplier * price + delta
 */
export type SinapsiPriceCompositionItem = {
  /** Additional price (in cents) to be added */
  delta?: Maybe<Scalars['Int']>;
  /** 'weight' of the resource's price in the combination of prices (in %: 100 means full price) */
  multiplier?: Maybe<Scalars['Int']>;
  /** ID of the (real) resource whose price has already been determined */
  resourceTypeId: Scalars['ID'];
};

/**
 * Define how the price of a (real) resource is used to composed the price of a mapped (virtual) resource.
 * The real resource's contribution is multiplier * price + sum
 */
export type SinapsiPriceCompositionItemInput = {
  /** Additional price (in cents) to be added */
  delta?: InputMaybe<Scalars['Int']>;
  /** 'weight' of the resource's price in the combination of prices (in %, so 100 means full price) */
  multiplier?: InputMaybe<Scalars['Int']>;
  /** ID of the (real) resource whose price has already been determined */
  resourceTypeId: Scalars['ID'];
};

export type SinapsiPriceInfos = {
  closed?: Maybe<Scalars['Boolean']>;
  pulled_by?: Maybe<Scalars['ID']>;
  pushed_by?: Maybe<Scalars['ID']>;
};

export type SinapsiPriceLimit = {
  max: Scalars['Int'];
  min: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

export type SinapsiPriceLimitInput = {
  max: Scalars['Int'];
  min: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

export type SinapsiPriceOverride = {
  from: Scalars['Date'];
  limits: Array<SinapsiPriceLimit>;
  to: Scalars['Date'];
};

export type SinapsiPriceOverrideInput = {
  from: Scalars['Date'];
  limits: Array<SinapsiPriceLimitInput>;
  to: Scalars['Date'];
};

export type SinapsiPriceWarnings = {
  max?: Maybe<Scalars['Boolean']>;
  min?: Maybe<Scalars['Boolean']>;
};

export type SinapsiPricing = {
  /** Percent variations for fine intra-week modulation of min-max prices (default: 0=unchanged), one per day of week (first entry is Sunday) */
  dayofweek_modulation?: Maybe<Array<Scalars['Int']>>;
  /** The day-of-week modulation also applies to overrides (default: true) */
  dayofweek_modulation_applied_to_overrides?: Maybe<Scalars['Boolean']>;
  /** Price intervals (minimum and maximum price) for every resource type */
  limits?: Maybe<Array<SinapsiPriceLimit>>;
  /** Resource prices can push/pull each other based on ordering */
  order?: Maybe<SinapsiPricingOrder>;
  /** Date-based exceptions to price intervals */
  overrides?: Maybe<Array<SinapsiPriceOverride>>;
  /** Near-term policy parameters */
  short_term?: Maybe<SinapsiShortTermPricingPolicy>;
};

export type SinapsiPricingInput = {
  /** Percent variations for fine intra-week modulation of min-max prices (default: 0=unchanged), one per day of week (first entry is Sunday) */
  dayofweek_modulation?: InputMaybe<Array<Scalars['Int']>>;
  /** The day-of-week modulation also applies to overrides (default: true) */
  dayofweek_modulation_applied_to_overrides?: InputMaybe<Scalars['Boolean']>;
  /** Price intervals (minimum and maximum price) for every resource type */
  limits?: InputMaybe<Array<SinapsiPriceLimitInput>>;
  /** Resource prices can push/pull each other based on ordering */
  order?: InputMaybe<SinapsiPricingOrderInput>;
  /** Date-based exceptions to price intervals */
  overrides?: InputMaybe<Array<SinapsiPriceOverrideInput>>;
  /** Near-term policy parameters */
  short_term?: InputMaybe<SinapsiShortTermPricingPolicyInput>;
};

export type SinapsiPricingOrder = {
  active?: Maybe<Scalars['Boolean']>;
  exclude_from_ordering?: Maybe<Array<Scalars['ID']>>;
};

export type SinapsiPricingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** List of resources whose prices must not be pushed/pulled */
  exclude_from_ordering?: InputMaybe<Array<Scalars['ID']>>;
};

export type SinapsiQueryOptions = {
  /** Also compute budget forecast, default is true */
  do_budget?: InputMaybe<Scalars['Boolean']>;
  /** If false, recompute the cache from scratch; otherwise (default) incrementally update it with the latest events */
  incremental_cache_update?: InputMaybe<Scalars['Boolean']>;
  /** Number of days in the past for basic stats (if undefined, one week) */
  n_days_for_stats?: InputMaybe<Scalars['Int']>;
};

/**
 * Mapping between resources, used to set a correspondence between real resources,
 * or to map virtual ("origin") onto real ("destination") resources.
 * The mapping is composed of two parts:
 * - "forward" mapping, attributing reservations of the origin resource to possibly many "destination" ones (e.g. room to beds, apartment to rooms)
 * - "backwards" mapping: once the destination resource prices are determined by Sinapsi, combine them to set a price for the origin resource.
 */
export type SinapsiResourceMapping = {
  /**
   * Array of (real) resources to which every reservation of the origin resource must be copied.
   * The IDs may be one or more, and can be repeated, e.g. in case of a virtual room made of many equivalent real beds
   */
  destination_resourceTypeIds: Array<Scalars['ID']>;
  /** Optional mnemonic name of the mapping */
  name?: Maybe<Scalars['String']>;
  /** ID of the origin (e.g., virtual) resource whose reservations must be distributed to destinations and whose price will be derived fom them */
  origin_resourceTypeId: Scalars['ID'];
  /** Array of contributions to the price of the origin (e.g., virtual) room from real ones. */
  price_composition: Array<SinapsiPriceCompositionItem>;
  /**
   * Virtual/real room flag, used to guide the UI in displaying the mapping.
   * If true, the mapping refers to a virtual room composition;
   * if false or missing, the mapping is an association between real rooms.
   */
  virtual?: Maybe<Scalars['Boolean']>;
};

/**
 * Mapping between virtual ("origin") and real ("destination") resources.
 * The mapping is composed of two parts:
 * - "forward" mapping, attributing reservations for the virtual resource to possibly many real ones (e.g. room to beds, apartment to rooms)
 * - "backwards" mapping: once the real resource prices are determined by Sinapsi, combine them to fix a price for the virtual resource.
 */
export type SinapsiResourceMappingInput = {
  /**
   * Array of real resources to which every reservation of the origin resource must be copied.
   * The IDs may be one or more, and can be repeated, e.g. in case of a virtual room made of many equivalent real beds
   */
  destination_resourceTypeIds: Array<Scalars['ID']>;
  /** Optional mnemonic name of the mapping */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the virtual resource whose reservations must be distributed to real ones and whose price will be derived fom them */
  origin_resourceTypeId: Scalars['ID'];
  /** Array of contribution to the origin (virtual) room from real ones. */
  price_composition: Array<SinapsiPriceCompositionItemInput>;
  /**
   * Virtual/real room flag, used to guide the UI in displaying the mapping.
   * If true, the mapping refers to a virtual room composition;
   * if false or missing, the mapping is an association between real rooms.
   */
  virtual?: InputMaybe<Scalars['Boolean']>;
};

export type SinapsiResourceRecommendedPrice = {
  date: Scalars['Date'];
  debug_txt?: Maybe<Scalars['String']>;
  infos?: Maybe<SinapsiPriceInfos>;
  price: Scalars['Int'];
  warnings?: Maybe<SinapsiPriceWarnings>;
};

export type SinapsiResourceRecommendedPrices = {
  recommendations: Array<Maybe<SinapsiResourceRecommendedPrice>>;
  resourceTypeId: Scalars['ID'];
};

/** Sinapsi Configuration, embedded document */
export type SinapsiRiskProfileParameters = {
  /** low | medium | high */
  risk_appetite: Scalars['String'];
};

/** SINAPSI PARAMETERS  */
export type SinapsiRiskProfileParametersInput = {
  /** low | medium | high */
  risk_appetite: Scalars['String'];
};

export type SinapsiShortTermPricingPolicy = {
  /** Number of days for the short-term period (0 = none) */
  start: Scalars['Int'];
  /** Optional: minimum fraction of reserved units, below which the resource is underbooked (0 or missing = inactive) */
  underbooking_threshold?: Maybe<Scalars['Float']>;
};

export type SinapsiShortTermPricingPolicyInput = {
  /** Number of days for the short-term period (0 = none) */
  start: Scalars['Int'];
  /** Optional: minimum fraction of reserved units, below which the resource is underbooked (0 or missing = inactive) */
  underbooking_threshold?: InputMaybe<Scalars['Float']>;
};

export type SinapsiUpdateOptions = {
  incremental_cache_update?: InputMaybe<Scalars['Boolean']>;
  perform_cache_updates: Scalars['Boolean'];
  propertyId?: InputMaybe<Scalars['ID']>;
  run_autopilot: Scalars['Boolean'];
  serial_queries_override?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type SinapsiUpdateOutcome = {
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
  warnings?: Maybe<Array<Scalars['String']>>;
};

export const Sort = {
  asc: 'asc',
  desc: 'desc'
} as const;

export type Sort = typeof Sort[keyof typeof Sort];
export type SplitProductionAssignedInput = {
  destinationBills?: InputMaybe<Array<Scalars['ID']>>;
  productionAssigneds: Array<Scalars['ID']>;
  splitType: SplitType;
  tenantId: Scalars['ID'];
  value: Scalars['Int'];
};

export const SplitType = {
  BY_VALUE: 'BY_VALUE',
  EQUAL_PARTS: 'EQUAL_PARTS'
} as const;

export type SplitType = typeof SplitType[keyof typeof SplitType];
export type StartTotemWorkflowInput = {
  /** The customer ID is required for the privacy workflow */
  customerId?: InputMaybe<Scalars['ID']>;
  /** The guest type is required for the OCR workflow */
  guestType?: InputMaybe<GuestType>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  totemId: Scalars['ID'];
  workflow: TotemWorkflow;
};

/** Stati delle entità di HIC */
export const State = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  DRAFT: 'DRAFT',
  INACTIVE: 'INACTIVE'
} as const;

export type State = typeof State[keyof typeof State];
export const StatisticDetail = {
  CHARGECATEGORY: 'CHARGECATEGORY',
  DATE: 'DATE',
  ORIGIN: 'ORIGIN',
  RATE: 'RATE',
  RESOURCE: 'RESOURCE',
  RESOURCETYPE: 'RESOURCETYPE'
} as const;

export type StatisticDetail = typeof StatisticDetail[keyof typeof StatisticDetail];
/**  STATISTIC  */
export type StatisticFilter = {
  agency?: InputMaybe<Scalars['Boolean']>;
  chargeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  company?: InputMaybe<Scalars['Boolean']>;
  consolidated?: InputMaybe<Scalars['Boolean']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  end: Scalars['Date'];
  excludedTagIds?: InputMaybe<Array<Scalars['ID']>>;
  groups?: InputMaybe<Scalars['Boolean']>;
  nationalityIsoCodes?: InputMaybe<Array<Scalars['String']>>;
  origins?: InputMaybe<Array<Scalars['String']>>;
  passersBy?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  rangeType: StatisticRangeType;
  rateIds?: InputMaybe<Array<Scalars['ID']>>;
  reservationStates?: InputMaybe<Array<StatisticReservationStates>>;
  resourceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  start: Scalars['Date'];
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  vatIncluded: Scalars['Boolean'];
};

export type StatisticOutput = {
  adr: Scalars['Float'];
  chargeCategory?: Maybe<ChargeCategory>;
  chargeCategoryId?: Maybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  date?: Maybe<Scalars['Date']>;
  guests?: Maybe<GuestStatistic>;
  id: Scalars['ID'];
  /**  inventory and unavailability should not be added when reduced to a single day  */
  inventory: Scalars['Int'];
  lengthOfStay: Array<Scalars['Int']>;
  occupancy: Scalars['Int'];
  originLabel?: Maybe<Scalars['String']>;
  pickup: Array<Scalars['Int']>;
  rate?: Maybe<Rate>;
  rateId?: Maybe<Scalars['ID']>;
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType?: Maybe<ResourceType>;
  resourceTypeId?: Maybe<Scalars['ID']>;
  revpar: Scalars['Float'];
  roomProduction: Scalars['Float'];
  shadow: Scalars['Int'];
  totalProduction: Scalars['Float'];
  trevpar: Scalars['Float'];
  unavailability: Scalars['Int'];
};

export const StatisticRangeType = {
  CREATION: 'CREATION',
  STAY: 'STAY'
} as const;

export type StatisticRangeType = typeof StatisticRangeType[keyof typeof StatisticRangeType];
export const StatisticReservationStates = {
  CONFIRMED: 'CONFIRMED',
  NOSHOW: 'NOSHOW',
  OPTIONED: 'OPTIONED'
} as const;

export type StatisticReservationStates = typeof StatisticReservationStates[keyof typeof StatisticReservationStates];
export type StopSellInput = {
  end: Scalars['Date'];
  onlineInventory?: InputMaybe<Scalars['Int']>;
  onlineLimit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  stopSellOTA?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

export type StopTotemWorkflowInput = {
  eventId: Scalars['String'];
  propertyId: Scalars['ID'];
  state: StopTotemWorkflowState;
  tenantId: Scalars['ID'];
  totemId: Scalars['ID'];
};

export const StopTotemWorkflowState = {
  ABORTED: 'ABORTED',
  COMPLETED: 'COMPLETED'
} as const;

export type StopTotemWorkflowState = typeof StopTotemWorkflowState[keyof typeof StopTotemWorkflowState];
export type StoreCustomerImagesInput = {
  identificationDocument?: InputMaybe<CustomerIdentificationDocumentInput>;
  privacy?: InputMaybe<CustomerPrivacyInfo>;
  selfieImage?: InputMaybe<CustomerImage>;
};

export type StoreResponse = {
  code: Scalars['String'];
  name: Scalars['String'];
  pricesPages?: Maybe<Array<PricesPage>>;
};

export type StoreUpgradeInput = {
  action: Scalars['String'];
  email: Scalars['String'];
  planReference: Scalars['String'];
  productCode: Scalars['String'];
  subscriptionIdToUpgrade: Scalars['String'];
};

export type StoreUpgradeRequest = {
  action: Scalars['String'];
  email: Scalars['String'];
  planReference: Scalars['String'];
  productCode: Scalars['String'];
  subscriptionIdToUpgrade: Scalars['String'];
};

export type StoreUpgradeResponse = {
  url: Scalars['String'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  channelManagerEvent?: Maybe<ChannelManagerEvent>;
  dailyClosureEvent?: Maybe<DailyClosureEvent>;
  dashboardKpiEvent?: Maybe<DashBoardRefreshEvent>;
  documentExportedEvent?: Maybe<DocumentExportedEvent>;
  fakeEvent?: Maybe<FakeOutput>;
  newThreadMessageEvent?: Maybe<NewThreadMessageEvent>;
  rebuildPropertyAvailabilityEvent?: Maybe<RebuildPropertyAvailabilityEvent>;
  reservedResourceEvent?: Maybe<ReservedResourceEvent>;
  reservedResourceProductionEvent?: Maybe<ReservedResourceProductionEvent>;
  resourceEvent?: Maybe<ResourceEvent>;
  totemEvent?: Maybe<TotemEvent>;
};


export type SubscriptionchannelManagerEventArgs = {
  filter: ChannelManagerEventFilter;
};


export type SubscriptiondailyClosureEventArgs = {
  filter: DailyClosureEventFilter;
};


export type SubscriptiondashboardKpiEventArgs = {
  filter: DashboardQueryFilter;
};


export type SubscriptiondocumentExportedEventArgs = {
  filter: DocumentExportedEventFilter;
};


export type SubscriptionnewThreadMessageEventArgs = {
  filter: NewThreadMessageEventFilter;
};


export type SubscriptionrebuildPropertyAvailabilityEventArgs = {
  filter: RebuildPropertyAvailabilityEventFilter;
};


export type SubscriptionreservedResourceEventArgs = {
  filter: ReservedResourceEventFilter;
};


export type SubscriptionreservedResourceProductionEventArgs = {
  filter: ReservedResourceProductionEventFilter;
};


export type SubscriptionresourceEventArgs = {
  filter: ResourceEventFilter;
};


export type SubscriptiontotemEventArgs = {
  filter: TotemEventFilter;
};

export type SubscriptionDigital = {
  active?: Maybe<Scalars['Boolean']>;
  appDescription?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type SubscriptionInfoInput = {
  featureCode: MeteringModule;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SubscriptionModuleOutput = {
  features?: Maybe<Array<Feature>>;
  modules?: Maybe<Array<MeteringModule>>;
  trialModules?: Maybe<Array<TrialModule>>;
  userModules?: Maybe<Array<MeteringModule>>;
  userRole?: Maybe<UserRoleOutput>;
};

/** Le entità Tag sono per tenantId */
export type Tag = {
  auditable: Auditable;
  color: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type TagInput = {
  color: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type TagQueryFilter = {
  id?: InputMaybe<IDFilter>;
  label?: InputMaybe<StringFilter>;
  tenantId: IDFilter;
};

/** Entità che contiene i dati delle lookup gestite */
export type Taxonomy = {
  auditable: Auditable;
  description: Scalars['LocalizedString'];
  id: Scalars['ID'];
  /** Ordinamento è da utilizzare quando viene tirata su la lookup. */
  order: Scalars['Int'];
  parent?: Maybe<Taxonomy>;
  /** E' possibile creare lookup master detail specificando il parent */
  parentId?: Maybe<Scalars['ID']>;
  /** Codice usato per l'associazione con elementi parent durante la migration e per mappare con la gestione dei classifier del workspace/office */
  ref?: Maybe<Scalars['String']>;
  /** Tipologia della lookup */
  type: TaxonomyType;
};

export type TaxonomyInput = {
  description: Scalars['LocalizedString'];
  order: Scalars['Int'];
  parentId?: InputMaybe<Scalars['ID']>;
  type: TaxonomyType;
};

export type TaxonomyQueryFilter = {
  id?: InputMaybe<IDFilter>;
  parentId?: InputMaybe<IDFilter>;
  type?: InputMaybe<TaxonomyTypeFilter>;
};

export const TaxonomyType = {
  CHILDTYPE: 'CHILDTYPE',
  PAYMENT: 'PAYMENT',
  PROPERTY_CATEGORY: 'PROPERTY_CATEGORY',
  PROPERTY_CLASSTYPE: 'PROPERTY_CLASSTYPE',
  RESOURCE_CATEGORY: 'RESOURCE_CATEGORY',
  RESOURCE_NAME: 'RESOURCE_NAME'
} as const;

export type TaxonomyType = typeof TaxonomyType[keyof typeof TaxonomyType];
export type TaxonomyTypeFilter = {
  eq?: InputMaybe<TaxonomyType>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<TaxonomyType>>;
  ne?: InputMaybe<TaxonomyType>;
  nin?: InputMaybe<Array<TaxonomyType>>;
};

/** Il Tenant rappresenta il cliente che acquista Hotel in Cloud, la creazione del Tenant avviene tramite provisioning. */
export type Tenant = {
  auditable: Auditable;
  backoffice?: Maybe<Scalars['Boolean']>;
  cassaInCloudConfiguration?: Maybe<CassaInCloudConfiguration>;
  currency: Scalars['Currency'];
  description?: Maybe<Scalars['String']>;
  fiscalCode?: Maybe<Scalars['String']>;
  fiscalGatewayData?: Maybe<FiscalGatewayData>;
  id: Scalars['ID'];
  language: Scalars['Language'];
  modules?: Maybe<Array<Module>>;
  ncsId?: Maybe<Scalars['String']>;
  privacySettings?: Maybe<PrivacySettings>;
  registryItemId: Scalars['String'];
  scelTemplate?: Maybe<Scalars['String']>;
  sellerName?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type TenantPropertyIdFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type TenantQueryFilter = {
  id?: InputMaybe<IDFilter>;
};

export type Thread = {
  archived: Scalars['Boolean'];
  auditable: Auditable;
  externalId: Scalars['String'];
  externalUsers: Array<ThreadUser>;
  id: Scalars['ID'];
  lastMessage?: Maybe<LastThreadMessage>;
  messages: Array<ThreadMessage>;
  origin: ThreadOrigin;
  propertyId: Scalars['ID'];
  propertyPortalCode?: Maybe<Scalars['String']>;
  read: Scalars['Boolean'];
  reservation: Reservation;
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ThreadMessage = {
  auditable: Auditable;
  externalId?: Maybe<Scalars['String']>;
  /**  valorizzato solo per gli utenti esterni, se non valorizzato è un messaggio della struttura inviato dall'utente auditable.createdBy   */
  externalUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalNote: Scalars['Boolean'];
  message: Scalars['String'];
  messageAutomationId?: Maybe<Scalars['ID']>;
  messageTemplateId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type ThreadMessageQueryFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export const ThreadOrigin = {
  AIRBNB: 'AIRBNB',
  BOOKING: 'BOOKING'
} as const;

export type ThreadOrigin = typeof ThreadOrigin[keyof typeof ThreadOrigin];
export type ThreadQueryFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  reservationId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type ThreadUser = {
  externalId: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  preferred_locale?: Maybe<Scalars['String']>;
};

export type TimeConfiguration = {
  activity?: Maybe<TimeRange>;
  chargeCategoryId: Scalars['ID'];
  unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement;
};

export type TimeConfigurationInput = {
  activity?: InputMaybe<TimeRangeInput>;
  chargeCategoryId: Scalars['ID'];
  unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement;
};

export type TimeRange = {
  from: Scalars['Time'];
  to: Scalars['Time'];
};

export type TimeRangeInput = {
  from: Scalars['Time'];
  to: Scalars['Time'];
};

export type Totem = {
  auditable: Auditable;
  id: Scalars['ID'];
  link: Scalars['String'];
  name: Scalars['String'];
  property: Property;
  propertyId: Scalars['ID'];
  subAddresses?: Maybe<Array<Scalars['String']>>;
  supportedWorkflows: Array<TotemWorkflow>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type TotemEvent = {
  customerId?: Maybe<Scalars['ID']>;
  eventId: Scalars['String'];
  eventType: TotemEventType;
  guestType?: Maybe<GuestType>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  token: Scalars['String'];
  totemId: Scalars['ID'];
};

export type TotemEventFilter = {
  eventId?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  totemId: Scalars['ID'];
};

export const TotemEventType = {
  ABORTED: 'ABORTED',
  COMPLETED: 'COMPLETED',
  OCR: 'OCR',
  PRIVACY: 'PRIVACY'
} as const;

export type TotemEventType = typeof TotemEventType[keyof typeof TotemEventType];
export type TotemInput = {
  name: Scalars['String'];
  propertyId: Scalars['ID'];
  subAddresses?: InputMaybe<Array<Scalars['String']>>;
  supportedWorkflows: Array<TotemWorkflow>;
  tenantId: Scalars['ID'];
};

export type TotemQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: Scalars['ID'];
};

export const TotemWorkflow = {
  OCR: 'OCR',
  PRIVACY: 'PRIVACY'
} as const;

export type TotemWorkflow = typeof TotemWorkflow[keyof typeof TotemWorkflow];
export type TrialModule = {
  module: MeteringModule;
  trialExpiration: Scalars['Date'];
};

export type TsPayApiKey = {
  apiKey: Scalars['String'];
  auditable: Auditable;
  authKey: Scalars['String'];
  id: Scalars['ID'];
  loginUrl: Scalars['String'];
  merchantRef: Scalars['String'];
  provider: OnlinePaymentsProvider;
  state: TsPayApiKeyState;
  tenantId: Scalars['ID'];
};

export const TsPayApiKeyState = {
  ACTIVE: 'ACTIVE',
  INIT: 'INIT'
} as const;

export type TsPayApiKeyState = typeof TsPayApiKeyState[keyof typeof TsPayApiKeyState];
export type TsPayCharge = {
  amount: Scalars['Int'];
  amountPreauth?: Maybe<Scalars['Int']>;
  apikey: TsPayApiKey;
  apikeyId: Scalars['ID'];
  auditable: Auditable;
  chargeKey: Scalars['String'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  error?: Maybe<TsPayError>;
  id: Scalars['ID'];
  link: TsPayLink;
  linkId: Scalars['ID'];
  netAmount: Scalars['Int'];
  payload?: Maybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  provider: OnlinePaymentsProvider;
  refundId?: Maybe<Scalars['String']>;
  refundReason?: Maybe<TsPayRefundReason>;
  reservationId?: Maybe<Scalars['ID']>;
  sourceKey?: Maybe<Scalars['String']>;
  state: TsPayChargeState;
  tenantId: Scalars['ID'];
};

export const TsPayChargeState = {
  DISPUTE_CLOSED: 'DISPUTE_CLOSED',
  DISPUTE_CLOSED_FORCED: 'DISPUTE_CLOSED_FORCED',
  DISPUTE_CLOSED_LOST: 'DISPUTE_CLOSED_LOST',
  DISPUTE_CLOSED_WON: 'DISPUTE_CLOSED_WON',
  DISPUTE_CREATED: 'DISPUTE_CREATED',
  DISPUTE_REFOUNDED: 'DISPUTE_REFOUNDED',
  DISPUTE_UPDATED: 'DISPUTE_UPDATED',
  DISPUTE_WITHDRAWN: 'DISPUTE_WITHDRAWN',
  DONE: 'DONE',
  ERROR: 'ERROR',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PREAUTHED: 'PREAUTHED',
  PREAUTH_CANCELLED: 'PREAUTH_CANCELLED',
  REFOUNDED: 'REFOUNDED'
} as const;

export type TsPayChargeState = typeof TsPayChargeState[keyof typeof TsPayChargeState];
/** Dati relativi a TsPay */
export type TsPayData = {
  error?: Maybe<TsPayOnboardingError>;
  merchantRef?: Maybe<Scalars['String']>;
  sessionKey?: Maybe<Scalars['String']>;
  sessionUrl?: Maybe<Scalars['String']>;
  sourceTypesPayEnabled?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceTypesSaveEnabled?: Maybe<Array<Maybe<Scalars['String']>>>;
  state: TsPayOnboardingState;
};

export type TsPayDeclineCode = {
  declineCode?: Maybe<Scalars['String']>;
};

export type TsPayError = {
  decline: TsPayDeclineCode;
  errorKey?: Maybe<Scalars['String']>;
  errorType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
};

export type TsPayErrorLog = {
  error?: Maybe<TsPayError>;
  timestamp: Scalars['DateTime'];
};

export type TsPayLink = {
  amount: Scalars['Int'];
  apikey: TsPayApiKey;
  apikeyId: Scalars['ID'];
  auditable: Auditable;
  cardInfo?: Maybe<Scalars['String']>;
  charges: Array<TsPayCharge>;
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  /** Indica il documento di quietanza sospesi o di checkout al quale è collegato il pagamento */
  documentId?: Maybe<Scalars['ID']>;
  errors?: Maybe<Array<TsPayErrorLog>>;
  fiscalTypeForAdvance?: Maybe<FiscalType>;
  /**
   * Serve per discriminare se nella callback va o meno generato un documento.
   * Attualmente l'unico caso è per la reservation perché se il pagamento è un anticipo tramite link va generato un anticipo in automatico
   * mentre se il pagamento avviene in un secondo momento durante il checkout il documento non va creato (sarà l'operatore a farlo)
   */
  generateDocument: Scalars['Boolean'];
  id: Scalars['ID'];
  orderKey: Scalars['String'];
  propertyId: Scalars['ID'];
  provider: OnlinePaymentsProvider;
  quotation?: Maybe<TsPayQuotationInfo>;
  reservationId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  type: PaymentLinkType;
  url: Scalars['String'];
};

export type TsPayOnboardingError = {
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export const TsPayOnboardingState = {
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
  ERROR: 'ERROR',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
} as const;

export type TsPayOnboardingState = typeof TsPayOnboardingState[keyof typeof TsPayOnboardingState];
export type TsPayQuotationInfo = {
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
};

export const TsPayRefundReason = {
  DUPLICATE: 'DUPLICATE',
  EXPIRED_UNCAPTURED_CHARGE: 'EXPIRED_UNCAPTURED_CHARGE',
  FRAUDULENT: 'FRAUDULENT',
  REQUESTED_BY_CUSTOMER: 'REQUESTED_BY_CUSTOMER'
} as const;

export type TsPayRefundReason = typeof TsPayRefundReason[keyof typeof TsPayRefundReason];
export type TsPaySource = {
  expiration: Scalars['String'];
  last4: Scalars['String'];
  sourceKey: Scalars['String'];
  state: TsPaySourceState;
  type: Scalars['String'];
};

export const TsPaySourceState = {
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR'
} as const;

export type TsPaySourceState = typeof TsPaySourceState[keyof typeof TsPaySourceState];
export type TsPayWebhook = {
  apikey: Scalars['String'];
  auditable: Auditable;
  endpoint: Scalars['String'];
  event: Scalars['String'];
  extId: Scalars['String'];
  id: Scalars['ID'];
  secret: Scalars['String'];
  tenantId: Scalars['ID'];
};

export const UndoImportStep = {
  BILLS: 'BILLS',
  CONFIGURATION: 'CONFIGURATION',
  CUSTOMERS: 'CUSTOMERS',
  DOCUMENTS: 'DOCUMENTS',
  RESERVATIONS: 'RESERVATIONS'
} as const;

export type UndoImportStep = typeof UndoImportStep[keyof typeof UndoImportStep];
export type UpdateCounterInput = {
  documentActiveId?: InputMaybe<Scalars['ID']>;
  format: Scalars['String'];
  reset: Scalars['Boolean'];
  value?: InputMaybe<Scalars['Int']>;
};

/**  Input for mutation updateDepositAssigneds: provide only unused quotas  */
export type UpdateDepositAssigneds = {
  depositAssignedId?: InputMaybe<Scalars['ID']>;
  depositAssignment: DepositAssignmentInput;
};

export type UpdateDocumentNumberInput = {
  documentId: Scalars['ID'];
  number: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type UpdateResourceRoomTetrisOrderInput = {
  id: Scalars['ID'];
  roomTetrisOrder: Scalars['Int'];
};

export type UpdateResourceUnavailabilityInput = {
  resourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailability: ResourceUnavailabilityInput;
  unavailabilityId: Scalars['ID'];
};

export type UpdateThreadInput = {
  archived: Scalars['Boolean'];
  read: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

/** User, utente che può accedere al sistema */
export type User = {
  auditable: Auditable;
  authorizations?: Maybe<Array<UserAuthorization>>;
  backofficeAuthorizations?: Maybe<Array<UserAuthorization>>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ncsId?: Maybe<Scalars['String']>;
  onePlatformAuthorizations?: Maybe<Array<UserOnePlatformAuthorization>>;
  tsId?: Maybe<Scalars['String']>;
};

export type UserAddedResourceLayoutInput = {
  quotedResourceIndex: Scalars['Int'];
  reservedResourceLayoutId: Scalars['ID'];
};

export type UserAddedService = {
  additionalServices: Array<EmbeddedAdditionalServiceInput>;
  quotedResourceIndex: Scalars['Int'];
};

/**
 * Autorizzazioni dell'utente; può avere accesso solo ad alcune property.
 * Se sono presenti i moduli, ha solo accesso parziale al sistema
 */
export type UserAuthorization = {
  modules?: Maybe<Array<MeteringModule>>;
  propertyId?: Maybe<Scalars['ID']>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type UserFilterClient = {
  login?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantId?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mail: Scalars['String'];
  userRoles: Array<UserRoleInput>;
};

/**
 * Autorizzazione dell'utente nel dominio di One Platform.
 * Se ha dei livelli autorizzativi parziali, sono presenti i moduli
 */
export type UserOnePlatformAuthorization = {
  modules?: Maybe<Array<MeteringModule>>;
  registryItemId: Scalars['String'];
  role: OnePlatformRole;
};

export type UserPermissionInput = {
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  tsId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/**
 * Per gestire la security di un utente abbiamo bisogno di avere il ruolo, i moduli attivi sull'utente,
 *  e inoltre i moduli e le feature acquistate.
 *  I moduli trial sono esplicitati e hanno una data di scadenza
 */
export type UserPermissionOutput = {
  features?: Maybe<Array<Feature>>;
  modules?: Maybe<Array<MeteringModule>>;
  tenantSellerName?: Maybe<Scalars['String']>;
  trialModules?: Maybe<Array<TrialModule>>;
  userModules?: Maybe<Array<MeteringModule>>;
  userRole?: Maybe<UserRoleOutput>;
};

export type UserPermissionQueryInput = {
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type UserQueryInput = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  tsId?: InputMaybe<Scalars['String']>;
};

export type UserRoleInput = {
  propertyId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type UserRoleOutput = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  permissions?: Maybe<Array<Permissions>>;
};

export const ValueType = {
  PERCENTAGE: 'PERCENTAGE',
  VALUE: 'VALUE'
} as const;

export type ValueType = typeof ValueType[keyof typeof ValueType];
/** Tipologie aliquote iva, possono essere solo per tenant */
export type Vat = {
  auditable: Auditable;
  code: Scalars['String'];
  /** Il codice PA indica il codice di esenzione N1, N2... */
  codePa?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  /** Codice Export Dati */
  managementCode?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  propertyId?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  value: Scalars['Float'];
};

export type VatInput = {
  code: Scalars['String'];
  codePa?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  managementCode?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  value: Scalars['Float'];
};

export type VatQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Lo stato del Web Check-in. */
export const WciState = {
  CREATED: 'CREATED',
  VALIDATED: 'VALIDATED'
} as const;

export type WciState = typeof WciState[keyof typeof WciState];
/** Contatti web */
export type WebContact = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: WebContactType;
  value: Scalars['URL'];
};

export type WebContactInput = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: WebContactType;
  value: Scalars['URL'];
};

/** Tipologie di contatti web, compresi Social Network */
export const WebContactType = {
  INSTAGRAM: 'INSTAGRAM',
  META: 'META',
  TWITTER: 'TWITTER',
  WEBPRIVACY: 'WEBPRIVACY',
  WEBSITE: 'WEBSITE',
  YOUTUBE: 'YOUTUBE'
} as const;

export type WebContactType = typeof WebContactType[keyof typeof WebContactType];
export type WorstBookingPolicyInput = {
  firstNightAmount: Scalars['Int'];
  policies: Array<ReservationBookingPolicyInput>;
  totalAmount: Scalars['Int'];
};

export type OriginsAndReservationStatesQueryVariables = Exact<{
  originFilter: OriginQueryFilter;
  reservationStatesFilter: ReservationStateQueryFilter;
}>;


export type OriginsAndReservationStatesQuery = { origins?: Array<{ id: string }> | null, reservationStates?: Array<{ id: string, confirmed: boolean }> | null };

export type CreateReservationMutationVariables = Exact<{
  value: ReservationInput;
  options: ReservationOptions;
}>;


export type CreateReservationMutation = { createReservation: { reservationCode: string, id: string } };

export type CreateCustomerMutationVariables = Exact<{
  value: CustomerInput;
  returnExisting?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCustomerMutation = { createCustomer: { id: string } };

export type RatesAvailabilitiesQueryVariables = Exact<{
  filter: RqQueryFilter;
}>;


export type RatesAvailabilitiesQuery = { rateQuery: { id: string, resources?: Array<{ resourceTypeId: string, availability: number }> | null } };

export type ChildrenQueryVariables = Exact<{
  ChildrenFilter: ChildQueryFilter;
}>;


export type ChildrenQuery = { children?: Array<{ minAge: number, maxAge: number, id: string }> | null };

export type CreateQuotationForIBEMutationVariables = Exact<{
  value: QuotationInput;
  callbackUrl?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateQuotationForIBEMutation = { createQuotationForIbe: { link2Pay?: { url: string } | null, quotation?: { tenantId: string, propertyId: string, quotationId: string, token: string } | null } };

export type RetriveQuotationAfterErrorQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  quotationId: Scalars['ID'];
}>;


export type RetriveQuotationAfterErrorQuery = { quotation: { reference: { mainGuest: { firstName?: any | null, lastName?: any | null, mailContacts?: Array<{ type: MailContactType, value: string }> | null, phoneContacts?: Array<{ value: string, type: PhoneContactType }> | null } }, quotationDetails: Array<{ quotedResources: Array<{ identifier: string, adults: number, children: number, start: Date, end: Date, rate: { id: string, name: LocalizedString, description: LocalizedString, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, chargeCategory: { code?: ChargeCategoryBoard | null } }, manualDailyPrices?: Array<{ price: number }> | null, resourceOccupancies: Array<{ reservedResourceLayoutId?: string | null, resourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }> }> }> } };

export type PaymentMethodsQueryVariables = Exact<{
  filter: PaymentMethodQueryFilter;
}>;


export type PaymentMethodsQuery = { paymentMethods?: Array<{ type: PaymentMethodType, id: string }> | null };

export type CityTaxQueryVariables = Exact<{
  filter: RqQueryFilter;
}>;


export type CityTaxQuery = { rateQuery: { resources?: Array<{ cityTaxAmount?: number | null, resourceTypeId: string, requestedResourceIdx: number }> | null } };

export type ConfirmedReservationQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  quotationId: Scalars['ID'];
}>;


export type ConfirmedReservationQuery = { quotation: { reference: { mainGuest: { mailContacts?: Array<{ type: MailContactType, value: string }> | null } }, quotationDetails: Array<{ reservationId?: string | null, reservation?: { id: string, reservationCode: string, guestPortalLink?: string | null, reservedResources?: Array<{ id: string, start: Date, end: Date, adults: number, children: number, chargeCategory: { id: string, code?: ChargeCategoryBoard | null }, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ reservedResourceLayoutId?: string | null, reservedResourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, productions?: Array<{ amount: number, currency: Currency, additionalServiceId?: string | null, chargeCategory: { stayIncluded: boolean } }> | null, policy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } }> | null } | null }> } };

export type BookingEnginePropertyFragment = { id: string, description?: LocalizedString | null, name: string, ibeCode?: string | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string, id: string }> | null }> | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null, phoneContacts?: Array<{ value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null, phoneContacts?: Array<{ value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null }> | null, bookingEngineConfiguration?: { text?: LocalizedString | null } | null };

export type PropertyBookingEngineQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PropertyBookingEngineQuery = { properties?: Array<{ id: string, description?: LocalizedString | null, name: string, ibeCode?: string | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string, id: string }> | null }> | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null, phoneContacts?: Array<{ value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null, phoneContacts?: Array<{ value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null }> | null, bookingEngineConfiguration?: { text?: LocalizedString | null } | null }> | null };

export type PropertyTrackingCodesQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PropertyTrackingCodesQuery = { properties?: Array<{ bookingEngineConfiguration?: { googleGA4?: string | null, metaToken?: string | null } | null }> | null };

export type PrivacyPolicyBookingEngineQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PrivacyPolicyBookingEngineQuery = { properties?: Array<{ tenant: { id: string, privacySettings?: { useDirectMarketing: boolean, useThirdPartyMarketing: boolean, useProfiledMarketing: boolean, text: LocalizedString } | null } }> | null };

export type CheckinTimeQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type CheckinTimeQuery = { properties?: Array<{ checkin?: { from: Date, to: Date } | null, checkout?: { from: Date, to: Date } | null, subAddresses?: Array<{ name: string, checkin?: { from: Date, to: Date } | null, checkout?: { from: Date, to: Date } | null }> | null }> | null };

export type PropertyBookingTextFragment = { text?: LocalizedString | null };

export type ResolveBookingEngineUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type ResolveBookingEngineUrlQuery = { resolveBookingEngineUrl?: { propertyId: Array<string>, tenantId: string } | null };

export type AmenityFragment = { name: LocalizedString, image?: string | null };

export type ResourceLayoutFragment = { id: string, description: LocalizedString, occupation: number };

export type ResourceTypeFragment = { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> };

export type IbeQueryVariables = Exact<{
  ResourceTypeFilter: ResourceTypeQueryFilter;
  ChildrenFilter: ChildQueryFilter;
  PropertyFilter: PropertyQueryFilter;
}>;


export type IbeQuery = { resourceTypes?: Array<{ additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> }> | null, children?: Array<{ minAge: number, maxAge: number, id: string }> | null, properties?: Array<{ bookingEngineConfiguration?: { ibeDefaultPax?: number | null } | null }> | null };

export type BookingPolicyFragment = { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } };

export type ResourceRateFragment = { bookable: boolean, resourceTypeId: string, rateRestriction?: RateRestriction | null, dailyPrice: Array<{ restriction?: RateRestriction | null, price: number, day: Date }>, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } };

export type BookingEngineRateResourceFragment = { restrictionsNotMet?: Array<RateRestriction> | null, bookingPolicyOverride?: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } | null, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, chargeCategoryId: string, frequency?: RateFrequency | null, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } }, resourceRates?: Array<{ bookable: boolean, resourceTypeId: string, rateRestriction?: RateRestriction | null, dailyPrice: Array<{ restriction?: RateRestriction | null, price: number, day: Date }>, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }> | null };

export type ResourceAvailabilityFragment = { resourceTypeId: string, availability: number, cityTaxAmount?: number | null };

export type RatesQueryVariables = Exact<{
  filter: RqQueryFilter;
}>;


export type RatesQuery = { rateQuery: { id: string, rates?: Array<{ restrictionsNotMet?: Array<RateRestriction> | null, bookingPolicyOverride?: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } | null, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, chargeCategoryId: string, frequency?: RateFrequency | null, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } }, resourceRates?: Array<{ bookable: boolean, resourceTypeId: string, rateRestriction?: RateRestriction | null, dailyPrice: Array<{ restriction?: RateRestriction | null, price: number, day: Date }>, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }> | null }> | null, resources?: Array<{ resourceTypeId: string, availability: number, cityTaxAmount?: number | null }> | null } };

export type CreateAvailabilityRequestMutationVariables = Exact<{
  input: AvailabilityRequestInput;
}>;


export type CreateAvailabilityRequestMutation = { createAvailabilityRequest: { state: AvailabilityRequestState } };

export type ValidateIbeCodeQueryVariables = Exact<{
  filter: IbeCodeFilter;
}>;


export type ValidateIbeCodeQuery = { validateIbeCode: boolean };

export type AdditionalServiceFragment = { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null };

export type AdditionalServiceQueryVariables = Exact<{
  filter: AdditionalServiceQueryFilter;
}>;


export type AdditionalServiceQuery = { additionalServices?: Array<{ id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null }> | null };

export type GetWorstBookingPolicyQueryVariables = Exact<{
  input: WorstBookingPolicyInput;
}>;


export type GetWorstBookingPolicyQuery = { getWorstBookingPolicy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { percentage?: number | null, type: NoShowType }, paymentRule: { type: GuaranteeType, percentage?: number | null, paymentsAcceptedId?: Array<string> | null, guaranteedCreditCard: boolean } } };

export type PrivacyPolicyFragment = { id: string, privacySettings?: { useDirectMarketing: boolean, useThirdPartyMarketing: boolean, useProfiledMarketing: boolean, text: LocalizedString } | null };

export type AddressFragment = { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null };

export type PortalThemeConfigurationFragment = { primaryColor?: string | null, secondaryColor?: string | null, welcomeTextColor?: string | null, font?: string | null };

export type PortalThemeConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PortalThemeConfigurationQuery = { properties?: Array<{ bookingEngineConfiguration?: { primaryColor?: string | null, secondaryColor?: string | null, welcomeTextColor?: string | null, font?: string | null } | null }> | null };

export type IbePageConfigurationFragment = { resizeBackgroundImage?: boolean | null, backgroundStyle?: BackgroundStyle | null, ibeImage?: { URL: string, id: string } | null };

export type IbePageConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type IbePageConfigurationQuery = { properties?: Array<{ bookingEngineConfiguration?: { resizeBackgroundImage?: boolean | null, backgroundStyle?: BackgroundStyle | null, ibeImage?: { URL: string, id: string } | null } | null, images?: Array<{ type: PropertyImageType, images?: Array<{ URL: string, id: string }> | null }> | null }> | null };

export type GuestPortalAddServicesMutationVariables = Exact<{
  guestPortalAddServices: GuestPortalAddServicesInput;
}>;


export type GuestPortalAddServicesMutation = { guestPortalAddServices?: any | null };

export type AddedAdditionalServiceQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type AddedAdditionalServiceQuery = { guestPortalReservation?: { reservedResources?: Array<{ id: string, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null }> | null } | null };

export type IdsQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type IdsQuery = { guestPortalReservation?: { tenantId: string, propertyId: Array<string>, id: string } | null };

export type PropertyFragment = { name: string, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string>, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string }> | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null }> | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string }> | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null };

export type ImagePropertyQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type ImagePropertyQuery = { guestPortalReservation?: { id: string, property: Array<{ images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string, id: string }> | null }> | null }> } | null };

export type PropertyQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type PropertyQuery = { guestPortalReservation?: { id: string, property: Array<{ name: string, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string>, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string }> | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null }> | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string }> | null, mailContacts?: Array<{ value: string, type: MailContactType }> | null }> } | null };

export type BaseReservationQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type BaseReservationQuery = { guestPortalReservation?: { id: string, isGroup: boolean, reference: { mainGuest: { name: any } }, reservedResources?: Array<{ start: Date, end: Date, resourceOccupancies: Array<{ reservedResourceType: { id: string } }> }> | null, reservationState: { canceled: boolean } } | null };

export type SelfCheckinDoneQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type SelfCheckinDoneQuery = { guestPortalReservation?: { id: string, reservedResources?: Array<{ guestOccupancies?: Array<{ wciState?: WciState | null, guest: { id: string } }> | null }> | null } | null };

export type IncludedAdditionalServiceFragment = { additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } };

export type RateFragment = { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } };

export type ReservedResourceFragment = { id: string, start: Date, end: Date, adults: number, children: number, chargeCategory: { id: string, code?: ChargeCategoryBoard | null }, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ reservedResourceLayoutId?: string | null, reservedResourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, productions?: Array<{ amount: number, currency: Currency, additionalServiceId?: string | null, chargeCategory: { stayIncluded: boolean } }> | null, policy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } };

export type ReservationFragment = { id: string, reservationCode: string, credit: CreditType, auditable: { createdOn?: Date | null }, reservedResources?: Array<{ id: string, start: Date, end: Date, adults: number, children: number, chargeCategory: { id: string, code?: ChargeCategoryBoard | null }, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ reservedResourceLayoutId?: string | null, reservedResourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, productions?: Array<{ amount: number, currency: Currency, additionalServiceId?: string | null, chargeCategory: { stayIncluded: boolean } }> | null, policy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } }> | null };

export type InfoReservationQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type InfoReservationQuery = { guestPortalReservation?: { id: string, reservationCode: string, credit: CreditType, auditable: { createdOn?: Date | null }, reservedResources?: Array<{ id: string, start: Date, end: Date, adults: number, children: number, chargeCategory: { id: string, code?: ChargeCategoryBoard | null }, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ reservedResourceLayoutId?: string | null, reservedResourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, productions?: Array<{ amount: number, currency: Currency, additionalServiceId?: string | null, chargeCategory: { stayIncluded: boolean } }> | null, policy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } } }> | null } | null };

export type CommonReservationFragment = { id: string, reservedResources?: Array<{ id: string, children: number, adults: number, start: Date, end: Date, rate: { id: string, name: LocalizedString }, resourceOccupancies: Array<{ reservedResourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, childOccupancies?: Array<{ childId: string, quantity: number }> | null }> | null };

export type CommonReservationQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type CommonReservationQuery = { guestPortalReservation?: { id: string, reservedResources?: Array<{ id: string, children: number, adults: number, start: Date, end: Date, rate: { id: string, name: LocalizedString }, resourceOccupancies: Array<{ reservedResourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, childOccupancies?: Array<{ childId: string, quantity: number }> | null }> | null } | null };

export type GuestPortalCancelReservationMutationVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type GuestPortalCancelReservationMutation = { guestPortalCancelReservation: CancelReservationResult };

export type CanCancelReservationQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type CanCancelReservationQuery = { guestPortalReservation?: { id: string, reservedResources?: Array<{ phase: ReservedResourcePhase }> | null } | null };

export type CountryFragment = { name: LocalizedString, id: string };

export type MunicipalityFragment = { id: string, name: string };

export type CountryQueryVariables = Exact<{
  countryFilter?: InputMaybe<CountryQueryFilter>;
}>;


export type CountryQuery = { countries?: Array<{ name: LocalizedString, id: string }> | null };

export type IdentificationDocumentFragment = { name: LocalizedString, id: string, codeItalianPs: string };

export type IdentificationDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<IdentificationDocumentQueryFilter>;
}>;


export type IdentificationDocumentsQuery = { identificationDocuments?: Array<{ name: LocalizedString, id: string, codeItalianPs: string }> | null };

export type CountriesAndMunicipalitiesQueryVariables = Exact<{
  countryFilter?: InputMaybe<CountryQueryFilter>;
  municipalitiesFilter?: InputMaybe<MunicipalityQueryFilter>;
}>;


export type CountriesAndMunicipalitiesQuery = { countries?: Array<{ name: LocalizedString, id: string }> | null, municipalities?: Array<{ id: string, name: string }> | null };

export type GuestPortalWebCheckinMutationVariables = Exact<{
  value: GuestPortalWebCheckinInput;
}>;


export type GuestPortalWebCheckinMutation = { guestPortalWebCheckin?: any | null };

export type FileUploadResponseFragment = { preSignedURL: string, file: { id: string } };

export type FileUploadPresignedURLMutationVariables = Exact<{
  file: FileInput;
}>;


export type FileUploadPresignedURLMutation = { fileUploadPresignedURL: { preSignedURL: string, file: { id: string } } };

export type GetImageUploadedQueryVariables = Exact<{
  filter: FilesQueryFilter;
}>;


export type GetImageUploadedQuery = { files?: Array<{ URL: string, id: string }> | null };

export type PrivacyPolicyGuestPortalQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type PrivacyPolicyGuestPortalQuery = { guestPortalReservation?: { id: string, tenant: { id: string, privacySettings?: { useDirectMarketing: boolean, useThirdPartyMarketing: boolean, useProfiledMarketing: boolean, text: LocalizedString } | null } } | null };

export type PropertyHasChildrenQueryVariables = Exact<{
  filter: ChildQueryFilter;
}>;


export type PropertyHasChildrenQuery = { children?: Array<{ minAge: number, maxAge: number, id: string }> | null };

export type ChargeCategoryCodesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type ChargeCategoryCodesQuery = { chargeCategoryCodes?: Array<ChargeCategoryBoard> | null };

export type CreateQuotationRequestMutationVariables = Exact<{
  value: QuotationInput;
  request: QuotationRequestInput;
}>;


export type CreateQuotationRequestMutation = { createQuotationRequest?: any | null };

export type IbeDefaultPaxQueryVariables = Exact<{
  propertyFilter: PropertyQueryFilter;
}>;


export type IbeDefaultPaxQuery = { properties?: Array<{ bookingEngineConfiguration?: { ibeDefaultPax?: number | null } | null }> | null };

export type PhoneContactFragment = { order: number, isDefault: boolean, value: string, type: PhoneContactType };

export type MailContactFragment = { order: number, isDefault: boolean, value: string, type: MailContactType };

export type QuotationPropertyFragment = { id: string, ibeCode?: string | null, name: string, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string>, ibeCode?: string | null, mailContacts?: Array<{ order: number, isDefault: boolean, value: string, type: MailContactType }> | null, phoneContacts?: Array<{ order: number, isDefault: boolean, value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null }> | null, images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string }> | null }> | null, mailContacts?: Array<{ order: number, isDefault: boolean, value: string, type: MailContactType }> | null, phoneContacts?: Array<{ order: number, isDefault: boolean, value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null };

export type ManualDailyPriceFragment = { day: Date, price: number };

export type CustomerFragment = { firstName?: any | null, lastName?: any | null, language: Language, phoneContacts?: Array<{ value: string }> | null, mailContacts?: Array<{ value: string }> | null };

export type QuotedResourceFragment = { start: Date, end: Date, adults: number, manualPrice?: number | null, children: number, manualDailyPrices?: Array<{ day: Date, price: number }> | null, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ resourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, chargeCategory: { code?: ChargeCategoryBoard | null } };

export type QuotationDetailFragment = { reservationId?: string | null, quotedResources: Array<{ start: Date, end: Date, adults: number, manualPrice?: number | null, children: number, manualDailyPrices?: Array<{ day: Date, price: number }> | null, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ resourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, chargeCategory: { code?: ChargeCategoryBoard | null } }>, reservation?: { reservationCode: string } | null };

export type QuotationFragment = { expiration?: Date | null, id: string, propertyId: string, quotationCode: string, quotationState: QuotationState, noteForCustomer?: string | null, property: { id: string, ibeCode?: string | null, name: string, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string>, ibeCode?: string | null, mailContacts?: Array<{ order: number, isDefault: boolean, value: string, type: MailContactType }> | null, phoneContacts?: Array<{ order: number, isDefault: boolean, value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null }> | null, images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string }> | null }> | null, mailContacts?: Array<{ order: number, isDefault: boolean, value: string, type: MailContactType }> | null, phoneContacts?: Array<{ order: number, isDefault: boolean, value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null }, reference: { customerPerson?: { name: any } | null, mainGuest: { firstName?: any | null, lastName?: any | null, language: Language, phoneContacts?: Array<{ value: string }> | null, mailContacts?: Array<{ value: string }> | null } }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ start: Date, end: Date, adults: number, manualPrice?: number | null, children: number, manualDailyPrices?: Array<{ day: Date, price: number }> | null, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ resourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, chargeCategory: { code?: ChargeCategoryBoard | null } }>, reservation?: { reservationCode: string } | null }> };

export type QuotationQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  quotationId: Scalars['ID'];
  setReadState?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuotationQuery = { quotation: { expiration?: Date | null, id: string, propertyId: string, quotationCode: string, quotationState: QuotationState, noteForCustomer?: string | null, property: { id: string, ibeCode?: string | null, name: string, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string>, ibeCode?: string | null, mailContacts?: Array<{ order: number, isDefault: boolean, value: string, type: MailContactType }> | null, phoneContacts?: Array<{ order: number, isDefault: boolean, value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null, address?: { address?: any | null, province?: string | null, postalCode?: string | null, country?: { name: LocalizedString } | null, municipality?: { name: string } | null } | null }> | null, images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string }> | null }> | null, mailContacts?: Array<{ order: number, isDefault: boolean, value: string, type: MailContactType }> | null, phoneContacts?: Array<{ order: number, isDefault: boolean, value: string, type: PhoneContactType }> | null, webContacts?: Array<{ value: string, type: WebContactType }> | null }, reference: { customerPerson?: { name: any } | null, mainGuest: { firstName?: any | null, lastName?: any | null, language: Language, phoneContacts?: Array<{ value: string }> | null, mailContacts?: Array<{ value: string }> | null } }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ start: Date, end: Date, adults: number, manualPrice?: number | null, children: number, manualDailyPrices?: Array<{ day: Date, price: number }> | null, rate: { id: string, name: LocalizedString, description: LocalizedString, type: RateType, frequency?: RateFrequency | null, bookingPolicy: { name: string, additionalNote?: LocalizedString | null, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, hourWithoutPenalties?: Date | null, daysWithoutPenalties?: number | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null } }, mandatoryAdditionalServices?: Array<{ additionalServiceId: string, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null } }, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, name: LocalizedString, price: number, minStay?: number | null, maxStay?: number | null, order?: number | null, resourceTypeIds?: Array<string> | null, pmsOnly?: boolean | null, description: LocalizedString, currency: Currency, pricingType: PricingType, automaticForChildren: boolean, automaticForAdults: boolean, imageIds?: Array<string> | null, childServicePrices?: Array<{ price: number, childId: string }> | null, images?: Array<{ URL: string, id: string }> | null, chargeCategory: { code?: ChargeCategoryBoard | null }, validity?: { start?: Date | null, end?: Date | null } | null } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, resourceOccupancies: Array<{ resourceType: { additionalPersons: number, customName?: LocalizedString | null, currency: Currency, description: LocalizedString, id: string, imageIds?: Array<string> | null, persons: number, maxAdults?: number | null, minRate: number, visibilityOnIbe: boolean, amenities?: Array<{ name: LocalizedString, image?: string | null }> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, description: LocalizedString, occupation: number }> | null, equivalences: Array<{ type: OptionType, group: Array<{ resourceTypeId: string }> }> } }>, chargeCategory: { code?: ChargeCategoryBoard | null } }>, reservation?: { reservationCode: string } | null }> } };

export type PayAndConfirmQuotationFragment = { reservationId?: string | null, tenantId: string, link2Pay?: { url: string, orderKey: string } | null, reservation?: { reservationCode: string } | null };

export type ConfirmQuotationMutationVariables = Exact<{
  input: ConfirmQuotationInput;
  callbackUrl?: InputMaybe<Scalars['String']>;
}>;


export type ConfirmQuotationMutation = { confirmQuotation: { reservationId?: string | null, tenantId: string, link2Pay?: { url: string, orderKey: string } | null, reservation?: { reservationCode: string } | null } };

export type BookingEngineUrlsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BookingEngineUrlsQuery = { bookingEngineUrls: Array<{ url: string, propertyId: Array<string> }> };

export type QuotationPropertyTextFragment = { description?: LocalizedString | null, bookingEngineConfiguration?: { text?: LocalizedString | null } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null }> | null };

export type QuotationPropertyTextQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type QuotationPropertyTextQuery = { properties?: Array<{ description?: LocalizedString | null, bookingEngineConfiguration?: { text?: LocalizedString | null } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null }> | null }> | null };

export type GetOriginalPriceQuotedResourceQueryVariables = Exact<{
  filter: RqQueryFilter;
}>;


export type GetOriginalPriceQuotedResourceQuery = { rateQuery: { rates?: Array<{ rateId: string, resourceRates?: Array<{ resourceTypeId: string, dailyPrice: Array<{ price: number }> }> | null }> | null } };

export type TotemFragment = { id: string, propertyId: string, supportedWorkflows: Array<TotemWorkflow>, name: string };

export type PropertyTotemQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PropertyTotemQuery = { properties?: Array<{ id: string, name: string, images?: Array<{ type: PropertyImageType, images?: Array<{ URL: string, id: string }> | null }> | null }> | null };

export type TotemQueryVariables = Exact<{
  filter: TotemQueryFilter;
}>;


export type TotemQuery = { totems?: Array<{ id: string, propertyId: string, supportedWorkflows: Array<TotemWorkflow>, name: string }> | null };

export type TotemEventSubscriptionVariables = Exact<{
  filter: TotemEventFilter;
}>;


export type TotemEventSubscription = { totemEvent?: { eventType: TotemEventType, eventId: string, token: string, reservedResourceId: string, customerId?: string | null, guestType?: GuestType | null } | null };

export type StopTotemWorkflowMutationVariables = Exact<{
  input: StopTotemWorkflowInput;
}>;


export type StopTotemWorkflowMutation = { stopTotemWorkflow?: any | null };

export type UpdateCustomerPrivacySignMutationVariables = Exact<{
  input: CustomerPrivacyInput;
}>;


export type UpdateCustomerPrivacySignMutation = { updateCustomerPrivacySign?: any | null };

export type TotemPrivacyQueryVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type TotemPrivacyQuery = { guestPortalReservation?: { id: string, reservedResources?: Array<{ id: string, end: Date, guestOccupancies?: Array<{ end: Date, guest: { id: string, language: Language, privacy?: { managementConsent?: boolean | null, marketingConsent?: boolean | null, profiledMarketingConsent?: boolean | null, dataThirdPartyConsent?: boolean | null } | null } }> | null }> | null } | null };

export type OCRFragment = { birth_city?: string | null, birth_country_name?: string | null, birth_date?: string | null, birth_date_check?: number | null, document_number?: string | null, document_number_check?: number | null, document_type?: number | null, expiration_date?: string | null, expiration_date_check?: number | null, issuing_country_name?: string | null, issuing_municipality?: string | null, name?: string | null, reason?: string | null, residence_country_check?: number | null, residence_country_name?: string | null, residence_municipality?: string | null, sex?: string | null, success: number, surname?: string | null };

export type OCRQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  fileId: Scalars['ID'];
}>;


export type OCRQuery = { documentOcr: { birth_city?: string | null, birth_country_name?: string | null, birth_date?: string | null, birth_date_check?: number | null, document_number?: string | null, document_number_check?: number | null, document_type?: number | null, expiration_date?: string | null, expiration_date_check?: number | null, issuing_country_name?: string | null, issuing_municipality?: string | null, name?: string | null, reason?: string | null, residence_country_check?: number | null, residence_country_name?: string | null, residence_municipality?: string | null, sex?: string | null, success: number, surname?: string | null } };

export type UpsertReservedResourceGuestMutationVariables = Exact<{
  value: ReservedResourceGuestInput;
}>;


export type UpsertReservedResourceGuestMutation = { upsertReservedResourceGuest?: any | null };

export const AddressFragmentDoc = gql`
    fragment Address on Address {
  address
  province
  country {
    name
  }
  municipality {
    name
  }
  postalCode
}
    `;
export const PropertyBookingTextFragmentDoc = gql`
    fragment PropertyBookingText on BookingEngineConfiguration {
  text
}
    `;
export const BookingEnginePropertyFragmentDoc = gql`
    fragment BookingEngineProperty on Property {
  id
  description
  address {
    ...Address
  }
  images {
    type
    images {
      URL
      id
    }
    imageIds
  }
  mailContacts {
    value
    type
  }
  name
  phoneContacts {
    value
    type
  }
  webContacts {
    value
    type
  }
  ibeCode
  subAddresses {
    name
    description
    resourceTypeIds
    ibeCode
    address {
      ...Address
    }
    mailContacts {
      value
      type
    }
    phoneContacts {
      value
      type
    }
    webContacts {
      value
      type
    }
  }
  bookingEngineConfiguration {
    ...PropertyBookingText
  }
}
    ${AddressFragmentDoc}
${PropertyBookingTextFragmentDoc}`;
export const ResourceRateFragmentDoc = gql`
    fragment ResourceRate on PriceRq {
  dailyPrice {
    restriction
    price
    day
  }
  bookable
  resourceTypeId
  rateRestriction
  chargeCategory {
    id
    code
  }
}
    `;
export const BookingPolicyFragmentDoc = gql`
    fragment BookingPolicy on BookingPolicy {
  name
  noShowRule {
    type
    percentage
  }
  paymentRule {
    type
    percentage
    guaranteedCreditCard
    paymentsAcceptedId
  }
  additionalNote
  cancellationPolicy {
    type
    hourWithoutPenalties
    daysWithoutPenalties
    penaltyType
    percentage
  }
}
    `;
export const AdditionalServiceFragmentDoc = gql`
    fragment AdditionalService on AdditionalService {
  id
  name
  price
  minStay
  maxStay
  order
  resourceTypeIds
  pmsOnly
  description
  currency
  pricingType
  automaticForChildren
  automaticForAdults
  childServicePrices {
    price
    childId
  }
  imageIds
  images {
    URL
    id
  }
  chargeCategory {
    code
  }
  validity {
    start
    end
  }
  resourceTypeIds
}
    `;
export const BookingEngineRateResourceFragmentDoc = gql`
    fragment BookingEngineRateResource on RateRq {
  bookingPolicyOverride {
    ...BookingPolicy
  }
  rate {
    mandatoryAdditionalServices {
      additionalServiceId
      priceZero
      additionalService {
        ...AdditionalService
      }
    }
    id
    name
    bookingPolicy {
      ...BookingPolicy
    }
    description
    type
    chargeCategoryId
    frequency
  }
  resourceRates {
    dailyPrice {
      restriction
      price
      day
    }
    bookable
    resourceTypeId
    rateRestriction
    chargeCategory {
      id
      code
    }
  }
  restrictionsNotMet
}
    ${BookingPolicyFragmentDoc}
${AdditionalServiceFragmentDoc}`;
export const ResourceAvailabilityFragmentDoc = gql`
    fragment ResourceAvailability on ResourceAvailabilityRq {
  resourceTypeId
  availability
  cityTaxAmount
}
    `;
export const PrivacyPolicyFragmentDoc = gql`
    fragment PrivacyPolicy on Tenant {
  id
  privacySettings {
    useDirectMarketing
    useThirdPartyMarketing
    useProfiledMarketing
    text
  }
}
    `;
export const PortalThemeConfigurationFragmentDoc = gql`
    fragment PortalThemeConfiguration on BookingEngineConfiguration {
  primaryColor
  secondaryColor
  welcomeTextColor
  font
}
    `;
export const IbePageConfigurationFragmentDoc = gql`
    fragment IbePageConfiguration on BookingEngineConfiguration {
  ibeImage {
    URL
    id
  }
  resizeBackgroundImage
  backgroundStyle
}
    `;
export const PropertyFragmentDoc = gql`
    fragment Property on Property {
  name
  subAddresses {
    name
    resourceTypeIds
    address {
      ...Address
    }
    phoneContacts {
      type
      value
    }
    mailContacts {
      value
      type
    }
  }
  address {
    ...Address
  }
  phoneContacts {
    type
    value
  }
  mailContacts {
    value
    type
  }
}
    ${AddressFragmentDoc}`;
export const IncludedAdditionalServiceFragmentDoc = gql`
    fragment IncludedAdditionalService on RateMandatoryAdditionalService {
  additionalServiceId
  priceZero
  additionalService {
    ...AdditionalService
  }
}
    ${AdditionalServiceFragmentDoc}`;
export const RateFragmentDoc = gql`
    fragment Rate on Rate {
  id
  name
  description
  bookingPolicy {
    ...BookingPolicy
  }
  mandatoryAdditionalServices {
    ...IncludedAdditionalService
  }
  chargeCategory {
    id
    code
  }
  type
  frequency
}
    ${BookingPolicyFragmentDoc}
${IncludedAdditionalServiceFragmentDoc}`;
export const AmenityFragmentDoc = gql`
    fragment Amenity on Amenity {
  name
  image
}
    `;
export const ResourceLayoutFragmentDoc = gql`
    fragment ResourceLayout on ResourceLayout {
  id
  description
  occupation
}
    `;
export const ResourceTypeFragmentDoc = gql`
    fragment ResourceType on ResourceType {
  additionalPersons
  amenities {
    ...Amenity
  }
  customName
  currency
  description
  id
  imageIds
  images {
    URL
    id
  }
  persons
  name {
    description
  }
  maxAdults
  minRate
  visibilityOnIbe
  configurationsLayout {
    ...ResourceLayout
  }
  equivalences {
    type
    group {
      resourceTypeId
    }
  }
}
    ${AmenityFragmentDoc}
${ResourceLayoutFragmentDoc}`;
export const ReservedResourceFragmentDoc = gql`
    fragment ReservedResource on ReservedResource {
  id
  start
  end
  adults
  children
  chargeCategory {
    id
    code
  }
  rate {
    ...Rate
  }
  additionalServices {
    additionalService {
      ...AdditionalService
    }
    quantity
    priceZero
  }
  childOccupancies {
    childId
    quantity
  }
  resourceOccupancies {
    reservedResourceLayoutId
    reservedResourceType {
      ...ResourceType
    }
  }
  productions {
    amount
    chargeCategory {
      stayIncluded
    }
    currency
    additionalServiceId
  }
  policy {
    name
    noShowRule {
      type
      percentage
    }
    paymentRule {
      type
      percentage
      guaranteedCreditCard
      paymentsAcceptedId
    }
    additionalNote
    cancellationPolicy {
      type
      hourWithoutPenalties
      daysWithoutPenalties
      penaltyType
      percentage
    }
  }
}
    ${RateFragmentDoc}
${AdditionalServiceFragmentDoc}
${ResourceTypeFragmentDoc}`;
export const ReservationFragmentDoc = gql`
    fragment Reservation on Reservation {
  id
  reservationCode
  auditable {
    createdOn
  }
  credit
  reservedResources {
    ...ReservedResource
  }
}
    ${ReservedResourceFragmentDoc}`;
export const CommonReservationFragmentDoc = gql`
    fragment CommonReservation on Reservation {
  id
  reservedResources {
    id
    children
    adults
    start
    end
    rate {
      id
      name
    }
    resourceOccupancies {
      reservedResourceType {
        ...ResourceType
      }
    }
    childOccupancies {
      childId
      quantity
    }
  }
}
    ${ResourceTypeFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  name
  id
}
    `;
export const MunicipalityFragmentDoc = gql`
    fragment Municipality on Municipality {
  id
  name
}
    `;
export const IdentificationDocumentFragmentDoc = gql`
    fragment IdentificationDocument on IdentificationDocument {
  name
  id
  codeItalianPs
}
    `;
export const FileUploadResponseFragmentDoc = gql`
    fragment FileUploadResponse on FileUploadResponse {
  preSignedURL
  file {
    id
  }
}
    `;
export const MailContactFragmentDoc = gql`
    fragment MailContact on MailContact {
  order
  isDefault
  value
  type
}
    `;
export const PhoneContactFragmentDoc = gql`
    fragment PhoneContact on PhoneContact {
  order
  isDefault
  value
  type
}
    `;
export const QuotationPropertyFragmentDoc = gql`
    fragment QuotationProperty on Property {
  id
  address {
    ...Address
  }
  ibeCode
  subAddresses {
    name
    resourceTypeIds
    ibeCode
    mailContacts {
      ...MailContact
    }
    phoneContacts {
      ...PhoneContact
    }
    webContacts {
      value
      type
    }
    address {
      ...Address
    }
  }
  images {
    type
    images {
      URL
    }
    imageIds
  }
  mailContacts {
    ...MailContact
  }
  name
  phoneContacts {
    ...PhoneContact
  }
  webContacts {
    value
    type
  }
}
    ${AddressFragmentDoc}
${MailContactFragmentDoc}
${PhoneContactFragmentDoc}`;
export const ManualDailyPriceFragmentDoc = gql`
    fragment ManualDailyPrice on ManualDailyPrice {
  day
  price
}
    `;
export const QuotedResourceFragmentDoc = gql`
    fragment QuotedResource on QuotedResource {
  start
  end
  adults
  manualPrice
  manualDailyPrices {
    ...ManualDailyPrice
  }
  rate {
    ...Rate
  }
  additionalServices {
    quantity
    priceZero
    additionalService {
      ...AdditionalService
    }
  }
  children
  childOccupancies {
    childId
    quantity
  }
  resourceOccupancies {
    resourceType {
      ...ResourceType
    }
  }
  chargeCategory {
    code
  }
}
    ${ManualDailyPriceFragmentDoc}
${RateFragmentDoc}
${AdditionalServiceFragmentDoc}
${ResourceTypeFragmentDoc}`;
export const QuotationDetailFragmentDoc = gql`
    fragment QuotationDetail on QuotationDetail {
  quotedResources {
    ...QuotedResource
  }
  reservation {
    reservationCode
  }
  reservationId
}
    ${QuotedResourceFragmentDoc}`;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  firstName
  lastName
  phoneContacts {
    value
  }
  mailContacts {
    value
  }
  language
}
    `;
export const QuotationFragmentDoc = gql`
    fragment Quotation on Quotation {
  expiration
  id
  propertyId
  property {
    ...QuotationProperty
  }
  quotationCode
  quotationState
  reference {
    customerPerson {
      name
    }
  }
  noteForCustomer
  quotationDetails {
    ...QuotationDetail
  }
  reference {
    mainGuest {
      ...Customer
    }
  }
}
    ${QuotationPropertyFragmentDoc}
${QuotationDetailFragmentDoc}
${CustomerFragmentDoc}`;
export const PayAndConfirmQuotationFragmentDoc = gql`
    fragment PayAndConfirmQuotation on PayAndConfirmQuotation {
  link2Pay {
    url
    orderKey
  }
  reservationId
  tenantId
  reservation {
    reservationCode
  }
}
    `;
export const QuotationPropertyTextFragmentDoc = gql`
    fragment QuotationPropertyText on Property {
  bookingEngineConfiguration {
    text
  }
  description
  subAddresses {
    name
    description
  }
}
    `;
export const TotemFragmentDoc = gql`
    fragment Totem on Totem {
  id
  propertyId
  supportedWorkflows
  name
}
    `;
export const OCRFragmentDoc = gql`
    fragment OCR on CiaoAppOcrResponse {
  birth_city
  birth_country_name
  birth_date
  birth_date_check
  document_number
  document_number_check
  document_type
  expiration_date
  expiration_date_check
  issuing_country_name
  issuing_municipality
  name
  reason
  residence_country_check
  residence_country_name
  residence_municipality
  sex
  success
  surname
}
    `;
export const OriginsAndReservationStatesDocument = gql`
    query OriginsAndReservationStates($originFilter: OriginQueryFilter!, $reservationStatesFilter: ReservationStateQueryFilter!) {
  origins(filter: $originFilter) {
    id
  }
  reservationStates(filter: $reservationStatesFilter) {
    id
    confirmed
  }
}
    `;

/**
 * __useOriginsAndReservationStatesQuery__
 *
 * To run a query within a React component, call `useOriginsAndReservationStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginsAndReservationStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginsAndReservationStatesQuery({
 *   variables: {
 *      originFilter: // value for 'originFilter'
 *      reservationStatesFilter: // value for 'reservationStatesFilter'
 *   },
 * });
 */
export function useOriginsAndReservationStatesQuery(baseOptions: Apollo.QueryHookOptions<OriginsAndReservationStatesQuery, OriginsAndReservationStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginsAndReservationStatesQuery, OriginsAndReservationStatesQueryVariables>(OriginsAndReservationStatesDocument, options);
      }
export function useOriginsAndReservationStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginsAndReservationStatesQuery, OriginsAndReservationStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginsAndReservationStatesQuery, OriginsAndReservationStatesQueryVariables>(OriginsAndReservationStatesDocument, options);
        }
export type OriginsAndReservationStatesQueryHookResult = ReturnType<typeof useOriginsAndReservationStatesQuery>;
export type OriginsAndReservationStatesLazyQueryHookResult = ReturnType<typeof useOriginsAndReservationStatesLazyQuery>;
export type OriginsAndReservationStatesQueryResult = Apollo.QueryResult<OriginsAndReservationStatesQuery, OriginsAndReservationStatesQueryVariables>;
export const CreateReservationDocument = gql`
    mutation CreateReservation($value: ReservationInput!, $options: ReservationOptions!) {
  createReservation(value: $value, options: $options) {
    reservationCode
    id
  }
}
    `;
export type CreateReservationMutationFn = Apollo.MutationFunction<CreateReservationMutation, CreateReservationMutationVariables>;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationMutation, { data, loading, error }] = useCreateReservationMutation({
 *   variables: {
 *      value: // value for 'value'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCreateReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReservationMutation, CreateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReservationMutation, CreateReservationMutationVariables>(CreateReservationDocument, options);
      }
export type CreateReservationMutationHookResult = ReturnType<typeof useCreateReservationMutation>;
export type CreateReservationMutationResult = Apollo.MutationResult<CreateReservationMutation>;
export type CreateReservationMutationOptions = Apollo.BaseMutationOptions<CreateReservationMutation, CreateReservationMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($value: CustomerInput!, $returnExisting: Boolean) {
  createCustomer(value: $value, returnExisting: $returnExisting) {
    id
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      value: // value for 'value'
 *      returnExisting: // value for 'returnExisting'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const RatesAvailabilitiesDocument = gql`
    query RatesAvailabilities($filter: RqQueryFilter!) {
  rateQuery(filter: $filter) {
    id
    resources {
      resourceTypeId
      availability
    }
  }
}
    `;

/**
 * __useRatesAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useRatesAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesAvailabilitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRatesAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<RatesAvailabilitiesQuery, RatesAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RatesAvailabilitiesQuery, RatesAvailabilitiesQueryVariables>(RatesAvailabilitiesDocument, options);
      }
export function useRatesAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RatesAvailabilitiesQuery, RatesAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RatesAvailabilitiesQuery, RatesAvailabilitiesQueryVariables>(RatesAvailabilitiesDocument, options);
        }
export type RatesAvailabilitiesQueryHookResult = ReturnType<typeof useRatesAvailabilitiesQuery>;
export type RatesAvailabilitiesLazyQueryHookResult = ReturnType<typeof useRatesAvailabilitiesLazyQuery>;
export type RatesAvailabilitiesQueryResult = Apollo.QueryResult<RatesAvailabilitiesQuery, RatesAvailabilitiesQueryVariables>;
export const ChildrenDocument = gql`
    query Children($ChildrenFilter: ChildQueryFilter!) {
  children(filter: $ChildrenFilter) {
    minAge
    maxAge
    id
  }
}
    `;

/**
 * __useChildrenQuery__
 *
 * To run a query within a React component, call `useChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildrenQuery({
 *   variables: {
 *      ChildrenFilter: // value for 'ChildrenFilter'
 *   },
 * });
 */
export function useChildrenQuery(baseOptions: Apollo.QueryHookOptions<ChildrenQuery, ChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildrenQuery, ChildrenQueryVariables>(ChildrenDocument, options);
      }
export function useChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildrenQuery, ChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildrenQuery, ChildrenQueryVariables>(ChildrenDocument, options);
        }
export type ChildrenQueryHookResult = ReturnType<typeof useChildrenQuery>;
export type ChildrenLazyQueryHookResult = ReturnType<typeof useChildrenLazyQuery>;
export type ChildrenQueryResult = Apollo.QueryResult<ChildrenQuery, ChildrenQueryVariables>;
export const CreateQuotationForIBEDocument = gql`
    mutation CreateQuotationForIBE($value: QuotationInput!, $callbackUrl: String, $paymentMethodId: ID) {
  createQuotationForIbe(
    value: $value
    callbackUrl: $callbackUrl
    paymentMethodId: $paymentMethodId
  ) {
    link2Pay {
      url
    }
    quotation {
      tenantId
      propertyId
      quotationId
      token
    }
  }
}
    `;
export type CreateQuotationForIBEMutationFn = Apollo.MutationFunction<CreateQuotationForIBEMutation, CreateQuotationForIBEMutationVariables>;

/**
 * __useCreateQuotationForIBEMutation__
 *
 * To run a mutation, you first call `useCreateQuotationForIBEMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotationForIBEMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotationForIbeMutation, { data, loading, error }] = useCreateQuotationForIBEMutation({
 *   variables: {
 *      value: // value for 'value'
 *      callbackUrl: // value for 'callbackUrl'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useCreateQuotationForIBEMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuotationForIBEMutation, CreateQuotationForIBEMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuotationForIBEMutation, CreateQuotationForIBEMutationVariables>(CreateQuotationForIBEDocument, options);
      }
export type CreateQuotationForIBEMutationHookResult = ReturnType<typeof useCreateQuotationForIBEMutation>;
export type CreateQuotationForIBEMutationResult = Apollo.MutationResult<CreateQuotationForIBEMutation>;
export type CreateQuotationForIBEMutationOptions = Apollo.BaseMutationOptions<CreateQuotationForIBEMutation, CreateQuotationForIBEMutationVariables>;
export const RetriveQuotationAfterErrorDocument = gql`
    query RetriveQuotationAfterError($tenantId: ID!, $quotationId: ID!) {
  quotation(tenantId: $tenantId, id: $quotationId) {
    reference {
      mainGuest {
        mailContacts {
          type
          value
        }
        firstName
        lastName
        phoneContacts {
          value
          type
        }
      }
    }
    quotationDetails {
      quotedResources {
        identifier
        rate {
          mandatoryAdditionalServices {
            additionalServiceId
            priceZero
            additionalService {
              ...AdditionalService
            }
          }
          id
          name
          bookingPolicy {
            ...BookingPolicy
          }
          description
          chargeCategory {
            code
          }
        }
        adults
        children
        start
        end
        manualDailyPrices {
          price
        }
        resourceOccupancies {
          reservedResourceLayoutId
          resourceType {
            ...ResourceType
          }
        }
      }
    }
  }
}
    ${AdditionalServiceFragmentDoc}
${BookingPolicyFragmentDoc}
${ResourceTypeFragmentDoc}`;

/**
 * __useRetriveQuotationAfterErrorQuery__
 *
 * To run a query within a React component, call `useRetriveQuotationAfterErrorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetriveQuotationAfterErrorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetriveQuotationAfterErrorQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      quotationId: // value for 'quotationId'
 *   },
 * });
 */
export function useRetriveQuotationAfterErrorQuery(baseOptions: Apollo.QueryHookOptions<RetriveQuotationAfterErrorQuery, RetriveQuotationAfterErrorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetriveQuotationAfterErrorQuery, RetriveQuotationAfterErrorQueryVariables>(RetriveQuotationAfterErrorDocument, options);
      }
export function useRetriveQuotationAfterErrorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetriveQuotationAfterErrorQuery, RetriveQuotationAfterErrorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetriveQuotationAfterErrorQuery, RetriveQuotationAfterErrorQueryVariables>(RetriveQuotationAfterErrorDocument, options);
        }
export type RetriveQuotationAfterErrorQueryHookResult = ReturnType<typeof useRetriveQuotationAfterErrorQuery>;
export type RetriveQuotationAfterErrorLazyQueryHookResult = ReturnType<typeof useRetriveQuotationAfterErrorLazyQuery>;
export type RetriveQuotationAfterErrorQueryResult = Apollo.QueryResult<RetriveQuotationAfterErrorQuery, RetriveQuotationAfterErrorQueryVariables>;
export const PaymentMethodsDocument = gql`
    query PaymentMethods($filter: PaymentMethodQueryFilter!) {
  paymentMethods(filter: $filter) {
    type
    id
  }
}
    `;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const CityTaxDocument = gql`
    query CityTax($filter: RqQueryFilter!) {
  rateQuery(filter: $filter) {
    resources {
      cityTaxAmount
      resourceTypeId
      requestedResourceIdx
    }
  }
}
    `;

/**
 * __useCityTaxQuery__
 *
 * To run a query within a React component, call `useCityTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityTaxQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCityTaxQuery(baseOptions: Apollo.QueryHookOptions<CityTaxQuery, CityTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CityTaxQuery, CityTaxQueryVariables>(CityTaxDocument, options);
      }
export function useCityTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CityTaxQuery, CityTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CityTaxQuery, CityTaxQueryVariables>(CityTaxDocument, options);
        }
export type CityTaxQueryHookResult = ReturnType<typeof useCityTaxQuery>;
export type CityTaxLazyQueryHookResult = ReturnType<typeof useCityTaxLazyQuery>;
export type CityTaxQueryResult = Apollo.QueryResult<CityTaxQuery, CityTaxQueryVariables>;
export const ConfirmedReservationDocument = gql`
    query ConfirmedReservation($tenantId: ID!, $quotationId: ID!) {
  quotation(tenantId: $tenantId, id: $quotationId) {
    reference {
      mainGuest {
        mailContacts {
          type
          value
        }
      }
    }
    quotationDetails {
      reservationId
      reservation {
        id
        reservationCode
        guestPortalLink
        reservedResources {
          ...ReservedResource
        }
      }
    }
  }
}
    ${ReservedResourceFragmentDoc}`;

/**
 * __useConfirmedReservationQuery__
 *
 * To run a query within a React component, call `useConfirmedReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmedReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmedReservationQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      quotationId: // value for 'quotationId'
 *   },
 * });
 */
export function useConfirmedReservationQuery(baseOptions: Apollo.QueryHookOptions<ConfirmedReservationQuery, ConfirmedReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmedReservationQuery, ConfirmedReservationQueryVariables>(ConfirmedReservationDocument, options);
      }
export function useConfirmedReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmedReservationQuery, ConfirmedReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmedReservationQuery, ConfirmedReservationQueryVariables>(ConfirmedReservationDocument, options);
        }
export type ConfirmedReservationQueryHookResult = ReturnType<typeof useConfirmedReservationQuery>;
export type ConfirmedReservationLazyQueryHookResult = ReturnType<typeof useConfirmedReservationLazyQuery>;
export type ConfirmedReservationQueryResult = Apollo.QueryResult<ConfirmedReservationQuery, ConfirmedReservationQueryVariables>;
export const PropertyBookingEngineDocument = gql`
    query PropertyBookingEngine($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    ...BookingEngineProperty
  }
}
    ${BookingEnginePropertyFragmentDoc}`;

/**
 * __usePropertyBookingEngineQuery__
 *
 * To run a query within a React component, call `usePropertyBookingEngineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyBookingEngineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyBookingEngineQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyBookingEngineQuery(baseOptions: Apollo.QueryHookOptions<PropertyBookingEngineQuery, PropertyBookingEngineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyBookingEngineQuery, PropertyBookingEngineQueryVariables>(PropertyBookingEngineDocument, options);
      }
export function usePropertyBookingEngineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyBookingEngineQuery, PropertyBookingEngineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyBookingEngineQuery, PropertyBookingEngineQueryVariables>(PropertyBookingEngineDocument, options);
        }
export type PropertyBookingEngineQueryHookResult = ReturnType<typeof usePropertyBookingEngineQuery>;
export type PropertyBookingEngineLazyQueryHookResult = ReturnType<typeof usePropertyBookingEngineLazyQuery>;
export type PropertyBookingEngineQueryResult = Apollo.QueryResult<PropertyBookingEngineQuery, PropertyBookingEngineQueryVariables>;
export const PropertyTrackingCodesDocument = gql`
    query PropertyTrackingCodes($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    bookingEngineConfiguration {
      googleGA4
      metaToken
    }
  }
}
    `;

/**
 * __usePropertyTrackingCodesQuery__
 *
 * To run a query within a React component, call `usePropertyTrackingCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyTrackingCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyTrackingCodesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyTrackingCodesQuery(baseOptions: Apollo.QueryHookOptions<PropertyTrackingCodesQuery, PropertyTrackingCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyTrackingCodesQuery, PropertyTrackingCodesQueryVariables>(PropertyTrackingCodesDocument, options);
      }
export function usePropertyTrackingCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyTrackingCodesQuery, PropertyTrackingCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyTrackingCodesQuery, PropertyTrackingCodesQueryVariables>(PropertyTrackingCodesDocument, options);
        }
export type PropertyTrackingCodesQueryHookResult = ReturnType<typeof usePropertyTrackingCodesQuery>;
export type PropertyTrackingCodesLazyQueryHookResult = ReturnType<typeof usePropertyTrackingCodesLazyQuery>;
export type PropertyTrackingCodesQueryResult = Apollo.QueryResult<PropertyTrackingCodesQuery, PropertyTrackingCodesQueryVariables>;
export const PrivacyPolicyBookingEngineDocument = gql`
    query PrivacyPolicyBookingEngine($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    tenant {
      ...PrivacyPolicy
    }
  }
}
    ${PrivacyPolicyFragmentDoc}`;

/**
 * __usePrivacyPolicyBookingEngineQuery__
 *
 * To run a query within a React component, call `usePrivacyPolicyBookingEngineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyPolicyBookingEngineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyPolicyBookingEngineQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePrivacyPolicyBookingEngineQuery(baseOptions: Apollo.QueryHookOptions<PrivacyPolicyBookingEngineQuery, PrivacyPolicyBookingEngineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyPolicyBookingEngineQuery, PrivacyPolicyBookingEngineQueryVariables>(PrivacyPolicyBookingEngineDocument, options);
      }
export function usePrivacyPolicyBookingEngineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyPolicyBookingEngineQuery, PrivacyPolicyBookingEngineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyPolicyBookingEngineQuery, PrivacyPolicyBookingEngineQueryVariables>(PrivacyPolicyBookingEngineDocument, options);
        }
export type PrivacyPolicyBookingEngineQueryHookResult = ReturnType<typeof usePrivacyPolicyBookingEngineQuery>;
export type PrivacyPolicyBookingEngineLazyQueryHookResult = ReturnType<typeof usePrivacyPolicyBookingEngineLazyQuery>;
export type PrivacyPolicyBookingEngineQueryResult = Apollo.QueryResult<PrivacyPolicyBookingEngineQuery, PrivacyPolicyBookingEngineQueryVariables>;
export const CheckinTimeDocument = gql`
    query CheckinTime($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    checkin {
      from
      to
    }
    checkout {
      from
      to
    }
    subAddresses {
      name
      checkin {
        from
        to
      }
      checkout {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useCheckinTimeQuery__
 *
 * To run a query within a React component, call `useCheckinTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckinTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckinTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCheckinTimeQuery(baseOptions: Apollo.QueryHookOptions<CheckinTimeQuery, CheckinTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckinTimeQuery, CheckinTimeQueryVariables>(CheckinTimeDocument, options);
      }
export function useCheckinTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckinTimeQuery, CheckinTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckinTimeQuery, CheckinTimeQueryVariables>(CheckinTimeDocument, options);
        }
export type CheckinTimeQueryHookResult = ReturnType<typeof useCheckinTimeQuery>;
export type CheckinTimeLazyQueryHookResult = ReturnType<typeof useCheckinTimeLazyQuery>;
export type CheckinTimeQueryResult = Apollo.QueryResult<CheckinTimeQuery, CheckinTimeQueryVariables>;
export const ResolveBookingEngineUrlDocument = gql`
    query ResolveBookingEngineUrl($url: String!) {
  resolveBookingEngineUrl(url: $url) {
    propertyId
    tenantId
  }
}
    `;

/**
 * __useResolveBookingEngineUrlQuery__
 *
 * To run a query within a React component, call `useResolveBookingEngineUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveBookingEngineUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveBookingEngineUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useResolveBookingEngineUrlQuery(baseOptions: Apollo.QueryHookOptions<ResolveBookingEngineUrlQuery, ResolveBookingEngineUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveBookingEngineUrlQuery, ResolveBookingEngineUrlQueryVariables>(ResolveBookingEngineUrlDocument, options);
      }
export function useResolveBookingEngineUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveBookingEngineUrlQuery, ResolveBookingEngineUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveBookingEngineUrlQuery, ResolveBookingEngineUrlQueryVariables>(ResolveBookingEngineUrlDocument, options);
        }
export type ResolveBookingEngineUrlQueryHookResult = ReturnType<typeof useResolveBookingEngineUrlQuery>;
export type ResolveBookingEngineUrlLazyQueryHookResult = ReturnType<typeof useResolveBookingEngineUrlLazyQuery>;
export type ResolveBookingEngineUrlQueryResult = Apollo.QueryResult<ResolveBookingEngineUrlQuery, ResolveBookingEngineUrlQueryVariables>;
export const IbeDocument = gql`
    query Ibe($ResourceTypeFilter: ResourceTypeQueryFilter!, $ChildrenFilter: ChildQueryFilter!, $PropertyFilter: PropertyQueryFilter!) {
  resourceTypes(filter: $ResourceTypeFilter) {
    ...ResourceType
  }
  children(filter: $ChildrenFilter) {
    minAge
    maxAge
    id
  }
  properties(filter: $PropertyFilter) {
    bookingEngineConfiguration {
      ibeDefaultPax
    }
  }
}
    ${ResourceTypeFragmentDoc}`;

/**
 * __useIbeQuery__
 *
 * To run a query within a React component, call `useIbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIbeQuery({
 *   variables: {
 *      ResourceTypeFilter: // value for 'ResourceTypeFilter'
 *      ChildrenFilter: // value for 'ChildrenFilter'
 *      PropertyFilter: // value for 'PropertyFilter'
 *   },
 * });
 */
export function useIbeQuery(baseOptions: Apollo.QueryHookOptions<IbeQuery, IbeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IbeQuery, IbeQueryVariables>(IbeDocument, options);
      }
export function useIbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IbeQuery, IbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IbeQuery, IbeQueryVariables>(IbeDocument, options);
        }
export type IbeQueryHookResult = ReturnType<typeof useIbeQuery>;
export type IbeLazyQueryHookResult = ReturnType<typeof useIbeLazyQuery>;
export type IbeQueryResult = Apollo.QueryResult<IbeQuery, IbeQueryVariables>;
export const RatesDocument = gql`
    query Rates($filter: RqQueryFilter!) {
  rateQuery(filter: $filter) {
    id
    rates {
      ...BookingEngineRateResource
    }
    resources {
      ...ResourceAvailability
    }
  }
}
    ${BookingEngineRateResourceFragmentDoc}
${ResourceAvailabilityFragmentDoc}`;

/**
 * __useRatesQuery__
 *
 * To run a query within a React component, call `useRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRatesQuery(baseOptions: Apollo.QueryHookOptions<RatesQuery, RatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RatesQuery, RatesQueryVariables>(RatesDocument, options);
      }
export function useRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RatesQuery, RatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RatesQuery, RatesQueryVariables>(RatesDocument, options);
        }
export type RatesQueryHookResult = ReturnType<typeof useRatesQuery>;
export type RatesLazyQueryHookResult = ReturnType<typeof useRatesLazyQuery>;
export type RatesQueryResult = Apollo.QueryResult<RatesQuery, RatesQueryVariables>;
export const CreateAvailabilityRequestDocument = gql`
    mutation CreateAvailabilityRequest($input: AvailabilityRequestInput!) {
  createAvailabilityRequest(input: $input) {
    state
  }
}
    `;
export type CreateAvailabilityRequestMutationFn = Apollo.MutationFunction<CreateAvailabilityRequestMutation, CreateAvailabilityRequestMutationVariables>;

/**
 * __useCreateAvailabilityRequestMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvailabilityRequestMutation, { data, loading, error }] = useCreateAvailabilityRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAvailabilityRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateAvailabilityRequestMutation, CreateAvailabilityRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAvailabilityRequestMutation, CreateAvailabilityRequestMutationVariables>(CreateAvailabilityRequestDocument, options);
      }
export type CreateAvailabilityRequestMutationHookResult = ReturnType<typeof useCreateAvailabilityRequestMutation>;
export type CreateAvailabilityRequestMutationResult = Apollo.MutationResult<CreateAvailabilityRequestMutation>;
export type CreateAvailabilityRequestMutationOptions = Apollo.BaseMutationOptions<CreateAvailabilityRequestMutation, CreateAvailabilityRequestMutationVariables>;
export const ValidateIbeCodeDocument = gql`
    query ValidateIbeCode($filter: IbeCodeFilter!) {
  validateIbeCode(filter: $filter)
}
    `;

/**
 * __useValidateIbeCodeQuery__
 *
 * To run a query within a React component, call `useValidateIbeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateIbeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateIbeCodeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useValidateIbeCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateIbeCodeQuery, ValidateIbeCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateIbeCodeQuery, ValidateIbeCodeQueryVariables>(ValidateIbeCodeDocument, options);
      }
export function useValidateIbeCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateIbeCodeQuery, ValidateIbeCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateIbeCodeQuery, ValidateIbeCodeQueryVariables>(ValidateIbeCodeDocument, options);
        }
export type ValidateIbeCodeQueryHookResult = ReturnType<typeof useValidateIbeCodeQuery>;
export type ValidateIbeCodeLazyQueryHookResult = ReturnType<typeof useValidateIbeCodeLazyQuery>;
export type ValidateIbeCodeQueryResult = Apollo.QueryResult<ValidateIbeCodeQuery, ValidateIbeCodeQueryVariables>;
export const AdditionalServiceDocument = gql`
    query AdditionalService($filter: AdditionalServiceQueryFilter!) {
  additionalServices(filter: $filter) {
    ...AdditionalService
  }
}
    ${AdditionalServiceFragmentDoc}`;

/**
 * __useAdditionalServiceQuery__
 *
 * To run a query within a React component, call `useAdditionalServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalServiceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdditionalServiceQuery(baseOptions: Apollo.QueryHookOptions<AdditionalServiceQuery, AdditionalServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalServiceQuery, AdditionalServiceQueryVariables>(AdditionalServiceDocument, options);
      }
export function useAdditionalServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalServiceQuery, AdditionalServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalServiceQuery, AdditionalServiceQueryVariables>(AdditionalServiceDocument, options);
        }
export type AdditionalServiceQueryHookResult = ReturnType<typeof useAdditionalServiceQuery>;
export type AdditionalServiceLazyQueryHookResult = ReturnType<typeof useAdditionalServiceLazyQuery>;
export type AdditionalServiceQueryResult = Apollo.QueryResult<AdditionalServiceQuery, AdditionalServiceQueryVariables>;
export const GetWorstBookingPolicyDocument = gql`
    query GetWorstBookingPolicy($input: WorstBookingPolicyInput!) {
  getWorstBookingPolicy(input: $input) {
    additionalNote
    name
    cancellationPolicy {
      daysWithoutPenalties
      hourWithoutPenalties
      penaltyType
      percentage
      type
    }
    noShowRule {
      percentage
      type
    }
    paymentRule {
      type
      percentage
      paymentsAcceptedId
      guaranteedCreditCard
    }
  }
}
    `;

/**
 * __useGetWorstBookingPolicyQuery__
 *
 * To run a query within a React component, call `useGetWorstBookingPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorstBookingPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorstBookingPolicyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorstBookingPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>(GetWorstBookingPolicyDocument, options);
      }
export function useGetWorstBookingPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>(GetWorstBookingPolicyDocument, options);
        }
export type GetWorstBookingPolicyQueryHookResult = ReturnType<typeof useGetWorstBookingPolicyQuery>;
export type GetWorstBookingPolicyLazyQueryHookResult = ReturnType<typeof useGetWorstBookingPolicyLazyQuery>;
export type GetWorstBookingPolicyQueryResult = Apollo.QueryResult<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>;
export const PortalThemeConfigurationDocument = gql`
    query PortalThemeConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    bookingEngineConfiguration {
      ...PortalThemeConfiguration
    }
  }
}
    ${PortalThemeConfigurationFragmentDoc}`;

/**
 * __usePortalThemeConfigurationQuery__
 *
 * To run a query within a React component, call `usePortalThemeConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalThemeConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalThemeConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePortalThemeConfigurationQuery(baseOptions: Apollo.QueryHookOptions<PortalThemeConfigurationQuery, PortalThemeConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalThemeConfigurationQuery, PortalThemeConfigurationQueryVariables>(PortalThemeConfigurationDocument, options);
      }
export function usePortalThemeConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalThemeConfigurationQuery, PortalThemeConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalThemeConfigurationQuery, PortalThemeConfigurationQueryVariables>(PortalThemeConfigurationDocument, options);
        }
export type PortalThemeConfigurationQueryHookResult = ReturnType<typeof usePortalThemeConfigurationQuery>;
export type PortalThemeConfigurationLazyQueryHookResult = ReturnType<typeof usePortalThemeConfigurationLazyQuery>;
export type PortalThemeConfigurationQueryResult = Apollo.QueryResult<PortalThemeConfigurationQuery, PortalThemeConfigurationQueryVariables>;
export const IbePageConfigurationDocument = gql`
    query IbePageConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    bookingEngineConfiguration {
      ...IbePageConfiguration
    }
    images {
      type
      images {
        URL
        id
      }
    }
  }
}
    ${IbePageConfigurationFragmentDoc}`;

/**
 * __useIbePageConfigurationQuery__
 *
 * To run a query within a React component, call `useIbePageConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIbePageConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIbePageConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIbePageConfigurationQuery(baseOptions: Apollo.QueryHookOptions<IbePageConfigurationQuery, IbePageConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IbePageConfigurationQuery, IbePageConfigurationQueryVariables>(IbePageConfigurationDocument, options);
      }
export function useIbePageConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IbePageConfigurationQuery, IbePageConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IbePageConfigurationQuery, IbePageConfigurationQueryVariables>(IbePageConfigurationDocument, options);
        }
export type IbePageConfigurationQueryHookResult = ReturnType<typeof useIbePageConfigurationQuery>;
export type IbePageConfigurationLazyQueryHookResult = ReturnType<typeof useIbePageConfigurationLazyQuery>;
export type IbePageConfigurationQueryResult = Apollo.QueryResult<IbePageConfigurationQuery, IbePageConfigurationQueryVariables>;
export const GuestPortalAddServicesDocument = gql`
    mutation GuestPortalAddServices($guestPortalAddServices: GuestPortalAddServicesInput!) {
  guestPortalAddServices(value: $guestPortalAddServices)
}
    `;
export type GuestPortalAddServicesMutationFn = Apollo.MutationFunction<GuestPortalAddServicesMutation, GuestPortalAddServicesMutationVariables>;

/**
 * __useGuestPortalAddServicesMutation__
 *
 * To run a mutation, you first call `useGuestPortalAddServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestPortalAddServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestPortalAddServicesMutation, { data, loading, error }] = useGuestPortalAddServicesMutation({
 *   variables: {
 *      guestPortalAddServices: // value for 'guestPortalAddServices'
 *   },
 * });
 */
export function useGuestPortalAddServicesMutation(baseOptions?: Apollo.MutationHookOptions<GuestPortalAddServicesMutation, GuestPortalAddServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestPortalAddServicesMutation, GuestPortalAddServicesMutationVariables>(GuestPortalAddServicesDocument, options);
      }
export type GuestPortalAddServicesMutationHookResult = ReturnType<typeof useGuestPortalAddServicesMutation>;
export type GuestPortalAddServicesMutationResult = Apollo.MutationResult<GuestPortalAddServicesMutation>;
export type GuestPortalAddServicesMutationOptions = Apollo.BaseMutationOptions<GuestPortalAddServicesMutation, GuestPortalAddServicesMutationVariables>;
export const AddedAdditionalServiceDocument = gql`
    query AddedAdditionalService($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    reservedResources {
      id
      additionalServices {
        quantity
        priceZero
        additionalService {
          ...AdditionalService
        }
      }
    }
  }
}
    ${AdditionalServiceFragmentDoc}`;

/**
 * __useAddedAdditionalServiceQuery__
 *
 * To run a query within a React component, call `useAddedAdditionalServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddedAdditionalServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddedAdditionalServiceQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useAddedAdditionalServiceQuery(baseOptions: Apollo.QueryHookOptions<AddedAdditionalServiceQuery, AddedAdditionalServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddedAdditionalServiceQuery, AddedAdditionalServiceQueryVariables>(AddedAdditionalServiceDocument, options);
      }
export function useAddedAdditionalServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddedAdditionalServiceQuery, AddedAdditionalServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddedAdditionalServiceQuery, AddedAdditionalServiceQueryVariables>(AddedAdditionalServiceDocument, options);
        }
export type AddedAdditionalServiceQueryHookResult = ReturnType<typeof useAddedAdditionalServiceQuery>;
export type AddedAdditionalServiceLazyQueryHookResult = ReturnType<typeof useAddedAdditionalServiceLazyQuery>;
export type AddedAdditionalServiceQueryResult = Apollo.QueryResult<AddedAdditionalServiceQuery, AddedAdditionalServiceQueryVariables>;
export const IdsDocument = gql`
    query Ids($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    tenantId
    propertyId
    id
  }
}
    `;

/**
 * __useIdsQuery__
 *
 * To run a query within a React component, call `useIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdsQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useIdsQuery(baseOptions: Apollo.QueryHookOptions<IdsQuery, IdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdsQuery, IdsQueryVariables>(IdsDocument, options);
      }
export function useIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdsQuery, IdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdsQuery, IdsQueryVariables>(IdsDocument, options);
        }
export type IdsQueryHookResult = ReturnType<typeof useIdsQuery>;
export type IdsLazyQueryHookResult = ReturnType<typeof useIdsLazyQuery>;
export type IdsQueryResult = Apollo.QueryResult<IdsQuery, IdsQueryVariables>;
export const ImagePropertyDocument = gql`
    query ImageProperty($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    id
    property {
      images {
        images {
          URL
          id
        }
        type
        imageIds
      }
    }
  }
}
    `;

/**
 * __useImagePropertyQuery__
 *
 * To run a query within a React component, call `useImagePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useImagePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImagePropertyQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useImagePropertyQuery(baseOptions: Apollo.QueryHookOptions<ImagePropertyQuery, ImagePropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImagePropertyQuery, ImagePropertyQueryVariables>(ImagePropertyDocument, options);
      }
export function useImagePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImagePropertyQuery, ImagePropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImagePropertyQuery, ImagePropertyQueryVariables>(ImagePropertyDocument, options);
        }
export type ImagePropertyQueryHookResult = ReturnType<typeof useImagePropertyQuery>;
export type ImagePropertyLazyQueryHookResult = ReturnType<typeof useImagePropertyLazyQuery>;
export type ImagePropertyQueryResult = Apollo.QueryResult<ImagePropertyQuery, ImagePropertyQueryVariables>;
export const PropertyDocument = gql`
    query Property($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    id
    property {
      ...Property
    }
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function usePropertyQuery(baseOptions: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
      }
export function usePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
        }
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<typeof usePropertyLazyQuery>;
export type PropertyQueryResult = Apollo.QueryResult<PropertyQuery, PropertyQueryVariables>;
export const BaseReservationDocument = gql`
    query BaseReservation($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    id
    isGroup
    reference {
      mainGuest {
        name
      }
    }
    reservedResources {
      start
      end
      resourceOccupancies {
        reservedResourceType {
          id
        }
      }
    }
    reservationState {
      canceled
    }
  }
}
    `;

/**
 * __useBaseReservationQuery__
 *
 * To run a query within a React component, call `useBaseReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaseReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaseReservationQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useBaseReservationQuery(baseOptions: Apollo.QueryHookOptions<BaseReservationQuery, BaseReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BaseReservationQuery, BaseReservationQueryVariables>(BaseReservationDocument, options);
      }
export function useBaseReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BaseReservationQuery, BaseReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BaseReservationQuery, BaseReservationQueryVariables>(BaseReservationDocument, options);
        }
export type BaseReservationQueryHookResult = ReturnType<typeof useBaseReservationQuery>;
export type BaseReservationLazyQueryHookResult = ReturnType<typeof useBaseReservationLazyQuery>;
export type BaseReservationQueryResult = Apollo.QueryResult<BaseReservationQuery, BaseReservationQueryVariables>;
export const SelfCheckinDoneDocument = gql`
    query SelfCheckinDone($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    id
    reservedResources {
      guestOccupancies {
        wciState
        guest {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSelfCheckinDoneQuery__
 *
 * To run a query within a React component, call `useSelfCheckinDoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfCheckinDoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfCheckinDoneQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useSelfCheckinDoneQuery(baseOptions: Apollo.QueryHookOptions<SelfCheckinDoneQuery, SelfCheckinDoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfCheckinDoneQuery, SelfCheckinDoneQueryVariables>(SelfCheckinDoneDocument, options);
      }
export function useSelfCheckinDoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfCheckinDoneQuery, SelfCheckinDoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfCheckinDoneQuery, SelfCheckinDoneQueryVariables>(SelfCheckinDoneDocument, options);
        }
export type SelfCheckinDoneQueryHookResult = ReturnType<typeof useSelfCheckinDoneQuery>;
export type SelfCheckinDoneLazyQueryHookResult = ReturnType<typeof useSelfCheckinDoneLazyQuery>;
export type SelfCheckinDoneQueryResult = Apollo.QueryResult<SelfCheckinDoneQuery, SelfCheckinDoneQueryVariables>;
export const InfoReservationDocument = gql`
    query InfoReservation($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    ...Reservation
  }
}
    ${ReservationFragmentDoc}`;

/**
 * __useInfoReservationQuery__
 *
 * To run a query within a React component, call `useInfoReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoReservationQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useInfoReservationQuery(baseOptions: Apollo.QueryHookOptions<InfoReservationQuery, InfoReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoReservationQuery, InfoReservationQueryVariables>(InfoReservationDocument, options);
      }
export function useInfoReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoReservationQuery, InfoReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoReservationQuery, InfoReservationQueryVariables>(InfoReservationDocument, options);
        }
export type InfoReservationQueryHookResult = ReturnType<typeof useInfoReservationQuery>;
export type InfoReservationLazyQueryHookResult = ReturnType<typeof useInfoReservationLazyQuery>;
export type InfoReservationQueryResult = Apollo.QueryResult<InfoReservationQuery, InfoReservationQueryVariables>;
export const CommonReservationDocument = gql`
    query CommonReservation($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    ...CommonReservation
  }
}
    ${CommonReservationFragmentDoc}`;

/**
 * __useCommonReservationQuery__
 *
 * To run a query within a React component, call `useCommonReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonReservationQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useCommonReservationQuery(baseOptions: Apollo.QueryHookOptions<CommonReservationQuery, CommonReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommonReservationQuery, CommonReservationQueryVariables>(CommonReservationDocument, options);
      }
export function useCommonReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonReservationQuery, CommonReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommonReservationQuery, CommonReservationQueryVariables>(CommonReservationDocument, options);
        }
export type CommonReservationQueryHookResult = ReturnType<typeof useCommonReservationQuery>;
export type CommonReservationLazyQueryHookResult = ReturnType<typeof useCommonReservationLazyQuery>;
export type CommonReservationQueryResult = Apollo.QueryResult<CommonReservationQuery, CommonReservationQueryVariables>;
export const GuestPortalCancelReservationDocument = gql`
    mutation GuestPortalCancelReservation($reservationId: ID!) {
  guestPortalCancelReservation(reservationId: $reservationId)
}
    `;
export type GuestPortalCancelReservationMutationFn = Apollo.MutationFunction<GuestPortalCancelReservationMutation, GuestPortalCancelReservationMutationVariables>;

/**
 * __useGuestPortalCancelReservationMutation__
 *
 * To run a mutation, you first call `useGuestPortalCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestPortalCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestPortalCancelReservationMutation, { data, loading, error }] = useGuestPortalCancelReservationMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useGuestPortalCancelReservationMutation(baseOptions?: Apollo.MutationHookOptions<GuestPortalCancelReservationMutation, GuestPortalCancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestPortalCancelReservationMutation, GuestPortalCancelReservationMutationVariables>(GuestPortalCancelReservationDocument, options);
      }
export type GuestPortalCancelReservationMutationHookResult = ReturnType<typeof useGuestPortalCancelReservationMutation>;
export type GuestPortalCancelReservationMutationResult = Apollo.MutationResult<GuestPortalCancelReservationMutation>;
export type GuestPortalCancelReservationMutationOptions = Apollo.BaseMutationOptions<GuestPortalCancelReservationMutation, GuestPortalCancelReservationMutationVariables>;
export const CanCancelReservationDocument = gql`
    query CanCancelReservation($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    id
    reservedResources {
      phase
    }
  }
}
    `;

/**
 * __useCanCancelReservationQuery__
 *
 * To run a query within a React component, call `useCanCancelReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanCancelReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanCancelReservationQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useCanCancelReservationQuery(baseOptions: Apollo.QueryHookOptions<CanCancelReservationQuery, CanCancelReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanCancelReservationQuery, CanCancelReservationQueryVariables>(CanCancelReservationDocument, options);
      }
export function useCanCancelReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanCancelReservationQuery, CanCancelReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanCancelReservationQuery, CanCancelReservationQueryVariables>(CanCancelReservationDocument, options);
        }
export type CanCancelReservationQueryHookResult = ReturnType<typeof useCanCancelReservationQuery>;
export type CanCancelReservationLazyQueryHookResult = ReturnType<typeof useCanCancelReservationLazyQuery>;
export type CanCancelReservationQueryResult = Apollo.QueryResult<CanCancelReservationQuery, CanCancelReservationQueryVariables>;
export const CountryDocument = gql`
    query Country($countryFilter: CountryQueryFilter) {
  countries(filter: $countryFilter) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useCountryQuery__
 *
 * To run a query within a React component, call `useCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryQuery({
 *   variables: {
 *      countryFilter: // value for 'countryFilter'
 *   },
 * });
 */
export function useCountryQuery(baseOptions?: Apollo.QueryHookOptions<CountryQuery, CountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountryQuery, CountryQueryVariables>(CountryDocument, options);
      }
export function useCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountryQuery, CountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountryQuery, CountryQueryVariables>(CountryDocument, options);
        }
export type CountryQueryHookResult = ReturnType<typeof useCountryQuery>;
export type CountryLazyQueryHookResult = ReturnType<typeof useCountryLazyQuery>;
export type CountryQueryResult = Apollo.QueryResult<CountryQuery, CountryQueryVariables>;
export const IdentificationDocumentsDocument = gql`
    query IdentificationDocuments($filter: IdentificationDocumentQueryFilter) {
  identificationDocuments(filter: $filter) {
    ...IdentificationDocument
  }
}
    ${IdentificationDocumentFragmentDoc}`;

/**
 * __useIdentificationDocumentsQuery__
 *
 * To run a query within a React component, call `useIdentificationDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentificationDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentificationDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIdentificationDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>(IdentificationDocumentsDocument, options);
      }
export function useIdentificationDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>(IdentificationDocumentsDocument, options);
        }
export type IdentificationDocumentsQueryHookResult = ReturnType<typeof useIdentificationDocumentsQuery>;
export type IdentificationDocumentsLazyQueryHookResult = ReturnType<typeof useIdentificationDocumentsLazyQuery>;
export type IdentificationDocumentsQueryResult = Apollo.QueryResult<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>;
export const CountriesAndMunicipalitiesDocument = gql`
    query CountriesAndMunicipalities($countryFilter: CountryQueryFilter, $municipalitiesFilter: MunicipalityQueryFilter) {
  countries(filter: $countryFilter) {
    ...Country
  }
  municipalities(filter: $municipalitiesFilter) {
    ...Municipality
  }
}
    ${CountryFragmentDoc}
${MunicipalityFragmentDoc}`;

/**
 * __useCountriesAndMunicipalitiesQuery__
 *
 * To run a query within a React component, call `useCountriesAndMunicipalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesAndMunicipalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesAndMunicipalitiesQuery({
 *   variables: {
 *      countryFilter: // value for 'countryFilter'
 *      municipalitiesFilter: // value for 'municipalitiesFilter'
 *   },
 * });
 */
export function useCountriesAndMunicipalitiesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesAndMunicipalitiesQuery, CountriesAndMunicipalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesAndMunicipalitiesQuery, CountriesAndMunicipalitiesQueryVariables>(CountriesAndMunicipalitiesDocument, options);
      }
export function useCountriesAndMunicipalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesAndMunicipalitiesQuery, CountriesAndMunicipalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesAndMunicipalitiesQuery, CountriesAndMunicipalitiesQueryVariables>(CountriesAndMunicipalitiesDocument, options);
        }
export type CountriesAndMunicipalitiesQueryHookResult = ReturnType<typeof useCountriesAndMunicipalitiesQuery>;
export type CountriesAndMunicipalitiesLazyQueryHookResult = ReturnType<typeof useCountriesAndMunicipalitiesLazyQuery>;
export type CountriesAndMunicipalitiesQueryResult = Apollo.QueryResult<CountriesAndMunicipalitiesQuery, CountriesAndMunicipalitiesQueryVariables>;
export const GuestPortalWebCheckinDocument = gql`
    mutation GuestPortalWebCheckin($value: GuestPortalWebCheckinInput!) {
  guestPortalWebCheckin(value: $value)
}
    `;
export type GuestPortalWebCheckinMutationFn = Apollo.MutationFunction<GuestPortalWebCheckinMutation, GuestPortalWebCheckinMutationVariables>;

/**
 * __useGuestPortalWebCheckinMutation__
 *
 * To run a mutation, you first call `useGuestPortalWebCheckinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestPortalWebCheckinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestPortalWebCheckinMutation, { data, loading, error }] = useGuestPortalWebCheckinMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useGuestPortalWebCheckinMutation(baseOptions?: Apollo.MutationHookOptions<GuestPortalWebCheckinMutation, GuestPortalWebCheckinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestPortalWebCheckinMutation, GuestPortalWebCheckinMutationVariables>(GuestPortalWebCheckinDocument, options);
      }
export type GuestPortalWebCheckinMutationHookResult = ReturnType<typeof useGuestPortalWebCheckinMutation>;
export type GuestPortalWebCheckinMutationResult = Apollo.MutationResult<GuestPortalWebCheckinMutation>;
export type GuestPortalWebCheckinMutationOptions = Apollo.BaseMutationOptions<GuestPortalWebCheckinMutation, GuestPortalWebCheckinMutationVariables>;
export const FileUploadPresignedURLDocument = gql`
    mutation FileUploadPresignedURL($file: FileInput!) {
  fileUploadPresignedURL(file: $file) {
    ...FileUploadResponse
  }
}
    ${FileUploadResponseFragmentDoc}`;
export type FileUploadPresignedURLMutationFn = Apollo.MutationFunction<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>;

/**
 * __useFileUploadPresignedURLMutation__
 *
 * To run a mutation, you first call `useFileUploadPresignedURLMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploadPresignedURLMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploadPresignedUrlMutation, { data, loading, error }] = useFileUploadPresignedURLMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useFileUploadPresignedURLMutation(baseOptions?: Apollo.MutationHookOptions<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>(FileUploadPresignedURLDocument, options);
      }
export type FileUploadPresignedURLMutationHookResult = ReturnType<typeof useFileUploadPresignedURLMutation>;
export type FileUploadPresignedURLMutationResult = Apollo.MutationResult<FileUploadPresignedURLMutation>;
export type FileUploadPresignedURLMutationOptions = Apollo.BaseMutationOptions<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>;
export const GetImageUploadedDocument = gql`
    query GetImageUploaded($filter: FilesQueryFilter!) {
  files(filter: $filter) {
    URL
    id
  }
}
    `;

/**
 * __useGetImageUploadedQuery__
 *
 * To run a query within a React component, call `useGetImageUploadedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageUploadedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageUploadedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetImageUploadedQuery(baseOptions: Apollo.QueryHookOptions<GetImageUploadedQuery, GetImageUploadedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageUploadedQuery, GetImageUploadedQueryVariables>(GetImageUploadedDocument, options);
      }
export function useGetImageUploadedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageUploadedQuery, GetImageUploadedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageUploadedQuery, GetImageUploadedQueryVariables>(GetImageUploadedDocument, options);
        }
export type GetImageUploadedQueryHookResult = ReturnType<typeof useGetImageUploadedQuery>;
export type GetImageUploadedLazyQueryHookResult = ReturnType<typeof useGetImageUploadedLazyQuery>;
export type GetImageUploadedQueryResult = Apollo.QueryResult<GetImageUploadedQuery, GetImageUploadedQueryVariables>;
export const PrivacyPolicyGuestPortalDocument = gql`
    query PrivacyPolicyGuestPortal($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    id
    tenant {
      ...PrivacyPolicy
    }
  }
}
    ${PrivacyPolicyFragmentDoc}`;

/**
 * __usePrivacyPolicyGuestPortalQuery__
 *
 * To run a query within a React component, call `usePrivacyPolicyGuestPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyPolicyGuestPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyPolicyGuestPortalQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function usePrivacyPolicyGuestPortalQuery(baseOptions: Apollo.QueryHookOptions<PrivacyPolicyGuestPortalQuery, PrivacyPolicyGuestPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyPolicyGuestPortalQuery, PrivacyPolicyGuestPortalQueryVariables>(PrivacyPolicyGuestPortalDocument, options);
      }
export function usePrivacyPolicyGuestPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyPolicyGuestPortalQuery, PrivacyPolicyGuestPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyPolicyGuestPortalQuery, PrivacyPolicyGuestPortalQueryVariables>(PrivacyPolicyGuestPortalDocument, options);
        }
export type PrivacyPolicyGuestPortalQueryHookResult = ReturnType<typeof usePrivacyPolicyGuestPortalQuery>;
export type PrivacyPolicyGuestPortalLazyQueryHookResult = ReturnType<typeof usePrivacyPolicyGuestPortalLazyQuery>;
export type PrivacyPolicyGuestPortalQueryResult = Apollo.QueryResult<PrivacyPolicyGuestPortalQuery, PrivacyPolicyGuestPortalQueryVariables>;
export const PropertyHasChildrenDocument = gql`
    query PropertyHasChildren($filter: ChildQueryFilter!) {
  children(filter: $filter) {
    minAge
    maxAge
    id
  }
}
    `;

/**
 * __usePropertyHasChildrenQuery__
 *
 * To run a query within a React component, call `usePropertyHasChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyHasChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyHasChildrenQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyHasChildrenQuery(baseOptions: Apollo.QueryHookOptions<PropertyHasChildrenQuery, PropertyHasChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyHasChildrenQuery, PropertyHasChildrenQueryVariables>(PropertyHasChildrenDocument, options);
      }
export function usePropertyHasChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyHasChildrenQuery, PropertyHasChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyHasChildrenQuery, PropertyHasChildrenQueryVariables>(PropertyHasChildrenDocument, options);
        }
export type PropertyHasChildrenQueryHookResult = ReturnType<typeof usePropertyHasChildrenQuery>;
export type PropertyHasChildrenLazyQueryHookResult = ReturnType<typeof usePropertyHasChildrenLazyQuery>;
export type PropertyHasChildrenQueryResult = Apollo.QueryResult<PropertyHasChildrenQuery, PropertyHasChildrenQueryVariables>;
export const ChargeCategoryCodesDocument = gql`
    query ChargeCategoryCodes($tenantId: ID!, $propertyId: ID!) {
  chargeCategoryCodes(tenantId: $tenantId, propertyId: $propertyId)
}
    `;

/**
 * __useChargeCategoryCodesQuery__
 *
 * To run a query within a React component, call `useChargeCategoryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeCategoryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeCategoryCodesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useChargeCategoryCodesQuery(baseOptions: Apollo.QueryHookOptions<ChargeCategoryCodesQuery, ChargeCategoryCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChargeCategoryCodesQuery, ChargeCategoryCodesQueryVariables>(ChargeCategoryCodesDocument, options);
      }
export function useChargeCategoryCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChargeCategoryCodesQuery, ChargeCategoryCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChargeCategoryCodesQuery, ChargeCategoryCodesQueryVariables>(ChargeCategoryCodesDocument, options);
        }
export type ChargeCategoryCodesQueryHookResult = ReturnType<typeof useChargeCategoryCodesQuery>;
export type ChargeCategoryCodesLazyQueryHookResult = ReturnType<typeof useChargeCategoryCodesLazyQuery>;
export type ChargeCategoryCodesQueryResult = Apollo.QueryResult<ChargeCategoryCodesQuery, ChargeCategoryCodesQueryVariables>;
export const CreateQuotationRequestDocument = gql`
    mutation CreateQuotationRequest($value: QuotationInput!, $request: QuotationRequestInput!) {
  createQuotationRequest(value: $value, request: $request)
}
    `;
export type CreateQuotationRequestMutationFn = Apollo.MutationFunction<CreateQuotationRequestMutation, CreateQuotationRequestMutationVariables>;

/**
 * __useCreateQuotationRequestMutation__
 *
 * To run a mutation, you first call `useCreateQuotationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotationRequestMutation, { data, loading, error }] = useCreateQuotationRequestMutation({
 *   variables: {
 *      value: // value for 'value'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateQuotationRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuotationRequestMutation, CreateQuotationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuotationRequestMutation, CreateQuotationRequestMutationVariables>(CreateQuotationRequestDocument, options);
      }
export type CreateQuotationRequestMutationHookResult = ReturnType<typeof useCreateQuotationRequestMutation>;
export type CreateQuotationRequestMutationResult = Apollo.MutationResult<CreateQuotationRequestMutation>;
export type CreateQuotationRequestMutationOptions = Apollo.BaseMutationOptions<CreateQuotationRequestMutation, CreateQuotationRequestMutationVariables>;
export const IbeDefaultPaxDocument = gql`
    query IbeDefaultPax($propertyFilter: PropertyQueryFilter!) {
  properties(filter: $propertyFilter) {
    bookingEngineConfiguration {
      ibeDefaultPax
    }
  }
}
    `;

/**
 * __useIbeDefaultPaxQuery__
 *
 * To run a query within a React component, call `useIbeDefaultPaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useIbeDefaultPaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIbeDefaultPaxQuery({
 *   variables: {
 *      propertyFilter: // value for 'propertyFilter'
 *   },
 * });
 */
export function useIbeDefaultPaxQuery(baseOptions: Apollo.QueryHookOptions<IbeDefaultPaxQuery, IbeDefaultPaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IbeDefaultPaxQuery, IbeDefaultPaxQueryVariables>(IbeDefaultPaxDocument, options);
      }
export function useIbeDefaultPaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IbeDefaultPaxQuery, IbeDefaultPaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IbeDefaultPaxQuery, IbeDefaultPaxQueryVariables>(IbeDefaultPaxDocument, options);
        }
export type IbeDefaultPaxQueryHookResult = ReturnType<typeof useIbeDefaultPaxQuery>;
export type IbeDefaultPaxLazyQueryHookResult = ReturnType<typeof useIbeDefaultPaxLazyQuery>;
export type IbeDefaultPaxQueryResult = Apollo.QueryResult<IbeDefaultPaxQuery, IbeDefaultPaxQueryVariables>;
export const QuotationDocument = gql`
    query Quotation($tenantId: ID!, $quotationId: ID!, $setReadState: Boolean) {
  quotation(tenantId: $tenantId, id: $quotationId, setReadState: $setReadState) {
    ...Quotation
  }
}
    ${QuotationFragmentDoc}`;

/**
 * __useQuotationQuery__
 *
 * To run a query within a React component, call `useQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      quotationId: // value for 'quotationId'
 *      setReadState: // value for 'setReadState'
 *   },
 * });
 */
export function useQuotationQuery(baseOptions: Apollo.QueryHookOptions<QuotationQuery, QuotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotationQuery, QuotationQueryVariables>(QuotationDocument, options);
      }
export function useQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotationQuery, QuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotationQuery, QuotationQueryVariables>(QuotationDocument, options);
        }
export type QuotationQueryHookResult = ReturnType<typeof useQuotationQuery>;
export type QuotationLazyQueryHookResult = ReturnType<typeof useQuotationLazyQuery>;
export type QuotationQueryResult = Apollo.QueryResult<QuotationQuery, QuotationQueryVariables>;
export const ConfirmQuotationDocument = gql`
    mutation ConfirmQuotation($input: ConfirmQuotationInput!, $callbackUrl: String) {
  confirmQuotation(input: $input, callbackUrl: $callbackUrl) {
    ...PayAndConfirmQuotation
  }
}
    ${PayAndConfirmQuotationFragmentDoc}`;
export type ConfirmQuotationMutationFn = Apollo.MutationFunction<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>;

/**
 * __useConfirmQuotationMutation__
 *
 * To run a mutation, you first call `useConfirmQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmQuotationMutation, { data, loading, error }] = useConfirmQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      callbackUrl: // value for 'callbackUrl'
 *   },
 * });
 */
export function useConfirmQuotationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>(ConfirmQuotationDocument, options);
      }
export type ConfirmQuotationMutationHookResult = ReturnType<typeof useConfirmQuotationMutation>;
export type ConfirmQuotationMutationResult = Apollo.MutationResult<ConfirmQuotationMutation>;
export type ConfirmQuotationMutationOptions = Apollo.BaseMutationOptions<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>;
export const BookingEngineUrlsDocument = gql`
    query BookingEngineUrls($tenantId: ID!, $propertyId: [ID!]!) {
  bookingEngineUrls(tenantId: $tenantId, propertyId: $propertyId) {
    url
    propertyId
  }
}
    `;

/**
 * __useBookingEngineUrlsQuery__
 *
 * To run a query within a React component, call `useBookingEngineUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEngineUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEngineUrlsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useBookingEngineUrlsQuery(baseOptions: Apollo.QueryHookOptions<BookingEngineUrlsQuery, BookingEngineUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingEngineUrlsQuery, BookingEngineUrlsQueryVariables>(BookingEngineUrlsDocument, options);
      }
export function useBookingEngineUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingEngineUrlsQuery, BookingEngineUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingEngineUrlsQuery, BookingEngineUrlsQueryVariables>(BookingEngineUrlsDocument, options);
        }
export type BookingEngineUrlsQueryHookResult = ReturnType<typeof useBookingEngineUrlsQuery>;
export type BookingEngineUrlsLazyQueryHookResult = ReturnType<typeof useBookingEngineUrlsLazyQuery>;
export type BookingEngineUrlsQueryResult = Apollo.QueryResult<BookingEngineUrlsQuery, BookingEngineUrlsQueryVariables>;
export const QuotationPropertyTextDocument = gql`
    query QuotationPropertyText($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    ...QuotationPropertyText
  }
}
    ${QuotationPropertyTextFragmentDoc}`;

/**
 * __useQuotationPropertyTextQuery__
 *
 * To run a query within a React component, call `useQuotationPropertyTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationPropertyTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationPropertyTextQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQuotationPropertyTextQuery(baseOptions: Apollo.QueryHookOptions<QuotationPropertyTextQuery, QuotationPropertyTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotationPropertyTextQuery, QuotationPropertyTextQueryVariables>(QuotationPropertyTextDocument, options);
      }
export function useQuotationPropertyTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotationPropertyTextQuery, QuotationPropertyTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotationPropertyTextQuery, QuotationPropertyTextQueryVariables>(QuotationPropertyTextDocument, options);
        }
export type QuotationPropertyTextQueryHookResult = ReturnType<typeof useQuotationPropertyTextQuery>;
export type QuotationPropertyTextLazyQueryHookResult = ReturnType<typeof useQuotationPropertyTextLazyQuery>;
export type QuotationPropertyTextQueryResult = Apollo.QueryResult<QuotationPropertyTextQuery, QuotationPropertyTextQueryVariables>;
export const GetOriginalPriceQuotedResourceDocument = gql`
    query GetOriginalPriceQuotedResource($filter: RqQueryFilter!) {
  rateQuery(filter: $filter) {
    rates {
      resourceRates {
        dailyPrice {
          price
        }
        resourceTypeId
      }
      rateId
    }
  }
}
    `;

/**
 * __useGetOriginalPriceQuotedResourceQuery__
 *
 * To run a query within a React component, call `useGetOriginalPriceQuotedResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOriginalPriceQuotedResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOriginalPriceQuotedResourceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOriginalPriceQuotedResourceQuery(baseOptions: Apollo.QueryHookOptions<GetOriginalPriceQuotedResourceQuery, GetOriginalPriceQuotedResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOriginalPriceQuotedResourceQuery, GetOriginalPriceQuotedResourceQueryVariables>(GetOriginalPriceQuotedResourceDocument, options);
      }
export function useGetOriginalPriceQuotedResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOriginalPriceQuotedResourceQuery, GetOriginalPriceQuotedResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOriginalPriceQuotedResourceQuery, GetOriginalPriceQuotedResourceQueryVariables>(GetOriginalPriceQuotedResourceDocument, options);
        }
export type GetOriginalPriceQuotedResourceQueryHookResult = ReturnType<typeof useGetOriginalPriceQuotedResourceQuery>;
export type GetOriginalPriceQuotedResourceLazyQueryHookResult = ReturnType<typeof useGetOriginalPriceQuotedResourceLazyQuery>;
export type GetOriginalPriceQuotedResourceQueryResult = Apollo.QueryResult<GetOriginalPriceQuotedResourceQuery, GetOriginalPriceQuotedResourceQueryVariables>;
export const PropertyTotemDocument = gql`
    query PropertyTotem($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    id
    name
    images {
      type
      images {
        URL
        id
      }
    }
  }
}
    `;

/**
 * __usePropertyTotemQuery__
 *
 * To run a query within a React component, call `usePropertyTotemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyTotemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyTotemQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyTotemQuery(baseOptions: Apollo.QueryHookOptions<PropertyTotemQuery, PropertyTotemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyTotemQuery, PropertyTotemQueryVariables>(PropertyTotemDocument, options);
      }
export function usePropertyTotemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyTotemQuery, PropertyTotemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyTotemQuery, PropertyTotemQueryVariables>(PropertyTotemDocument, options);
        }
export type PropertyTotemQueryHookResult = ReturnType<typeof usePropertyTotemQuery>;
export type PropertyTotemLazyQueryHookResult = ReturnType<typeof usePropertyTotemLazyQuery>;
export type PropertyTotemQueryResult = Apollo.QueryResult<PropertyTotemQuery, PropertyTotemQueryVariables>;
export const TotemDocument = gql`
    query Totem($filter: TotemQueryFilter!) {
  totems(filter: $filter) {
    ...Totem
  }
}
    ${TotemFragmentDoc}`;

/**
 * __useTotemQuery__
 *
 * To run a query within a React component, call `useTotemQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotemQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTotemQuery(baseOptions: Apollo.QueryHookOptions<TotemQuery, TotemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotemQuery, TotemQueryVariables>(TotemDocument, options);
      }
export function useTotemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotemQuery, TotemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotemQuery, TotemQueryVariables>(TotemDocument, options);
        }
export type TotemQueryHookResult = ReturnType<typeof useTotemQuery>;
export type TotemLazyQueryHookResult = ReturnType<typeof useTotemLazyQuery>;
export type TotemQueryResult = Apollo.QueryResult<TotemQuery, TotemQueryVariables>;
export const TotemEventDocument = gql`
    subscription TotemEvent($filter: TotemEventFilter!) {
  totemEvent(filter: $filter) {
    eventType
    eventId
    token
    reservedResourceId
    customerId
    guestType
  }
}
    `;

/**
 * __useTotemEventSubscription__
 *
 * To run a query within a React component, call `useTotemEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTotemEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotemEventSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTotemEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<TotemEventSubscription, TotemEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TotemEventSubscription, TotemEventSubscriptionVariables>(TotemEventDocument, options);
      }
export type TotemEventSubscriptionHookResult = ReturnType<typeof useTotemEventSubscription>;
export type TotemEventSubscriptionResult = Apollo.SubscriptionResult<TotemEventSubscription>;
export const StopTotemWorkflowDocument = gql`
    mutation StopTotemWorkflow($input: StopTotemWorkflowInput!) {
  stopTotemWorkflow(input: $input)
}
    `;
export type StopTotemWorkflowMutationFn = Apollo.MutationFunction<StopTotemWorkflowMutation, StopTotemWorkflowMutationVariables>;

/**
 * __useStopTotemWorkflowMutation__
 *
 * To run a mutation, you first call `useStopTotemWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTotemWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTotemWorkflowMutation, { data, loading, error }] = useStopTotemWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopTotemWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StopTotemWorkflowMutation, StopTotemWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopTotemWorkflowMutation, StopTotemWorkflowMutationVariables>(StopTotemWorkflowDocument, options);
      }
export type StopTotemWorkflowMutationHookResult = ReturnType<typeof useStopTotemWorkflowMutation>;
export type StopTotemWorkflowMutationResult = Apollo.MutationResult<StopTotemWorkflowMutation>;
export type StopTotemWorkflowMutationOptions = Apollo.BaseMutationOptions<StopTotemWorkflowMutation, StopTotemWorkflowMutationVariables>;
export const UpdateCustomerPrivacySignDocument = gql`
    mutation UpdateCustomerPrivacySign($input: CustomerPrivacyInput!) {
  updateCustomerPrivacySign(input: $input)
}
    `;
export type UpdateCustomerPrivacySignMutationFn = Apollo.MutationFunction<UpdateCustomerPrivacySignMutation, UpdateCustomerPrivacySignMutationVariables>;

/**
 * __useUpdateCustomerPrivacySignMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerPrivacySignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerPrivacySignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerPrivacySignMutation, { data, loading, error }] = useUpdateCustomerPrivacySignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerPrivacySignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerPrivacySignMutation, UpdateCustomerPrivacySignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerPrivacySignMutation, UpdateCustomerPrivacySignMutationVariables>(UpdateCustomerPrivacySignDocument, options);
      }
export type UpdateCustomerPrivacySignMutationHookResult = ReturnType<typeof useUpdateCustomerPrivacySignMutation>;
export type UpdateCustomerPrivacySignMutationResult = Apollo.MutationResult<UpdateCustomerPrivacySignMutation>;
export type UpdateCustomerPrivacySignMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerPrivacySignMutation, UpdateCustomerPrivacySignMutationVariables>;
export const TotemPrivacyDocument = gql`
    query TotemPrivacy($reservationId: ID!) {
  guestPortalReservation(reservationId: $reservationId) {
    id
    reservedResources {
      id
      end
      guestOccupancies {
        end
        guest {
          id
          language
          privacy {
            managementConsent
            marketingConsent
            profiledMarketingConsent
            dataThirdPartyConsent
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTotemPrivacyQuery__
 *
 * To run a query within a React component, call `useTotemPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotemPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotemPrivacyQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useTotemPrivacyQuery(baseOptions: Apollo.QueryHookOptions<TotemPrivacyQuery, TotemPrivacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotemPrivacyQuery, TotemPrivacyQueryVariables>(TotemPrivacyDocument, options);
      }
export function useTotemPrivacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotemPrivacyQuery, TotemPrivacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotemPrivacyQuery, TotemPrivacyQueryVariables>(TotemPrivacyDocument, options);
        }
export type TotemPrivacyQueryHookResult = ReturnType<typeof useTotemPrivacyQuery>;
export type TotemPrivacyLazyQueryHookResult = ReturnType<typeof useTotemPrivacyLazyQuery>;
export type TotemPrivacyQueryResult = Apollo.QueryResult<TotemPrivacyQuery, TotemPrivacyQueryVariables>;
export const OCRDocument = gql`
    query OCR($tenantId: ID!, $fileId: ID!) {
  documentOcr(tenantId: $tenantId, fileId: $fileId) {
    ...OCR
  }
}
    ${OCRFragmentDoc}`;

/**
 * __useOCRQuery__
 *
 * To run a query within a React component, call `useOCRQuery` and pass it any options that fit your needs.
 * When your component renders, `useOCRQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOCRQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useOCRQuery(baseOptions: Apollo.QueryHookOptions<OCRQuery, OCRQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OCRQuery, OCRQueryVariables>(OCRDocument, options);
      }
export function useOCRLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OCRQuery, OCRQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OCRQuery, OCRQueryVariables>(OCRDocument, options);
        }
export type OCRQueryHookResult = ReturnType<typeof useOCRQuery>;
export type OCRLazyQueryHookResult = ReturnType<typeof useOCRLazyQuery>;
export type OCRQueryResult = Apollo.QueryResult<OCRQuery, OCRQueryVariables>;
export const UpsertReservedResourceGuestDocument = gql`
    mutation UpsertReservedResourceGuest($value: ReservedResourceGuestInput!) {
  upsertReservedResourceGuest(value: $value)
}
    `;
export type UpsertReservedResourceGuestMutationFn = Apollo.MutationFunction<UpsertReservedResourceGuestMutation, UpsertReservedResourceGuestMutationVariables>;

/**
 * __useUpsertReservedResourceGuestMutation__
 *
 * To run a mutation, you first call `useUpsertReservedResourceGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReservedResourceGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertReservedResourceGuestMutation, { data, loading, error }] = useUpsertReservedResourceGuestMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertReservedResourceGuestMutation(baseOptions?: Apollo.MutationHookOptions<UpsertReservedResourceGuestMutation, UpsertReservedResourceGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertReservedResourceGuestMutation, UpsertReservedResourceGuestMutationVariables>(UpsertReservedResourceGuestDocument, options);
      }
export type UpsertReservedResourceGuestMutationHookResult = ReturnType<typeof useUpsertReservedResourceGuestMutation>;
export type UpsertReservedResourceGuestMutationResult = Apollo.MutationResult<UpsertReservedResourceGuestMutation>;
export type UpsertReservedResourceGuestMutationOptions = Apollo.BaseMutationOptions<UpsertReservedResourceGuestMutation, UpsertReservedResourceGuestMutationVariables>;